
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("hWg6N", function(module, exports) {

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $7iHUq = parcelRequire("7iHUq");

var $fWKP5 = parcelRequire("fWKP5");

var $4QIXk = parcelRequire("4QIXk");

var $38H9k = parcelRequire("38H9k");

var $1PSAp = parcelRequire("1PSAp");
(0, $fWKP5.provideHealthcheck)();
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $b82a31e50ab09976$var$container = document.createElement('div');
$b82a31e50ab09976$var$container.id = 'profilecard-app';
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
document.body && document.body.appendChild($b82a31e50ab09976$var$container);
(0, $aQK2r.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PSAp.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4QIXk.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
    id: "profilecard-next"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $38H9k.ProfileCardLegacy), null)))), $b82a31e50ab09976$var$container);

});
parcelRegister("fWKP5", function(module, exports) {

$parcel$export(module.exports, "provideHealthcheck", () => $536332286f9d55b5$export$90dcee7ddb8a0c0c);
const $536332286f9d55b5$var$globalObj = window || $parcel$global;
const $536332286f9d55b5$var$defaultHealthcheck = (callback)=>callback({
        isSuccess: true
    });
const $536332286f9d55b5$export$90dcee7ddb8a0c0c = (healthcheck = $536332286f9d55b5$var$defaultHealthcheck)=>{
    $536332286f9d55b5$var$globalObj.performHealthcheck = healthcheck;
};

});

parcelRegister("38H9k", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLegacy", () => $b8020302200efdbf$export$dd0591e04a6e8ce6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");

var $lcB5K = parcelRequire("lcB5K");

var $lRq8t = parcelRequire("lRq8t");

var $8q7lT = parcelRequire("8q7lT");


var $lFp9s = parcelRequire("lFp9s");

var $38H79 = parcelRequire("38H79");

var $9Vp8K = parcelRequire("9Vp8K");
const $b8020302200efdbf$export$dd0591e04a6e8ce6 = ({ externalProfileClient: externalProfileClient, actions: actions })=>{
    const intl = (0, $lRq8t.default)();
    const currentUserAccountId = (0, $8q7lT.useAccountId)();
    const onLoadError = (error, analyticsEvent)=>{
        if (analyticsEvent) (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, `${analyticsEvent.payload.actionSubject} ${analyticsEvent.payload.action}`, `${analyticsEvent.payload.actionSubject}${analyticsEvent.payload.action}`, {
            error: error
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: (0, $6d22448f78a7f25a$export$50632e21ea714398)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lFp9s.ProfileCardWrapper), {
        externalProfileClient: externalProfileClient,
        onLoadError: onLoadError
    }, currentUserAccountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b8020302200efdbf$var$LegacyProfileCardStyled, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Vp8K.ProfileCardLegacyView), {
            onGetActions: (accountId, onActionCleanup)=>(0, $38H79.getSpaActionsWithRouterPush)(accountId, intl, push, actions, onActionCleanup),
            onProfileClick: (profileAccountId)=>push(`/jira/people/${profileAccountId}`)
        }))) : null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8020302200efdbf$var$LegacyProfileCardStyled = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _1pbyb4wl",
            __cmplp.className
        ])
    });
});

});
// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("8q7lT", function(module, exports) {

$parcel$export(module.exports, "useAccountId", () => $1bd1fe7fb0bcdb0a$export$e72033e0f5baa3e);

var $lvKO5 = parcelRequire("lvKO5");
const $1bd1fe7fb0bcdb0a$export$e72033e0f5baa3e = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.atlassianAccountId || null;
};

});

const $6d22448f78a7f25a$export$9345d7360ffe0722 = 'jira-profilecard-next';
const $6d22448f78a7f25a$export$81319ffa9c0d18d7 = 'profileCardNext';
const $6d22448f78a7f25a$export$50632e21ea714398 = 'profileCardNextLegacy';
const $6d22448f78a7f25a$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $6d22448f78a7f25a$export$23cedd3261bd8015 = 'viewProfile';
const $6d22448f78a7f25a$export$6bef782d14a92db8 = 'assignedIssues';
const $6d22448f78a7f25a$export$6b36f20db7a18a86 = 'reportedIssues';
const $6d22448f78a7f25a$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("lFp9s", function(module, exports) {

$parcel$export(module.exports, "ProfileCardWrapper", () => $298aff9366b0951f$export$59abd6feb7dc8540);

var $eJOHy = parcelRequire("eJOHy");

var $kEUB1 = parcelRequire("kEUB1");

var $8q7lT = parcelRequire("8q7lT");

var $9hopi = parcelRequire("9hopi");

var $9yGgq = parcelRequire("9yGgq");

var $16TBK = parcelRequire("16TBK");
const $298aff9366b0951f$export$59abd6feb7dc8540 = ({ externalProfileClient: externalProfileClient, children: children, onLoadError: onLoadError })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const accountId = (0, $8q7lT.useAccountId)();
    const fabricPfDirUrl = (0, $9yGgq.useFabricProfileDirectoryUrl)();
    const orgId = (0, $9hopi.useOrgId)();
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16TBK.ProfileClientContainer), {
        fabricPfDirUrl: fabricPfDirUrl,
        profileClient: externalProfileClient || null,
        onLoadError: onLoadError,
        cloudId: cloudId,
        // Only use the global store when no external client is provided
        isGlobal: !externalProfileClient,
        orgId: orgId
    }, children);
    // When there is no tenantContext, this will cause the child
    // component of <ProfileCard> to render without being wrapped by
    // a profile card and it will do nothing on hover
    return children;
};

});
parcelRegister("9hopi", function(module, exports) {

$parcel$export(module.exports, "useOrgId", () => $854fde3141521561$export$52a03a3207af3687);

var $lvKO5 = parcelRequire("lvKO5");
const $854fde3141521561$export$52a03a3207af3687 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.orgId;
};

});

parcelRegister("9yGgq", function(module, exports) {

$parcel$export(module.exports, "useFabricProfileDirectoryUrl", () => $3671ddc1abbfe28d$export$cb9379d435214a54);

var $lvKO5 = parcelRequire("lvKO5");
const $3671ddc1abbfe28d$export$cb9379d435214a54 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.fabricPfDirUrl || '';
};

});

parcelRegister("16TBK", function(module, exports) {

$parcel$export(module.exports, "createUserProfileCardClient", () => $ca869b060f836c8a$export$c4393c51e6d104c3);
$parcel$export(module.exports, "ProfileClientContainer", () => $ca869b060f836c8a$export$d816ba2709570028);
$parcel$export(module.exports, "useProfileClient", () => $ca869b060f836c8a$export$d43dc22a8337ee9f);

var $d5fwz = parcelRequire("d5fwz");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $aBTmI = parcelRequire("aBTmI");
const $ca869b060f836c8a$var$GATEWAY_GRAPHQL_URL = '/gateway/api/graphql';
const $ca869b060f836c8a$export$c4393c51e6d104c3 = (fabricPfDirUrl, onLoadError, gatewayGraphqlUrl, cloudId, orgId)=>{
    const userClient = new (0, $aBTmI.CustomUserProfileClient)(fabricPfDirUrl, onLoadError);
    // From upward version 14 of `@atlaskit/profilecard`, `ProfileClient` class accepts `userClient` and `teamClient` in the 2nd argument.
    return new (0, $d5fwz.default)({
        cacheMaxAge: 180000,
        cacheSize: 20,
        url: fabricPfDirUrl,
        productIdentifier: 'jira',
        gatewayGraphqlUrl: gatewayGraphqlUrl,
        cloudId: cloudId,
        orgId: orgId
    }, {
        userClient: userClient
    });
};
const $ca869b060f836c8a$export$e324594224ef24da = {
    bootstrap: ()=>({ setState: setState }, { fabricPfDirUrl: fabricPfDirUrl, profileClient: profileClient, onLoadError: onLoadError, cloudId: cloudId, orgId: orgId })=>{
            const finalProfileClient = profileClient || $ca869b060f836c8a$export$c4393c51e6d104c3(fabricPfDirUrl ?? '', onLoadError, $ca869b060f836c8a$var$GATEWAY_GRAPHQL_URL, cloudId, orgId);
            setState({
                profileClient: finalProfileClient
            });
        }
};
const $ca869b060f836c8a$export$d816ba2709570028 = (0, $6E16M.createContainer)({
    displayName: 'ProfileClientContainer'
});
const $ca869b060f836c8a$export$d4c72bab9d6cc13a = {
    profileClient: null
};
const $ca869b060f836c8a$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'ProfileClientStore',
    initialState: $ca869b060f836c8a$export$d4c72bab9d6cc13a,
    actions: $ca869b060f836c8a$export$e324594224ef24da,
    containedBy: $ca869b060f836c8a$export$d816ba2709570028,
    handlers: {
        onInit: ()=>({ dispatch: dispatch })=>dispatch($ca869b060f836c8a$export$e324594224ef24da.bootstrap())
    }
});
const $ca869b060f836c8a$export$d43dc22a8337ee9f = (0, $iJq0l.createStateHook)($ca869b060f836c8a$export$6f57813fe9f31bf9);

});
parcelRegister("d5fwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f71266daf2e15d5$export$2e2bcd8739ae039);


var $9PyvN = parcelRequire("9PyvN");


var $9uvjI = parcelRequire("9uvjI");
var $5f71266daf2e15d5$export$2e2bcd8739ae039 = (0, $9PyvN.default);

});
parcelRegister("9PyvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $495edb629a854866$export$2e2bcd8739ae039);

var $8RHPx = parcelRequire("8RHPx");
var $lopBx = parcelRequire("lopBx");

var $bRjww = parcelRequire("bRjww");

var $49UfM = parcelRequire("49UfM");

var $52RFj = parcelRequire("52RFj");

var $9uvjI = parcelRequire("9uvjI");
const $495edb629a854866$var$defaultConfig = {
    gatewayGraphqlUrl: '/gateway/api/graphql'
};
class $495edb629a854866$var$ProfileCardClient {
    constructor(config, clients){
        //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
        const withDefaultConfig = {
            ...$495edb629a854866$var$defaultConfig,
            ...config,
            gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $495edb629a854866$var$defaultConfig.gatewayGraphqlUrl
        };
        this.userClient = clients?.userClient || new (0, $9uvjI.default)(withDefaultConfig);
        this.teamClient = clients?.teamClient || new (0, $52RFj.default)(withDefaultConfig);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $bRjww.default)(withDefaultConfig);
        this.tcClient = $495edb629a854866$var$maybeCreateTeamCentralClient(withDefaultConfig, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    async getTeamCentralBaseUrl(teamCentralScopes) {
        if (this.tcClient === undefined) return Promise.resolve(undefined);
        const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
        if (!isGlobalExperienceWorkspace) return Promise.resolve((0, $8RHPx.getATLContextUrl)('team'));
        let suffix = '';
        if (teamCentralScopes !== undefined) {
            const orgId = await this.tcClient.getOrgId();
            if (orgId === null) return Promise.resolve(undefined);
            suffix += `/o/${orgId}`;
            if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
        }
        return Promise.resolve(`${(0, $8RHPx.getATLContextUrl)('home')}${suffix}`);
    }
    async shouldShowGiveKudos() {
        if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
    getRovoAgentPermissions(id, fireAnalytics) {
        return this.rovoAgentClient?.getPermissions(id, fireAnalytics);
    }
    deleteAgent(id, analytics) {
        return this.rovoAgentClient?.deleteAgent(id, analytics);
    }
    setFavouriteAgent(id, isFavourite, analytics) {
        return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
    }
}
function $495edb629a854866$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $lopBx.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralEnabled = config.teamCentralDisabled !== true;
    return teamCentralEnabled ? new (0, $49UfM.default)({
        ...config
    }) : undefined;
}
var $495edb629a854866$export$2e2bcd8739ae039 = $495edb629a854866$var$ProfileCardClient;

});
parcelRegister("bRjww", function(module, exports) {

$parcel$export(module.exports, "default", () => $05e8b6328c708954$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $2EPX4 = parcelRequire("2EPX4");

var $kNQN4 = parcelRequire("kNQN4");

var $fqVaP = parcelRequire("fqVaP");

var $2stUb = parcelRequire("2stUb");
const $05e8b6328c708954$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $05e8b6328c708954$export$2e2bcd8739ae039 extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    basePath() {
        return (0, $eGOwo.fg)('pt-deprecate-assistance-service') ? '/gateway/api/assist/rovo/v1/agents' : '/gateway/api/assist/agents/v1';
    }
    makeRequest(id, cloudId) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId);
        if (id.type === 'identity') return fetch(new Request(`${this.basePath()}/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        return fetch(new Request(`${this.basePath()}/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
    }
    getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('triggered'));
            this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('succeeded', 'request', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('failed', 'request', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('triggered'));
            const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`${this.basePath()}/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('failed', 'deleteAgent', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('triggered', 'actionSubjectId'));
            const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`${this.basePath()}/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('succeeded', actionSubjectId, {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('failed', actionSubjectId, {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics((0, $2EPX4.agentRequestAnalytics)('triggered'));
            const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics((0, $2EPX4.agentRequestAnalytics)('succeeded', 'getAgentPermissions', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics((0, $2EPX4.agentRequestAnalytics)('failed', 'getAgentPermissions', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("2EPX4", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $7d8a130fd15a8bb5$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $7d8a130fd15a8bb5$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $7d8a130fd15a8bb5$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $7d8a130fd15a8bb5$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $7d8a130fd15a8bb5$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $7d8a130fd15a8bb5$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $7d8a130fd15a8bb5$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $7d8a130fd15a8bb5$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $7d8a130fd15a8bb5$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $7d8a130fd15a8bb5$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $7d8a130fd15a8bb5$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $7d8a130fd15a8bb5$export$a9f8c9f412cf5664);

var $kNQN4 = parcelRequire("kNQN4");
/** Below lines are copied from teams common analytics */ const $7d8a130fd15a8bb5$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $7d8a130fd15a8bb5$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $7d8a130fd15a8bb5$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $7d8a130fd15a8bb5$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($7d8a130fd15a8bb5$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $7d8a130fd15a8bb5$var$TEAM_SUBJECT = 'teamProfileCard';
const $7d8a130fd15a8bb5$var$USER_SUBJECT = 'profilecard';
const $7d8a130fd15a8bb5$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $7d8a130fd15a8bb5$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $kNQN4.getPageTime)())
        }
    });
const $7d8a130fd15a8bb5$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $7d8a130fd15a8bb5$var$USER_SUBJECT;
        case 'team':
            return $7d8a130fd15a8bb5$var$TEAM_SUBJECT;
        case 'agent':
            return $7d8a130fd15a8bb5$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $7d8a130fd15a8bb5$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $7d8a130fd15a8bb5$var$createEvent('ui', 'triggered', $7d8a130fd15a8bb5$var$getActionSubject(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $7d8a130fd15a8bb5$export$c9b0e37b229a297b = (action, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'request', attributes);
const $7d8a130fd15a8bb5$export$12dae48763368ac9 = (action, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$USER_SUBJECT, 'request', attributes);
const $7d8a130fd15a8bb5$export$41816a317479160b = (type, actionSubjectId, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'rendered', $7d8a130fd15a8bb5$var$getActionSubject(type), actionSubjectId, attributes);
const $7d8a130fd15a8bb5$export$fdcd134fbeb1f921 = (type, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$getActionSubject(type), 'action', attributes);
const $7d8a130fd15a8bb5$export$93260987012593be = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$USER_SUBJECT, 'reportingLines', attributes);
const $7d8a130fd15a8bb5$export$79befd155063a6a7 = (type, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$getActionSubject(type), 'moreActions', attributes);
const $7d8a130fd15a8bb5$export$2703289b35687fde = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'avatar', attributes);
const $7d8a130fd15a8bb5$export$b4411a7661cf2d3f = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $7d8a130fd15a8bb5$export$c86679da702d560e = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $7d8a130fd15a8bb5$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("kNQN4", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $64b9704217d393a1$export$e9faea7c41053334);
const $64b9704217d393a1$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $64b9704217d393a1$var$performanceAvailable = $64b9704217d393a1$var$isPerformanceAvailable();
const $64b9704217d393a1$var$initialPageTime = Date.now();
const $64b9704217d393a1$export$e9faea7c41053334 = ()=>{
    if ($64b9704217d393a1$var$performanceAvailable) return performance.now();
    return Date.now() - $64b9704217d393a1$var$initialPageTime;
};

});


parcelRegister("fqVaP", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc90275f52a03ea7$export$2e2bcd8739ae039);

var $7xkt0 = parcelRequire("7xkt0");
class $cc90275f52a03ea7$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $7xkt0.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});
parcelRegister("7xkt0", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("2stUb", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $3d31a5950b175c26$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $3d31a5950b175c26$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $3d31a5950b175c26$export$d9ad65d422ee3f8c);

var $as7HK = parcelRequire("as7HK");
const $3d31a5950b175c26$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $3d31a5950b175c26$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $3d31a5950b175c26$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $3d31a5950b175c26$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $as7HK.DirectoryGraphQLError)) return !!error && $3d31a5950b175c26$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $as7HK.AGGError)) return !!error.errorType && $3d31a5950b175c26$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $3d31a5950b175c26$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $3d31a5950b175c26$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $as7HK.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($3d31a5950b175c26$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($3d31a5950b175c26$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $as7HK.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$3d31a5950b175c26$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $as7HK.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($3d31a5950b175c26$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($3d31a5950b175c26$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $as7HK.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$3d31a5950b175c26$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $as7HK.DirectoryGraphQLErrors) || causeError instanceof (0, $as7HK.AGGErrors)) return $3d31a5950b175c26$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $3d31a5950b175c26$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $as7HK.DirectoryGraphQLErrors)(errors, traceId);
};
const $3d31a5950b175c26$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $as7HK.AGGErrors)(errors, traceId);
};

});
parcelRegister("as7HK", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $e980080011a8d765$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $e980080011a8d765$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $e980080011a8d765$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $e980080011a8d765$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $e980080011a8d765$export$60d8267243755b9c);
class $e980080011a8d765$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $e980080011a8d765$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $e980080011a8d765$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $e980080011a8d765$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $e980080011a8d765$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $e980080011a8d765$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $e980080011a8d765$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});



parcelRegister("49UfM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b519ebe8bdd19c29$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $fqVaP = parcelRequire("fqVaP");

var $jjeHq = parcelRequire("jjeHq");

var $4qbZy = parcelRequire("4qbZy");
const $b519ebe8bdd19c29$var$UNSHARDED_PREFIX = '/gateway/api/watermelon';
const $b519ebe8bdd19c29$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $b519ebe8bdd19c29$var$orgContainsAnyWorkspacePromiseCache = new Map();
const $b519ebe8bdd19c29$var$orgIdPromiseCache = new Map();
const $b519ebe8bdd19c29$var$workspaceExistsWithTypePromiseCache = new Map();
class $b519ebe8bdd19c29$var$TeamCentralCardClient extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.orgContainsAnyWorkspacePromise = this.createOrgContainsAnyWorkspacePromise(options);
        this.workspaceExistsWithTypePromise = this.preloadWorkspaceExistsWithType(options.cloudId);
        this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
    }
    createOrgContainsAnyWorkspacePromise(config) {
        if (config.cloudId) {
            let promise = $b519ebe8bdd19c29$var$orgContainsAnyWorkspacePromiseCache.get(config.cloudId);
            if (!promise) {
                promise = this.getOrgContainsAnyWorkspace(config.cloudId);
                $b519ebe8bdd19c29$var$orgContainsAnyWorkspacePromiseCache.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    getReportingLines(userId) {
        return this.orgContainsAnyWorkspacePromise.then((orgContainsAnyWorkspace)=>{
            if (orgContainsAnyWorkspace) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    /**
	 * `public` so that mock client can override it; do not use it otherwise!
	 */ async makeRequest(userId) {
        if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
        const query = $b519ebe8bdd19c29$export$1862ef0c3880ca8d(userId);
        const response = await (0, $4qbZy.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
        return response.reportingLines;
    }
    async checkWorkspaceExists() {
        const workspaceExistsPromise = (0, $eGOwo.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? this.workspaceExistsWithTypePromise.then((workspaceExistsWithType)=>workspaceExistsWithType !== undefined) : this.orgContainsAnyWorkspacePromise;
        return workspaceExistsPromise.then((workspaceExistsWithType)=>{
            if (workspaceExistsWithType) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    async getIsGlobalExperienceWorkspace() {
        return await this.workspaceExistsWithTypePromise === 'GLOBAL_EXPERIENCE';
    }
    getOrgId() {
        return this.orgIdPromise;
    }
    preloadWorkspaceExistsWithType(cloudId) {
        if (cloudId === undefined) return Promise.resolve(undefined);
        const maybeWorkspaceExistsWithTypePromise = $b519ebe8bdd19c29$var$workspaceExistsWithTypePromiseCache.get(cloudId);
        if (maybeWorkspaceExistsWithTypePromise !== undefined) return maybeWorkspaceExistsWithTypePromise;
        const workspaceExistsWithTypePromise = this.getWorkspaceExistsWithType(cloudId);
        $b519ebe8bdd19c29$var$workspaceExistsWithTypePromiseCache.set(cloudId, workspaceExistsWithTypePromise);
        return workspaceExistsWithTypePromise;
    }
    getOrgContainsAnyWorkspace(cloudId) {
        if (cloudId) return fetch(((0, $eGOwo.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $b519ebe8bdd19c29$var$UNSHARDED_PREFIX : this.getShardedApiPath(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`).then((res)=>{
            return !res || res && res.ok;
        });
        else return Promise.resolve(false);
    }
    async getWorkspaceExistsWithType(cloudId) {
        try {
            const response = await fetch(`${this.getShardedApiPath(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                credentials: 'include'
            });
            if (response.ok) {
                const workspaceType = await response.text();
                return Promise.resolve(workspaceType);
            }
        } catch (err) {
            return Promise.resolve(undefined);
        }
    }
    preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
        if (cloudId === undefined) return Promise.resolve(null);
        if (orgId !== undefined) return Promise.resolve(orgId);
        const maybeOrgIdForCloudIdPromise = $b519ebe8bdd19c29$var$orgIdPromiseCache.get(cloudId);
        if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
        const orgIdForCloudIdPromise = (0, $jjeHq.getOrgIdForCloudIdFromAGG)(gatewayGraphqlUrl, cloudId);
        $b519ebe8bdd19c29$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
        return orgIdForCloudIdPromise;
    }
    getShardedApiPath(cloudId) {
        return `/gateway/api/townsquare/s/${cloudId}`;
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $b519ebe8bdd19c29$export$2e2bcd8739ae039 = $b519ebe8bdd19c29$var$TeamCentralCardClient;

});
parcelRegister("jjeHq", function(module, exports) {

$parcel$export(module.exports, "getOrgIdForCloudIdFromAGG", () => $a1fbf8b2b4930fa8$export$d38a536fd806c68f);

var $4qbZy = parcelRequire("4qbZy");
const $a1fbf8b2b4930fa8$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
const $a1fbf8b2b4930fa8$var$addHeaders = (headers)=>{
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $a1fbf8b2b4930fa8$export$d38a536fd806c68f(url, cloudId) {
    const query = {
        query: $a1fbf8b2b4930fa8$var$ORG_ID_FROM_CLOUD_ID_QUERY,
        variables: {
            cloudId: cloudId
        }
    };
    try {
        const { tenantContexts: tenantContexts } = await (0, $4qbZy.AGGQuery)(url, query, $a1fbf8b2b4930fa8$var$addHeaders);
        if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
        return tenantContexts[0].orgId;
    } catch (err) {
        // don't bubble up the error, and let consumers handle it as if the cloud ID
        // doesn't resolve to an org ID
        return null;
    }
}

});
parcelRegister("4qbZy", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $79a99a18e51eddf3$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $79a99a18e51eddf3$export$a14afb5f82fe705);

var $as7HK = parcelRequire("as7HK");

var $2stUb = parcelRequire("2stUb");
const $79a99a18e51eddf3$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $79a99a18e51eddf3$var$id = (headers)=>headers;
async function $79a99a18e51eddf3$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $79a99a18e51eddf3$var$id) {
    return $79a99a18e51eddf3$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $2stUb.handleDirectoryGraphQLErrors));
}
async function $79a99a18e51eddf3$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $79a99a18e51eddf3$var$id) {
    return $79a99a18e51eddf3$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $2stUb.handleAGGErrors));
}
async function $79a99a18e51eddf3$var$graphQLQuery(serviceUrl, query, processHeaders = $79a99a18e51eddf3$var$id, handleErrors) {
    const headers = processHeaders($79a99a18e51eddf3$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $as7HK.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});



parcelRegister("52RFj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8330ec0bc030b200$export$2e2bcd8739ae039);

var $2EPX4 = parcelRequire("2EPX4");

var $kNQN4 = parcelRequire("kNQN4");

var $fqVaP = parcelRequire("fqVaP");

var $2stUb = parcelRequire("2stUb");

var $7jwft = parcelRequire("7jwft");
class $8330ec0bc030b200$export$2e2bcd8739ae039 extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $7jwft.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            if (analytics) analytics((0, $2EPX4.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $2EPX4.teamRequestAnalytics)('succeeded', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.teamRequestAnalytics)('failed', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("7jwft", function(module, exports) {

$parcel$export(module.exports, "extractIdFromAri", () => $34e7bc800a4991e6$export$5816a09dbb711691);
$parcel$export(module.exports, "getTeamFromAGG", () => $34e7bc800a4991e6$export$26a8aad0c7182dd6);

var $4qbZy = parcelRequire("4qbZy");
const $34e7bc800a4991e6$var$ARI_PREFIX = 'ari:cloud:identity::team/';
const $34e7bc800a4991e6$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $34e7bc800a4991e6$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $34e7bc800a4991e6$export$7878e28c136af76 = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith($34e7bc800a4991e6$var$ARI_PREFIX) ? teamIdOrTeamAri : $34e7bc800a4991e6$export$681597d03c8a0fd2(teamIdOrTeamAri);
const $34e7bc800a4991e6$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $34e7bc800a4991e6$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $34e7bc800a4991e6$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
	  isVerified
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $34e7bc800a4991e6$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$34e7bc800a4991e6$var$TEAM_FRAGMENT}
    }
  }
}`;
const $34e7bc800a4991e6$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $34e7bc800a4991e6$export$4968f4e0119a5d9c,
        variables: {
            teamId: $34e7bc800a4991e6$export$7878e28c136af76(teamId),
            siteId: siteId || 'None'
        }
    });
const $34e7bc800a4991e6$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $34e7bc800a4991e6$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $34e7bc800a4991e6$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $4qbZy.AGGQuery)(url, query, $34e7bc800a4991e6$export$1229c72526c01df2);
    return $34e7bc800a4991e6$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("9uvjI", function(module, exports) {

$parcel$export(module.exports, "default", () => $467a485168b1cd0d$export$2e2bcd8739ae039);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");

var $eGOwo = parcelRequire("eGOwo");

var $2EPX4 = parcelRequire("2EPX4");

var $hX5cm = parcelRequire("hX5cm");

var $kNQN4 = parcelRequire("kNQN4");

var $fqVaP = parcelRequire("fqVaP");

var $2stUb = parcelRequire("2stUb");

var $4qbZy = parcelRequire("4qbZy");
const $467a485168b1cd0d$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $467a485168b1cd0d$var$aggUserQuery = (0, $kuAvn.default)`
	query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`;
const $467a485168b1cd0d$var$aggUserQueryString = `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`;
const $467a485168b1cd0d$export$8230f28f7ae567ea = (userId)=>({
        query: (0, $eGOwo.fg)('platform_agg_user_query_doc_change') ? (0, $6NFTG.print)($467a485168b1cd0d$var$aggUserQuery) : $467a485168b1cd0d$var$aggUserQueryString,
        variables: {
            userId: userId
        }
    });
const $467a485168b1cd0d$var$queryAGGUser = async (url, userId)=>{
    const query = $467a485168b1cd0d$export$8230f28f7ae567ea(userId);
    const { user: user } = await (0, $4qbZy.AGGQuery)(url, query);
    return user;
};
class $467a485168b1cd0d$export$2e2bcd8739ae039 extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
        const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
        const userQueryPromise = $467a485168b1cd0d$var$queryAGGUser(urlWithOperationName, userId);
        const user = await userQueryPromise;
        let timestring;
        const localWeekdayIndex = new Date().getDay().toString();
        const timeFormat = (0, $eGOwo.fg)('platform_profilecard-update-time-format') ? 'h:mmaaa' : 'h:mmbbb';
        if (user.zoneinfo) {
            if ((0, $hX5cm.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $hX5cm.localTime)(user.zoneinfo, timeFormat) || undefined;
            else timestring = (0, $hX5cm.localTime)(user.zoneinfo, `eee ${timeFormat}`) || undefined;
        }
        return {
            ...user,
            isBot: user.__typename === 'AppUser',
            isAgent: user.appType === 'agent',
            isServiceAccount: user.__typename === 'AppUser' && user.appType === 'service',
            status: user.accountStatus,
            statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
            avatarUrl: user.picture,
            email: user.email,
            fullName: user.name,
            location: user.extendedProfile?.location,
            meta: user.extendedProfile?.jobTitle,
            nickname: user.nickname,
            companyName: user.extendedProfile?.organization,
            timestring: timestring
        };
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            if (analytics) analytics((0, $2EPX4.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $2EPX4.userRequestAnalytics)('succeeded', {
                    duration: (0, $kNQN4.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.userRequestAnalytics)('failed', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("6NFTG", function(module, exports) {

$parcel$export(module.exports, "print", () => $4f37d191c0ef7631$export$c2d084dc44961371);

var $9E3xk = parcelRequire("9E3xk");

var $l68uS = parcelRequire("l68uS");
function $4f37d191c0ef7631$export$c2d084dc44961371(ast) {
    return (0, $9E3xk.visit)(ast, {
        leave: $4f37d191c0ef7631$var$printDocASTReducer
    });
}
var $4f37d191c0ef7631$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $4f37d191c0ef7631$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $4f37d191c0ef7631$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(node.variableDefinitions, ', '), ')');
        var directives = $4f37d191c0ef7631$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $4f37d191c0ef7631$var$join([
            op,
            $4f37d191c0ef7631$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $4f37d191c0ef7631$var$wrap(' = ', defaultValue) + $4f37d191c0ef7631$var$wrap(' ', $4f37d191c0ef7631$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $4f37d191c0ef7631$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $4f37d191c0ef7631$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(args, ', '), ')');
        if (argsLine.length > $4f37d191c0ef7631$var$MAX_LINE_LENGTH) argsLine = prefix + $4f37d191c0ef7631$var$wrap('(\n', $4f37d191c0ef7631$var$indent($4f37d191c0ef7631$var$join(args, '\n')), '\n)');
        return $4f37d191c0ef7631$var$join([
            argsLine,
            $4f37d191c0ef7631$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $4f37d191c0ef7631$var$wrap(' ', $4f37d191c0ef7631$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $4f37d191c0ef7631$var$join([
            '...',
            $4f37d191c0ef7631$var$wrap('on ', typeCondition),
            $4f37d191c0ef7631$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($4f37d191c0ef7631$var$wrap('', $4f37d191c0ef7631$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $l68uS.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $4f37d191c0ef7631$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $4f37d191c0ef7631$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $4f37d191c0ef7631$var$join([
            'schema',
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $4f37d191c0ef7631$var$join([
            'scalar',
            name,
            $4f37d191c0ef7631$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $4f37d191c0ef7631$var$join([
            'type',
            name,
            $4f37d191c0ef7631$var$wrap('implements ', $4f37d191c0ef7631$var$join(interfaces, ' & ')),
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($4f37d191c0ef7631$var$hasMultilineItems(args) ? $4f37d191c0ef7631$var$wrap('(\n', $4f37d191c0ef7631$var$indent($4f37d191c0ef7631$var$join(args, '\n')), '\n)') : $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(args, ', '), ')')) + ': ' + type + $4f37d191c0ef7631$var$wrap(' ', $4f37d191c0ef7631$var$join(directives, ' '));
    }),
    InputValueDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $4f37d191c0ef7631$var$join([
            name + ': ' + type,
            $4f37d191c0ef7631$var$wrap('= ', defaultValue),
            $4f37d191c0ef7631$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $4f37d191c0ef7631$var$join([
            'interface',
            name,
            $4f37d191c0ef7631$var$wrap('implements ', $4f37d191c0ef7631$var$join(interfaces, ' & ')),
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $4f37d191c0ef7631$var$join([
            'union',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $4f37d191c0ef7631$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $4f37d191c0ef7631$var$join([
            'enum',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $4f37d191c0ef7631$var$join([
            name,
            $4f37d191c0ef7631$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $4f37d191c0ef7631$var$join([
            'input',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($4f37d191c0ef7631$var$hasMultilineItems(args) ? $4f37d191c0ef7631$var$wrap('(\n', $4f37d191c0ef7631$var$indent($4f37d191c0ef7631$var$join(args, '\n')), '\n)') : $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $4f37d191c0ef7631$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $4f37d191c0ef7631$var$join([
            'extend schema',
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $4f37d191c0ef7631$var$join([
            'extend scalar',
            name,
            $4f37d191c0ef7631$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $4f37d191c0ef7631$var$join([
            'extend type',
            name,
            $4f37d191c0ef7631$var$wrap('implements ', $4f37d191c0ef7631$var$join(interfaces, ' & ')),
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $4f37d191c0ef7631$var$join([
            'extend interface',
            name,
            $4f37d191c0ef7631$var$wrap('implements ', $4f37d191c0ef7631$var$join(interfaces, ' & ')),
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $4f37d191c0ef7631$var$join([
            'extend union',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $4f37d191c0ef7631$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $4f37d191c0ef7631$var$join([
            'extend enum',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $4f37d191c0ef7631$var$join([
            'extend input',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    }
};
function $4f37d191c0ef7631$var$addDescription(cb) {
    return function(node) {
        return $4f37d191c0ef7631$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $4f37d191c0ef7631$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $4f37d191c0ef7631$var$block(array) {
    return $4f37d191c0ef7631$var$wrap('{\n', $4f37d191c0ef7631$var$indent($4f37d191c0ef7631$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $4f37d191c0ef7631$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $4f37d191c0ef7631$var$indent(str) {
    return $4f37d191c0ef7631$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $4f37d191c0ef7631$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $4f37d191c0ef7631$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($4f37d191c0ef7631$var$isMultiline);
}

});
parcelRegister("9E3xk", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $705a97c9b44c8772$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $705a97c9b44c8772$export$bf638b60ea8b89b7);

var $4QE9P = parcelRequire("4QE9P");

var $19BqA = parcelRequire("19BqA");
var $705a97c9b44c8772$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $705a97c9b44c8772$export$a89c95c098ac2a58 = Object.freeze({});
function $705a97c9b44c8772$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $705a97c9b44c8772$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $19BqA.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $4QE9P.default)(node), "."));
            var visitFn = $705a97c9b44c8772$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $705a97c9b44c8772$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $19BqA.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $705a97c9b44c8772$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $705a97c9b44c8772$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $705a97c9b44c8772$export$a89c95c098ac2a58) skipping[i] = $705a97c9b44c8772$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $705a97c9b44c8772$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $705a97c9b44c8772$export$a89c95c098ac2a58) skipping[i] = $705a97c9b44c8772$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $705a97c9b44c8772$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("4QE9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $387b2b38bb5e6d4b$export$2e2bcd8739ae039);

var $e5Dlp = parcelRequire("e5Dlp");
function $387b2b38bb5e6d4b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $387b2b38bb5e6d4b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $387b2b38bb5e6d4b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $387b2b38bb5e6d4b$var$_typeof(obj);
}
var $387b2b38bb5e6d4b$var$MAX_ARRAY_LENGTH = 10;
var $387b2b38bb5e6d4b$var$MAX_RECURSIVE_DEPTH = 2;
function $387b2b38bb5e6d4b$export$2e2bcd8739ae039(value) {
    return $387b2b38bb5e6d4b$var$formatValue(value, []);
}
function $387b2b38bb5e6d4b$var$formatValue(value, seenValues) {
    switch($387b2b38bb5e6d4b$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $387b2b38bb5e6d4b$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $387b2b38bb5e6d4b$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $387b2b38bb5e6d4b$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $387b2b38bb5e6d4b$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $387b2b38bb5e6d4b$var$formatArray(value, seenValues);
    return $387b2b38bb5e6d4b$var$formatObject(value, seenValues);
}
function $387b2b38bb5e6d4b$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $387b2b38bb5e6d4b$var$MAX_RECURSIVE_DEPTH) return '[' + $387b2b38bb5e6d4b$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $387b2b38bb5e6d4b$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $387b2b38bb5e6d4b$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $387b2b38bb5e6d4b$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($387b2b38bb5e6d4b$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($387b2b38bb5e6d4b$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $387b2b38bb5e6d4b$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $e5Dlp.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $387b2b38bb5e6d4b$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("e5Dlp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4200d41543ce842$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $a4200d41543ce842$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $a4200d41543ce842$export$2e2bcd8739ae039 = $a4200d41543ce842$var$nodejsCustomInspectSymbol;

});


parcelRegister("19BqA", function(module, exports) {

$parcel$export(module.exports, "Location", () => $0d73aa1a6bd3d4cf$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $0d73aa1a6bd3d4cf$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $0d73aa1a6bd3d4cf$export$8ee0fc9ee280b4ee);

var $k3Xa1 = parcelRequire("k3Xa1");
var $0d73aa1a6bd3d4cf$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $k3Xa1.default)($0d73aa1a6bd3d4cf$export$18a2be9195644f38);
var $0d73aa1a6bd3d4cf$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $k3Xa1.default)($0d73aa1a6bd3d4cf$export$50792b0e93539fde);
function $0d73aa1a6bd3d4cf$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("k3Xa1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9b1fa842852583f$export$2e2bcd8739ae039);

var $8oZnC = parcelRequire("8oZnC");

var $e5Dlp = parcelRequire("e5Dlp");
function $e9b1fa842852583f$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $8oZnC.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $e5Dlp.default) classObject.prototype[0, $e5Dlp.default] = fn;
}

});
parcelRegister("8oZnC", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e02d6059f2aabe$export$2e2bcd8739ae039);
function $61e02d6059f2aabe$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("l68uS", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $f5c0bfd4ee7d8292$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $f5c0bfd4ee7d8292$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $f5c0bfd4ee7d8292$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $f5c0bfd4ee7d8292$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $f5c0bfd4ee7d8292$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $f5c0bfd4ee7d8292$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $f5c0bfd4ee7d8292$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $f5c0bfd4ee7d8292$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $f5c0bfd4ee7d8292$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});


parcelRegister("kuAvn", function(module, exports) {

$parcel$export(module.exports, "gql", () => $eeb2ed1fa1f7c351$export$72e4926bf8358653);
$parcel$export(module.exports, "default", () => $eeb2ed1fa1f7c351$export$2e2bcd8739ae039);

var $dnskZ = parcelRequire("dnskZ");

var $f6P3g = parcelRequire("f6P3g");
var $eeb2ed1fa1f7c351$var$docCache = new Map();
var $eeb2ed1fa1f7c351$var$fragmentSourceMap = new Map();
var $eeb2ed1fa1f7c351$var$printFragmentWarnings = true;
var $eeb2ed1fa1f7c351$var$experimentalFragmentVariables = false;
function $eeb2ed1fa1f7c351$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $eeb2ed1fa1f7c351$var$cacheKeyFromLoc(loc) {
    return $eeb2ed1fa1f7c351$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $eeb2ed1fa1f7c351$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $eeb2ed1fa1f7c351$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $eeb2ed1fa1f7c351$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($eeb2ed1fa1f7c351$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $eeb2ed1fa1f7c351$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, ast), {
        definitions: definitions
    });
}
function $eeb2ed1fa1f7c351$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $eeb2ed1fa1f7c351$var$parseDocument(source) {
    var cacheKey = $eeb2ed1fa1f7c351$var$normalize(source);
    if (!$eeb2ed1fa1f7c351$var$docCache.has(cacheKey)) {
        var parsed = (0, $f6P3g.parse)(source, {
            experimentalFragmentVariables: $eeb2ed1fa1f7c351$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $eeb2ed1fa1f7c351$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $eeb2ed1fa1f7c351$var$docCache.set(cacheKey, $eeb2ed1fa1f7c351$var$stripLoc($eeb2ed1fa1f7c351$var$processFragments(parsed)));
    }
    return $eeb2ed1fa1f7c351$var$docCache.get(cacheKey);
}
function $eeb2ed1fa1f7c351$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $eeb2ed1fa1f7c351$var$parseDocument(result);
}
function $eeb2ed1fa1f7c351$export$657554ef4dc7ac2d() {
    $eeb2ed1fa1f7c351$var$docCache.clear();
    $eeb2ed1fa1f7c351$var$fragmentSourceMap.clear();
}
function $eeb2ed1fa1f7c351$export$e4294e638636c6ab() {
    $eeb2ed1fa1f7c351$var$printFragmentWarnings = false;
}
function $eeb2ed1fa1f7c351$export$78cf889af350c840() {
    $eeb2ed1fa1f7c351$var$experimentalFragmentVariables = true;
}
function $eeb2ed1fa1f7c351$export$5290df9bbbd3cfa() {
    $eeb2ed1fa1f7c351$var$experimentalFragmentVariables = false;
}
var $eeb2ed1fa1f7c351$var$extras = {
    gql: $eeb2ed1fa1f7c351$export$72e4926bf8358653,
    resetCaches: $eeb2ed1fa1f7c351$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $eeb2ed1fa1f7c351$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $eeb2ed1fa1f7c351$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $eeb2ed1fa1f7c351$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $eeb2ed1fa1f7c351$var$extras.gql, gql_1.resetCaches = $eeb2ed1fa1f7c351$var$extras.resetCaches, gql_1.disableFragmentWarnings = $eeb2ed1fa1f7c351$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $eeb2ed1fa1f7c351$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $eeb2ed1fa1f7c351$var$extras.disableExperimentalFragmentVariables;
})($eeb2ed1fa1f7c351$export$72e4926bf8358653 || ($eeb2ed1fa1f7c351$export$72e4926bf8358653 = {}));
$eeb2ed1fa1f7c351$export$72e4926bf8358653["default"] = $eeb2ed1fa1f7c351$export$72e4926bf8358653;
var $eeb2ed1fa1f7c351$export$2e2bcd8739ae039 = $eeb2ed1fa1f7c351$export$72e4926bf8358653;

});
parcelRegister("f6P3g", function(module, exports) {

$parcel$export(module.exports, "parse", () => $afff0452d66d5631$export$98e6a39c04603d36);

var $iZFMu = parcelRequire("iZFMu");

var $4oHdA = parcelRequire("4oHdA");

var $19BqA = parcelRequire("19BqA");

var $ePiKI = parcelRequire("ePiKI");

var $6dDiC = parcelRequire("6dDiC");

var $4nWzJ = parcelRequire("4nWzJ");

var $6XgSE = parcelRequire("6XgSE");
function $afff0452d66d5631$export$98e6a39c04603d36(source, options) {
    var parser = new $afff0452d66d5631$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $afff0452d66d5631$export$5303528d1070ff6f(source, options) {
    var parser = new $afff0452d66d5631$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ePiKI.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $ePiKI.TokenKind).EOF);
    return value;
}
function $afff0452d66d5631$export$28b8f402ccc88182(source, options) {
    var parser = new $afff0452d66d5631$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ePiKI.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $ePiKI.TokenKind).EOF);
    return type;
}
var $afff0452d66d5631$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $6dDiC.isSource)(source) ? source : new (0, $6dDiC.Source)(source);
        this._lexer = new (0, $6XgSE.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $ePiKI.TokenKind).NAME);
        return {
            kind: (0, $4oHdA.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).DOCUMENT,
            definitions: this.many((0, $ePiKI.TokenKind).SOF, this.parseDefinition, (0, $ePiKI.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $ePiKI.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $ePiKI.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $ePiKI.TokenKind).BRACE_L)) return {
            kind: (0, $4oHdA.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $ePiKI.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $4oHdA.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $ePiKI.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $ePiKI.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $ePiKI.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $ePiKI.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $ePiKI.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $ePiKI.TokenKind).DOLLAR);
        return {
            kind: (0, $4oHdA.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).SELECTION_SET,
            selections: this.many((0, $ePiKI.TokenKind).BRACE_L, this.parseSelection, (0, $ePiKI.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $ePiKI.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $ePiKI.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $4oHdA.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $ePiKI.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $ePiKI.TokenKind).PAREN_L, item, (0, $ePiKI.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        return {
            kind: (0, $4oHdA.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $ePiKI.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $ePiKI.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $ePiKI.TokenKind).NAME)) return {
            kind: (0, $4oHdA.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $4oHdA.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $4oHdA.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $4oHdA.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $ePiKI.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $ePiKI.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $ePiKI.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $4oHdA.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $ePiKI.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $4oHdA.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $ePiKI.TokenKind).STRING:
            case (0, $ePiKI.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $ePiKI.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $4oHdA.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $4oHdA.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $4oHdA.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $4oHdA.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $ePiKI.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $4oHdA.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $ePiKI.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $4oHdA.Kind).LIST,
            values: this.any((0, $ePiKI.TokenKind).BRACKET_L, item, (0, $ePiKI.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $4oHdA.Kind).OBJECT,
            fields: this.any((0, $ePiKI.TokenKind).BRACE_L, item, (0, $ePiKI.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        return {
            kind: (0, $4oHdA.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $ePiKI.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $ePiKI.TokenKind).AT);
        return {
            kind: (0, $4oHdA.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $ePiKI.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $ePiKI.TokenKind).BRACKET_R);
            type = {
                kind: (0, $4oHdA.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $ePiKI.TokenKind).BANG)) return {
            kind: (0, $4oHdA.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $ePiKI.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $ePiKI.TokenKind).STRING) || this.peek((0, $ePiKI.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $ePiKI.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $ePiKI.TokenKind).BRACE_R);
        return {
            kind: (0, $4oHdA.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $4oHdA.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $4oHdA.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $4oHdA.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $ePiKI.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $ePiKI.TokenKind).AMP) || this.peek((0, $ePiKI.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $ePiKI.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $ePiKI.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $ePiKI.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $ePiKI.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $ePiKI.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $4oHdA.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $ePiKI.TokenKind).PAREN_L, this.parseInputValueDef, (0, $ePiKI.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $ePiKI.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $4oHdA.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $4oHdA.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $4oHdA.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $ePiKI.TokenKind).EQUALS) ? this.delimitedMany((0, $ePiKI.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $4oHdA.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $ePiKI.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $ePiKI.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $4oHdA.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $4oHdA.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $ePiKI.TokenKind).BRACE_L, this.parseInputValueDef, (0, $ePiKI.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $ePiKI.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $ePiKI.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $ePiKI.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $ePiKI.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $4oHdA.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $ePiKI.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $4nWzJ.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $19BqA.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $iZFMu.syntaxError)(this._lexer.source, token.start, "Expected ".concat($afff0452d66d5631$var$getTokenKindDesc(kind), ", found ").concat($afff0452d66d5631$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $ePiKI.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $iZFMu.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($afff0452d66d5631$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $ePiKI.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $iZFMu.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($afff0452d66d5631$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $afff0452d66d5631$var$getTokenDesc(token) {
    var value = token.value;
    return $afff0452d66d5631$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $afff0452d66d5631$var$getTokenKindDesc(kind) {
    return (0, $6XgSE.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("iZFMu", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $dd3e555a07a61943$export$bbee0c6176c019d4);

var $eXc8C = parcelRequire("eXc8C");
function $dd3e555a07a61943$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $eXc8C.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("eXc8C", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $ae2ffdc10628e3fd$export$92d6ed0888e7cb7f);

var $fjX8u = parcelRequire("fjX8u");

var $j38tO = parcelRequire("j38tO");

var $3iKxr = parcelRequire("3iKxr");

var $hD37S = parcelRequire("hD37S");

var $1TwT7 = parcelRequire("1TwT7");
function $ae2ffdc10628e3fd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ae2ffdc10628e3fd$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ae2ffdc10628e3fd$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ae2ffdc10628e3fd$var$_typeof(obj);
}
function $ae2ffdc10628e3fd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ae2ffdc10628e3fd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ae2ffdc10628e3fd$var$ownKeys(Object(source), true).forEach(function(key) {
            $ae2ffdc10628e3fd$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ae2ffdc10628e3fd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ae2ffdc10628e3fd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ae2ffdc10628e3fd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ae2ffdc10628e3fd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ae2ffdc10628e3fd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ae2ffdc10628e3fd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ae2ffdc10628e3fd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ae2ffdc10628e3fd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ae2ffdc10628e3fd$var$_setPrototypeOf(subClass, superClass);
}
function $ae2ffdc10628e3fd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ae2ffdc10628e3fd$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ae2ffdc10628e3fd$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ae2ffdc10628e3fd$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ae2ffdc10628e3fd$var$_possibleConstructorReturn(this, result);
    };
}
function $ae2ffdc10628e3fd$var$_possibleConstructorReturn(self, call) {
    if (call && ($ae2ffdc10628e3fd$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $ae2ffdc10628e3fd$var$_assertThisInitialized(self);
}
function $ae2ffdc10628e3fd$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ae2ffdc10628e3fd$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $ae2ffdc10628e3fd$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$ae2ffdc10628e3fd$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $ae2ffdc10628e3fd$var$_construct(Class, arguments, $ae2ffdc10628e3fd$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $ae2ffdc10628e3fd$var$_setPrototypeOf(Wrapper, Class);
    };
    return $ae2ffdc10628e3fd$var$_wrapNativeSuper(Class);
}
function $ae2ffdc10628e3fd$var$_construct(Parent, args, Class) {
    if ($ae2ffdc10628e3fd$var$_isNativeReflectConstruct()) $ae2ffdc10628e3fd$var$_construct = Reflect.construct;
    else $ae2ffdc10628e3fd$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $ae2ffdc10628e3fd$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $ae2ffdc10628e3fd$var$_construct.apply(null, arguments);
}
function $ae2ffdc10628e3fd$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ae2ffdc10628e3fd$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $ae2ffdc10628e3fd$var$_setPrototypeOf(o, p) {
    $ae2ffdc10628e3fd$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ae2ffdc10628e3fd$var$_setPrototypeOf(o, p);
}
function $ae2ffdc10628e3fd$var$_getPrototypeOf(o) {
    $ae2ffdc10628e3fd$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ae2ffdc10628e3fd$var$_getPrototypeOf(o);
}
var $ae2ffdc10628e3fd$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $ae2ffdc10628e3fd$var$_inherits(GraphQLError, _Error);
    var _super = $ae2ffdc10628e3fd$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $ae2ffdc10628e3fd$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $ae2ffdc10628e3fd$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $ae2ffdc10628e3fd$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $hD37S.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $hD37S.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $j38tO.default)(originalExtensions)) _this.extensions = $ae2ffdc10628e3fd$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($ae2ffdc10628e3fd$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($ae2ffdc10628e3fd$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $ae2ffdc10628e3fd$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($ae2ffdc10628e3fd$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($ae2ffdc10628e3fd$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $ae2ffdc10628e3fd$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $ae2ffdc10628e3fd$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $ae2ffdc10628e3fd$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $3iKxr.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $ae2ffdc10628e3fd$var$_wrapNativeSuper(Error));
function $ae2ffdc10628e3fd$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $ae2ffdc10628e3fd$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $1TwT7.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $1TwT7.printSourceLocation)(error.source, location);
    }
    return output;
}
function $ae2ffdc10628e3fd$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $fjX8u.default)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 

});
parcelRegister("fjX8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2768086a269b262$export$2e2bcd8739ae039);
function $b2768086a269b262$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("j38tO", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde4e0129ad4f4db$export$2e2bcd8739ae039);
function $dde4e0129ad4f4db$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $dde4e0129ad4f4db$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $dde4e0129ad4f4db$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $dde4e0129ad4f4db$var$_typeof(obj);
}
function $dde4e0129ad4f4db$export$2e2bcd8739ae039(value) {
    return $dde4e0129ad4f4db$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("3iKxr", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $2677271cc8cb2427$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $2677271cc8cb2427$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $2677271cc8cb2427$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $2677271cc8cb2427$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("hD37S", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $cd5880f6ab51819f$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $cd5880f6ab51819f$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("1TwT7", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $1614705cd80bb521$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $1614705cd80bb521$export$867940333fd9f869);

var $hD37S = parcelRequire("hD37S");
function $1614705cd80bb521$export$96a9681e539deed(location) {
    return $1614705cd80bb521$export$867940333fd9f869(location.source, (0, $hD37S.getLocation)(location.source, location.start));
}
function $1614705cd80bb521$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $1614705cd80bb521$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $1614705cd80bb521$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $1614705cd80bb521$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $1614705cd80bb521$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $1614705cd80bb521$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $1614705cd80bb521$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $1614705cd80bb521$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $1614705cd80bb521$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $1614705cd80bb521$var$leftPad(len, str) {
    return $1614705cd80bb521$var$whitespace(len - str.length) + str;
}

});



parcelRegister("4oHdA", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $333aed883d7e11f5$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $333aed883d7e11f5$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("ePiKI", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $acb45ff744d0f320$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $acb45ff744d0f320$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("6dDiC", function(module, exports) {

$parcel$export(module.exports, "Source", () => $487270f96a0f45cd$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $487270f96a0f45cd$export$75135ee9ed6e435b);

var $3iKxr = parcelRequire("3iKxr");

var $4QE9P = parcelRequire("4QE9P");

var $fjX8u = parcelRequire("fjX8u");

var $9kbnx = parcelRequire("9kbnx");
function $487270f96a0f45cd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $487270f96a0f45cd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $487270f96a0f45cd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $487270f96a0f45cd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $487270f96a0f45cd$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $fjX8u.default)(0, "Body must be a string. Received: ".concat((0, $4QE9P.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $fjX8u.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $fjX8u.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $487270f96a0f45cd$var$_createClass(Source, [
        {
            key: (0, $3iKxr.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $487270f96a0f45cd$export$75135ee9ed6e435b(source) {
    return (0, $9kbnx.default)(source, $487270f96a0f45cd$export$1d2df86270c81ecb);
}

});
parcelRegister("9kbnx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c9ecedfbfa67ab7$export$2e2bcd8739ae039);

function $6c9ecedfbfa67ab7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6c9ecedfbfa67ab7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6c9ecedfbfa67ab7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6c9ecedfbfa67ab7$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$6c9ecedfbfa67ab7$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("4nWzJ", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $3316bf4202cd07db$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $3316bf4202cd07db$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("6XgSE", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $510558e4af143ea3$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $510558e4af143ea3$export$59ac0f4da287406a);

var $iZFMu = parcelRequire("iZFMu");

var $19BqA = parcelRequire("19BqA");

var $ePiKI = parcelRequire("ePiKI");

var $l68uS = parcelRequire("l68uS");
var $510558e4af143ea3$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $19BqA.Token)((0, $ePiKI.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $ePiKI.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $510558e4af143ea3$var$readToken(this, token);
        }while (token.kind === (0, $ePiKI.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $510558e4af143ea3$export$59ac0f4da287406a(kind) {
    return kind === (0, $ePiKI.TokenKind).BANG || kind === (0, $ePiKI.TokenKind).DOLLAR || kind === (0, $ePiKI.TokenKind).AMP || kind === (0, $ePiKI.TokenKind).PAREN_L || kind === (0, $ePiKI.TokenKind).PAREN_R || kind === (0, $ePiKI.TokenKind).SPREAD || kind === (0, $ePiKI.TokenKind).COLON || kind === (0, $ePiKI.TokenKind).EQUALS || kind === (0, $ePiKI.TokenKind).AT || kind === (0, $ePiKI.TokenKind).BRACKET_L || kind === (0, $ePiKI.TokenKind).BRACKET_R || kind === (0, $ePiKI.TokenKind).BRACE_L || kind === (0, $ePiKI.TokenKind).PIPE || kind === (0, $ePiKI.TokenKind).BRACE_R;
}
function $510558e4af143ea3$var$printCharCode(code) {
    return isNaN(code) ? (0, $ePiKI.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $510558e4af143ea3$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $510558e4af143ea3$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $510558e4af143ea3$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $510558e4af143ea3$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $510558e4af143ea3$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $510558e4af143ea3$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $iZFMu.syntaxError)(source, pos, $510558e4af143ea3$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $510558e4af143ea3$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($510558e4af143ea3$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($510558e4af143ea3$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $510558e4af143ea3$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $510558e4af143ea3$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $iZFMu.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
    } else {
        position = $510558e4af143ea3$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $510558e4af143ea3$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $510558e4af143ea3$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $510558e4af143ea3$var$isNameStart(code)) throw (0, $iZFMu.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
    return new (0, $19BqA.Token)(isFloat ? (0, $ePiKI.TokenKind).FLOAT : (0, $ePiKI.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $510558e4af143ea3$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $iZFMu.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $510558e4af143ea3$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $iZFMu.syntaxError)(source, position, "Invalid character within String: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $510558e4af143ea3$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $iZFMu.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $iZFMu.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $iZFMu.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $510558e4af143ea3$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $l68uS.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $iZFMu.syntaxError)(source, position, "Invalid character within String: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $iZFMu.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $510558e4af143ea3$var$uniCharCode(a, b, c, d) {
    return $510558e4af143ea3$var$char2hex(a) << 12 | $510558e4af143ea3$var$char2hex(b) << 8 | $510558e4af143ea3$var$char2hex(c) << 4 | $510558e4af143ea3$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $510558e4af143ea3$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $510558e4af143ea3$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $510558e4af143ea3$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});



parcelRegister("hX5cm", function(module, exports) {

$parcel$export(module.exports, "localTime", () => $98ebf9c8b6385a65$export$f0dfd716e7b023cd);
parcelRequire("7XJii");
var $iLEEy = parcelRequire("iLEEy");
const $98ebf9c8b6385a65$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $iLEEy.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};

});
parcelRegister("7XJii", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("iLEEy")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $iLEEy = parcelRequire("iLEEy");





});
parcelRegister("iLEEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $da9c26a946bf047b$export$2e2bcd8739ae039);

var $7noXc = parcelRequire("7noXc");

var $a4wuW = parcelRequire("a4wuW");

var $iEVvn = parcelRequire("iEVvn");
function $da9c26a946bf047b$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($7noXc)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $a4wuW.default)((0, $iEVvn.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("7noXc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $55ee09b25d235297$var$cloneObject;

var $55ee09b25d235297$var$_index = $55ee09b25d235297$var$_interopRequireDefault((parcelRequire("kLhoC")));
function $55ee09b25d235297$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $55ee09b25d235297$var$cloneObject(dirtyObject) {
    return (0, $55ee09b25d235297$var$_index.default)({}, dirtyObject);
}
module.exports = module.exports.default;

});
parcelRegister("kLhoC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1d5b0ef828f96ec$var$assign;
function $f1d5b0ef828f96ec$var$assign(target, dirtyObject) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
    return target;
}
module.exports = module.exports.default;

});


parcelRegister("a4wuW", function(module, exports) {

$parcel$export(module.exports, "default", () => $75537c87aa32bbea$export$2e2bcd8739ae039);

var $47etr = parcelRequire("47etr");

var $jn1Yb = parcelRequire("jn1Yb");

var $bWiNt = parcelRequire("bWiNt");
var $75537c87aa32bbea$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $75537c87aa32bbea$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($75537c87aa32bbea$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $bWiNt.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $jn1Yb.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($47etr)))(dirtyDate, formatStr, options);
}

});
parcelRegister("47etr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ff30b0f5d6c94be$var$format;

var $2ff30b0f5d6c94be$var$_index = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("9ATkL")));

var $2ff30b0f5d6c94be$var$_index2 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("5Ex2M")));

var $2ff30b0f5d6c94be$var$_index3 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("9e8fk")));

var $2ff30b0f5d6c94be$var$_index4 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("411TS")));

var $2ff30b0f5d6c94be$var$_index5 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("1S5cf")));

var $2ff30b0f5d6c94be$var$_index6 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("3f2WU")));

var $2ff30b0f5d6c94be$var$_index7 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("ejJXr")));

var $7AKXx = parcelRequire("7AKXx");

var $2ff30b0f5d6c94be$var$_index9 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("a04h3")));

var $2ff30b0f5d6c94be$var$_index10 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $2ff30b0f5d6c94be$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $2ff30b0f5d6c94be$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $2ff30b0f5d6c94be$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $2ff30b0f5d6c94be$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $2ff30b0f5d6c94be$var$doubleQuoteRegExp = /''/g;
var $2ff30b0f5d6c94be$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $2ff30b0f5d6c94be$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $2ff30b0f5d6c94be$var$_index10.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || $2ff30b0f5d6c94be$var$_index2.default;
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $2ff30b0f5d6c94be$var$_index9.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $2ff30b0f5d6c94be$var$_index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $2ff30b0f5d6c94be$var$_index9.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $2ff30b0f5d6c94be$var$_index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $2ff30b0f5d6c94be$var$_index4.default)(dirtyDate);
    if (!(0, $2ff30b0f5d6c94be$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $2ff30b0f5d6c94be$var$_index7.default)(originalDate);
    var utcDate = (0, $2ff30b0f5d6c94be$var$_index3.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($2ff30b0f5d6c94be$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $2ff30b0f5d6c94be$var$_index6.default[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join('').match($2ff30b0f5d6c94be$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $2ff30b0f5d6c94be$var$cleanEscapedString(substring);
        var formatter = $2ff30b0f5d6c94be$var$_index5.default[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $7AKXx.isProtectedWeekYearToken)(substring)) (0, $7AKXx.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $7AKXx.isProtectedDayOfYearToken)(substring)) (0, $7AKXx.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($2ff30b0f5d6c94be$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $2ff30b0f5d6c94be$var$cleanEscapedString(input) {
    return input.match($2ff30b0f5d6c94be$var$escapedStringRegExp)[1].replace($2ff30b0f5d6c94be$var$doubleQuoteRegExp, "'");
}
module.exports = module.exports.default;

});
parcelRegister("9ATkL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6fc265fbf88f3fb2$var$isValid;

var $6fc265fbf88f3fb2$var$_index = $6fc265fbf88f3fb2$var$_interopRequireDefault((parcelRequire("411TS")));

var $6fc265fbf88f3fb2$var$_index2 = $6fc265fbf88f3fb2$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $6fc265fbf88f3fb2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */ function $6fc265fbf88f3fb2$var$isValid(dirtyDate) {
    (0, $6fc265fbf88f3fb2$var$_index2.default)(1, arguments);
    var date = (0, $6fc265fbf88f3fb2$var$_index.default)(dirtyDate);
    return !isNaN(date);
}
module.exports = module.exports.default;

});
parcelRegister("411TS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ec8bac3829b5d77$var$toDate;

var $2ec8bac3829b5d77$var$_index = $2ec8bac3829b5d77$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $2ec8bac3829b5d77$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $2ec8bac3829b5d77$var$toDate(argument) {
    (0, $2ec8bac3829b5d77$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});
parcelRegister("4YZVX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3a0ccec6969661ab$var$requiredArgs;
function $3a0ccec6969661ab$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});



parcelRegister("5Ex2M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41da51fb3f7f2e9e$var$_index = $41da51fb3f7f2e9e$var$_interopRequireDefault((parcelRequire("j0Eie")));

var $41da51fb3f7f2e9e$var$_index2 = $41da51fb3f7f2e9e$var$_interopRequireDefault((parcelRequire("hCaWU")));

var $41da51fb3f7f2e9e$var$_index3 = $41da51fb3f7f2e9e$var$_interopRequireDefault((parcelRequire("grk3U")));

var $41da51fb3f7f2e9e$var$_index4 = $41da51fb3f7f2e9e$var$_interopRequireDefault((parcelRequire("36Npg")));

var $41da51fb3f7f2e9e$var$_index5 = $41da51fb3f7f2e9e$var$_interopRequireDefault((parcelRequire("72ljP")));
function $41da51fb3f7f2e9e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $41da51fb3f7f2e9e$var$locale = {
    code: 'en-US',
    formatDistance: $41da51fb3f7f2e9e$var$_index.default,
    formatLong: $41da51fb3f7f2e9e$var$_index2.default,
    formatRelative: $41da51fb3f7f2e9e$var$_index3.default,
    localize: $41da51fb3f7f2e9e$var$_index4.default,
    match: $41da51fb3f7f2e9e$var$_index5.default,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $41da51fb3f7f2e9e$var$_default = $41da51fb3f7f2e9e$var$locale;
module.exports.default = $41da51fb3f7f2e9e$var$_default;
module.exports = module.exports.default;

});
parcelRegister("j0Eie", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd6d45c5fb0de521$var$formatDistance;
var $dd6d45c5fb0de521$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
function $dd6d45c5fb0de521$var$formatDistance(token, count, options) {
    options = options || {};
    var result;
    if (typeof $dd6d45c5fb0de521$var$formatDistanceLocale[token] === 'string') result = $dd6d45c5fb0de521$var$formatDistanceLocale[token];
    else if (count === 1) result = $dd6d45c5fb0de521$var$formatDistanceLocale[token].one;
    else result = $dd6d45c5fb0de521$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
}
module.exports = module.exports.default;

});

parcelRegister("hCaWU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd2e7a8b4adafb98$var$_index = $cd2e7a8b4adafb98$var$_interopRequireDefault((parcelRequire("1KaiK")));
function $cd2e7a8b4adafb98$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cd2e7a8b4adafb98$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $cd2e7a8b4adafb98$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $cd2e7a8b4adafb98$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $cd2e7a8b4adafb98$var$formatLong = {
    date: (0, $cd2e7a8b4adafb98$var$_index.default)({
        formats: $cd2e7a8b4adafb98$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $cd2e7a8b4adafb98$var$_index.default)({
        formats: $cd2e7a8b4adafb98$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $cd2e7a8b4adafb98$var$_index.default)({
        formats: $cd2e7a8b4adafb98$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $cd2e7a8b4adafb98$var$_default = $cd2e7a8b4adafb98$var$formatLong;
module.exports.default = $cd2e7a8b4adafb98$var$_default;
module.exports = module.exports.default;

});
parcelRegister("1KaiK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $145213f5e2256761$var$buildFormatLongFn;
function $145213f5e2256761$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("grk3U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf7ebae278921a82$var$formatRelative;
var $bf7ebae278921a82$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
function $bf7ebae278921a82$var$formatRelative(token, _date, _baseDate, _options) {
    return $bf7ebae278921a82$var$formatRelativeLocale[token];
}
module.exports = module.exports.default;

});

parcelRegister("36Npg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $243841b569f75983$var$_index = $243841b569f75983$var$_interopRequireDefault((parcelRequire("4Oo0u")));
function $243841b569f75983$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $243841b569f75983$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $243841b569f75983$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $243841b569f75983$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $243841b569f75983$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $243841b569f75983$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $243841b569f75983$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
function $243841b569f75983$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
}
var $243841b569f75983$var$localize = {
    ordinalNumber: $243841b569f75983$var$ordinalNumber,
    era: (0, $243841b569f75983$var$_index.default)({
        values: $243841b569f75983$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $243841b569f75983$var$_index.default)({
        values: $243841b569f75983$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $243841b569f75983$var$_index.default)({
        values: $243841b569f75983$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $243841b569f75983$var$_index.default)({
        values: $243841b569f75983$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $243841b569f75983$var$_index.default)({
        values: $243841b569f75983$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $243841b569f75983$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $243841b569f75983$var$_default = $243841b569f75983$var$localize;
module.exports.default = $243841b569f75983$var$_default;
module.exports = module.exports.default;

});
parcelRegister("4Oo0u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $380e7433bb720b67$var$buildLocalizeFn;
function $380e7433bb720b67$var$buildLocalizeFn(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("72ljP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $51f941c45a4dfa75$var$_index = $51f941c45a4dfa75$var$_interopRequireDefault((parcelRequire("04buv")));

var $51f941c45a4dfa75$var$_index2 = $51f941c45a4dfa75$var$_interopRequireDefault((parcelRequire("eVPlb")));
function $51f941c45a4dfa75$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $51f941c45a4dfa75$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $51f941c45a4dfa75$var$parseOrdinalNumberPattern = /\d+/i;
var $51f941c45a4dfa75$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $51f941c45a4dfa75$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $51f941c45a4dfa75$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $51f941c45a4dfa75$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $51f941c45a4dfa75$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $51f941c45a4dfa75$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $51f941c45a4dfa75$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $51f941c45a4dfa75$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $51f941c45a4dfa75$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $51f941c45a4dfa75$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $51f941c45a4dfa75$var$match = {
    ordinalNumber: (0, $51f941c45a4dfa75$var$_index.default)({
        matchPattern: $51f941c45a4dfa75$var$matchOrdinalNumberPattern,
        parsePattern: $51f941c45a4dfa75$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $51f941c45a4dfa75$var$_index2.default)({
        matchPatterns: $51f941c45a4dfa75$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $51f941c45a4dfa75$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $51f941c45a4dfa75$var$_index2.default)({
        matchPatterns: $51f941c45a4dfa75$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $51f941c45a4dfa75$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $51f941c45a4dfa75$var$_index2.default)({
        matchPatterns: $51f941c45a4dfa75$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $51f941c45a4dfa75$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $51f941c45a4dfa75$var$_index2.default)({
        matchPatterns: $51f941c45a4dfa75$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $51f941c45a4dfa75$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $51f941c45a4dfa75$var$_index2.default)({
        matchPatterns: $51f941c45a4dfa75$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $51f941c45a4dfa75$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $51f941c45a4dfa75$var$_default = $51f941c45a4dfa75$var$match;
module.exports.default = $51f941c45a4dfa75$var$_default;
module.exports = module.exports.default;

});
parcelRegister("04buv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $00c949bab0549061$var$buildMatchPatternFn;
function $00c949bab0549061$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});

parcelRegister("eVPlb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adee36c0e746269c$var$buildMatchFn;
function $adee36c0e746269c$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $adee36c0e746269c$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $adee36c0e746269c$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $adee36c0e746269c$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $adee36c0e746269c$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});



parcelRegister("9e8fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b7bd16a2a6c1a1e$var$subMilliseconds;

var $6b7bd16a2a6c1a1e$var$_index = $6b7bd16a2a6c1a1e$var$_interopRequireDefault((parcelRequire("a04h3")));

var $6b7bd16a2a6c1a1e$var$_index2 = $6b7bd16a2a6c1a1e$var$_interopRequireDefault((parcelRequire("9ZBzx")));

var $6b7bd16a2a6c1a1e$var$_index3 = $6b7bd16a2a6c1a1e$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $6b7bd16a2a6c1a1e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $6b7bd16a2a6c1a1e$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $6b7bd16a2a6c1a1e$var$_index3.default)(2, arguments);
    var amount = (0, $6b7bd16a2a6c1a1e$var$_index.default)(dirtyAmount);
    return (0, $6b7bd16a2a6c1a1e$var$_index2.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("a04h3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $747d383b4b873594$var$toInteger;
function $747d383b4b873594$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});

parcelRegister("9ZBzx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7466f4a04eca45f4$var$addMilliseconds;

var $7466f4a04eca45f4$var$_index = $7466f4a04eca45f4$var$_interopRequireDefault((parcelRequire("a04h3")));

var $7466f4a04eca45f4$var$_index2 = $7466f4a04eca45f4$var$_interopRequireDefault((parcelRequire("411TS")));

var $7466f4a04eca45f4$var$_index3 = $7466f4a04eca45f4$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $7466f4a04eca45f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $7466f4a04eca45f4$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $7466f4a04eca45f4$var$_index3.default)(2, arguments);
    var timestamp = (0, $7466f4a04eca45f4$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $7466f4a04eca45f4$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});


parcelRegister("1S5cf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $15cedd7f8242ee45$var$_index = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("a9DiA")));

var $15cedd7f8242ee45$var$_index2 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("8aeCZ")));

var $15cedd7f8242ee45$var$_index3 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("5sEnr")));

var $15cedd7f8242ee45$var$_index4 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("iA62f")));

var $15cedd7f8242ee45$var$_index5 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("ldYz2")));

var $15cedd7f8242ee45$var$_index6 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("lc9Za")));

var $15cedd7f8242ee45$var$_index7 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("lYG1t")));
function $15cedd7f8242ee45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $15cedd7f8242ee45$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $15cedd7f8242ee45$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $15cedd7f8242ee45$var$_index.default.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $15cedd7f8242ee45$var$_index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $15cedd7f8242ee45$var$_index7.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $15cedd7f8242ee45$var$_index7.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $15cedd7f8242ee45$var$_index4.default)(date); // Padding
        return (0, $15cedd7f8242ee45$var$_index7.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $15cedd7f8242ee45$var$_index7.default)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $15cedd7f8242ee45$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $15cedd7f8242ee45$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $15cedd7f8242ee45$var$_index.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $15cedd7f8242ee45$var$_index7.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $15cedd7f8242ee45$var$_index5.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $15cedd7f8242ee45$var$_index7.default)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $15cedd7f8242ee45$var$_index3.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $15cedd7f8242ee45$var$_index7.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $15cedd7f8242ee45$var$_index.default.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $15cedd7f8242ee45$var$_index2.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $15cedd7f8242ee45$var$_index7.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $15cedd7f8242ee45$var$_index7.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $15cedd7f8242ee45$var$_index7.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $15cedd7f8242ee45$var$_index7.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $15cedd7f8242ee45$var$_index.default.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $15cedd7f8242ee45$var$_index.default.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $15cedd7f8242ee45$var$_index7.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $15cedd7f8242ee45$var$_index7.default)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $15cedd7f8242ee45$var$_index.default.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $15cedd7f8242ee45$var$_index.default.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $15cedd7f8242ee45$var$_index.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $15cedd7f8242ee45$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $15cedd7f8242ee45$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $15cedd7f8242ee45$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $15cedd7f8242ee45$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $15cedd7f8242ee45$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $15cedd7f8242ee45$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $15cedd7f8242ee45$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $15cedd7f8242ee45$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $15cedd7f8242ee45$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $15cedd7f8242ee45$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $15cedd7f8242ee45$var$_index7.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $15cedd7f8242ee45$var$_index7.default)(timestamp, token.length);
    }
};
function $15cedd7f8242ee45$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $15cedd7f8242ee45$var$_index7.default)(minutes, 2);
}
function $15cedd7f8242ee45$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $15cedd7f8242ee45$var$_index7.default)(Math.abs(offset) / 60, 2);
    }
    return $15cedd7f8242ee45$var$formatTimezone(offset, dirtyDelimiter);
}
function $15cedd7f8242ee45$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $15cedd7f8242ee45$var$_index7.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $15cedd7f8242ee45$var$_index7.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $15cedd7f8242ee45$var$_default = $15cedd7f8242ee45$var$formatters;
module.exports.default = $15cedd7f8242ee45$var$_default;
module.exports = module.exports.default;

});
parcelRegister("a9DiA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76493a941b8ff202$var$_index = $76493a941b8ff202$var$_interopRequireDefault((parcelRequire("lYG1t")));
function $76493a941b8ff202$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $76493a941b8ff202$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $76493a941b8ff202$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $76493a941b8ff202$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $76493a941b8ff202$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $76493a941b8ff202$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $76493a941b8ff202$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $76493a941b8ff202$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $76493a941b8ff202$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $76493a941b8ff202$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $76493a941b8ff202$var$_default = $76493a941b8ff202$var$formatters;
module.exports.default = $76493a941b8ff202$var$_default;
module.exports = module.exports.default;

});
parcelRegister("lYG1t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ffffcc6552a18812$var$addLeadingZeros;
function $ffffcc6552a18812$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});


parcelRegister("8aeCZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f1a9aac6c7c6a94$var$getUTCDayOfYear;

var $5f1a9aac6c7c6a94$var$_index = $5f1a9aac6c7c6a94$var$_interopRequireDefault((parcelRequire("411TS")));

var $5f1a9aac6c7c6a94$var$_index2 = $5f1a9aac6c7c6a94$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $5f1a9aac6c7c6a94$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5f1a9aac6c7c6a94$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $5f1a9aac6c7c6a94$var$getUTCDayOfYear(dirtyDate) {
    (0, $5f1a9aac6c7c6a94$var$_index2.default)(1, arguments);
    var date = (0, $5f1a9aac6c7c6a94$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $5f1a9aac6c7c6a94$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("5sEnr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f9ee3540ad931d2$var$getUTCISOWeek;

var $3f9ee3540ad931d2$var$_index = $3f9ee3540ad931d2$var$_interopRequireDefault((parcelRequire("411TS")));

var $3f9ee3540ad931d2$var$_index2 = $3f9ee3540ad931d2$var$_interopRequireDefault((parcelRequire("i0cv4")));

var $3f9ee3540ad931d2$var$_index3 = $3f9ee3540ad931d2$var$_interopRequireDefault((parcelRequire("guQGo")));

var $3f9ee3540ad931d2$var$_index4 = $3f9ee3540ad931d2$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $3f9ee3540ad931d2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3f9ee3540ad931d2$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $3f9ee3540ad931d2$var$getUTCISOWeek(dirtyDate) {
    (0, $3f9ee3540ad931d2$var$_index4.default)(1, arguments);
    var date = (0, $3f9ee3540ad931d2$var$_index.default)(dirtyDate);
    var diff = (0, $3f9ee3540ad931d2$var$_index2.default)(date).getTime() - (0, $3f9ee3540ad931d2$var$_index3.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $3f9ee3540ad931d2$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("i0cv4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d1b1ec55b955b3ea$var$startOfUTCISOWeek;

var $d1b1ec55b955b3ea$var$_index = $d1b1ec55b955b3ea$var$_interopRequireDefault((parcelRequire("411TS")));

var $d1b1ec55b955b3ea$var$_index2 = $d1b1ec55b955b3ea$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $d1b1ec55b955b3ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $d1b1ec55b955b3ea$var$startOfUTCISOWeek(dirtyDate) {
    (0, $d1b1ec55b955b3ea$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $d1b1ec55b955b3ea$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("guQGo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c028505fe514d6e3$var$startOfUTCISOWeekYear;

var $c028505fe514d6e3$var$_index = $c028505fe514d6e3$var$_interopRequireDefault((parcelRequire("iA62f")));

var $c028505fe514d6e3$var$_index2 = $c028505fe514d6e3$var$_interopRequireDefault((parcelRequire("i0cv4")));

var $c028505fe514d6e3$var$_index3 = $c028505fe514d6e3$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $c028505fe514d6e3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $c028505fe514d6e3$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $c028505fe514d6e3$var$_index3.default)(1, arguments);
    var year = (0, $c028505fe514d6e3$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $c028505fe514d6e3$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("iA62f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d870453ff24bf26d$var$getUTCISOWeekYear;

var $d870453ff24bf26d$var$_index = $d870453ff24bf26d$var$_interopRequireDefault((parcelRequire("411TS")));

var $d870453ff24bf26d$var$_index2 = $d870453ff24bf26d$var$_interopRequireDefault((parcelRequire("i0cv4")));

var $d870453ff24bf26d$var$_index3 = $d870453ff24bf26d$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $d870453ff24bf26d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $d870453ff24bf26d$var$getUTCISOWeekYear(dirtyDate) {
    (0, $d870453ff24bf26d$var$_index3.default)(1, arguments);
    var date = (0, $d870453ff24bf26d$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $d870453ff24bf26d$var$_index2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $d870453ff24bf26d$var$_index2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("ldYz2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f739caa789a1bb9b$var$getUTCWeek;

var $f739caa789a1bb9b$var$_index = $f739caa789a1bb9b$var$_interopRequireDefault((parcelRequire("411TS")));

var $f739caa789a1bb9b$var$_index2 = $f739caa789a1bb9b$var$_interopRequireDefault((parcelRequire("geMjG")));

var $f739caa789a1bb9b$var$_index3 = $f739caa789a1bb9b$var$_interopRequireDefault((parcelRequire("kpxoI")));

var $f739caa789a1bb9b$var$_index4 = $f739caa789a1bb9b$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $f739caa789a1bb9b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f739caa789a1bb9b$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $f739caa789a1bb9b$var$getUTCWeek(dirtyDate, options) {
    (0, $f739caa789a1bb9b$var$_index4.default)(1, arguments);
    var date = (0, $f739caa789a1bb9b$var$_index.default)(dirtyDate);
    var diff = (0, $f739caa789a1bb9b$var$_index2.default)(date, options).getTime() - (0, $f739caa789a1bb9b$var$_index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $f739caa789a1bb9b$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("geMjG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bd236ec50df9f54c$var$startOfUTCWeek;

var $bd236ec50df9f54c$var$_index = $bd236ec50df9f54c$var$_interopRequireDefault((parcelRequire("a04h3")));

var $bd236ec50df9f54c$var$_index2 = $bd236ec50df9f54c$var$_interopRequireDefault((parcelRequire("411TS")));

var $bd236ec50df9f54c$var$_index3 = $bd236ec50df9f54c$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $bd236ec50df9f54c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $bd236ec50df9f54c$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
    (0, $bd236ec50df9f54c$var$_index3.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $bd236ec50df9f54c$var$_index.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $bd236ec50df9f54c$var$_index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $bd236ec50df9f54c$var$_index2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("kpxoI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $edc00c8c056e63ce$var$startOfUTCWeekYear;

var $edc00c8c056e63ce$var$_index = $edc00c8c056e63ce$var$_interopRequireDefault((parcelRequire("a04h3")));

var $edc00c8c056e63ce$var$_index2 = $edc00c8c056e63ce$var$_interopRequireDefault((parcelRequire("lc9Za")));

var $edc00c8c056e63ce$var$_index3 = $edc00c8c056e63ce$var$_interopRequireDefault((parcelRequire("geMjG")));

var $edc00c8c056e63ce$var$_index4 = $edc00c8c056e63ce$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $edc00c8c056e63ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $edc00c8c056e63ce$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $edc00c8c056e63ce$var$_index4.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $edc00c8c056e63ce$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $edc00c8c056e63ce$var$_index.default)(options.firstWeekContainsDate);
    var year = (0, $edc00c8c056e63ce$var$_index2.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $edc00c8c056e63ce$var$_index3.default)(firstWeek, dirtyOptions);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("lc9Za", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f6e276e76c61e58d$var$getUTCWeekYear;

var $f6e276e76c61e58d$var$_index = $f6e276e76c61e58d$var$_interopRequireDefault((parcelRequire("a04h3")));

var $f6e276e76c61e58d$var$_index2 = $f6e276e76c61e58d$var$_interopRequireDefault((parcelRequire("411TS")));

var $f6e276e76c61e58d$var$_index3 = $f6e276e76c61e58d$var$_interopRequireDefault((parcelRequire("geMjG")));

var $f6e276e76c61e58d$var$_index4 = $f6e276e76c61e58d$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $f6e276e76c61e58d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $f6e276e76c61e58d$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $f6e276e76c61e58d$var$_index4.default)(1, arguments);
    var date = (0, $f6e276e76c61e58d$var$_index2.default)(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $f6e276e76c61e58d$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $f6e276e76c61e58d$var$_index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $f6e276e76c61e58d$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $f6e276e76c61e58d$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});




parcelRegister("3f2WU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $25c50f6d9939631e$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
}
function $25c50f6d9939631e$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
}
function $25c50f6d9939631e$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $25c50f6d9939631e$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $25c50f6d9939631e$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $25c50f6d9939631e$var$timeLongFormatter(timePattern, formatLong));
}
var $25c50f6d9939631e$var$longFormatters = {
    p: $25c50f6d9939631e$var$timeLongFormatter,
    P: $25c50f6d9939631e$var$dateTimeLongFormatter
};
var $25c50f6d9939631e$var$_default = $25c50f6d9939631e$var$longFormatters;
module.exports.default = $25c50f6d9939631e$var$_default;
module.exports = module.exports.default;

});

parcelRegister("ejJXr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a6c67d4b841f38e8$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $a6c67d4b841f38e8$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("7AKXx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProtectedDayOfYearToken = $58705255ffd27ebc$var$isProtectedDayOfYearToken;
module.exports.isProtectedWeekYearToken = $58705255ffd27ebc$var$isProtectedWeekYearToken;
module.exports.throwProtectedError = $58705255ffd27ebc$var$throwProtectedError;
var $58705255ffd27ebc$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $58705255ffd27ebc$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $58705255ffd27ebc$var$isProtectedDayOfYearToken(token) {
    return $58705255ffd27ebc$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $58705255ffd27ebc$var$isProtectedWeekYearToken(token) {
    return $58705255ffd27ebc$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $58705255ffd27ebc$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}

});


parcelRegister("jn1Yb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a1b16befdfb889$export$2e2bcd8739ae039);

var $emmbH = parcelRequire("emmbH");

var $a2zuC = parcelRequire("a2zuC");
var $e1a1b16befdfb889$var$MILLISECONDS_IN_MINUTE = 60000;
var $e1a1b16befdfb889$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $e1a1b16befdfb889$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $e1a1b16befdfb889$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $e1a1b16befdfb889$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $e1a1b16befdfb889$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $e1a1b16befdfb889$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $e1a1b16befdfb889$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $e1a1b16befdfb889$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $emmbH.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $emmbH.default)('long', date, options);
        }
    }
};
function $e1a1b16befdfb889$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $a2zuC.default)(timeZone, originalDate, true) / $e1a1b16befdfb889$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $e1a1b16befdfb889$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $e1a1b16befdfb889$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $e1a1b16befdfb889$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $e1a1b16befdfb889$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $e1a1b16befdfb889$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $e1a1b16befdfb889$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $e1a1b16befdfb889$var$formatTimezone(offset, dirtyDelimeter);
}
function $e1a1b16befdfb889$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $e1a1b16befdfb889$var$addLeadingZeros(minutes, 2);
}
var $e1a1b16befdfb889$export$2e2bcd8739ae039 = $e1a1b16befdfb889$var$formatters;

});
parcelRegister("emmbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a74454c810e10efc$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $a74454c810e10efc$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $a74454c810e10efc$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $a74454c810e10efc$var$partsTimeZone(dtf, date) : $a74454c810e10efc$var$hackyTimeZone(dtf, date);
}
function $a74454c810e10efc$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $a74454c810e10efc$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $a74454c810e10efc$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("a2zuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f59f73042f5ea2$export$2e2bcd8739ae039);

var $iKmlv = parcelRequire("iKmlv");

var $eMjjs = parcelRequire("eMjjs");
var $74f59f73042f5ea2$var$MILLISECONDS_IN_HOUR = 3600000;
var $74f59f73042f5ea2$var$MILLISECONDS_IN_MINUTE = 60000;
var $74f59f73042f5ea2$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $74f59f73042f5ea2$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $74f59f73042f5ea2$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $74f59f73042f5ea2$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$74f59f73042f5ea2$var$validateTimezone(hours)) return NaN;
        return -(hours * $74f59f73042f5ea2$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $74f59f73042f5ea2$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$74f59f73042f5ea2$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $74f59f73042f5ea2$var$MILLISECONDS_IN_HOUR + minutes * $74f59f73042f5ea2$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($74f59f73042f5ea2$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $74f59f73042f5ea2$var$toUtcDate(date);
        var offset = $74f59f73042f5ea2$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $74f59f73042f5ea2$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $74f59f73042f5ea2$var$toUtcDate(date) {
    return (0, $eMjjs.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $74f59f73042f5ea2$var$calcOffset(date, timezoneString) {
    var tokens = (0, $iKmlv.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $eMjjs.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $74f59f73042f5ea2$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $74f59f73042f5ea2$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $74f59f73042f5ea2$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $74f59f73042f5ea2$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $74f59f73042f5ea2$var$validIANATimezoneCache = {};
function $74f59f73042f5ea2$var$isValidTimezoneIANAString(timeZoneString) {
    if ($74f59f73042f5ea2$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $74f59f73042f5ea2$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("iKmlv", function(module, exports) {

$parcel$export(module.exports, "default", () => $da5ddb5213ce8f83$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $da5ddb5213ce8f83$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $da5ddb5213ce8f83$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $da5ddb5213ce8f83$var$partsOffset(dtf, date) : $da5ddb5213ce8f83$var$hackyOffset(dtf, date);
}
var $da5ddb5213ce8f83$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $da5ddb5213ce8f83$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $da5ddb5213ce8f83$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $da5ddb5213ce8f83$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $da5ddb5213ce8f83$var$dtfCache = {};
function $da5ddb5213ce8f83$var$getDateTimeFormat(timeZone) {
    if (!$da5ddb5213ce8f83$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $da5ddb5213ce8f83$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $da5ddb5213ce8f83$var$dtfCache[timeZone];
}

});

parcelRegister("eMjjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac2487857a682a48$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $ac2487857a682a48$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("bWiNt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b13b1308e9ec166$export$2e2bcd8739ae039);

var $a04h3 = parcelRequire("a04h3");

var $ejJXr = parcelRequire("ejJXr");

var $a2zuC = parcelRequire("a2zuC");

var $cIjNZ = parcelRequire("cIjNZ");
var $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR = 3600000;
var $8b13b1308e9ec166$var$MILLISECONDS_IN_MINUTE = 60000;
var $8b13b1308e9ec166$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $8b13b1308e9ec166$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $cIjNZ.default)
};
function $8b13b1308e9ec166$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $8b13b1308e9ec166$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($a04h3)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $8b13b1308e9ec166$var$splitDateString(argument);
    var parseYearResult = $8b13b1308e9ec166$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $8b13b1308e9ec166$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $8b13b1308e9ec166$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $a2zuC.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $8b13b1308e9ec166$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $8b13b1308e9ec166$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $8b13b1308e9ec166$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $8b13b1308e9ec166$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $8b13b1308e9ec166$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $8b13b1308e9ec166$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $8b13b1308e9ec166$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $8b13b1308e9ec166$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $8b13b1308e9ec166$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $8b13b1308e9ec166$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $8b13b1308e9ec166$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$8b13b1308e9ec166$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $8b13b1308e9ec166$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$8b13b1308e9ec166$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $8b13b1308e9ec166$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$8b13b1308e9ec166$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $8b13b1308e9ec166$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$8b13b1308e9ec166$var$validateWeekDate(year, week)) return new Date(NaN);
        return $8b13b1308e9ec166$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $8b13b1308e9ec166$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$8b13b1308e9ec166$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $8b13b1308e9ec166$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $8b13b1308e9ec166$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $8b13b1308e9ec166$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$8b13b1308e9ec166$var$validateTime(hours)) return NaN;
        return hours % 24 * $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $8b13b1308e9ec166$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$8b13b1308e9ec166$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR + minutes * $8b13b1308e9ec166$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $8b13b1308e9ec166$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$8b13b1308e9ec166$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR + minutes * $8b13b1308e9ec166$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $8b13b1308e9ec166$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $8b13b1308e9ec166$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $8b13b1308e9ec166$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $8b13b1308e9ec166$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $8b13b1308e9ec166$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $8b13b1308e9ec166$var$isLeapYearIndex(year);
        if (isLeapYear && date > $8b13b1308e9ec166$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $8b13b1308e9ec166$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $8b13b1308e9ec166$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $8b13b1308e9ec166$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $8b13b1308e9ec166$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $8b13b1308e9ec166$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("cIjNZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9418f4fd702d1312$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $9418f4fd702d1312$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $9418f4fd702d1312$export$2e2bcd8739ae039 = $9418f4fd702d1312$var$tzPattern;

});



parcelRegister("iEVvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d95891bc4ee0ba6d$export$2e2bcd8739ae039);

var $a2zuC = parcelRequire("a2zuC");

var $bWiNt = parcelRequire("bWiNt");
function $d95891bc4ee0ba6d$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $bWiNt.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $a2zuC.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});







parcelRegister("aBTmI", function(module, exports) {

$parcel$export(module.exports, "CustomUserProfileClient", () => $21d1f3a214a5c794$export$4b2a86afb64f42f1);

var $9uvjI = parcelRequire("9uvjI");

var $1Ozm9 = parcelRequire("1Ozm9");

var $38H79 = parcelRequire("38H79");
class $21d1f3a214a5c794$export$4b2a86afb64f42f1 extends (0, $9uvjI.default) {
    constructor(fabricPfDirUrl, onLoadError){
        super({
            url: fabricPfDirUrl,
            cacheSize: 20,
            cacheMaxAge: 180000
        }), this.makeRequest = async (cloudId, userId)=>{
            // call old profile rest endpoint
            try {
                if ((0, $38H79.isCustomerAccount)(userId)) {
                    const response = await (0, $1Ozm9.default)(`/rest/api/3/user?accountId=${userId}`);
                    return (0, $38H79.restResponseToUserData)(response);
                }
                return await this.parentMakeRequest(cloudId, userId);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const error = new Error(`Unable to fetch user: ${err.message}`, {
                    cause: err
                });
                this.onLoadError?.(err);
                throw error;
            }
        };
        this.onLoadError = onLoadError;
        this.parentMakeRequest = super.makeRequest;
    }
}

});
parcelRegister("38H79", function(module, exports) {

$parcel$export(module.exports, "generateUserLink", () => $b826be912fd09914$export$f4673d7e11341514);
$parcel$export(module.exports, "generateTeamLink", () => $b826be912fd09914$export$b163ce931504dcff);
$parcel$export(module.exports, "isTeamProfileCardEventContentRendered", () => $b826be912fd09914$export$6dc006c3779708c0);
$parcel$export(module.exports, "fireLegacyTeamAnalytics", () => $b826be912fd09914$export$ffbbcf55d672ec61);
$parcel$export(module.exports, "restResponseToUserData", () => $b826be912fd09914$export$66691b1affeb3bc5);
$parcel$export(module.exports, "isCustomerAccount", () => $b826be912fd09914$export$67a41405362363f0);
$parcel$export(module.exports, "getSpaActions", () => $b826be912fd09914$export$518f47d656cb4e1a);
$parcel$export(module.exports, "getSpaActionsWithRouterPush", () => $b826be912fd09914$export$96e0a21dc8f6c225);

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");

var $a62R3 = parcelRequire("a62R3");

var $9LvIj = parcelRequire("9LvIj");

const $b826be912fd09914$export$f4673d7e11341514 = (userId)=>{
    const userProfile = (0, $a62R3.getNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        }
    });
    return (0, $a62R3.isTeamsAppEnabled)() ? userProfile.href : `/jira/people/${userId}`;
};
const $b826be912fd09914$export$b163ce931504dcff = (teamId)=>{
    const teamProfile = (0, $a62R3.getNavigateToTeamsApp)({
        type: 'TEAM',
        payload: {
            teamId: teamId
        }
    });
    return (0, $a62R3.isTeamsAppEnabled)() ? teamProfile.href : `/jira/people/team/${teamId}`;
};
const $b826be912fd09914$export$7b55c373f7e07896 = (label, profileUrl)=>({
        id: 'view-profile',
        label: label,
        callback: (event)=>{
            event.stopPropagation();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(profileUrl);
        }
    });
const $b826be912fd09914$export$6dc006c3779708c0 = (analyticsPayload)=>analyticsPayload?.action === 'rendered' && analyticsPayload?.actionSubjectId === 'content';
const $b826be912fd09914$export$ffbbcf55d672ec61 = (analyticsEvent)=>{
    if (analyticsEvent?.payload?.eventType === 'ui') {
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, `legacyTeamProfileCard ${analyticsEvent.payload.action}}`);
        if ($b826be912fd09914$export$6dc006c3779708c0(analyticsEvent?.payload)) (0, $gCeeo.fireScreenAnalytics)(analyticsEvent);
    }
};
const $b826be912fd09914$export$66691b1affeb3bc5 = (userData)=>({
        avatarUrl: userData.avatarUrls?.['48x48'],
        email: userData.emailAddress,
        fullName: userData.displayName,
        isBot: false,
        isCurrentUser: false,
        status: userData.active ? 'active' : 'inactive',
        accountType: userData.accountType
    });
const $b826be912fd09914$export$67a41405362363f0 = (accountId)=>accountId ? accountId.lastIndexOf('qm:', 0) === 0 : false;
const $b826be912fd09914$export$f38de51a346a7b1 = (intl, accountId)=>{
    const userProfile = (0, $a62R3.getNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: accountId
        }
    });
    return {
        label: intl && intl.formatMessage((0, $9LvIj.profileCardMessages).viewProfile),
        id: 'view-profile',
        link: (0, $a62R3.isTeamsAppEnabled)() ? userProfile.href : `/jira/people/${accountId}`,
        callback: (0, $a62R3.isTeamsAppEnabled)() ? userProfile.onNavigate : undefined,
        shouldRender: (data)=>/*
     * Those without @atlassian.com accounts do not have viewable profiles
     */ data?.accountType !== 'customer'
    };
};
const $b826be912fd09914$var$getSpaViewProfileActionWithRouterPush = (intl, accountId, onPushAction, onActionCleanup)=>({
        label: intl && intl.formatMessage((0, $9LvIj.profileCardMessages).viewProfile),
        id: 'view-profile',
        callback: ()=>{
            onPushAction(`/jira/people/${accountId}`);
            onActionCleanup && onActionCleanup();
        },
        link: `/jira/people/${accountId}`,
        shouldRender: (data)=>/*
   * Those without @atlassian.com accounts do not have viewable profiles
   */ data?.accountType !== 'customer'
    });
const $b826be912fd09914$var$getAssignedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $9LvIj.profileCardMessages).assignedIssuesIssueTerminologyRefreshM4 : (0, $9LvIj.profileCardMessages).assignedIssues),
        id: 'assigned-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`assignee="${accountId || ''}" AND resolution is empty`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $b826be912fd09914$var$getReportedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $9LvIj.profileCardMessages).reportedIssuesIssueTerminologyRefreshM4 : (0, $9LvIj.profileCardMessages).reportedIssues),
        id: 'reported-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`reporter="${accountId || ''}" order by created DESC`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $b826be912fd09914$var$getViewFiltersAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $9LvIj.profileCardMessages).viewFilters),
        id: 'view-filters',
        callback: ()=>{
            const url = `/jira/filters?owner=${encodeURIComponent(accountId)}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $b826be912fd09914$export$518f47d656cb4e1a = (accountId, intl, actions)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $6d22448f78a7f25a$export$23cedd3261bd8015:
                return $b826be912fd09914$export$f38de51a346a7b1(intl, accountId);
            case 0, $6d22448f78a7f25a$export$6bef782d14a92db8:
                return $b826be912fd09914$var$getAssignedIssuesAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$6b36f20db7a18a86:
                return $b826be912fd09914$var$getReportedIssuesAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$56da0dd0b0aa67b9:
                return $b826be912fd09914$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $b826be912fd09914$export$f38de51a346a7b1(intl, accountId)
    ];
};
const $b826be912fd09914$export$96e0a21dc8f6c225 = (accountId, intl, onPushAction, actions, onActionCleanup)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $6d22448f78a7f25a$export$23cedd3261bd8015:
                return $b826be912fd09914$var$getSpaViewProfileActionWithRouterPush(intl, accountId, onPushAction, onActionCleanup);
            case 0, $6d22448f78a7f25a$export$6bef782d14a92db8:
                return $b826be912fd09914$var$getAssignedIssuesAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$6b36f20db7a18a86:
                return $b826be912fd09914$var$getReportedIssuesAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$56da0dd0b0aa67b9:
                return $b826be912fd09914$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $b826be912fd09914$var$getSpaViewProfileActionWithRouterPush(intl, accountId, onPushAction, onActionCleanup)
    ];
};

});
parcelRegister("a62R3", function(module, exports) {

$parcel$export(module.exports, "useNavigateToTeamsApp", () => $4bdb55387d231b38$export$520a42ab062954ec);
$parcel$export(module.exports, "getNavigateToTeamsApp", () => $4bdb55387d231b38$export$cfadab73fb247145);
$parcel$export(module.exports, "useTransformToTeamsAppUrl", () => $4bdb55387d231b38$export$dc7e633fb6368a43);
$parcel$export(module.exports, "toTeamsAppURL", () => $4bdb55387d231b38$export$196b2cec97b1c87c);
$parcel$export(module.exports, "isTeamsAppEnabled", () => $4bdb55387d231b38$export$5921b2a93a401547);

var $fvpPO = parcelRequire("fvpPO");

var $j19W0 = parcelRequire("j19W0");

var $g9Vr6 = parcelRequire("g9Vr6");

var $kEUB1 = parcelRequire("kEUB1");

var $83DiZ = parcelRequire("83DiZ");

var $6zXPf = parcelRequire("6zXPf");

var $hWeHP = parcelRequire("hWeHP");
const $4bdb55387d231b38$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    if (!orgId && !cloudId) throw new Error('Org ID or Cloud ID is required to navigate to Teams App');
    return (0, $j19W0.navigateToTeamsApp)({
        push: push,
        hostProduct: 'jira',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)(),
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
const $4bdb55387d231b38$export$cfadab73fb247145 = (navActionPayload, shouldOpenInSameTab)=>{
    const orgId = (0, $hWeHP.default)('ajs-org-id');
    const cloudId = (0, $hWeHP.default)('ajs-cloud-id');
    return (0, $j19W0.navigateToTeamsApp)({
        hostProduct: 'jira',
        orgId: orgId || '',
        cloudId: cloudId || undefined,
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)(),
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
const $4bdb55387d231b38$export$dc7e633fb6368a43 = (path, search = '')=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    return (0, $j19W0.toTeamsAppURL)(path, search, {
        orgId: orgId,
        cloudId: cloudId
    });
};
const $4bdb55387d231b38$export$196b2cec97b1c87c = (path, search = '')=>{
    const orgId = (0, $hWeHP.default)('ajs-org-id');
    const cloudId = (0, $hWeHP.default)('ajs-cloud-id');
    return (0, $j19W0.toTeamsAppURL)(path, search, {
        orgId: orgId ?? '',
        cloudId: cloudId ?? ''
    });
};
const $4bdb55387d231b38$export$5921b2a93a401547 = ()=>{
    return (0, $fvpPO.isTeamsAppEnabled)({
        hostProduct: 'jira',
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)()
    });
};

});
parcelRegister("fvpPO", function(module, exports) {

$parcel$export(module.exports, "isTeamsAppEnabled", () => $e45f3caa2e661ed2$export$5921b2a93a401547);

var $lopBx = parcelRequire("lopBx");

var $59rsN = parcelRequire("59rsN");

var $eGOwo = parcelRequire("eGOwo");
function $e45f3caa2e661ed2$export$5921b2a93a401547(config) {
    // Due to experiment exposures, we need to first check if Nav4 is enabled to see if the user is in the cohort
    // In FedRamp, we are ignoring the Nav4 dependency
    if (!(0, $lopBx.isFedRamp)() && config.userHasNav4Enabled !== undefined && !config.userHasNav4Enabled) return false;
    if ((0, $59rsN.default).initializeCompleted()) {
        // Next we check the experiment value based on the host product
        if (config.hostProduct === 'jira' && (0, $59rsN.default).getExperimentValue('migrate-jira-people-directory-to-teams-app', 'isEnabled', false)) return true;
        if (config.hostProduct === 'confluence' && (0, $59rsN.default).getExperimentValue('migrate-confluence-people-directory-to-teams-app', 'isEnabled', false)) return true;
    }
    // Lastly we check the feature gate which we are using for dogfooding, we won't roll this flag out in production.
    return (0, $eGOwo.fg)('should-redirect-directory-to-teams-app');
}

});

parcelRegister("j19W0", function(module, exports) {

$parcel$export(module.exports, "navigateToTeamsApp", () => $bcd485df6c831087$export$cd99a4ca8e852372);
$parcel$export(module.exports, "toTeamsAppURL", () => $bcd485df6c831087$export$196b2cec97b1c87c);

var $fvpPO = parcelRequire("fvpPO");

var $0FujR = parcelRequire("0FujR");
const $bcd485df6c831087$export$cd99a4ca8e852372 = (action)=>{
    const { hostProduct: hostProduct, shouldOpenInSameTab: shouldOpenInSameTab } = action;
    const actionWithDefaults = {
        ...action,
        /**
		 * If teams app is enabled, default to opening in new tab.
		 */ shouldOpenInSameTab: shouldOpenInSameTab === undefined ? !(0, $fvpPO.isTeamsAppEnabled)(action) : shouldOpenInSameTab,
        hostProduct: hostProduct || (0, $0FujR.getHostProductFromPath)()
    };
    const { path: path, query: query } = (0, $0FujR.getPathAndQuery)(actionWithDefaults);
    const href = (0, $0FujR.generatePath)(path, actionWithDefaults, query);
    const onNavigate = (0, $0FujR.onNavigateBase)(href, actionWithDefaults);
    const result = {
        onNavigate: onNavigate,
        href: href,
        target: actionWithDefaults.shouldOpenInSameTab ? '_self' : '_blank'
    };
    return result;
};
const $bcd485df6c831087$export$196b2cec97b1c87c = (path, search, config)=>{
    return (0, $0FujR.generateTeamsAppPath)(path, config, new URLSearchParams(search));
};

});
parcelRegister("0FujR", function(module, exports) {

$parcel$export(module.exports, "generateTeamsAppPath", () => $a228ae66ede9224c$export$9665cb78fbba2c92);
$parcel$export(module.exports, "generatePath", () => $a228ae66ede9224c$export$82476f982757e71e);
$parcel$export(module.exports, "onNavigateBase", () => $a228ae66ede9224c$export$39f25014273b0a58);
$parcel$export(module.exports, "getPathAndQuery", () => $a228ae66ede9224c$export$b406f12e2156b3fe);
$parcel$export(module.exports, "getHostProductFromPath", () => $a228ae66ede9224c$export$a792d22ca73cc3ca);

var $8RHPx = parcelRequire("8RHPx");
var $lopBx = parcelRequire("lopBx");

var $chYv1 = parcelRequire("chYv1");

var $fvpPO = parcelRequire("fvpPO");
function $a228ae66ede9224c$export$9665cb78fbba2c92(path, config, query = new URLSearchParams(), anchor) {
    if (config.cloudId) query.set('cloudId', config.cloudId);
    const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`;
    const pathWithPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash : `/people${pathWithLeadingSlash}`;
    const pathWithoutPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash.replace(/^\/people\//, '/') : pathWithLeadingSlash;
    // URLSearchParams.size doesn't work in jest
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    // Home & therefore the Teams app, is not deployed to FedRamp, instead we have deployed Standalone directory.
    // At some point, likely both Commercial & FedRamp will follow the same URL convention and we can remove this,
    // but for now, we need to generate a different URL for FedRamp.
    if ((0, $lopBx.isFedRamp)()) // We can't use getATLContextUrl here as the URL doesn't yet exist in commercial. When it does, we should properly define it there.
    return `https://teams${$a228ae66ede9224c$export$a9f2c34176fff494() ? '.stg' : ''}.atlassian-us-gov.com${pathWithoutPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
    const orgIdString = config.orgId ? `/o/${config.orgId}` : '';
    return `${(0, $8RHPx.getATLContextUrl)('home')}${orgIdString}${pathWithPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
}
function $a228ae66ede9224c$export$82476f982757e71e(path, config, query = new URLSearchParams(), anchor) {
    if ((0, $fvpPO.isTeamsAppEnabled)(config) || config.hostProduct === 'home' || !config.hostProduct) return $a228ae66ede9224c$export$9665cb78fbba2c92(path, config, query, anchor);
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    return `${(0, $chYv1.origin)()}/${config.hostProduct === 'confluence' ? 'wiki' : 'jira'}/people/${path}${queryString}`;
}
const $a228ae66ede9224c$export$39f25014273b0a58 = (href, config)=>(e)=>{
        if (e) e.preventDefault();
        if ((0, $fvpPO.isTeamsAppEnabled)(config)) {
            if (config.shouldOpenInSameTab) {
                (0, $chYv1.redirect)(href);
                return;
            }
            (0, $chYv1.openInNewTab)(href);
            return;
        } else if (config.shouldOpenInSameTab) {
            if (config.push) {
                config.push(href);
                return;
            }
            (0, $chYv1.redirect)(href);
            return;
        } else {
            (0, $chYv1.openInNewTab)(href);
            return;
        }
    };
function $a228ae66ede9224c$var$stripAriFromId(id) {
    // Return everything after the last slash
    return id.includes('/') ? id.split('/').pop() || '' : id;
}
function $a228ae66ede9224c$export$b406f12e2156b3fe(action) {
    switch(action.type){
        case 'LANDING':
        case 'DIRECTORY':
            return {
                path: ''
            };
        case 'USER':
            // Safety check for undefined userId, just redirect to the landing page as the profile redirect will fail
            if (!action.payload?.userId) return {
                path: ''
            };
            return {
                path: `${$a228ae66ede9224c$var$stripAriFromId(action.payload.userId)}`,
                anchor: action.payload.section
            };
        case 'TEAM':
            // Safety check for undefined teamId, just redirect to the landing page as the team redirect will fail
            if (!action.payload?.teamId) return {
                path: ''
            };
            return {
                path: `team/${$a228ae66ede9224c$var$stripAriFromId(action.payload.teamId)}`
            };
        case 'AGENT':
            // Safety check for undefined agentId, just redirect to the landing page as the agent redirect will fail
            if (!action.payload?.agentId) return {
                path: ''
            };
            return {
                path: `agent/${$a228ae66ede9224c$var$stripAriFromId(action.payload.agentId)}`
            };
        case 'KUDOS':
            // Safety check for undefined kudosId, just redirect to the landing page as the kudos redirect will fail
            if (!action.payload?.kudosId) return {
                path: ''
            };
            return {
                path: `kudos/${$a228ae66ede9224c$var$stripAriFromId(action.payload.kudosId)}`
            };
        case 'TEAMS_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_TEAMS'
                })
            };
        case 'PEOPLE_DIRECTORY':
            return {
                path: `search/people`,
                query: new URLSearchParams(action.payload.query)
            };
        case 'USER_WORK':
            return {
                path: `${$a228ae66ede9224c$var$stripAriFromId(action.payload.userId)}/work`
            };
        case 'CURRENT_USER_PROFILE':
            return {
                path: 'me'
            };
        default:
            return {
                path: ''
            };
    }
}
function $a228ae66ede9224c$export$a9f2c34176fff494() {
    const host = (0, $chYv1.hostname)();
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (host.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return true;
    return false;
}
function $a228ae66ede9224c$export$a792d22ca73cc3ca() {
    const path = (0, $chYv1.pathname)();
    if (path.startsWith('/wiki')) return 'confluence';
    if (path.startsWith('/jira')) return 'jira';
    if ((0, $chYv1.hostname)().startsWith('home')) return 'home';
    return undefined;
}

});
parcelRegister("chYv1", function(module, exports) {

$parcel$export(module.exports, "redirect", () => $c76ad79e98e47bfd$export$89e12c5b50f7529d);
$parcel$export(module.exports, "openInNewTab", () => $c76ad79e98e47bfd$export$9e52b10d57ddf9e3);
$parcel$export(module.exports, "hostname", () => $c76ad79e98e47bfd$export$640106f6dc7d2706);
$parcel$export(module.exports, "origin", () => $c76ad79e98e47bfd$export$f710a83a91838a36);
$parcel$export(module.exports, "pathname", () => $c76ad79e98e47bfd$export$7333db99aa99d383);
function $c76ad79e98e47bfd$export$89e12c5b50f7529d(url) {
    window.location.href = url;
}
const $c76ad79e98e47bfd$export$9e52b10d57ddf9e3 = (url)=>window.open(url, '_blank', 'noopener noreferrer');
const $c76ad79e98e47bfd$export$640106f6dc7d2706 = ()=>globalThis.location?.hostname;
const $c76ad79e98e47bfd$export$f710a83a91838a36 = ()=>globalThis.location?.origin;
const $c76ad79e98e47bfd$export$7333db99aa99d383 = ()=>globalThis.location?.pathname;

});




parcelRegister("9LvIj", function(module, exports) {

$parcel$export(module.exports, "profileCardMessages", () => $8d56fb88e7ef3ba6$export$49f2d2ccb123fddf);

var $7qGN1 = parcelRequire("7qGN1");
const $8d56fb88e7ef3ba6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    view: {
        "id": "profilecard-next",
        "defaultMessage": "View profile"
    }
});
const $8d56fb88e7ef3ba6$export$49f2d2ccb123fddf = (0, $7qGN1.defineMessages)({
    assignedIssues: {
        "id": "profilecard-next.assigned-issues",
        "defaultMessage": "Assigned issues"
    },
    viewProfile: {
        "id": "profilecard-next.view-profile",
        "defaultMessage": "View profile"
    },
    reportedIssues: {
        "id": "profilecard-next.reported-issues",
        "defaultMessage": "Reported issues"
    },
    viewFilters: {
        "id": "profilecard-next.view-filters",
        "defaultMessage": "View filters"
    },
    assignedIssuesIssueTerminologyRefreshM4: {
        "id": "profilecard-next.assigned-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Assigned work items"
    },
    reportedIssuesIssueTerminologyRefreshM4: {
        "id": "profilecard-next.reported-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Reported work items"
    }
});

});





parcelRegister("9Vp8K", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLegacyView", () => $1d2ce6dbf3060ff0$export$f603724b266e8fe7);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $lcuMI = parcelRequire("lcuMI");

var $hjf2q = parcelRequire("hjf2q");

var $kEUB1 = parcelRequire("kEUB1");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");

var $1QXCG = parcelRequire("1QXCG");

var $fBp9y = parcelRequire("fBp9y");

var $eL3VJ = parcelRequire("eL3VJ");

var $16TBK = parcelRequire("16TBK");


var $jSFBS = parcelRequire("jSFBS");
const $1d2ce6dbf3060ff0$var$AnalyticsWrapper = (0, $hjf2q.AnalyticsEventToProps)((0, $55746a299dc1482c$export$a1455360a24a2234), {
    onAnalytics: 'fired'
});
const $1d2ce6dbf3060ff0$export$23f88898e1cb6da9 = $1d2ce6dbf3060ff0$var$AnalyticsWrapper((0, $lcuMI.default)((0, $jSFBS.default)));
const $1d2ce6dbf3060ff0$var$eventListenerOptions = {
    passive: true
};
const $1d2ce6dbf3060ff0$export$f603724b266e8fe7 = ({ onGetActions: onGetActions, onProfileClick: onProfileClick })=>{
    // Required for mocking in VR Tests
    (0, $gRw8I.di)(setTimeout);
    // Hooks
    const [userData, setUserData] = (0, $eJOHy.useState)(null);
    const [referenceElement, setReferenceElement] = (0, $eJOHy.useState)(null);
    const [showProfileCard, setShowProfileCard] = (0, $eJOHy.useState)(false);
    const [offset, setOffset] = (0, $eJOHy.useState)(null);
    const showTimeoutId = (0, $eJOHy.useRef)(null);
    const cloudId = (0, $kEUB1.useCloudId)();
    const { profileClient: profileClient } = (0, $16TBK.useProfileClient)();
    const onMouseLeaveCancelShowCard = (0, $fAZgY.useCallbackWithCondition)(()=>{
        if (showTimeoutId.current) clearTimeout(showTimeoutId.current);
    }, [
        showTimeoutId
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-platform-2'));
    const onHideProfileCard = (0, $fAZgY.useCallbackWithCondition)(()=>{
        setShowProfileCard(false);
        onMouseLeaveCancelShowCard();
    }, [
        setShowProfileCard,
        onMouseLeaveCancelShowCard
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-platform-2'));
    const { setTriggerRef: setTriggerRef, setCardRef: setCardRef, unsetTriggerRef: unsetTriggerRef, unsetCardRef: unsetCardRef, getTimeoutId: getTimeoutId } = (0, $fBp9y.useHideProfileCardDelayed)(true, false, onHideProfileCard);
    // Add event listener using our hook
    (0, $fBp9y.useEventListener)('mouseleave', unsetTriggerRef, referenceElement, $1d2ce6dbf3060ff0$var$eventListenerOptions);
    (0, $fBp9y.useEventListener)('mouseleave', onMouseLeaveCancelShowCard, referenceElement, $1d2ce6dbf3060ff0$var$eventListenerOptions);
    (0, $fBp9y.useEventListener)('mouseenter', setTriggerRef, referenceElement, $1d2ce6dbf3060ff0$var$eventListenerOptions);
    // @ts-expect-error - TS2345 - Argument of type 'Window & typeof globalThis' is not assignable to parameter of type 'HTMLElement | null'.
    (0, $fBp9y.useEventListener)('scroll', onHideProfileCard, window, $1d2ce6dbf3060ff0$var$eventListenerOptions);
    const clearHideCardTimeout = (timeoutId)=>{
        if (timeoutId) clearTimeout(timeoutId);
    };
    const setShowProfileCardDelayed = ()=>setTimeout(()=>setShowProfileCard(true), (0, $776ef75d5b01ad48$export$5b956b542f1bc1b3));
    const setData = (data, ref, offsetValue)=>{
        clearHideCardTimeout(getTimeoutId());
        setOffset(offsetValue || '0, 8px');
        setUserData(data);
        setReferenceElement(ref);
        showTimeoutId.current = setShowProfileCardDelayed();
    };
    const api = {
        setData: setData,
        hideProfileCard: onHideProfileCard
    };
    (0, $eL3VJ.default)(api);
    return showProfileCard && referenceElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1QXCG.ProfileCardLegacyWrapper), {
        onMouseEnter: setCardRef,
        onMouseLeave: unsetCardRef,
        referenceElement: referenceElement,
        offset: offset
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1d2ce6dbf3060ff0$export$23f88898e1cb6da9, {
            accountId: userData?.accountId,
            cloudId: cloudId,
            handleEscapeKeydown: onHideProfileCard,
            handleClickOutside: onHideProfileCard,
            profileClient: profileClient,
            actions: onGetActions(userData?.accountId ?? '', ()=>{
                clearHideCardTimeout(getTimeoutId());
                onHideProfileCard();
            }),
            onProfileClick: onProfileClick
        }));
};

});
const $776ef75d5b01ad48$export$5b956b542f1bc1b3 = 800;
const $776ef75d5b01ad48$export$89a9f35a94d7f196 = 200;

parcelRegister("lcuMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $743f1f4f47ea3596$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");
function $743f1f4f47ea3596$export$2e2bcd8739ae039(Component) {
    return class WithOuterListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
        componentDidMount() {
            if (this.props.handleClickOutside) document.addEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) document.addEventListener('keydown', this.handleKeydown, false);
        }
        componentWillUnmount() {
            if (this.props.handleClickOutside) document.removeEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) document.removeEventListener('keydown', this.handleKeydown, false);
        }
        render() {
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.handleClick = (evt)=>{
                const { handleClickOutside: handleClickOutside } = this.props;
                if (handleClickOutside) {
                    const domNode = (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).findDOMNode(this); // eslint-disable-line react/no-find-dom-node
                    if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) handleClickOutside();
                }
            }, this.handleKeydown = (evt)=>{
                const { handleEscapeKeydown: handleEscapeKeydown } = this.props;
                if (handleEscapeKeydown && evt.code === 'Escape') handleEscapeKeydown();
            };
        }
    };
}

});

parcelRegister("hjf2q", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $1d3706030416e425$export$3e9ef96ba97ea9dc);

var $4J0ad = parcelRequire("4J0ad");
const $1d3706030416e425$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $1d3706030416e425$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $4J0ad.default)($1d3706030416e425$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("1QXCG", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLegacyWrapper", () => $5530a93af5ae1f5c$export$6ef7d4845cf112be);

var $eJOHy = parcelRequire("eJOHy");

var $8dH3d = parcelRequire("8dH3d");

var $8cv11 = parcelRequire("8cv11");

var $fBp9y = parcelRequire("fBp9y");

// Updated version of popper requires tuple but provided value may be a string
const $5530a93af5ae1f5c$var$parsePopperOffsetValue = (offset)=>{
    let offsetArray = [
        0,
        0
    ];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(offset)) return offsetArray;
    if (typeof offset === 'string') // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type '[number | null | undefined, number | null | undefined]'.
    offsetArray = offset.split(',').map((pxValue)=>parseInt(pxValue.replace('px', ''), 10));
    else if (Array.isArray(offset) && offset.length === 2) // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type '[number | null | undefined, number | null | undefined]'.
    offsetArray = offset;
    return offsetArray.some(Number.isNaN) ? [
        0,
        0
    ] : offsetArray;
};
const $5530a93af5ae1f5c$export$6ef7d4845cf112be = ({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, referenceElement: referenceElement, offset: offset, children: children, placement: placement })=>{
    const offsetTuple = $5530a93af5ae1f5c$var$parsePopperOffsetValue(offset);
    const modifiers = [
        {
            name: 'offset',
            options: {
                offset: offsetTuple
            }
        },
        {
            name: 'preventOverflow',
            options: {
                tether: true
            }
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8cv11.JiraPopper), {
        referenceElement: referenceElement,
        placement: placement || (0, $fBp9y.getPlacement)(referenceElement),
        modifiers: modifiers,
        messageId: "profilecard-next.common.ui.legacy-profile-card.popper",
        messageType: "transactional"
    }, ({ ref: ref, style: style, forceUpdate: forceUpdate })=>// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": "profilecard-next.common.ui.legacy-profile-card.div",
            ref: ref,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...style
            },
            onMouseLeave: onMouseLeave,
            onMouseEnter: onMouseEnter
        }, children(forceUpdate)));
};

});
parcelRegister("8cv11", function(module, exports) {

$parcel$export(module.exports, "JiraPopper", () => $7c774b4266762c6b$export$23789575ac361b5d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $8qmYl = parcelRequire("8qmYl");

var $SyPNn = parcelRequire("SyPNn");

var $k3Xbr = parcelRequire("k3Xbr");
const $7c774b4266762c6b$export$23789575ac361b5d = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k3Xbr.ChoreographerPopper), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8qmYl.Popper), rest);
};

});
parcelRegister("k3Xbr", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopper", () => $035f7c874f3f3baa$export$6077de4a190b560c);
// eslint-disable-next-line jira/restricted/react-component-props

var $8qmYl = parcelRequire("8qmYl");

var $1pkzT = parcelRequire("1pkzT");
const $035f7c874f3f3baa$export$6077de4a190b560c = (0, $1pkzT.withChoreographedRender)((0, $8qmYl.Popper));

});


parcelRegister("fBp9y", function(module, exports) {

$parcel$export(module.exports, "useEventListener", () => $f7f992598fb2ad9d$export$7080b3e976bc91ab);
$parcel$export(module.exports, "useHideProfileCardDelayed", () => $f7f992598fb2ad9d$export$30416a530a92ed77);
$parcel$export(module.exports, "getPlacement", () => $f7f992598fb2ad9d$export$a9fe23cfa43a7b55);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $fAZgY = parcelRequire("fAZgY");
const $f7f992598fb2ad9d$export$7080b3e976bc91ab = (eventName, handler, element, // @ts-expect-error - TS2304 - Cannot find name 'EventListenerOptionsOrUseCapture'.
options)=>{
    // Create a ref that stores handler
    const savedHandler = (0, $eJOHy.useRef)();
    // Update ref.current value if handler changes.
    // This allows our effect below to always get latest handler ...
    // ... without us needing to pass it in effect deps array ...
    // ... and potentially cause effect to re-run every render.
    (0, $eJOHy.useEffect)(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Create event listener that calls handler function stored in ref
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const eventListener = ()=>savedHandler.current && savedHandler.current();
        // Add event listener
        element && element.addEventListener(eventName, eventListener, options);
        // Remove event listener on cleanup
        return ()=>{
            element && element.removeEventListener(eventName, eventListener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
};
const $f7f992598fb2ad9d$export$30416a530a92ed77 = (initialfirst, initialSecond, callback)=>{
    const triggerRef = (0, $eJOHy.useRef)(initialfirst);
    const cardRef = (0, $eJOHy.useRef)(initialSecond);
    const timeoutId = (0, $eJOHy.useRef)(null);
    const setStateDelayed = (0, $fAZgY.useCallbackWithCondition)(()=>{
        if (timeoutId.current) // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(()=>{
            if (!triggerRef.current && !cardRef.current) callback();
        }, 400);
    }, [
        callback
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-platform-2'));
    const setTriggerRef = (0, $fAZgY.useCallbackWithCondition)(()=>{
        triggerRef.current = true;
        setStateDelayed();
    }, [
        setStateDelayed
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-platform-2'));
    const unsetTriggerRef = (0, $fAZgY.useCallbackWithCondition)(()=>{
        triggerRef.current = false;
        setStateDelayed();
    }, [
        setStateDelayed
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-platform-2'));
    const setCardRef = (0, $fAZgY.useCallbackWithCondition)(()=>{
        cardRef.current = true;
        setStateDelayed();
    }, [
        setStateDelayed
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-platform-2'));
    const unsetCardRef = (0, $fAZgY.useCallbackWithCondition)(()=>{
        cardRef.current = false;
        setStateDelayed();
    }, [
        setStateDelayed
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-platform-2'));
    const getTimeoutId = ()=>timeoutId.current;
    return {
        setTriggerRef: setTriggerRef,
        setCardRef: setCardRef,
        unsetTriggerRef: unsetTriggerRef,
        unsetCardRef: unsetCardRef,
        getTimeoutId: // @ts-expect-error - TS2322 - Type '() => unknown' is not assignable to type '() => number | null'.
        getTimeoutId
    };
};
const $f7f992598fb2ad9d$export$a9fe23cfa43a7b55 = (referenceElement)=>{
    if (referenceElement && typeof referenceElement.id === 'string' && referenceElement.id.indexOf('issue_summary') > -1) return 'left-start';
    return 'top-start';
};

});


parcelRegister("eL3VJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad4ee23c910e8573$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $iyT45 = parcelRequire("iyT45");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad4ee23c910e8573$export$2e2bcd8739ae039 = (api)=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $iyT45.loadBridgeWeak)({
        name: 'jira/profilecard/bridge'
    }).then((bridge)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        bridge(api);
    });
};

});
parcelRegister("iyT45", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $f6004e9afa2128c3$export$3cefda82396756a1);

var $6M1XZ = parcelRequire("6M1XZ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $f6004e9afa2128c3$var$pollingSingleton = null;
const $f6004e9afa2128c3$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $f6004e9afa2128c3$var$pollingSingleton ?? (0, $6M1XZ.createPollingCollection)((v)=>window.require(v), 100);
    $f6004e9afa2128c3$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("6M1XZ", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $0a667df7ad6c937e$export$f163446a982a8077);

var $gRw8I = parcelRequire("gRw8I");

var $2oJXr = parcelRequire("2oJXr");
const $0a667df7ad6c937e$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gRw8I.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $2oJXr.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $2oJXr.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("2oJXr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b7015c609345acf$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $3b7015c609345acf$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $3b7015c609345acf$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $3b7015c609345acf$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




const $55746a299dc1482c$export$a1455360a24a2234 = 'profileCardNextLegacyView';

parcelRegister("jSFBS", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaa2152a6b8020a3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kxrV4 = parcelRequire("kxrV4");

var $22c3C = parcelRequire("22c3C");
var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $38H79 = parcelRequire("38H79");
const $eaa2152a6b8020a3$export$6f67c636e2e30540 = ({ cloudId: cloudId, profileClient: profileClient, accountId: accountId, actions: actions, onProfileClick: onProfileClick })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const onReportingLinesClick = onProfileClick ? (user)=>onProfileClick(user.accountIdentifier) : undefined;
    const profileCardProps = {
        userId: accountId,
        cloudId: cloudId,
        actions: (0, $38H79.isCustomerAccount)(accountId) ? [] : actions,
        resourceClient: profileClient,
        onReportingLinesClick: onReportingLinesClick
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kxrV4.default), {
        ...profileCardProps,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        addFlag: (flag)=>{
            const flagId = (0, $hrodw.toFlagId)(flag.id);
            showFlag({
                id: flagId,
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $22c3C.default), {
                        ...flag,
                        onDismissed: ()=>{
                            dismissFlag(flagId);
                        },
                        messageId: `profilecard-next.ui.profilecard-legacy.profilecard-resourced.ak-flag.${flagId}`,
                        messageType: "transactional",
                        ...props
                    })
            });
        }
    });
};
const $eaa2152a6b8020a3$var$ProfileCardResourced = $eaa2152a6b8020a3$export$6f67c636e2e30540;
var $eaa2152a6b8020a3$export$2e2bcd8739ae039 = $eaa2152a6b8020a3$var$ProfileCardResourced;

});
parcelRegister("kxrV4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a9b9ff03c21340b$export$2e2bcd8739ae039);
// Avoid exporting new components in this file as they will affect the bundle size of all consumers
// importing directly from @atlaskit/profilecard.

var $9PyvN = parcelRequire("9PyvN");




var $gEn3C = parcelRequire("gEn3C");



var $c8mEv = parcelRequire("c8mEv");

var $39Fdj = parcelRequire("39Fdj");


var $lcuMI = parcelRequire("lcuMI");

var $gVW5o = parcelRequire("gVW5o");

var $gt9J0 = parcelRequire("gt9J0");

var $6a9b9ff03c21340b$export$2e2bcd8739ae039 = (0, $c8mEv.default);

});
parcelRegister("gEn3C", function(module, exports) {

$parcel$export(module.exports, "TeamProfileCard", () => $7703b0ae3adb3ff9$export$5be70f0332137d36);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $ftN6c = parcelRequire("ftN6c");

var $gqBnP = parcelRequire("gqBnP");

var $806LH = parcelRequire("806LH");

var $f58rc = parcelRequire("f58rc");

var $lXcOw = parcelRequire("lXcOw");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $6djmC = parcelRequire("6djmC");
var $46R8N = parcelRequire("46R8N");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $6qS8z = parcelRequire("6qS8z");

var $PNL4D = parcelRequire("PNL4D");
var $6MZ4F = parcelRequire("6MZ4F");

var $2EPX4 = parcelRequire("2EPX4");

var $kVKdq = parcelRequire("kVKdq");

var $j1svA = parcelRequire("j1svA");

var $cn8gg = parcelRequire("cn8gg");

var $24Kc0 = parcelRequire("24Kc0");
const $7703b0ae3adb3ff9$var$noop = ()=>{};
const $7703b0ae3adb3ff9$var$styles = {
    wrapperStyles: "_2rkopd34 _v564nm7n _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bsb1gwv _1ul95x59 _4t3i1wug",
    containerStyles: "_otyrpxbi",
    avatarImageStyles: "_kqswstnw _18u01ejb",
    headerImageStyles: "_5ral1dfr _s7n4jp4b _4t3i53f4 _1bsb1osq",
    newHeaderImageStyles: "_5ral1dfr _s7n4jp4b _4t3i12am _1bsb1osq",
    teamInformationStyles: "_18u01ejb _19pku2gc _2hwx1ejb",
    teamConnectionHeaderStyles: "_18u0u2gc _2hwxu2gc _c71lx2si _18m91wug",
    teamConnectionContainerStyles: "_18u0u2gc _2hwxu2gc",
    teamConnectionStyles: "_18u0u2gc _2hwxu2gc",
    teamConnectionItemsStyles: "_c71lx2si _18m91wug",
    connectionTitleStyles: "_11c81vhk _18u0pxbi _19pk1b66 _2hwxpxbi _otyr12x7 _syaz1gjq",
    teamAppTileStyles: "_18u01wug _4t3i7vkz _1bsb7vkz",
    viewProfileContainerStyles: "_4cvr1h6o _uwhke4h9 _15a5nqa1 _1i53muej _19bv1ejb _u5f31ejb",
    viewProfileButtonStyles: "_2rkoiti9 _189ee4h9 _1dqonqa1 _1h6dmuej _bfhk1w7a _syaz1gjq _1bsb1osq _4t3i1ul9 _19pkpxbi"
};
const $7703b0ae3adb3ff9$var$TeamCardWrapper = ({ id: id, children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $7703b0ae3adb3ff9$var$styles.wrapperStyles,
        testId: `team-card-${id}`,
        children: children
    });
const $7703b0ae3adb3ff9$var$HeaderImage = ({ srcUrl: srcUrl })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "img",
        src: srcUrl,
        xcss: $7703b0ae3adb3ff9$var$styles.headerImageStyles,
        testId: "profile-header-image",
        alt: "team-header-image"
    });
const $7703b0ae3adb3ff9$export$5be70f0332137d36 = ({ containerId: containerId, teamId: teamId, displayName: displayName, description: description, avatarImageUrl: avatarImageUrl, headerImageUrl: headerImageUrl, memberAvatars: memberAvatars, memberCount: memberCount, cloudId: cloudId, userId: userId, isVerified: isVerified, teamProfileUrl: teamProfileUrl, ...props })=>{
    const { teamContainers: teamContainers, loading: loading } = (0, $6MZ4F.useTeamContainers)(teamId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // Ensure that the current container is not the only connection for this team before showing the "Where we work" section
    const hasOtherTeamConnections = (0, $eJOHy.useMemo)(()=>teamContainers.filter((tc)=>tc.id === containerId).length < teamContainers.length, [
        containerId,
        teamContainers
    ]);
    // TODO: set isNewLayout to be true when clean up 'team-bi-directional-container-connection' experiment
    const isNewLayout = Boolean(props.isKudosEnabled || props.otherActions);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (createAnalyticsEvent) (0, $2EPX4.fireEvent)(createAnalyticsEvent, {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'viewTeamProfileButton',
            attributes: {}
        });
        if (!isNewLayout) window.open(teamProfileUrl, '_blank');
    }, [
        createAnalyticsEvent,
        teamProfileUrl,
        isNewLayout
    ]);
    if (isNewLayout) return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
        xcss: $7703b0ae3adb3ff9$var$styles.wrapperStyles,
        testId: `team-card-${teamId}`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "img",
                src: headerImageUrl,
                xcss: $7703b0ae3adb3ff9$var$styles.newHeaderImageStyles,
                testId: "profile-header-image",
                alt: "team-header-image"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.200",
                xcss: $7703b0ae3adb3ff9$var$styles.containerStyles,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                        spread: "space-between",
                        alignBlock: "center",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: $7703b0ae3adb3ff9$var$styles.avatarImageStyles,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6qS8z.default), {
                                size: "medium",
                                src: avatarImageUrl
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                        xcss: $7703b0ae3adb3ff9$var$styles.teamInformationStyles,
                        space: "space.200",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                                        space: "space.050",
                                        children: [
                                            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                                                alignBlock: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                                                        size: "medium",
                                                        children: displayName
                                                    }),
                                                    isVerified && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lXcOw.VerifiedTeamIcon), {
                                                        showTooltip: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                                color: "color.text.subtlest",
                                                children: typeof memberCount === 'string' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                                    defaultMessage: "Contributing team \u2022 {memberCount} members",
                                                    values: {
                                                        memberCount: memberCount
                                                    },
                                                    id: "people-and-teams.team-profile-card.large-member-count"
                                                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                                    defaultMessage: "Contributing team \u2022 {count, plural, one {# member} other {# members}}",
                                                    values: {
                                                        count: memberCount
                                                    },
                                                    id: "people-and-teams.team-profile-card.member-count"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j1svA.TeamActions), {
                                        cloudId: cloudId,
                                        teamId: teamId,
                                        ...props
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gqBnP.default), {
                                    appearance: "stack",
                                    data: memberAvatars
                                })
                            }),
                            description && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                color: "color.text",
                                maxLines: 3,
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                        xcss: $7703b0ae3adb3ff9$var$styles.teamConnectionStyles,
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                                xcss: $7703b0ae3adb3ff9$var$styles.connectionTitleStyles,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                    defaultMessage: "Team links",
                                    id: "people-and-teams.team-profile-card.team-connections"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                                xcss: $7703b0ae3adb3ff9$var$styles.teamConnectionItemsStyles,
                                children: [
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f58rc.default), {
                                        href: teamProfileUrl,
                                        target: "_blank",
                                        onClick: onClick,
                                        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                            defaultMessage: "Team profile",
                                            id: "people-and-teams.team-profile-card.team-profile-description"
                                        }),
                                        iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6qS8z.default), {
                                            size: "small",
                                            src: avatarImageUrl
                                        }),
                                        iconAfter: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                                            as: "img",
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($kVKdq))),
                                            testId: "team-app-tile",
                                            alt: "team-app-tile",
                                            xcss: $7703b0ae3adb3ff9$var$styles.teamAppTileStyles
                                        }),
                                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                            maxLines: 1,
                                            color: "color.text",
                                            children: displayName
                                        })
                                    }),
                                    (loading || hasOtherTeamConnections) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $PNL4D.TeamContainers), {
                                        teamId: teamId,
                                        onAddAContainerClick: $7703b0ae3adb3ff9$var$noop,
                                        userId: userId,
                                        cloudId: cloudId,
                                        components: {
                                            ContainerCard: (0, $cn8gg.NewTeamConnections),
                                            TeamContainersSkeleton: (0, $24Kc0.TeamContainersSkeleton)
                                        },
                                        filterContainerId: containerId,
                                        isDisplayedOnProfileCard: true,
                                        maxNumberOfContainersToShow: loading ? 0 : 9
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)($7703b0ae3adb3ff9$var$TeamCardWrapper, {
        id: teamId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($7703b0ae3adb3ff9$var$HeaderImage, {
                srcUrl: headerImageUrl
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.200",
                xcss: $7703b0ae3adb3ff9$var$styles.containerStyles,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                        spread: "space-between",
                        alignBlock: "center",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: $7703b0ae3adb3ff9$var$styles.avatarImageStyles,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6qS8z.default), {
                                size: "medium",
                                src: avatarImageUrl
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                        xcss: $7703b0ae3adb3ff9$var$styles.teamInformationStyles,
                        space: "space.200",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                                space: "space.050",
                                children: [
                                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                                        alignBlock: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                                                size: "medium",
                                                children: displayName
                                            }),
                                            isVerified && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lXcOw.VerifiedTeamIcon), {
                                                showTooltip: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                        color: "color.text.subtlest",
                                        children: typeof memberCount === 'string' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                            defaultMessage: "Contributing team \u2022 {memberCount} members",
                                            values: {
                                                memberCount: memberCount
                                            },
                                            id: "people-and-teams.team-profile-card.large-member-count"
                                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                            defaultMessage: "Contributing team \u2022 {count, plural, one {# member} other {# members}}",
                                            values: {
                                                count: memberCount
                                            },
                                            id: "people-and-teams.team-profile-card.member-count"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gqBnP.default), {
                                    appearance: "stack",
                                    data: memberAvatars
                                })
                            }),
                            description && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                color: "color.text",
                                maxLines: 3,
                                children: description
                            })
                        ]
                    }),
                    (loading || hasOtherTeamConnections) && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                        xcss: hasOtherTeamConnections ? $7703b0ae3adb3ff9$var$styles.teamConnectionHeaderStyles : $7703b0ae3adb3ff9$var$styles.teamConnectionContainerStyles,
                        children: [
                            hasOtherTeamConnections && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                                xcss: $7703b0ae3adb3ff9$var$styles.connectionTitleStyles,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                    defaultMessage: "Where we work",
                                    id: "people-and-teams.team-profile-card.team-connections-header"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $PNL4D.TeamContainers), {
                                teamId: teamId,
                                onAddAContainerClick: $7703b0ae3adb3ff9$var$noop,
                                userId: userId,
                                cloudId: cloudId,
                                components: {
                                    ContainerCard: (0, $cn8gg.TeamConnections),
                                    TeamContainersSkeleton: (0, $24Kc0.TeamContainersSkeleton)
                                },
                                filterContainerId: containerId,
                                isDisplayedOnProfileCard: true
                            })
                        ]
                    }),
                    teamProfileUrl && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $78OnL.default), {
                        xcss: $7703b0ae3adb3ff9$var$styles.viewProfileContainerStyles,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                            onClick: onClick,
                            xcss: $7703b0ae3adb3ff9$var$styles.viewProfileButtonStyles,
                            testId: "view-profile-button",
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                defaultMessage: "View profile",
                                id: "people-and-teams.team-profile-card.view-profile"
                            })
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("lXcOw", function(module, exports) {

$parcel$export(module.exports, "VerifiedTeamIcon", () => $c2242de582b8e66d$export$d7949f68d31e5edd);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $acRfo = parcelRequire("acRfo");

var $6REzD = parcelRequire("6REzD");

var $k71qx = parcelRequire("k71qx");

var $6dApG = parcelRequire("6dApG");
const $c2242de582b8e66d$export$d7949f68d31e5edd = ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $6dApG.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acRfo))), {
                    color: "var(--ds-icon-accent-blue, #1D7AFC)",
                    LEGACY_size: "medium",
                    label: tooltipContent,
                    spacing: "spacious",
                    LEGACY_fallbackIcon: (0, $6REzD.default)
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acRfo))), {
        color: "var(--ds-icon-accent-blue, #1D7AFC)",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: label,
        LEGACY_fallbackIcon: (0, $6REzD.default)
    });
};

});
parcelRegister("acRfo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e3a26defb7fafbfaa404238ab66b0242>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76e454285004b3dd$var$_react = $76e454285004b3dd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $76e454285004b3dd$var$_baseNew = $76e454285004b3dd$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $76e454285004b3dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
Filled status icons provide higher visual contrast draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76e454285004b3dd$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $76e454285004b3dd$var$_react.default.createElement($76e454285004b3dd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.85.444a1.713 1.713 0 0 1 2.301 0L10.3 1.486a.2.2 0 0 0 .15.055L12 1.48a1.71 1.71 0 0 1 1.762 1.479l.21 1.537a.2.2 0 0 0 .081.139l1.226.95c.696.54.87 1.52.4 2.266l-.828 1.312a.2.2 0 0 0-.027.158l.328 1.516a1.713 1.713 0 0 1-1.151 1.993l-1.477.474a.2.2 0 0 0-.123.103l-.723 1.372a1.713 1.713 0 0 1-2.162.787l-1.435-.587a.2.2 0 0 0-.161 0l-1.436.587a1.713 1.713 0 0 1-2.162-.787l-.723-1.372a.22.22 0 0 0-.124-.103L2 12.83a1.713 1.713 0 0 1-1.15-1.993l.327-1.516a.2.2 0 0 0-.027-.158L.322 7.852a1.713 1.713 0 0 1 .4-2.266l1.225-.95a.2.2 0 0 0 .081-.14l.21-1.536a1.71 1.71 0 0 1 1.763-1.48l1.55.06a.2.2 0 0 0 .15-.055zm-.1 9.384L4.826 7.519l-1.152.961 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$76e454285004b3dd$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $76e454285004b3dd$var$_default = module.exports.default = $76e454285004b3dd$var$StatusVerifiedIcon;

});

parcelRegister("6REzD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d20d54ab5dbe4363$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $d20d54ab5dbe4363$var$VerifiedIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.6666 6.65507C17.7592 4.89362 15.2407 4.89362 14.3332 6.65507C13.7879 7.7135 12.5577 8.22306 11.4237 7.86022C9.53648 7.25639 7.75565 9.03721 8.35949 10.9244C8.72232 12.0584 8.21276 13.2886 7.15434 13.8339C5.39289 14.7414 5.39289 17.2599 7.15434 18.1674C8.21276 18.7127 8.72232 19.9429 8.35949 21.0769C7.75565 22.9641 9.53648 24.7449 11.4237 24.1411C12.5577 23.7783 13.7879 24.2878 14.3332 25.3462C15.2407 27.1077 17.7592 27.1077 18.6666 25.3462C19.212 24.2878 20.4421 23.7783 21.5761 24.1411C23.4634 24.7449 25.2442 22.9641 24.6404 21.0769C24.2775 19.9429 24.7871 18.7127 25.8455 18.1674C27.607 17.2599 27.607 14.7414 25.8455 13.8339C24.7871 13.2886 24.2775 12.0584 24.6404 10.9244C25.2442 9.03721 23.4634 7.25639 21.5761 7.86022C20.4421 8.22306 19.212 7.7135 18.6666 6.65507ZM20.7898 12.7002L20.8932 12.7923C21.323 13.2221 21.3537 13.8998 20.9853 14.365L20.8932 14.4684L16.1524 19.2091C15.7226 19.6389 15.0449 19.6696 14.5797 19.3012L14.4764 19.2091L12.106 16.8388C11.6431 16.3759 11.6431 15.6255 12.106 15.1627C12.5358 14.7329 13.2135 14.7022 13.6787 15.0706L13.7821 15.1627L15.3146 16.6944L19.2171 12.7923C19.6469 12.3625 20.3246 12.3318 20.7898 12.7002Z",
            fill: "currentColor"
        })
    });
/**
 * __VerifiedIcon__
 */ const $d20d54ab5dbe4363$var$VerifiedIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $d20d54ab5dbe4363$var$VerifiedIconGlyph
    });
var $d20d54ab5dbe4363$export$2e2bcd8739ae039 = $d20d54ab5dbe4363$var$VerifiedIcon;

});

parcelRegister("6dApG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $369d053bcf2cee48$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $369d053bcf2cee48$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
        defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
        description: 'Tooltip text for the verified team icon'
    }
});

});


parcelRegister("6qS8z", function(module, exports) {

$parcel$export(module.exports, "default", () => $502b93618fdc9c00$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");


var $6qfsx = parcelRequire("6qfsx");

var $kQ8ft = parcelRequire("kQ8ft");
const $502b93618fdc9c00$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`;
const $502b93618fdc9c00$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $7bb4c1736002a04a$export$7c87d337fb91a97d)})`;
function $502b93618fdc9c00$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', ...props }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
        appearance: (0, $kQ8ft.isSquareIcon)(src) ? 'square' : 'circle',
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6qfsx.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId
        })
    });
}

});
var $7bb4c1736002a04a$exports = {};

$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';

parcelRegister("6qfsx", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $deb06dadb11ac687$export$ac3673635a5387be);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $2TCFC = parcelRequire("2TCFC");
var $iwbbq = parcelRequire("iwbbq");

var $hxN6p = parcelRequire("hxN6p");

var $9HVF4 = parcelRequire("9HVF4");

var $eGOwo = parcelRequire("eGOwo");


var $efgFx = parcelRequire("efgFx");

var $3VLDr = parcelRequire("3VLDr");
function $deb06dadb11ac687$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $deb06dadb11ac687$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`;
const $deb06dadb11ac687$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $7bb4c1736002a04a$export$7c87d337fb91a97d)})`;
// used in a size calculation so can't be a token. Without this the avatar looks very squished
const $deb06dadb11ac687$var$ICON_PADDING = 4;
const $deb06dadb11ac687$var$avatarDefaultIconStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    backgroundColor: $deb06dadb11ac687$var$ICON_COLOR,
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
});
const $deb06dadb11ac687$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $deb06dadb11ac687$var$nestedAvatarStyles = Object.entries((0, $2TCFC.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $1NIU8.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`,
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: `${size - $deb06dadb11ac687$var$ICON_PADDING}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: `${size - $deb06dadb11ac687$var$ICON_PADDING}px`
            }
        })
    };
}, {});
const $deb06dadb11ac687$var$avatarImageStyles = {
    name: "n68006",
    styles: "display:flex;flex:1 1 100%;width:100%;height:100%"
};
const $deb06dadb11ac687$export$9cfabd93718c0a2e = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    // If src changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        if ((0, $eGOwo.fg)('enable-team-avatar-switch')) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $efgFx.FallbackAvatar), {
            "aria-label": alt,
            width: $deb06dadb11ac687$var$SIZES[size],
            height: $deb06dadb11ac687$var$SIZES[size],
            "data-testid": testId
        });
        return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: [
                $deb06dadb11ac687$var$avatarDefaultIconStyles,
                $deb06dadb11ac687$var$nestedAvatarStyles[size]
            ]
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hxN6p))), {
            label: alt,
            color: $deb06dadb11ac687$var$ICON_BACKGROUND,
            LEGACY_secondaryColor: $deb06dadb11ac687$var$ICON_COLOR,
            testId: testId && `${testId}--team`,
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9HVF4)))
        }));
    }
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $iwbbq.AvatarContent), null, /*#__PURE__*/ (0, $1NIU8.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        css: $deb06dadb11ac687$var$avatarImageStyles,
        onError: ()=>setHasImageErrored(true)
    }));
};
const $deb06dadb11ac687$export$ac3673635a5387be = (props)=>{
    if ((0, $eGOwo.fg)('team-avatar-radii')) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3VLDr.TeamAvatarImage), props);
    return /*#__PURE__*/ (0, $1NIU8.jsx)($deb06dadb11ac687$export$9cfabd93718c0a2e, props);
};

});
parcelRegister("2TCFC", function(module, exports) {

$parcel$export(module.exports, "AVATAR_SIZES", () => $db6435c31362d4b0$export$9a270941bcff7e77);
$parcel$export(module.exports, "AVATAR_RADIUS", () => $db6435c31362d4b0$export$e6da6efe4d1a5c9b);
$parcel$export(module.exports, "BORDER_WIDTH", () => $db6435c31362d4b0$export$e2bd4c1faded7921);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $IW7jS = parcelRequire("IW7jS");
const $db6435c31362d4b0$export$9a270941bcff7e77 = {
    xsmall: (0, $IW7jS.gridSize)() * 2,
    small: (0, $IW7jS.gridSize)() * 3,
    medium: (0, $IW7jS.gridSize)() * 4,
    large: (0, $IW7jS.gridSize)() * 5,
    xlarge: (0, $IW7jS.gridSize)() * 12,
    xxlarge: (0, $IW7jS.gridSize)() * 16
};
const $db6435c31362d4b0$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
const $db6435c31362d4b0$export$e2bd4c1faded7921 = 2;
const $db6435c31362d4b0$export$89a980dfdf90df51 = 0.9;
const $db6435c31362d4b0$export$3c061e31594ebabe = '--avatar-background-color';
const $db6435c31362d4b0$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
const $db6435c31362d4b0$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});

parcelRegister("9HVF4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7114db95708449c8$var$_react = $7114db95708449c8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $7114db95708449c8$var$_peopleGroup = $7114db95708449c8$var$_interopRequireDefault((parcelRequire("hxN6p")));
function $7114db95708449c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7114db95708449c8$var$PeopleIcon = (props)=>/*#__PURE__*/ $7114db95708449c8$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $7114db95708449c8$var$_peopleGroup.default
    }));
$7114db95708449c8$var$PeopleIcon.displayName = 'PeopleIcon';
var $7114db95708449c8$var$_default = module.exports.default = $7114db95708449c8$var$PeopleIcon;

});

parcelRegister("efgFx", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $9a97cfaf5fcee5b8$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $9a97cfaf5fcee5b8$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $9a97cfaf5fcee5b8$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $9a97cfaf5fcee5b8$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});

parcelRegister("3VLDr", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $a603c42947de9ccd$export$ac3673635a5387be);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jGMLA = parcelRequire("jGMLA");
const $a603c42947de9ccd$var$boxShadowCssVar = '--avatar-box-shadow';
const $a603c42947de9ccd$var$bgColorCssVar = '--avatar-bg-color';
/**
 * We need to maintan the container styles manually until Avatar provides the correct border radius.
 * After that we can return to wrapping in <AvatarContent> rather than span
 */ const $a603c42947de9ccd$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw",
    circle: "_2rko1q5u _14mj1q5u",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
const $a603c42947de9ccd$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpuw83z _ez1ykb7n _gcm11et6 _eeh8kb7n _jlxit94y"
};
const $a603c42947de9ccd$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $a603c42947de9ccd$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $a603c42947de9ccd$var$borderRadiusMap = {
    xsmall: "_2rko1y44",
    small: "_2rkoi2wt",
    medium: "_2rkopd34",
    large: "_2rko19bv",
    xlarge: "_2rko1tcg",
    xxlarge: "_2rkozwfg"
};
const $a603c42947de9ccd$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $a603c42947de9ccd$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    // If src changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jGMLA.FallbackAvatar), {
        "aria-label": alt,
        width: $a603c42947de9ccd$var$SIZES[size],
        height: $a603c42947de9ccd$var$SIZES[size],
        "data-testid": testId
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $hcewu.default)([
            $a603c42947de9ccd$var$unboundStyles.root,
            $a603c42947de9ccd$var$containerStyles.root,
            $a603c42947de9ccd$var$borderRadiusMap[size],
            $a603c42947de9ccd$var$widthHeightMap[size]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            src: src,
            alt: alt,
            "data-testId": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $hcewu.default)([
                $a603c42947de9ccd$var$avatarImageStyles.image
            ])
        })
    });
};

});
parcelRegister("jGMLA", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $761169972cdf4da8$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $761169972cdf4da8$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $761169972cdf4da8$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $761169972cdf4da8$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});



parcelRegister("kQ8ft", function(module, exports) {

$parcel$export(module.exports, "isSquareIcon", () => $6612c987a73983c4$export$d5a05ffb65695bc0);

var $eGOwo = parcelRequire("eGOwo");
function $6612c987a73983c4$export$d5a05ffb65695bc0(src) {
    if (!src) return false;
    try {
        const url = new URL(src);
        const host = url.host;
        const path = url.pathname;
        if ((host.startsWith('ptc-directory-sited-static') || host.startsWith('teams-directory-frontend')) && path.includes('teams/avatars/v4') && (0, $eGOwo.fg)('enable-team-avatar-switch')) return true;
    } catch  {
    // The src wasn't a URL, so it's obviously not the refreshed avatar.
    }
    return false;
}

});


parcelRegister("PNL4D", function(module, exports) {

$parcel$export(module.exports, "TeamContainers", () => $45dad054b8df0869$export$73c2d2b9b49926f5);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");
var $kDaaB = parcelRequire("kDaaB");

var $ftN6c = parcelRequire("ftN6c");

var $5CSKW = parcelRequire("5CSKW");

var $59rsN = parcelRequire("59rsN");

var $956it = parcelRequire("956it");

var $eGOwo = parcelRequire("eGOwo");

var $aewX5 = parcelRequire("aewX5");
var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");

var $aYtlL = parcelRequire("aYtlL");
var $fVapN = parcelRequire("fVapN");

var $7eAIS = parcelRequire("7eAIS");
var $301JM = parcelRequire("301JM");

var $5oAZz = parcelRequire("5oAZz");


var $8HcYM = parcelRequire("8HcYM");

var $7RSVt = parcelRequire("7RSVt");

var $1jIHx = parcelRequire("1jIHx");

var $8Xvdz = parcelRequire("8Xvdz");

var $j29cm = parcelRequire("j29cm");

var $jEhCW = parcelRequire("jEhCW");

var $6MZ4F = parcelRequire("6MZ4F");

var $127OW = parcelRequire("127OW");

var $bXnEP = parcelRequire("bXnEP");

var $i9St2 = parcelRequire("i9St2");

var $8HUCq = parcelRequire("8HUCq");

var $3Koe6 = parcelRequire("3Koe6");

var $cW3YY = parcelRequire("cW3YY");

var $89pUB = parcelRequire("89pUB");
const $45dad054b8df0869$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`;
const $45dad054b8df0869$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $7bb4c1736002a04a$export$7c87d337fb91a97d)})`;
const $45dad054b8df0869$export$33f8090aba665a84 = 4;
const $45dad054b8df0869$var$containerTypeMap = {
    Confluence: (0, $5oAZz.ContainerType).CONFLUENCE_SPACE,
    Jira: (0, $5oAZz.ContainerType).JIRA_PROJECT,
    Loom: (0, $5oAZz.ContainerType).LOOM_SPACE
};
const $45dad054b8df0869$var$containerTypeToTextMap = {
    Confluence: 'Confluence space',
    Jira: 'Jira project',
    Loom: 'Loom space'
};
const $45dad054b8df0869$export$73c2d2b9b49926f5 = ({ teamId: teamId, onAddAContainerClick: onAddAContainerClick, onEditContainerClick: onEditContainerClick, onRequestedContainerTimeout: onRequestedContainerTimeout = ()=>{}, components: components, userId: userId, cloudId: cloudId, filterContainerId: filterContainerId, isDisplayedOnProfileCard: isDisplayedOnProfileCard, maxNumberOfContainersToShow: maxNumberOfContainersToShow = $45dad054b8df0869$export$33f8090aba665a84, addFlag: addFlag })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { unlinkError: unlinkError, refetchTeamContainers: refetchTeamContainers } = (0, $6MZ4F.useTeamContainers)(teamId);
    const { teamLinks: teamLinks, removeTeamLink: removeTeamLink, iconsLoading: iconsLoading, iconHasLoaded: iconHasLoaded, isLoading: linksLoading } = (0, $127OW.useTeamLinksAndContainers)(teamId, true);
    const { requestedContainers: requestedContainers } = (0, $jEhCW.useRequestedContainers)({
        teamId: teamId,
        cloudId: cloudId,
        onRequestedContainerTimeout: onRequestedContainerTimeout
    });
    const [_, actions] = (0, $6MZ4F.useTeamContainersHook)();
    const [showMore, setShowMore] = (0, $eJOHy.useState)(false);
    const [isDisconnectDialogOpen, setIsDisconnectDialogOpen] = (0, $eJOHy.useState)(false);
    const [selectedContainerDetails, setSelectedContainerDetails] = (0, $eJOHy.useState)();
    const [filteredTeamLinks, setFilteredTeamLinks] = (0, $eJOHy.useState)(teamLinks);
    const [showAddContainer, setShowAddContainer] = (0, $eJOHy.useState)({
        Jira: false,
        Confluence: false,
        Loom: false,
        WebLink: false
    });
    const [containersBeingCreated, setContainersBeingCreated] = (0, $eJOHy.useState)({
        jira: false,
        confluence: false,
        loom: false
    });
    const { fireOperationalEvent: fireOperationalEvent, fireTrackEvent: fireTrackEvent } = (0, $1jIHx.usePeopleAndTeamAnalytics)();
    const { data: productPermissions, loading: productPermissionIsLoading } = (0, $fVapN.useProductPermissions)({
        userId: userId,
        cloudId: cloudId,
        permissionsToCheck: {
            jira: [
                'CREATE_PROJECT',
                'manage',
                'write'
            ],
            loom: [
                'write',
                'manage'
            ],
            confluence: [
                'write',
                'manage'
            ]
        },
        options: {
            enabled: (0, $eGOwo.fg)('migrate-product-permissions')
        }
    });
    const { data: productPermissionsOld, loading: productPermissionIsLoadingOld } = (0, $j29cm.useProductPermissions)({
        userId: userId,
        cloudId: cloudId
    }, {
        enabled: !(0, $eGOwo.fg)('migrate-product-permissions')
    });
    const hasPermissionToCreateContainers = (0, $eJOHy.useMemo)(()=>{
        if (!productPermissions) return false;
        if ((0, $eGOwo.fg)('migrate-product-permissions')) return (0, $aYtlL.hasProductPermission)(productPermissions, 'jira', [
            'CREATE_PROJECT'
        ]) || //@todo: fix in PTC-12660
        (0, $aYtlL.hasProductPermission)(productPermissions, 'confluence', [
            'write'
        ]) || (0, $aYtlL.hasProductPermission)(productPermissions, 'loom', [
            'write'
        ]);
        return false;
    }, [
        productPermissions
    ]);
    const isCreateContainerExperimentEnabled = (0, $eJOHy.useMemo)(()=>{
        return hasPermissionToCreateContainers && (0, $59rsN.default).initializeCompleted() && (0, $59rsN.default).getExperimentValue('teams_app_auto_container_creation', 'isEnabled', false);
    }, [
        hasPermissionToCreateContainers
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isDisplayedOnProfileCard && filterContainerId) setFilteredTeamLinks(teamLinks.filter((container)=>container.id !== filterContainerId && !requestedContainers.includes(container.type)));
        else setFilteredTeamLinks(teamLinks);
    }, [
        teamLinks,
        isDisplayedOnProfileCard,
        filterContainerId,
        requestedContainers
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const containersToCheck = filteredTeamLinks;
        if (containersToCheck.length > maxNumberOfContainersToShow || isDisplayedOnProfileCard) setShowAddContainer({
            Jira: false,
            Confluence: false,
            Loom: false,
            WebLink: false
        });
        else {
            const containerExists = (type)=>containersToCheck.some((container)=>container.type === type);
            const containerRequested = (type)=>requestedContainers.includes(type);
            const showContainer = (containerExists, isRequesting, product, permissionIds)=>{
                if (containerExists || isRequesting) return false;
                if ((0, $eGOwo.fg)('migrate-product-permissions')) return productPermissions && (0, $aYtlL.hasProductPermission)(productPermissions, product, permissionIds) || false;
                return productPermissionsOld && (0, $8Xvdz.hasProductPermission)(productPermissionsOld, product, permissionIds) || false;
            };
            setShowAddContainer({
                Jira: showContainer(containerExists('JiraProject'), containerRequested('JiraProject'), 'jira', isCreateContainerExperimentEnabled ? [
                    'CREATE_PROJECT'
                ] : []),
                Confluence: showContainer(containerExists('ConfluenceSpace'), containerRequested('ConfluenceSpace'), 'confluence', isCreateContainerExperimentEnabled ? [
                    'write'
                ] : []),
                Loom: showContainer(containerExists('LoomSpace'), containerRequested('LoomSpace'), 'loom', isCreateContainerExperimentEnabled ? [
                    'write'
                ] : []),
                WebLink: !containerExists('WebLink')
            });
        }
    }, [
        isDisplayedOnProfileCard,
        productPermissions,
        productPermissionsOld,
        filteredTeamLinks,
        maxNumberOfContainersToShow,
        requestedContainers,
        isCreateContainerExperimentEnabled
    ]);
    const handleShowMore = ()=>{
        setShowMore(!showMore);
    };
    const handleOpenDisconnectDialog = (0, $eJOHy.useCallback)((containerDetails)=>{
        setSelectedContainerDetails(containerDetails);
        setIsDisconnectDialogOpen(true);
        fireTrackEvent(createAnalyticsEvent, {
            action: (0, $1jIHx.AnalyticsAction).OPENED,
            actionSubject: 'unlinkContainerDialog',
            attributes: {
                teamId: teamId
            }
        });
    }, [
        createAnalyticsEvent,
        fireTrackEvent,
        teamId
    ]);
    const handleEditContainerClick = (0, $eJOHy.useCallback)((container)=>{
        if (container.type === 'WebLink' && onEditContainerClick) onEditContainerClick(container.id, container.link || '', container.name);
    }, [
        onEditContainerClick
    ]);
    const LinkedContainerCardComponent = components?.ContainerCard || (0, $cW3YY.TeamLinkCard);
    const handleDisconnect = (0, $eJOHy.useCallback)(async (containerId)=>{
        const removedContainer = filteredTeamLinks.find((container)=>container.id === containerId);
        if (removedContainer) await removeTeamLink(removedContainer);
        else await actions.unlinkTeamContainers(teamId, containerId);
        setIsDisconnectDialogOpen(false);
        if (unlinkError) fireOperationalEvent(createAnalyticsEvent, {
            action: (0, $1jIHx.AnalyticsAction).FAILED,
            actionSubject: 'teamContainerUnlinked'
        });
        else fireOperationalEvent(createAnalyticsEvent, {
            action: (0, $1jIHx.AnalyticsAction).SUCCEEDED,
            actionSubject: 'teamContainerUnlinked',
            attributes: {
                containerRemoved: {
                    containerId: removedContainer?.id,
                    container: removedContainer?.type
                },
                teamId: teamId
            }
        });
    }, [
        actions,
        createAnalyticsEvent,
        fireOperationalEvent,
        filteredTeamLinks,
        removeTeamLink,
        teamId,
        unlinkError
    ]);
    const handleCreateContainer = (0, $eJOHy.useCallback)(async (containerType)=>{
        setContainersBeingCreated({
            ...containersBeingCreated,
            [containerType.toLowerCase()]: true
        });
        try {
            const result = await (0, $301JM.teamsClient).createTeamContainers({
                teamId: teamId,
                containers: [
                    {
                        type: $45dad054b8df0869$var$containerTypeMap[containerType],
                        containerSiteId: cloudId
                    }
                ]
            });
            if (result.containersNotCreated.length === 0) {
                fireOperationalEvent(createAnalyticsEvent, {
                    action: (0, $1jIHx.AnalyticsAction).SUCCEEDED,
                    actionSubject: 'teamContainerCreate',
                    attributes: {
                        containerType: containerType,
                        teamId: teamId
                    }
                });
                refetchTeamContainers();
            } else {
                fireOperationalEvent(createAnalyticsEvent, {
                    action: (0, $1jIHx.AnalyticsAction).FAILED,
                    actionSubject: 'teamContainerCreate',
                    attributes: {
                        containerType: containerType,
                        teamId: teamId
                    }
                });
                addFlag?.((0, $89pUB.getCreateContainerTryAgainFlag)({
                    tryAgainAction: ()=>{
                        handleCreateContainer(containerType);
                    },
                    containerType: $45dad054b8df0869$var$containerTypeToTextMap[containerType]
                }));
            }
            setContainersBeingCreated({
                ...containersBeingCreated,
                [containerType.toLowerCase()]: false
            });
        } catch (error) {
            fireOperationalEvent(createAnalyticsEvent, {
                action: (0, $1jIHx.AnalyticsAction).FAILED,
                actionSubject: 'teamContainerCreate',
                attributes: {
                    containerType: containerType,
                    teamId: teamId
                }
            });
            if (error instanceof (0, $7eAIS.HttpError)) {
                if (error.status === 500) addFlag?.((0, $89pUB.getCreateContainerTryAgainFlag)({
                    tryAgainAction: ()=>{
                        handleCreateContainer(containerType);
                    },
                    containerType: $45dad054b8df0869$var$containerTypeToTextMap[containerType]
                }));
                else addFlag?.((0, $89pUB.getCreateContainerContactSupportFlag)());
            }
        }
    }, [
        containersBeingCreated,
        teamId,
        cloudId,
        fireOperationalEvent,
        createAnalyticsEvent,
        refetchTeamContainers,
        addFlag
    ]);
    const TeamContainersSkeletonComponent = components?.TeamContainersSkeleton || (0, $8HcYM.TeamContainersSkeleton);
    const hasNoPermissions = (0, $eJOHy.useMemo)(()=>{
        if ((0, $eGOwo.fg)('migrate-product-permissions')) return productPermissions && !(0, $aYtlL.hasProductPermission)(productPermissions, 'jira') && !(0, $aYtlL.hasProductPermission)(productPermissions, 'confluence') && !(0, $aYtlL.hasProductPermission)(productPermissions, 'loom');
        return productPermissionsOld && !(0, $8Xvdz.hasProductPermission)(productPermissionsOld, 'jira') && !(0, $8Xvdz.hasProductPermission)(productPermissionsOld, 'confluence') && !(0, $8Xvdz.hasProductPermission)(productPermissionsOld, 'loom');
    }, [
        productPermissions,
        productPermissionsOld
    ]);
    const hasNoContainers = (0, $eJOHy.useMemo)(()=>{
        return filteredTeamLinks.length === 0;
    }, [
        filteredTeamLinks
    ]);
    const isLoading = (0, $eJOHy.useMemo)(()=>{
        if (linksLoading) return true;
        if ((0, $eGOwo.fg)('migrate-product-permissions')) return productPermissionIsLoading;
        return productPermissionIsLoadingOld;
    }, [
        linksLoading,
        productPermissionIsLoading,
        productPermissionIsLoadingOld
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $gt9Am.jsx)(TeamContainersSkeletonComponent, {
        numberOfContainers: maxNumberOfContainersToShow
    });
    if (hasNoContainers && !isDisplayedOnProfileCard && hasNoPermissions) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Koe6.NoProductAccessState), {});
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $aewX5.default), {
                        templateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                        gap: isDisplayedOnProfileCard ? 'space.0' : 'space.100',
                        children: [
                            requestedContainers.map((containerType)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7RSVt.LinkedContainerCardSkeleton), {
                                    containerType: containerType
                                }, containerType)),
                            filteredTeamLinks.slice(0, maxNumberOfContainersToShow).map((container)=>{
                                return /*#__PURE__*/ (0, $gt9Am.jsx)(LinkedContainerCardComponent, {
                                    containerType: container.type,
                                    containerTypeProperties: container.containerTypeProperties,
                                    title: container.name,
                                    containerIcon: container.icon || undefined,
                                    link: container.link || undefined,
                                    containerId: container.id,
                                    iconsLoading: iconsLoading,
                                    iconHasLoaded: iconHasLoaded,
                                    onDisconnectButtonClick: ()=>handleOpenDisconnectDialog({
                                            containerId: container.id,
                                            containerType: container.type,
                                            containerName: container.name
                                        }),
                                    onEditLinkClick: ()=>handleEditContainerClick(container)
                                }, container.id);
                            }),
                            isCreateContainerExperimentEnabled ? (0, $i9St2.getAddContainerCardsWithCreate)({
                                showAddContainer: showAddContainer,
                                onAddAContainerClick: (e, containerType)=>{
                                    onAddAContainerClick(e, containerType);
                                },
                                containersLoading: containersBeingCreated
                            }) : (0, $bXnEP.getAddContainerCards)({
                                showAddContainer: showAddContainer,
                                onAddAContainerClick: onAddAContainerClick
                            }),
                            showMore && filteredTeamLinks.slice(maxNumberOfContainersToShow).map((container)=>{
                                return /*#__PURE__*/ (0, $gt9Am.jsx)(LinkedContainerCardComponent, {
                                    containerType: container.type,
                                    containerTypeProperties: container.containerTypeProperties,
                                    title: container.name,
                                    containerId: container.id,
                                    containerIcon: container.icon || undefined,
                                    link: container.link || undefined,
                                    iconsLoading: iconsLoading,
                                    iconHasLoaded: iconHasLoaded,
                                    onDisconnectButtonClick: ()=>handleOpenDisconnectDialog({
                                            containerId: container.id,
                                            containerType: container.type,
                                            containerName: container.name
                                        }),
                                    onEditLinkClick: ()=>handleEditContainerClick(container)
                                }, container.id);
                            })
                        ]
                    }),
                    filteredTeamLinks.length > maxNumberOfContainersToShow && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Wh6p.default), {
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                            appearance: "subtle",
                            onClick: handleShowMore,
                            children: showMore ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...$45dad054b8df0869$var$messages.showLess
                            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...$45dad054b8df0869$var$messages.showMore
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
                children: isDisconnectDialogOpen && selectedContainerDetails && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8HUCq.DisconnectDialogLazy), {
                    containerName: selectedContainerDetails.containerName,
                    containerType: selectedContainerDetails.containerType,
                    onClose: ()=>setIsDisconnectDialogOpen(false),
                    onDisconnect: ()=>handleDisconnect(selectedContainerDetails.containerId)
                })
            })
        ]
    });
};
const $45dad054b8df0869$var$messages = (0, $7qGN1.defineMessages)({
    showMore: {
        id: 'ptc-directory.team-profile-page.team-containers.show-more',
        defaultMessage: 'Show more',
        description: 'Button to show more containers'
    },
    showLess: {
        id: 'ptc-directory.team-profile-page.team-containers.show-less',
        defaultMessage: 'Show less',
        description: 'Button to show less containers'
    }
});

});
parcelRegister("aYtlL", function(module, exports) {

$parcel$export(module.exports, "hasProductPermission", () => $170137dcc4934d9a$export$a2eea90ce05a9f1c);
const $170137dcc4934d9a$export$a2eea90ce05a9f1c = (permissions, product, permissionIds)=>{
    if (!permissions[product]) return false;
    if ((!permissionIds || permissionIds.length === 0) && permissions[product]) return Object.values(permissions[product] || {}).some((value)=>value === true);
    return permissionIds?.some((permissionId)=>permissions[product]?.[permissionId]);
};

});

parcelRegister("fVapN", function(module, exports) {

$parcel$export(module.exports, "useProductPermissions", () => $9e8f949cc6540099$export$5814f9544ee53f3b);

var $eJOHy = parcelRequire("eJOHy");

var $5QuPd = parcelRequire("5QuPd");
const $9e8f949cc6540099$export$5814f9544ee53f3b = ({ userId: userId, cloudId: cloudId, permissionsToCheck: permissionsToCheck, options: options })=>{
    const [state, { getPermissions: getPermissions }] = (0, $5QuPd.useProductPermissionsStore)();
    const fetchData = (0, $eJOHy.useCallback)(async ()=>{
        getPermissions({
            cloudId: cloudId,
            userId: userId,
            enabled: options?.enabled ?? true,
            permissionsToCheck: permissionsToCheck || {
                jira: [
                    'manage',
                    'write'
                ],
                confluence: [
                    'manage',
                    'write'
                ],
                loom: [
                    'manage',
                    'write'
                ]
            }
        });
    }, [
        cloudId,
        options,
        getPermissions,
        userId,
        permissionsToCheck
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissions,
        error: state.error
    };
};

});
parcelRegister("5QuPd", function(module, exports) {

$parcel$export(module.exports, "useProductPermissionsStore", () => $65f9aeda45ff3c67$export$933ed92af1ed5de9);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $dBVvL = parcelRequire("dBVvL");

var $6lYLP = parcelRequire("6lYLP");

var $dS6C8 = parcelRequire("dS6C8");
const $65f9aeda45ff3c67$var$actions = {
    getPermissions: ({ userId: userId, cloudId: cloudId, enabled: enabled, permissionsToCheck: permissionsToCheck })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading, permissions: permissions } = getState();
            if (isLoading || !userId || !cloudId || !enabled) return;
            const shouldFetch = !hasLoaded || permissionsToCheck.jira?.some((permissionId)=>permissions.jira?.[permissionId] === undefined) || permissionsToCheck.confluence?.some((permissionId)=>permissions.confluence?.[permissionId] === undefined) || permissionsToCheck.loom?.some((permissionId)=>permissions.loom?.[permissionId] === undefined);
            if (!shouldFetch) return;
            try {
                setState({
                    isLoading: true
                });
                const permissions = [];
                const productPermissions = [];
                const apiCallPromises = [];
                const productKeys = Object.keys(permissionsToCheck);
                productKeys.forEach((productKey)=>permissionsToCheck[productKey]?.forEach(async (permission)=>{
                        const endpoint = (0, $dBVvL.getEndpoint)(productKey, permission, cloudId);
                        if (endpoint) {
                            if (endpoint.type === 'rest') {
                                const res = await (0, $6lYLP.makeRestApiRequest)({
                                    url: endpoint.url
                                });
                                const responseData = await res.json();
                                permissions.push(endpoint.transformResponse(responseData));
                            } else if (endpoint.type === 'graphql') {
                                const headers = new Headers();
                                headers.append('Content-Type', 'application/json');
                                const response = await (0, $6lYLP.makeGraphqlRequest)({
                                    url: endpoint.url,
                                    query: endpoint.query,
                                    variables: endpoint.variables
                                });
                                const responseData = await response.json();
                                permissions.push(endpoint.transformResponse(responseData));
                            } else if (endpoint.type === 'default') productPermissions.push({
                                product: endpoint.payload.product,
                                permissionId: endpoint.payload.permissionId
                            });
                        } else productPermissions.push({
                            product: productKey,
                            permissionId: permission
                        });
                    }));
                const errors = [];
                if (productPermissions.length > 0) apiCallPromises.push((async ()=>{
                    try {
                        const response = await (0, $6lYLP.makeRestApiRequest)({
                            url: '/gateway/api/permissions/bulk/permitted',
                            body: (0, $6lYLP.getProductPermissionRequestBody)(cloudId, userId, productPermissions)
                        });
                        if (!response.ok) throw new Error('Failed to fetch product permissions');
                        const bulkPermissions = await response.json();
                        permissions.push(...bulkPermissions);
                    } catch (error) {
                        errors.push(new Error(`Error fetching product permissions with error ${error}`));
                    }
                })());
                await Promise.all(apiCallPromises);
                dispatch($65f9aeda45ff3c67$var$actions.setPermissions(permissions));
            } catch (error) {
                dispatch($65f9aeda45ff3c67$var$actions.setError(new Error('Failed to fetch product permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ getState: getState, setState: setState })=>{
            const newPermissions = (0, $dS6C8.transformPermissions)(permissions);
            const oldPermissions = getState().permissions;
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: {
                    jira: {
                        ...oldPermissions.jira,
                        ...newPermissions.jira
                    },
                    confluence: {
                        ...oldPermissions.confluence,
                        ...newPermissions.confluence
                    },
                    loom: {
                        ...oldPermissions.loom,
                        ...newPermissions.loom
                    }
                },
                permissionsResponse: permissions
            });
        }
};
const $65f9aeda45ff3c67$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {}
    },
    actions: $65f9aeda45ff3c67$var$actions,
    name: 'product-permissions'
});
const $65f9aeda45ff3c67$export$933ed92af1ed5de9 = (0, $iJq0l.createHook)($65f9aeda45ff3c67$var$Store);

});
parcelRegister("dBVvL", function(module, exports) {

$parcel$export(module.exports, "getEndpoint", () => $782a70f140be1a51$export$544dab20dbe3f2e7);
const $782a70f140be1a51$export$544dab20dbe3f2e7 = (product, permissionId, cloudId)=>{
    if (product === 'jira' && permissionId === 'CREATE_PROJECT') return {
        type: 'graphql',
        url: '/gateway/api/graphql',
        query: `query CanCreateProject($cloudId: ID!) {
						jira {
							canPerform  (cloudId: $cloudId, type: CREATE_PROJECT) @optIn(to: "JiraAction")
						}
					}`,
        variables: {
            cloudId: cloudId
        },
        transformResponse: (response)=>{
            return {
                permissionId: 'CREATE_PROJECT',
                resourceId: 'jira',
                permitted: response?.data?.jira?.canPerform || false
            };
        }
    };
    else if (product === 'confluence' && permissionId === 'create/space') return {
        type: 'default',
        payload: {
            product: 'confluence',
            permissionId: 'create/space'
        }
    };
};

});

parcelRegister("6lYLP", function(module, exports) {

$parcel$export(module.exports, "makeGraphqlRequest", () => $7c9455fd1da99ba9$export$29429bc4d26dfcf8);
$parcel$export(module.exports, "makeRestApiRequest", () => $7c9455fd1da99ba9$export$98fa14561e3049ec);
$parcel$export(module.exports, "getProductPermissionRequestBody", () => $7c9455fd1da99ba9$export$e16fe80afd1ad74c);
const $7c9455fd1da99ba9$var$JIRA_SUB_PRODUCTS = [
    'jira',
    'jira-core',
    'jira-software',
    'jira-servicedesk',
    'jira-product-discovery'
];
const $7c9455fd1da99ba9$export$29429bc4d26dfcf8 = ({ url: url, query: query, variables: variables })=>{
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query: query,
            variables: variables
        })
    });
};
const $7c9455fd1da99ba9$export$98fa14561e3049ec = ({ url: url, body: body })=>{
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: body
    });
};
const $7c9455fd1da99ba9$export$e16fe80afd1ad74c = (cloudId, userId, productPermissions)=>{
    const body = productPermissions.reduce((acc, productPermission)=>{
        const permission = {
            permissionId: productPermission.permissionId,
            resourceId: '',
            principalId: `ari:cloud:identity::user/${userId}`,
            dontRequirePrincipalInSite: true
        };
        if (productPermission.product === 'jira') $7c9455fd1da99ba9$var$JIRA_SUB_PRODUCTS.forEach((product)=>{
            acc.push({
                ...permission,
                resourceId: `ari:cloud:${product}::site/${cloudId}`
            });
        });
        else acc.push({
            ...permission,
            resourceId: `ari:cloud:${productPermission.product}::site/${cloudId}`
        });
        return acc;
    }, []);
    return JSON.stringify(body);
};

});

parcelRegister("dS6C8", function(module, exports) {

$parcel$export(module.exports, "transformPermissions", () => $8ce7b8ab5d578ff0$export$7fe0bfa353103198);

var $8GgXp = parcelRequire("8GgXp");
const $8ce7b8ab5d578ff0$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        (0, $8GgXp.SUPPORTED_PRODUCTS).forEach((supportedProduct)=>{
            if (permission.resourceId.includes(supportedProduct)) acc[supportedProduct] = {
                ...acc[supportedProduct],
                [permission.permissionId]: acc[supportedProduct]?.[permission.permissionId] || permission.permitted
            };
        });
        return acc;
    }, {});
};

});
parcelRegister("8GgXp", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_PRODUCTS", () => $8686446cf1c8aafa$export$69caceff42c0da80);
const $8686446cf1c8aafa$export$69caceff42c0da80 = [
    'confluence',
    'jira',
    'loom'
];

});




parcelRegister("7eAIS", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $4ce6a32b1f0ec576$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $4ce6a32b1f0ec576$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $4ce6a32b1f0ec576$export$9677d7c364ada66c);
$parcel$export(module.exports, "DefaultError", () => $4ce6a32b1f0ec576$export$c73ca302efeda3b4);
$parcel$export(module.exports, "SLOIgnoreError", () => $4ce6a32b1f0ec576$export$d87f401f8106d7a2);
$parcel$export(module.exports, "HttpError", () => $4ce6a32b1f0ec576$export$65bd6083489bd8bb);
$parcel$export(module.exports, "SLOIgnoreHttpError", () => $4ce6a32b1f0ec576$export$826a3d65b8435adf);
$parcel$export(module.exports, "GraphQLError", () => $4ce6a32b1f0ec576$export$92d6ed0888e7cb7f);
$parcel$export(module.exports, "isNetworkError", () => $4ce6a32b1f0ec576$export$476aa014e2fd89d5);
var $4ce6a32b1f0ec576$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
var $4ce6a32b1f0ec576$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $4ce6a32b1f0ec576$export$cde1786a482f9a1c(error) {
    return $4ce6a32b1f0ec576$export$9677d7c364ada66c(401, error) || $4ce6a32b1f0ec576$export$9677d7c364ada66c(403, error);
}
function $4ce6a32b1f0ec576$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}
function $4ce6a32b1f0ec576$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
var $4ce6a32b1f0ec576$export$c33cd4757598521c = /*#__PURE__*/ function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    return TeamErrorType;
}({});
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $4ce6a32b1f0ec576$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message || 'UnknownError';
        this.stack = new Error(message).stack || '';
    }
}
class $4ce6a32b1f0ec576$export$c73ca302efeda3b4 extends $4ce6a32b1f0ec576$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $4ce6a32b1f0ec576$export$c73ca302efeda3b4.prototype);
    }
}
class $4ce6a32b1f0ec576$export$d87f401f8106d7a2 extends $4ce6a32b1f0ec576$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $4ce6a32b1f0ec576$export$d87f401f8106d7a2.prototype);
    }
}
class $4ce6a32b1f0ec576$export$65bd6083489bd8bb extends $4ce6a32b1f0ec576$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId, path: path }){
        super(message);
        Object.setPrototypeOf(this, $4ce6a32b1f0ec576$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
        this.path = path;
    }
}
class $4ce6a32b1f0ec576$export$826a3d65b8435adf extends $4ce6a32b1f0ec576$export$65bd6083489bd8bb {
    constructor(props){
        super(props);
        Object.setPrototypeOf(this, $4ce6a32b1f0ec576$export$826a3d65b8435adf.prototype);
    }
}
class $4ce6a32b1f0ec576$export$92d6ed0888e7cb7f extends $4ce6a32b1f0ec576$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $4ce6a32b1f0ec576$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $4ce6a32b1f0ec576$export$92d6ed0888e7cb7f(errorData);
        };
    }
}
function $4ce6a32b1f0ec576$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}

});

parcelRegister("301JM", function(module, exports) {

$parcel$export(module.exports, "teamsClient", () => $a265c137afbb4e9c$export$5ed932c3646b89c6);

var $eGOwo = parcelRequire("eGOwo");

var $4jBhU = parcelRequire("4jBhU");

var $5SB4z = parcelRequire("5SB4z");

var $jWVEO = parcelRequire("jWVEO");

var $kl6VX = parcelRequire("kl6VX");

var $bP17Z = parcelRequire("bP17Z");

var $1Ah8w = parcelRequire("1Ah8w");

var $a6X0K = parcelRequire("a6X0K");

var $lrqlI = parcelRequire("lrqlI");

var $hmfTD = parcelRequire("hmfTD");

var $1qjKt = parcelRequire("1qjKt");

var $3aHkO = parcelRequire("3aHkO");

var $4Xjsv = parcelRequire("4Xjsv");

var $3vA2C = parcelRequire("3vA2C");

var $6s0GD = parcelRequire("6s0GD");

var $fecpt = parcelRequire("fecpt");
class $a265c137afbb4e9c$export$db59823f35bf78ce {
    constructor(/**
		 * @param {ClientContextProps} context - Context including CloudId & OrgId to be used for all requests
		 */ context){
        this._aggClient = (0, $5SB4z.aggClient);
        this._directoryClient = (0, $kl6VX.directoryClient);
        this._legionClient = (0, $a6X0K.defaultLegionClient);
        this._mutabilityClient = (0, $lrqlI.default);
        this._permsClient = (0, $1qjKt.default);
        this._publicApiClient = (0, $3aHkO.default);
        this._invitationsClient = (0, $1Ah8w.default);
        this._userPreferencesClient = (0, $fecpt.default);
        this._objectResolverClient = (0, $hmfTD.default);
        this._teamsInSlackClient = (0, $6s0GD.default);
        this._collaborationGraphClient = (0, $jWVEO.default);
        this._identityClient = (0, $bP17Z.default);
        this._teamCentralClient = (0, $3vA2C.default);
        this._replinesClient = (0, $4Xjsv.default);
        if (context) this.setContext(context);
    }
    async measurePerformance(name, fn) {
        const exp = (0, $4jBhU.TEAMS_CLIENT_EXPERIENCES).get(name);
        if (!exp) return fn();
        exp.start();
        try {
            const result = await fn();
            exp.success();
            return result;
        } catch (e) {
            exp.failWithError(e);
            throw e;
        }
    }
    /**
	 * Sets the base URL to be used in the client requests
	 * @param {string} baseUrl - The new base URL
	 */ setBaseUrl(baseUrl) {
        this._aggClient.setBaseUrl(baseUrl);
        this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Sets context including CloudId & OrgId to be used for all requests
	 */ setContext(context) {
        this._aggClient.setContext(context);
        this._directoryClient.setContext(context);
        this._legionClient.setContext(context);
        this._permsClient.setContext(context);
        this._mutabilityClient.setContext(context);
        this._publicApiClient.setContext(context);
        this._invitationsClient.setContext(context);
        this._replinesClient.setContext(context);
    }
    setTeamCentralContext(baseUrl, context) {
        this._teamCentralClient.setContext(context);
        this._teamCentralClient.setBaseUrl(baseUrl);
    }
    /**
	 * @private
	 * @deprecated use setBaseUrl instead
	 */ setDirectoryBaseUrl(baseUrl) {
        // eslint-disable-next-line no-console
        console.warn('setDirectoryBaseUrl is deprecated, use setBaseUrl instead');
        return this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Fetches Browse user settings
	 */ async querySettings(cloudId, product) {
        if (cloudId) {
            if ((0, $eGOwo.fg)('fix_query_settings_context')) {
                const previousContext = this._legionClient.getContext();
                this.setContext({
                    ...previousContext,
                    cloudId: cloudId
                });
            } else this.setContext({
                cloudId: cloudId
            });
        }
        return this.measurePerformance('querySettings', async ()=>{
            if (!product) throw new Error('Product is required');
            const response = await this._legionClient.retrieveBrowseUserPermission(product);
            return {
                'internal.browse-users-allowed': response.canSearchUsers
            };
        });
    }
    /**
	 * This will return all of the teams-related permissions that your user has for the org and site in the client context.
	 */ async getPermissions() {
        return this.measurePerformance('getPermissions', ()=>this._legionClient.getPermissions());
    }
    /**
	 * Fetches feature flags from Directory
	 * @deprecated As part of decommisioning pf-directoy
	 */ async queryFeatureFlags(...args) {
        return this.measurePerformance('queryFeatureFlags', ()=>this._directoryClient.queryFeatureFlags(...args));
    }
    /**
	 * Get user information of members of a team, paginated
	 * @param {string} teamId
	 * @returns {Promise}
	 */ async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        return this._aggClient.queryTeamMemberships(teamId, membershipState, pageInfo);
    }
    /**
	 * Get user information given an user id
	 * @param {string} userId
	 * @returns {Promise}
	 */ async queryAGGUser(userId) {
        return this._aggClient.queryAGGUser(userId);
    }
    /**
	 * Get the agents associated with the team
	 * @param {string} userId
	 * @returns {Promise}
	 */ async queryTeamHasAgents(teamId) {
        return this._aggClient.queryTeamHasAgents(teamId);
    }
    /**
	 * Get user information of a member of a team
	 * @param {string} userId
	 * @returns {Promise<CloudUser>}
	 */ queryUser(...args) {
        return this.measurePerformance('queryUser', ()=>this._directoryClient.queryUser(...args));
    }
    setLegionRootUrl(url) {
        return this._legionClient.setRootUrl(url);
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<TeamWithImageUrls>}
	 */ async getTeamById(teamId) {
        return this.measurePerformance('getTeamById', ()=>this._legionClient.getTeamById(teamId));
    }
    /**
	 * Search teams based on query
	 */ async getAllTeams(...args) {
        return this.measurePerformance('getAllTeams', ()=>this._legionClient.getAllTeams(...args));
    }
    /**
	 * Update team details
	 */ async updateTeamById(...args) {
        return this.measurePerformance('updateTeamById', ()=>this._legionClient.updateTeamById(...args));
    }
    /**
	 * @private
	 * @deprecated use addUsersToTeam instead
	 */ async inviteUsersToTeam(...args) {
        return this.measurePerformance('inviteUsersToTeam', ()=>this._legionClient.inviteUsersToTeam(...args));
    }
    /**
	 * Get the current user's team membership
	 */ async getMyTeamMembership(...args) {
        return this.measurePerformance('getMyTeamMembership', ()=>this._legionClient.getMyTeamMembership(...args));
    }
    /**
	 * Get a teams "Links"
	 */ async getTeamLinksByTeamId(teamId) {
        return this.measurePerformance('getTeamLinksByTeamId', ()=>this._legionClient.getTeamLinksByTeamId(teamId));
    }
    /**
	 * Create a team link
	 */ async createTeamLink(...args) {
        return this.measurePerformance('createTeamLink', ()=>this._legionClient.createTeamLink(...args));
    }
    /**
	 * Update a team link
	 */ async updateTeamLink(...args) {
        return this.measurePerformance('updateTeamLink', ()=>this._legionClient.updateTeamLink(...args));
    }
    /**
	 * Delete a team link
	 */ async deleteTeamLink(...args) {
        return this.measurePerformance('deleteTeamLink', ()=>this._legionClient.deleteTeamLink(...args));
    }
    /**
	 * Reorder a team link
	 */ async reorderTeamLink(...args) {
        return this.measurePerformance('reorderTeamLink', ()=>this._legionClient.reorderTeamLink(...args));
    }
    /**
	 * Get org's eligibility for managed teams
	 */ async getOrgEligibilityForManagedTeams() {
        return this.measurePerformance('getOrgEligibilityForManagedTeams', ()=>this._legionClient.getOrgEligibilityForManagedTeams());
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Accept a team invitation
	 */ async acceptTeamInvitation(...args) {
        return this.measurePerformance('acceptTeamInvitation', ()=>this._legionClient.acceptTeamInvitation(...args));
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Decline a team invitation
	 */ async declineTeamInvitation(...args) {
        return this.measurePerformance('declineTeamInvitation', ()=>this._legionClient.declineTeamInvitation(...args));
    }
    /**
	 * Add current user to a team
	 */ async selfJoinTeam(...args) {
        return this.measurePerformance('selfJoinTeam', ()=>this._legionClient.selfJoinTeam(...args));
    }
    /**
	 * Add agent to a team
	 */ async addAgentsToTeam(...args) {
        return this.measurePerformance('addAgentToTeam', ()=>this._legionClient.addAgentsToTeam(...args));
    }
    async removeAgentTeamAssociation(...args) {
        return this.measurePerformance('removeAgentTeamAssociation', ()=>this._legionClient.removeAgentTeamAssociation(...args));
    }
    /**
	 * Cancel a join request to a private team
	 */ async cancelJoinRequest(teamId) {
        return this.measurePerformance('cancelJoinRequest', ()=>this._legionClient.cancelJoinRequest(teamId));
    }
    /**
	 * Accept a join request to a private team
	 */ async acceptJoinRequest(...args) {
        return this.measurePerformance('acceptJoinRequest', ()=>this._legionClient.acceptJoinRequest(...args));
    }
    /**
	 * Decline a join request to a private team
	 */ async declineJoinRequest(...args) {
        return this.measurePerformance('declineJoinRequest', ()=>this._legionClient.declineJoinRequest(...args));
    }
    /**
	 * @deprecated use removeTeamMemberships instead
	 */ async deleteTeamMembership(...args) {
        return this.measurePerformance('deleteTeamMembership', ()=>this._legionClient.deleteTeamMembership(...args));
    }
    /**
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(...args) {
        return this.measurePerformance('revokeTeamInvite', ()=>this._legionClient.revokeTeamInvite(...args));
    }
    /**
	 * Delete a team
	 */ async deleteTeam(teamId) {
        return this.measurePerformance('deleteTeam', ()=>this._legionClient.deleteTeam(teamId));
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        return this._legionClient.isSingleFullMemberTeam(teamId);
    }
    /**
	 * Create a team
	 */ async createTeam(...args) {
        return this.measurePerformance('createTeam', ()=>this._legionClient.createTeam(...args));
    }
    /**
	 * Create containers for a team
	 */ async createTeamContainers(...args) {
        return this.measurePerformance('createTeamContainers', ()=>this._legionClient.createTeamContainers(...args));
    }
    /**
	 * Create a external team
	 * @param {string} groupDescription - The description of the group, which will be used as the team description. The group name will be fetched from the identity service, so it does not need to be provided.
	 * @param {ExternalReference} externalReference
	 */ async createExternalTeam(...args) {
        return this.measurePerformance('createExternalTeam', ()=>this._legionClient.createExternalTeam(...args));
    }
    /**
	 * Get linked teams for a groups in bulk
	 * @param {string} groupIds - The group ids to fetch linked teams for
	 */ async getLinkedTeamsBulk(...args) {
        return this.measurePerformance('getLinkedTeamsBulk', ()=>this._legionClient.getLinkedTeamsBulk(...args));
    }
    /**
	 * Get Org scope
	 */ async getOrgScope(...args) {
        return this.measurePerformance('getOrgScope', ()=>this._legionClient.getOrgScope(...args));
    }
    /**
	 * Restore soft-deleted team and sync to group
	 */ async restoreTeamToSyncedGroup(...args) {
        return this.measurePerformance('restoreTeamToSyncedGroup', ()=>this._legionClient.restoreTeamToSyncedGroup(...args));
    }
    /**
	 * Get the difference between a team and a group
	 * @param teamId
	 * @param {ExternalReference} externalReference
	 * @returns {Promise<TeamAndGroupDifference>}
	 */ async getTeamAndGroupDiff(...args) {
        return this.measurePerformance('getTeamAndGroupDiff', ()=>this._legionClient.getTeamAndGroupDiff(...args));
    }
    /**
	 * Link an existing team to a group
	 * @param teamId
	 * @param {ExternalReference} externalReference
	 */ async linkExistingTeamToGroup(...args) {
        return this.measurePerformance('linkExistingTeamToGroup', ()=>this._legionClient.linkExistingTeamToGroup(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<LinkedTeamsProfileDetails>}
	 */ async getTeamProfileDetailsByTeamId(...args) {
        return this.measurePerformance('getTeamProfileDetails', ()=>this._legionClient.getTeamProfileDetails(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getSoftDeletdTeamById(teamId) {
        return this.measurePerformance('getSoftDeletedTeamById', ()=>this._legionClient.getSoftDeletedTeamById(teamId));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 * @param userId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getUserInSiteUserBase(userId) {
        return this.measurePerformance('getUserInSiteUserBase', ()=>this._legionClient.getUserInSiteUserBase(userId));
    }
    trimTeamARI(teamId = '') {
        return this._legionClient.trimTeamARI(teamId);
    }
    /**
	 * Get user profile with mutability constraints
	 */ async getProfileWithMutability(...args) {
        return this.measurePerformance('getProfileWithMutability', ()=>this._mutabilityClient.getProfileWithMutability(...args));
    }
    /**
	 * Get enabled sites for a team
	 */ async getTeamEnabledSites(...args) {
        return this.measurePerformance('getTeamEnabledSites', ()=>this._legionClient.getTeamEnabledSites(...args));
    }
    /**
	 * Assign teams to sites
	 * @param migrations
	 * @returns {Promise<AssignTeamsToSitesResponse>}
	 */ async assignTeamsToSites(...args) {
        return this.measurePerformance('assignTeamsToSites', ()=>this._legionClient.assignTeamsToSites(...args));
    }
    /**
	 * Is the current user a site admin
	 */ getIsSiteAdmin(...args) {
        return this.measurePerformance('getIsSiteAdmin', ()=>this._permsClient.getIsSiteAdmin(...args));
    }
    /**
	 * Add users to a team
	 */ addUsersToTeam(...args) {
        return this.measurePerformance('addUsersToTeam', ()=>this._publicApiClient.addUsersToTeam(...args));
    }
    /**
	 * Remove users from a team
	 */ removeTeamMemberships(...args) {
        return this.measurePerformance('removeTeamMemberships', ()=>this._publicApiClient.removeTeamMemberships(...args));
    }
    /**
	 * Restore a deleted team
	 */ restoreTeam(...args) {
        return this.measurePerformance('restoreTeam', ()=>this._publicApiClient.restoreTeam(...args));
    }
    getRecommendedProducts(...args) {
        return this.measurePerformance('getRecommendedProducts', ()=>this._invitationsClient.getProductRecommendations(...args));
    }
    joinOrRequestDefaultAccessToProductsBulk(...args) {
        return this.measurePerformance('joinOrRequestDefaultAccessToProductsBulk', ()=>this._invitationsClient.joinOrRequestDefaultAccessToProductsBulk(...args));
    }
    /**
	 * Get token to upload media for a team
	 */ async getWriteTeamMediaToken() {
        return this.measurePerformance('getWriteTeamMediaToken', ()=>this._legionClient.getWriteMediaToken());
    }
    /**
	 * Get token to read media for a user
	 */ async getReadMediaToken(...args) {
        return this.measurePerformance('getReadMediaToken', ()=>this._userPreferencesClient.getReadMediaToken(...args));
    }
    /**
	 * Get token to upload media for a user
	 */ async getWriteUserMediaToken() {
        return this.measurePerformance('getWriteUserMediaToken', ()=>this._userPreferencesClient.getWriteMediaToken());
    }
    /**
	 * Update header image for a user
	 */ async updateUserHeaderImage(headerImageId) {
        return this.measurePerformance('updateUserHeaderImage', ()=>this._userPreferencesClient.updateUserHeaderImage(headerImageId));
    }
    /**
	 * Fetch user containers from collboration graph
	 */ async getUserContainers(...args) {
        return this.measurePerformance('getUserContainers', ()=>this._collaborationGraphClient.getUserContainers(...args));
    }
    /**
	 * Fetch mutatability of external managed user fields
	 */ async getUserManageConfig(...args) {
        return this.measurePerformance('getUserManageConfig', ()=>this._identityClient.getUserManageConfig(...args));
    }
    /**
	 * Fetch user avatar uploaded status
	 */ async getMyAvatarUploadedStatus(...args) {
        return this.measurePerformance('getMyAvatarUploadedStatus', ()=>this._identityClient.getMyAvatarUploadedStatus(...args));
    }
    /**
	 * Delete user avatar
	 */ async deleteAvatar(...args) {
        return this.measurePerformance('deleteUserAvatar', ()=>this._identityClient.deleteAvatar(...args));
    }
    async fetchUserAvatarInfo(...args) {
        return this.measurePerformance('fetchUserAvatarInfo', ()=>this._identityClient.fetchUserAvatarInfo(...args));
    }
    /**
	 * Fetch Team link icons
	 */ async getTeamLinkIcons(...args) {
        return this.measurePerformance('getTeamLinkIcons', ()=>this._objectResolverClient.getTeamLinkIcons(...args));
    }
    /**
	 * Fetch ARI from URL
	 */ async getAriFromUrl(...args) {
        return this.measurePerformance('getAriFromUrl', ()=>this._objectResolverClient.getAriFromUrl(...args));
    }
    /**
	 * Fetch web link title
	 */ async getWebLinkTitle(...args) {
        return this.measurePerformance('getWebLinkTitle', ()=>this._objectResolverClient.getWebLinkTitle(...args));
    }
    /**
	 * Fetch team in slack details
	 */ async getTeamInSlack(...args) {
        return this.measurePerformance('getTeamInSlack', ()=>this._teamsInSlackClient.getTeamInSlack(...args));
    }
    /**
	 * Delete team in slack
	 */ async disconnectTeamInSlack(...args) {
        return this.measurePerformance('disconnectTeamInSlack', ()=>this._teamsInSlackClient.disconnectTeamInSlack(...args));
    }
    /**
	 * Update team in slack
	 */ async updateTeamInSlack(...args) {
        return this.measurePerformance('updateTeamInSlack', ()=>this._teamsInSlackClient.updateTeamInSlack(...args));
    }
    /**
	 * Update user details
	 */ async updateUser(...args) {
        return this.measurePerformance('updateUser', ()=>this._identityClient.updateUser(...args));
    }
    async updateUserAvatar(...args) {
        return this.measurePerformance('updateUserAvatar', ()=>this._identityClient.updateUserAvatar(...args));
    }
    async addTeamWatcher(...args) {
        return this._teamCentralClient.addTeamWatcher(...args);
    }
    async removeTeamWatcher(...args) {
        return this._teamCentralClient.removeTeamWatcher(...args);
    }
    async deleteKudos(...args) {
        return this._teamCentralClient.deleteKudos(...args);
    }
    async queryTagList(...args) {
        return this._teamCentralClient.queryTagList(...args);
    }
    async createTag(...args) {
        return this._teamCentralClient.createTag(...args);
    }
    async createHelpPointer(...args) {
        return this._teamCentralClient.createHelpPointer(...args);
    }
    async updateHelpPointer(...args) {
        return this._teamCentralClient.updateHelpPointer(...args);
    }
    async deleteHelpPointer(...args) {
        return this._teamCentralClient.deleteHelpPointer(...args);
    }
    async getUserTenure(...args) {
        return this.measurePerformance('getUserTenure', ()=>this._replinesClient.getUserTenure(...args));
    }
}
const $a265c137afbb4e9c$export$5ed932c3646b89c6 = new $a265c137afbb4e9c$export$db59823f35bf78ce();

});
parcelRegister("4jBhU", function(module, exports) {

$parcel$export(module.exports, "TEAMS_CLIENT_EXPERIENCES", () => $54c07f12bcdc1fb3$export$879344107b04120c);

var $aRnO1 = parcelRequire("aRnO1");

var $fGETV = parcelRequire("fGETV");
const $54c07f12bcdc1fb3$var$TeamsClientExperienceKeyList = [
    'getAllTeams',
    'getTeamById',
    'updateTeamById',
    'querySettings',
    'queryFeatureFlags',
    'queryTeamMemberships',
    'queryUser',
    'inviteUsersToTeam',
    'getMyTeamMembership',
    'getTeamLinksByTeamId',
    'createTeamLink',
    'updateTeamLink',
    'deleteTeamLink',
    'reorderTeamLink',
    'acceptTeamInvitation',
    'declineTeamInvitation',
    'selfJoinTeam',
    'cancelJoinRequest',
    'acceptJoinRequest',
    'declineJoinRequest',
    'deleteTeamMembership',
    'revokeTeamInvite',
    'deleteTeam',
    'isSingleFullMemberTeam',
    'createTeam',
    'createTeamContainers',
    'createExternalTeam',
    'getProfileWithMutability',
    'getIsSiteAdmin',
    'addUsersToTeam',
    'removeTeamMemberships',
    'getRecommendedProducts',
    'joinOrRequestDefaultAccessToProductsBulk',
    'getReadMediaToken',
    'getWriteUserMediaToken',
    'updateUserHeaderImage',
    'getWriteTeamMediaToken',
    'getSoftDeletedTeamById',
    'restoreTeam',
    'getUserInSiteUserBase',
    'getLinkedTeamsBulk',
    'getTeamProfileDetails',
    'getUserContainers',
    'getPermissions',
    'getUserManageConfig',
    'getMyAvatarUploadedStatus',
    'deleteUserAvatar',
    'getTeamLinkIcons',
    'getTeamInSlack',
    'getOrgScope',
    'restoreTeamToSyncedGroup',
    'getTeamAndGroupDiff',
    'linkExistingTeamToGroup',
    'fetchUserAvatarInfo',
    'getOrgEligibilityForManagedTeams',
    'updateUser',
    'updateUserAvatar',
    'disconnectTeamInSlack',
    'updateTeamInSlack',
    'getUserTenure',
    'getAriFromUrl',
    'getWebLinkTitle',
    'addAgentToTeam',
    'getTeamEnabledSites',
    'assignTeamsToSites',
    'removeAgentTeamAssociation'
];
const $54c07f12bcdc1fb3$export$879344107b04120c = new Map([
    ...$54c07f12bcdc1fb3$var$TeamsClientExperienceKeyList.map((key)=>[
            key,
            // camelCase to kebab-case
            new (0, $fGETV.TeamsUFOExperience)(`teams-client-${key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`, {
                type: (0, $aRnO1.ExperienceTypes).Operation,
                performanceType: (0, $aRnO1.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'people'
                }
            })
        ])
]);

});
parcelRegister("aRnO1", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $a0f874ab7df0b90c$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $a0f874ab7df0b90c$export$cc26007c03242fff);
var $a0f874ab7df0b90c$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $a0f874ab7df0b90c$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("fGETV", function(module, exports) {

$parcel$export(module.exports, "TeamsUFOExperience", () => $6d42ddbd74afe72d$export$9a18529d1e90e81a);

var $2pMzV = parcelRequire("2pMzV");

var $7eAIS = parcelRequire("7eAIS");

var $aanSe = parcelRequire("aanSe");
class $6d42ddbd74afe72d$export$9a18529d1e90e81a extends (0, $2pMzV.UFOExperience) {
    abortWithError(error, reason) {
        return super.abort({
            metadata: {
                error: (0, $aanSe.createErrorMetadata)(error),
                reason: reason
            }
        });
    }
    failWithError(error) {
        if (error instanceof Error) {
            if ((0, $7eAIS.isAuthError)(error)) return this.abortWithError(error, 'Abort due to user unauthenticated');
            if ((0, $7eAIS.isErrorStatusCode)((0, $7eAIS.StatusCode).GONE, error)) return this.abortWithError(error, 'Abort due to unavailable resource');
            if ((0, $aanSe.isIgnoredError)(error)) return this.abortWithError(error, 'Abort due to an error in ignore list');
            if ((0, $7eAIS.isNetworkError)(error)) return this.abortWithError(error, 'Abort due to network error');
            return super.failure({
                metadata: {
                    error: (0, $aanSe.createErrorMetadata)(error),
                    packageVersion: "0.0.0-use.local",
                    packageName: "platform-pkg"
                }
            });
        }
        return super.failure({
            metadata: {
                error: 'unknown error',
                packageVersion: "0.0.0-use.local",
                packageName: "platform-pkg"
            }
        });
    }
}

});
parcelRegister("2pMzV", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $eb40b99b73192801$export$c00d22927c60484a);

var $aSYAD = parcelRequire("aSYAD");
class $eb40b99b73192801$export$c00d22927c60484a extends (0, $aSYAD.UFOAbstractExperience) {
}

});
parcelRegister("aSYAD", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $fb5df3e7e01c2259$export$d31c89db257648c);

var $aXKmr = parcelRequire("aXKmr");


var $6uX6b = parcelRequire("6uX6b");

var $jJiQE = parcelRequire("jJiQE");

var $5hbWe = parcelRequire("5hbWe");

var $ccWvh = parcelRequire("ccWvh");

var $aP4V0 = parcelRequire("aP4V0");

var $2Ilzg = parcelRequire("2Ilzg");

var $g0oDq = parcelRequire("g0oDq");

var $8OSL8 = parcelRequire("8OSL8");

var $aRnO1 = parcelRequire("aRnO1");
const $fb5df3e7e01c2259$var$getPageVisibleState = ()=>{
    return !(0, $2Ilzg.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $ccWvh.PageVisibleState).VISIBLE : (0, $ccWvh.PageVisibleState).HIDDEN;
};
const $fb5df3e7e01c2259$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $aP4V0.roundPerfNow)();
};
class $fb5df3e7e01c2259$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $g0oDq.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $ccWvh.PageVisibleState).MIXED;
            (0, $5hbWe.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $fb5df3e7e01c2259$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $aRnO1.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $jJiQE.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $8OSL8.canTransition)(this.state, newState)) {
            (0, $jJiQE.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $g0oDq.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $aXKmr.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.unsubscribeEvent)((0, $ccWvh.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $jJiQE.ufolog)('this.parent', this.parent);
                (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $jJiQE.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $jJiQE.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $g0oDq.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $fb5df3e7e01c2259$var$getPageVisibleState();
            (0, $5hbWe.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $jJiQE.ufolog)('subscribed', this.id);
                (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.subscribeEvent)((0, $ccWvh.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $ccWvh.FMP_MARK) && name !== (0, $ccWvh.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $jJiQE.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $g0oDq.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $ccWvh.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $ccWvh.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $jJiQE.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $5hbWe.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $jJiQE.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $4e1f4772088a5f3c$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $4e1f4772088a5f3c$export$2295b861f318254a = '0.1.5';

parcelRegister("6uX6b", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $aa71c8960fce0a9f$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $aa71c8960fce0a9f$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $aa71c8960fce0a9f$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $aa71c8960fce0a9f$export$7c957416596ca127);

var $jJiQE = parcelRequire("jJiQE");

var $ccWvh = parcelRequire("ccWvh");
const $aa71c8960fce0a9f$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $aa71c8960fce0a9f$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $aa71c8960fce0a9f$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $aa71c8960fce0a9f$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $jJiQE.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $aa71c8960fce0a9f$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $aa71c8960fce0a9f$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $aa71c8960fce0a9f$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("jJiQE", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $3c943c12e74b5b78$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $3c943c12e74b5b78$export$d53d07b6034c4560);
class $3c943c12e74b5b78$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($3c943c12e74b5b78$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($3c943c12e74b5b78$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $3c943c12e74b5b78$export$4ab84f6f04f6566d = new $3c943c12e74b5b78$var$UFOLogger();
const $3c943c12e74b5b78$export$b4958caff08a0960 = (...args)=>{
    $3c943c12e74b5b78$export$4ab84f6f04f6566d.log(...args);
};
const $3c943c12e74b5b78$export$d53d07b6034c4560 = (...args)=>{
    $3c943c12e74b5b78$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("ccWvh", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $eeff76e3a75af2a8$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $eeff76e3a75af2a8$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $eeff76e3a75af2a8$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $eeff76e3a75af2a8$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $eeff76e3a75af2a8$export$837e0f79a8056912);
var $eeff76e3a75af2a8$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $eeff76e3a75af2a8$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $eeff76e3a75af2a8$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $eeff76e3a75af2a8$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $eeff76e3a75af2a8$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $eeff76e3a75af2a8$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $eeff76e3a75af2a8$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $eeff76e3a75af2a8$export$9f2bf58999404c75 = 'fmp';
const $eeff76e3a75af2a8$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("5hbWe", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $d460cc96d513760c$export$13e680397ec8f3eb);

var $2Ilzg = parcelRequire("2Ilzg");
class $d460cc96d513760c$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $2Ilzg.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $d460cc96d513760c$export$13e680397ec8f3eb = new $d460cc96d513760c$var$VisibilityChangeObserver();

});
parcelRegister("2Ilzg", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $5b8b2c70c6400f35$export$15e172712955e18f);
const $5b8b2c70c6400f35$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("aP4V0", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $53acaf7fbb090f6e$export$5f490af6b2b115cf);
const $53acaf7fbb090f6e$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("g0oDq", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $7c8f0df3a7880bc0$export$81b70111112841a0);
const $7c8f0df3a7880bc0$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("8OSL8", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $ac48b2b50e1c5998$export$178881f329fdb81f);

var $g0oDq = parcelRequire("g0oDq");
const $ac48b2b50e1c5998$var$UFOStateAvailableTransitions = {
    [(0, $g0oDq.UFOExperienceState).NOT_STARTED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).STARTED.id]: [
        (0, $g0oDq.UFOExperienceState).IN_PROGRESS.id,
        (0, $g0oDq.UFOExperienceState).BLOCKED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $g0oDq.UFOExperienceState).BLOCKED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).BLOCKED.id]: [
        (0, $g0oDq.UFOExperienceState).RECOVERED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).RECOVERED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).SUCCEEDED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).FAILED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).ABORTED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ]
};
const $ac48b2b50e1c5998$export$178881f329fdb81f = (state1, state2)=>{
    return $ac48b2b50e1c5998$var$UFOStateAvailableTransitions[state1.id] && $ac48b2b50e1c5998$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});



parcelRegister("aanSe", function(module, exports) {

$parcel$export(module.exports, "createErrorMetadata", () => $913e69277c97885c$export$7286a0fb7b5aab6b);
$parcel$export(module.exports, "isIgnoredError", () => $913e69277c97885c$export$a8da197a8bcc7e95);

var $7eAIS = parcelRequire("7eAIS");
const $913e69277c97885c$export$7286a0fb7b5aab6b = (error)=>({
        error: {
            name: error.name,
            message: error.message,
            stack: error.stack,
            traceId: error instanceof (0, $7eAIS.HttpError) ? error.traceId : undefined,
            status: error instanceof (0, $7eAIS.HttpError) ? error.status : undefined
        }
    });
const $913e69277c97885c$var$ignoredErrors = [
    'SLOIgnoreError',
    'SLOIgnoreHttpError'
];
const $913e69277c97885c$export$a8da197a8bcc7e95 = (error)=>{
    const errorName = error?.constructor.name;
    if (!errorName) return false;
    return $913e69277c97885c$var$ignoredErrors.includes(errorName);
};

});



parcelRegister("5SB4z", function(module, exports) {

$parcel$export(module.exports, "aggClient", () => $f9ac644f32b216ad$export$464c991dbf0b2393);

var $b8xXJ = parcelRequire("b8xXJ");

var $hncrn = parcelRequire("hncrn");

var $le4QF = parcelRequire("le4QF");

var $kP1cg = parcelRequire("kP1cg");

var $8ZouZ = parcelRequire("8ZouZ");

var $kFoav = parcelRequire("kFoav");

var $1C7fa = parcelRequire("1C7fa");

var $6qJst = parcelRequire("6qJst");
class $f9ac644f32b216ad$export$b44e5dafe13af7b3 extends (0, $le4QF.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/graphql`);
    }
    async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        const response = await this.makeGraphQLRequest({
            query: (0, $kFoav.default),
            variables: {
                teamId: teamId,
                membershipState: membershipState,
                siteId: this.getCloudId(),
                ...pageInfo
            }
        }, {
            operationName: 'TeamMembership'
        });
        return {
            edges: response.team.teamV2.members.edges.map(({ node: node })=>({
                    membershipId: {
                        teamId: teamId,
                        memberId: (0, $b8xXJ.toUserId)(node.member.id)
                    },
                    state: node.state,
                    role: node.role,
                    user: {
                        id: (0, $b8xXJ.toUserId)(node.member.id),
                        fullName: node.member.name,
                        avatarUrl: node.member.picture,
                        status: node.member.accountStatus,
                        title: node.member.extendedProfile?.jobTitle ?? undefined,
                        userType: (0, $6qJst.toUserType)({
                            appType: node.member.appType
                        })
                    }
                })),
            pageInfo: response.team.teamV2.members.pageInfo
        };
    }
    async queryAGGUser(userId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $1C7fa.TeamsUserQuery),
            variables: {
                userId: userId
            }
        }, {
            operationName: 'TeamsUserQuery'
        });
        return response.user;
    }
    async queryTeamHasAgents(teamId) {
        const teamAri = (0, $b8xXJ.toTeamARI)(teamId);
        const response = await this.makeGraphQLRequest({
            query: (0, $8ZouZ.TeamHasAgentsQuery),
            variables: {
                id: teamAri
            }
        }, {
            operationName: 'TeamHasAgentsQuery'
        });
        return this.processTeamHasAgentsResponse(teamId, response.graphStore);
    }
    processTeamHasAgentsResponse(teamId, response) {
        return response.teamHasAgents.edges.map(({ node: node })=>({
                associationId: {
                    teamId: teamId,
                    accountId: (0, $b8xXJ.toUserId)(node.id)
                },
                agent: {
                    id: node.id,
                    fullName: node.name,
                    avatarUrl: node.picture
                }
            }));
    }
}
const $f9ac644f32b216ad$export$464c991dbf0b2393 = new $f9ac644f32b216ad$export$b44e5dafe13af7b3((0, $hncrn.DEFAULT_CONFIG).stargateRoot, {
    logException: $kP1cg.logException
});

});
parcelRegister("b8xXJ", function(module, exports) {

$parcel$export(module.exports, "toUserId", () => $5a33a4679e11b704$export$1d0eef1d33b05366);
$parcel$export(module.exports, "toUserARI", () => $5a33a4679e11b704$export$fca6a88adb58674a);
$parcel$export(module.exports, "toTeamARI", () => $5a33a4679e11b704$export$2bcc6e4924859c6f);

const $5a33a4679e11b704$export$caac29844ad91f64 = (ari)=>ari.startsWith((0, $3a6f84ebc0be7810$export$470b0d72e4fdc43a));
const $5a33a4679e11b704$export$1d0eef1d33b05366 = (ari)=>{
    if ($5a33a4679e11b704$export$caac29844ad91f64(ari)) return ari.replace((0, $3a6f84ebc0be7810$export$470b0d72e4fdc43a), '');
    throw new Error('Invalid UserARI');
};
const $5a33a4679e11b704$export$fca6a88adb58674a = (userId)=>{
    return $5a33a4679e11b704$export$caac29844ad91f64(userId) ? userId : `${0, $3a6f84ebc0be7810$export$470b0d72e4fdc43a}${userId}`;
};
const $5a33a4679e11b704$export$7b81d5dfd83c8166 = (ari)=>ari.startsWith((0, $3a6f84ebc0be7810$export$cfedc369802e0c68));
const $5a33a4679e11b704$export$e78216c959b9f3af = (ari)=>{
    if ($5a33a4679e11b704$export$7b81d5dfd83c8166(ari)) return ari.replace((0, $3a6f84ebc0be7810$export$cfedc369802e0c68), '');
    throw new Error('Invalid TeamARI');
};
const $5a33a4679e11b704$export$2bcc6e4924859c6f = (teamId)=>{
    return $5a33a4679e11b704$export$7b81d5dfd83c8166(teamId) ? teamId : `${0, $3a6f84ebc0be7810$export$cfedc369802e0c68}${teamId}`;
};

});
const $3a6f84ebc0be7810$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $3a6f84ebc0be7810$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';


parcelRegister("hncrn", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONFIG", () => $43d6e2e0b1d23bff$export$c2f8e0cc249a8d8f);
const $43d6e2e0b1d23bff$export$c2f8e0cc249a8d8f = {
    stargateRoot: '/gateway/api',
    permsServiceUrl: '/gateway/api/permissions',
    publicApiRoot: '/gateway/api/public',
    invitationsServiceUrl: '/gateway/api/invitations',
    collaborationGraphUrl: '/gateway/api/collaboration'
};

});

parcelRegister("le4QF", function(module, exports) {

$parcel$export(module.exports, "BaseGraphQlClient", () => $482516509fd40a68$export$42f6d6baced34b2d);

var $7eAIS = parcelRequire("7eAIS");

var $2k5M1 = parcelRequire("2k5M1");

var $bao60 = parcelRequire("bao60");
class $482516509fd40a68$export$42f6d6baced34b2d extends (0, $2k5M1.BaseClient) {
    constructor(serviceUrl, config){
        super(config);
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async makeGraphQLRequest(body, options = {}) {
        try {
            return (0, $bao60.handleGraphQLRequest)(this.serviceUrl, body, options);
        } catch (error) {
            if (error instanceof (0, $7eAIS.GraphQLError)) throw error;
            this.logException(error, 'UnknownError in GraphQLClient.makeGraphQLRequestWithoutRetries');
            throw new (0, $7eAIS.DefaultError)({});
        }
    }
}

});
parcelRegister("2k5M1", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $1bc81acb842a6186$export$4f22f74eddb7716a);

var $kP1cg = parcelRequire("kP1cg");
class $1bc81acb842a6186$export$4f22f74eddb7716a {
    constructor(config){
        this.cache = {};
        this.logException = (ex, name, context)=>{
            (0, $kP1cg.logException)(ex, name, context);
            this.config.logException(ex, name, context);
        };
        this.config = config;
        this.context = {
            cloudId: 'None'
        };
    }
    setContext(context) {
        this.context = {
            ...context,
            cloudId: context.cloudId || 'None'
        };
    }
    getContext() {
        return this.context;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getOrgId(localValue) {
        const orgId = localValue || this.getContext().orgId;
        if (!orgId) {
            const err = new Error('No orgId set');
            this.logException(err, 'No orgId set');
            throw err;
        }
        return orgId;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getCloudId(localValue) {
        return localValue || this.getContext().cloudId;
    }
    keyWithContext(key) {
        return `${this.getContext().cloudId}-${this.getContext().orgId ?? 'no-org-id'}-${this.getContext().userId ?? 'no-user-id'}-${key}`;
    }
    // Default expiration is 5 minutes
    cacheValue(key, value, expiryMs = 300000) {
        this.cache[this.keyWithContext(key)] = {
            data: value,
            expiration: Date.now() + expiryMs
        };
    }
    getCachedValue(key) {
        const record = this.cache[this.keyWithContext(key)];
        if (record && record.expiration > Date.now()) return record.data;
        return undefined;
    }
}

});
parcelRegister("kP1cg", function(module, exports) {

$parcel$export(module.exports, "logException", () => $950c0743f70e539d$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $950c0743f70e539d$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $950c0743f70e539d$export$386587bcf05ee8ea);
$parcel$export(module.exports, "logExceptionWithPackageContext", () => $950c0743f70e539d$export$7208e9272a946c36);
$parcel$export(module.exports, "logErrorMessageWithPackageContext", () => $950c0743f70e539d$export$dbd2da61a76fb8d2);
$parcel$export(module.exports, "logInfoMessageWithPackageContext", () => $950c0743f70e539d$export$f242834c5699e597);
$parcel$export(module.exports, "createErrorHandlerWithPackageContext", () => $950c0743f70e539d$export$6b2a307bf7c6c1dc);
$parcel$export(module.exports, "addBreadcrumb", () => $950c0743f70e539d$export$efda9a273d7a036d);
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript

var $356Lx = parcelRequire("356Lx");
function $950c0743f70e539d$var$decorateScope(scope, context) {
    const { tags: tags, ...otherContext } = context;
    if (tags) scope.setTags(tags);
    if (Object.keys(otherContext).length) scope.setExtras(otherContext);
    return scope;
}
async function $950c0743f70e539d$export$f86b2a1a2ce291b3(ex, name, context = {}) {
    try {
        const sentryClient = await (0, $356Lx.getSentryClient)();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            $950c0743f70e539d$var$decorateScope(scope, context);
            scope.setTag('name', name);
            scope.setTag('packageName', context.packageName ?? 'unknown');
            scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
            sentryClient.captureException(ex, scope);
        });
    } catch  {
    // silence sentry exceptions
    }
}
async function $950c0743f70e539d$var$logMessage(severity, message, context = {}) {
    const sentryClient = await (0, $356Lx.getSentryClient)();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        $950c0743f70e539d$var$decorateScope(scope, context);
        // The Severity enum is being replaced by SeverityLevel type in v7 anyway
        scope.setLevel(severity);
        scope.setTag('packageName', context.packageName ?? 'unknown');
        scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
        sentryClient.captureMessage(message, scope);
    });
}
function $950c0743f70e539d$export$ece28f5cfa04608(message, context = {}) {
    $950c0743f70e539d$var$logMessage('error', message, context).catch(()=>{});
}
function $950c0743f70e539d$export$386587bcf05ee8ea(message, context = {}) {
    $950c0743f70e539d$var$logMessage('info', message, context).catch(()=>{});
}
const $950c0743f70e539d$export$9edc7d6f1c33ddc = (details)=>{
    return (error, message, tags = {})=>{
        $950c0743f70e539d$export$f86b2a1a2ce291b3(error, message, {
            tags: {
                ...details,
                ...tags
            }
        });
    };
};
const $950c0743f70e539d$export$7208e9272a946c36 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $950c0743f70e539d$export$f86b2a1a2ce291b3(args[0], args[1], {
            ...args[2],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $950c0743f70e539d$export$dbd2da61a76fb8d2 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $950c0743f70e539d$export$ece28f5cfa04608(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $950c0743f70e539d$export$f242834c5699e597 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $950c0743f70e539d$export$386587bcf05ee8ea(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $950c0743f70e539d$export$6b2a307bf7c6c1dc = (packageContext)=>(...args)=>$950c0743f70e539d$export$9edc7d6f1c33ddc({
            ...args[0],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
async function $950c0743f70e539d$export$efda9a273d7a036d(crumb) {
    const sentryClient = await (0, $356Lx.getSentryClient)();
    sentryClient.withScope((scope)=>{
        scope.addBreadcrumb(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
    });
}

});
parcelRegister("356Lx", function(module, exports) {

$parcel$export(module.exports, "sentryClient", () => $d6fe0b5616dbf418$export$ac71c212168fcd2b);
$parcel$export(module.exports, "setSentryClient", () => $d6fe0b5616dbf418$export$7d446c6f4e54de82);
$parcel$export(module.exports, "getSentryClient", () => $d6fe0b5616dbf418$export$f553e8b08ef59d31);
$parcel$export(module.exports, "setupSentryClient", () => $d6fe0b5616dbf418$export$d8bd0edf6c978788);

var $b0bYt = parcelRequire("b0bYt");

var $6ceSs = parcelRequire("6ceSs");
let $d6fe0b5616dbf418$export$ac71c212168fcd2b;
const $d6fe0b5616dbf418$export$7d446c6f4e54de82 = (client)=>{
    $d6fe0b5616dbf418$export$ac71c212168fcd2b = client;
};
const $d6fe0b5616dbf418$export$f553e8b08ef59d31 = async ()=>{
    if (!$d6fe0b5616dbf418$export$ac71c212168fcd2b) await $d6fe0b5616dbf418$export$d8bd0edf6c978788({});
    return $d6fe0b5616dbf418$export$ac71c212168fcd2b;
};
async function $d6fe0b5616dbf418$export$d8bd0edf6c978788({ appName: appName, env: env }) {
    const sentryClient = await $d6fe0b5616dbf418$var$requireSentryLib();
    if (!sentryClient) return;
    // initialiseSentry sets the sentry client
    (0, $6ceSs.initialiseSentry)(sentryClient, {
        initialScope: {
            tags: {
                renderMode: appName || 'unknown',
                productBuild: // @ts-ignore Jira  - window.BUILD_KEY, confluence - window.__buildInfo
                window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION || 'unknown',
                product: $d6fe0b5616dbf418$var$getProduct()
            }
        },
        env: env,
        noGlobals: true,
        dsn: (0, $b0bYt.SENTRY_DSN),
        attachStacktrace: true
    });
}

async function $d6fe0b5616dbf418$var$requireSentryLib() {
    // saving ~40K
    try {
        return (parcelRequire("9vXJM"));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Ignoring rejected promise when loading sentry resource.', error);
    }
}
function $d6fe0b5616dbf418$var$getProduct() {
    const path = window.location.pathname;
    if (path.includes('/jira/people')) return 'jira';
    else if (path.includes('/wiki/people')) return 'confluence';
    return 'unknown';
}

});
parcelRegister("b0bYt", function(module, exports) {

$parcel$export(module.exports, "SENTRY_DSN", () => $3bfcaf52858a3244$export$6faa4a850bc4d0ce);

var $lopBx = parcelRequire("lopBx");
const $3bfcaf52858a3244$export$9cf97fd92bea5d81 = '1dc056d49dfe4df8961dc1b810e4620d';
const $3bfcaf52858a3244$export$68c35ed3898e185a = '5988845';
const $3bfcaf52858a3244$export$b03be5cdb5af5197 = '067abcc494be9a87b3cdf9416f2b97d5';
const $3bfcaf52858a3244$export$97db6664a1e55fa6 = '47';
const $3bfcaf52858a3244$var$SENTRY_COMMERCIAL_DSN = `https://${$3bfcaf52858a3244$export$9cf97fd92bea5d81}@o55978.ingest.sentry.io/${$3bfcaf52858a3244$export$68c35ed3898e185a}`;
const $3bfcaf52858a3244$var$SENTRY_FEDRAMP_DSN = `https://${$3bfcaf52858a3244$export$b03be5cdb5af5197}@sentry.atlassian-us-gov-mod.com/${$3bfcaf52858a3244$export$97db6664a1e55fa6}`;
const $3bfcaf52858a3244$export$6faa4a850bc4d0ce = (0, $lopBx.isFedRamp)() ? $3bfcaf52858a3244$var$SENTRY_FEDRAMP_DSN : $3bfcaf52858a3244$var$SENTRY_COMMERCIAL_DSN;

});

parcelRegister("6ceSs", function(module, exports) {

$parcel$export(module.exports, "initialiseSentry", () => $d6feef4366a3b41b$export$357606956af25316);

var $3Cktb = parcelRequire("3Cktb");

var $356Lx = parcelRequire("356Lx");
const $d6feef4366a3b41b$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
async function $d6feef4366a3b41b$export$357606956af25316(client, options) {
    if (0, $356Lx.sentryClient) return;
    if (!client) return;
    (0, $356Lx.setSentryClient)(client);
    const sentryConfig = (0, $3Cktb.getSentryConfig)(options);
    (0, $356Lx.sentryClient).init({
        ...sentryConfig,
        integrations: function(integrations) {
            return integrations.filter(function(integration) {
                return $d6feef4366a3b41b$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        }
    });
}

});
parcelRegister("3Cktb", function(module, exports) {

$parcel$export(module.exports, "getSentryConfig", () => $fd3d2aa688325677$export$5580e6304e95c792);

var $b0bYt = parcelRequire("b0bYt");
const $fd3d2aa688325677$var$DEFAULT_SENTRY_CONFIG = {
    whitelistUrls: [
        /atl-paas.net/,
        // test local host
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/,
        // Network related errors
        'The operation was aborted',
        'Software caused connection abort',
        'GraphQL error: Failed to fetch',
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        'AbortError: The user aborted a request.',
        /^network error/i,
        /^network failure/i,
        /^NetworkError/i,
        /^Unexpected token ..*/
    ],
    ignoreUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
    ],
    dsn: (0, $b0bYt.SENTRY_DSN),
    attachStacktrace: true
};
function $fd3d2aa688325677$export$5580e6304e95c792(options) {
    const { env: env, version: version, noGlobals: _, ...otherOptions } = options;
    return {
        ...otherOptions,
        ...$fd3d2aa688325677$var$DEFAULT_SENTRY_CONFIG,
        // Standalone __VERSION__ is set from `bin/set-release-version.sh`
        // when building to deploy to production
        release: `${"platform-pkg"}@${"0.0.0-use.local"}` || // @ts-ignore Jira  - window.BUILD_KEY
        window.BUILD_KEY || // @ts-ignore Confluence - window.__buildInfo
        window.__buildInfo?.FRONTEND_VERSION || '---',
        environment: env || 'prod'
    };
}

});


parcelRegister("9vXJM", function(module, exports) {

let $6ed558e4c4924f7b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6ed558e4c4924f7b$var$load("94M02").then(()=>parcelRequire('497YX'));

});




parcelRegister("bao60", function(module, exports) {

$parcel$export(module.exports, "handleGraphQLRequest", () => $2e6b10bf02df85e7$export$7feffc86760ee7ce);

var $7eAIS = parcelRequire("7eAIS");

var $kdyFn = parcelRequire("kdyFn");

var $fmVjq = parcelRequire("fmVjq");
async function $2e6b10bf02df85e7$export$93d33e3b46bf00e7(serviceUrl, body, options = {}) {
    const operationNameQuery = options.operationName ? `?q=${options.operationName}` : '';
    const errorPolicy = options.errorPolicy || 'none';
    const url = serviceUrl + operationNameQuery;
    const request = fetch(url, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        credentials: 'include',
        body: JSON.stringify(body)
    }).then((res)=>{
        if (res.status < 300 || res.status === 400) return res.json();
        else throw res;
    });
    try {
        const response = await request;
        const errors = response.errors;
        if (errors) {
            if (errorPolicy === 'none') throw (0, $7eAIS.GraphQLError).from(errors);
            else if (errorPolicy === 'all') // Set timeout will postpone error throwing and de-touch it to another event loop,
            // so we can return data along with throwing error
            return new Promise((resolve, reject)=>{
                setTimeout(()=>{
                    reject((0, $7eAIS.GraphQLError).from(errors));
                }, 0);
            });
        }
        return response.data;
    } catch (error) {
        if (error instanceof Response) return {
            response: error
        };
        if (Object(error).hasOwnProperty('response')) throw error;
        return error;
    }
}
async function $2e6b10bf02df85e7$export$7feffc86760ee7ce(serviceUrl, body, options = {}) {
    const makeGraphQLRequestWithRetries = (0, $kdyFn.withExponentialBackoff)($2e6b10bf02df85e7$export$93d33e3b46bf00e7, {
        initial: (0, $kdyFn.EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
        jitter: (0, $kdyFn.EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
        max: (0, $kdyFn.EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
        retryIf: (data)=>{
            return (0, $kdyFn.isFetchResponse)(data) && (0, $kdyFn.is5xx)(data.response.status);
        }
    });
    const result = await makeGraphQLRequestWithRetries(serviceUrl, body, options);
    const response = result?.response;
    if (response) {
        const status = response.status;
        const statusText = response.statusText;
        const traceId = response.headers.get('atl-traceid');
        (0, $fmVjq.handleResponse)(response);
        if (status > 400 && status <= 599) throw new (0, $7eAIS.HttpError)({
            message: statusText,
            status: status,
            traceId: traceId ?? undefined
        });
    }
    return result;
}

});
parcelRegister("kdyFn", function(module, exports) {

$parcel$export(module.exports, "EXPONENTIAL_BACKOFF_RETRY_POLICY", () => $e284e0beeb1ad5b2$export$8f4286bf21155381);
$parcel$export(module.exports, "is5xx", () => $e284e0beeb1ad5b2$export$55b2fbd5d4a32495);
$parcel$export(module.exports, "isFetchResponse", () => $e284e0beeb1ad5b2$export$81f27058be86d7ea);
$parcel$export(module.exports, "withExponentialBackoff", () => $e284e0beeb1ad5b2$export$20eaa22f2295996f);
$parcel$export(module.exports, "fetchWithExponentialBackoff", () => $e284e0beeb1ad5b2$export$b4c0bf5325504bf3);
const $e284e0beeb1ad5b2$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $e284e0beeb1ad5b2$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
function $e284e0beeb1ad5b2$export$81f27058be86d7ea(data) {
    if (!data || !data.hasOwnProperty('response')) return false;
    return data.response instanceof Response;
}
// tslint:disable-next-line no-any
const $e284e0beeb1ad5b2$var$defaultRetryIfCallback = (a)=>!a;
const $e284e0beeb1ad5b2$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $e284e0beeb1ad5b2$var$defaultRetryIfCallback
};
function $e284e0beeb1ad5b2$export$20eaa22f2295996f(toTry, hofOptions = $e284e0beeb1ad5b2$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
const $e284e0beeb1ad5b2$export$b4c0bf5325504bf3 = $e284e0beeb1ad5b2$export$20eaa22f2295996f((url, init)=>fetch(url, init), {
    initial: $e284e0beeb1ad5b2$export$8f4286bf21155381.INITIAL_DELAY,
    jitter: $e284e0beeb1ad5b2$export$8f4286bf21155381.JITTER,
    max: $e284e0beeb1ad5b2$export$8f4286bf21155381.MAX_RETRIES,
    retryIf: (response)=>$e284e0beeb1ad5b2$export$55b2fbd5d4a32495(response.status)
});

});

parcelRegister("fmVjq", function(module, exports) {

$parcel$export(module.exports, "handleResponse", () => $ea5e8ca0da4c9de0$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $ea5e8ca0da4c9de0$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $ea5e8ca0da4c9de0$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $ea5e8ca0da4c9de0$export$8c005e458e12d501.handlers = handlers;
    }
};
function $ea5e8ca0da4c9de0$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $ea5e8ca0da4c9de0$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});



parcelRegister("8ZouZ", function(module, exports) {

$parcel$export(module.exports, "TeamHasAgentsQuery", () => $66f44aced11ede5e$export$5a63c9c7b444f1f5);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $66f44aced11ede5e$export$5a63c9c7b444f1f5 = (0, $6NFTG.print)((0, $kuAvn.default)`
	query serviceName_TeamHasAgentsQuery($id: ID!) {
		graphStore @optIn(to: "GraphStore") {
			teamHasAgents(id: $id) @optIn(to: "GraphStoreTeamHasAgents") {
				edges {
					node {
						... on AppUser {
							id
							name
							picture
						}
					}
					cursor
				}
				pageInfo {
					hasNextPage
					endCursor
				}
			}
		}
	}
`);

});

parcelRegister("kFoav", function(module, exports) {

$parcel$export(module.exports, "default", () => $b64af9936b3bc705$export$2e2bcd8739ae039);
const $b64af9936b3bc705$var$TeamMembershipQuery = `query app_user_characteristics($teamId: ID!, $siteId: String!, $membershipState: [TeamMembershipState!]!, $first: Int!, $after: String) {
    team {
      teamV2(
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        members(state: $membershipState, first: $first, after: $after) {
          edges {
            node {
              member {
                id
                name
                picture
                accountStatus
                ... on AtlassianAccountUser {
                  extendedProfile {
                    jobTitle
                  }
                }
                ... on AppUser {
                  appType
                }
              }
              role
              state
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }`;
var $b64af9936b3bc705$export$2e2bcd8739ae039 = $b64af9936b3bc705$var$TeamMembershipQuery;

});

parcelRegister("1C7fa", function(module, exports) {

$parcel$export(module.exports, "TeamsUserQuery", () => $fb20ed74c9109efd$export$9963ed3cbf7b791c);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $fb20ed74c9109efd$export$9963ed3cbf7b791c = (0, $6NFTG.print)((0, $kuAvn.default)`
	query TeamsUserQuery($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				locale
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					department
					location
					phoneNumbers {
						type
						value
					}
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				locale
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`);

});

parcelRegister("6qJst", function(module, exports) {

$parcel$export(module.exports, "toUserType", () => $385aa7799a3d60f2$export$6b53fef091c7e27d);
function $385aa7799a3d60f2$export$6b53fef091c7e27d({ isBot: isBot, appType: appType }) {
    // Note, the order of these checks is important
    if (appType?.toLocaleLowerCase() === 'agent') return 'agent';
    if (isBot) return 'bot';
    return 'user';
}

});


parcelRegister("jWVEO", function(module, exports) {

$parcel$export(module.exports, "default", () => $3deb5d9180d1d877$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");
var $3deb5d9180d1d877$var$CONTAINER_TYPE = /*#__PURE__*/ function(CONTAINER_TYPE) {
    CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
    CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    return CONTAINER_TYPE;
}($3deb5d9180d1d877$var$CONTAINER_TYPE || {});
var $3deb5d9180d1d877$var$ENTITY_TYPE = /*#__PURE__*/ function(ENTITY_TYPE) {
    ENTITY_TYPE["CONTAINER"] = "CONTAINER";
    ENTITY_TYPE["USER"] = "USER";
    return ENTITY_TYPE;
}($3deb5d9180d1d877$var$ENTITY_TYPE || {});
class $3deb5d9180d1d877$export$cd5b4a06db0ea4e2 extends (0, $f4dfy.RestClient) {
    getUserContainers({ userId: userId, principalId: principalId, siteId: siteId, sessionId: sessionId, maxNumberOfResults: maxNumberOfResults }) {
        return this.postResource('/v1/collaborationgraph/user/container', {
            context: {
                contextType: 'atlassianDirectory',
                principalId: principalId,
                siteId: siteId,
                sessionId: sessionId
            },
            containerTypes: [
                'confluenceSpace',
                'jiraProject'
            ],
            maxNumberOfResults: maxNumberOfResults,
            userId: userId,
            expanded: true
        });
    }
}
var $3deb5d9180d1d877$export$2e2bcd8739ae039 = new $3deb5d9180d1d877$export$cd5b4a06db0ea4e2({
    serviceUrl: (0, $hncrn.DEFAULT_CONFIG).collaborationGraphUrl
});

});
parcelRegister("f4dfy", function(module, exports) {

$parcel$export(module.exports, "RestClient", () => $f4b310ea0eea58cd$export$ea8b5b3aea9558ce);

var $bx11l = parcelRequire("bx11l");

var $7eAIS = parcelRequire("7eAIS");

var $kdyFn = parcelRequire("kdyFn");

var $fmVjq = parcelRequire("fmVjq");

var $2k5M1 = parcelRequire("2k5M1");

var $cTA7L = parcelRequire("cTA7L");

var $hT1xa = parcelRequire("hT1xa");

var $fLJk5 = parcelRequire("fLJk5");

var $bZ6Gn = parcelRequire("bZ6Gn");
const $f4b310ea0eea58cd$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
let $f4b310ea0eea58cd$var$incrementRedirectCount;
let $f4b310ea0eea58cd$var$clearRedirectCount;
$f4b310ea0eea58cd$export$7a0fc52d8c359feb();
function $f4b310ea0eea58cd$export$7a0fc52d8c359feb() {
    $f4b310ea0eea58cd$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bx11l)))(()=>(0, $cTA7L.setCookie)((0, $cTA7L.REDIRECT_COUNT), (0, $cTA7L.getCookieAsInteger)((0, $cTA7L.REDIRECT_COUNT)) + 1));
    $f4b310ea0eea58cd$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bx11l)))(()=>(0, $cTA7L.clearCookie)((0, $cTA7L.REDIRECT_COUNT)));
}
class $f4b310ea0eea58cd$export$ea8b5b3aea9558ce extends (0, $2k5M1.BaseClient) {
    constructor({ serviceUrl: serviceUrl = '', config: config = {
        logException: ()=>{}
    } }){
        super(config), /**
	 * This function is necessary for if `statusCodeHandler` prescribes a login
	 * redirect upon a 401 response.
	 * While the default redirect behaviour may be overriden, this function has
	 * been kept separate to ensure it cannot be overriden, lest a host
	 * application supply embeddable-directory with a custom handler that suffers
	 * the infinite redirect bug.
	 */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $f4b310ea0eea58cd$var$incrementRedirectCount();
            } else $f4b310ea0eea58cd$var$clearRedirectCount();
        };
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async getResource(path, fetchOptions = {}) {
        return this.makeRequest(path, fetchOptions);
    }
    async getResourceCached(path, fetchOptions = {}, cacheOptions) {
        const cacheKey = path;
        const cacheRecord = this.getCachedValue(cacheKey);
        if (cacheRecord) return cacheRecord;
        const response = await this.getResource(path, fetchOptions);
        this.cacheValue(cacheKey, response, cacheOptions?.expiration);
        return response;
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
			 * PATCH must be uppercase as per fetch spec only
			 * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
			 * are normalised to uppercase.
			 *
			 * https://github.com/github/fetch/issues/37
			 * https://fetch.spec.whatwg.org/#methods
			 */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {
        shouldLogError: (e)=>e.status !== 429
    }) {
        const url = this.serviceUrl + path;
        const options = {
            ...$f4b310ea0eea58cd$var$defaultFetchOptions,
            ...additionalFetchOptions
        };
        const response = await (0, $kdyFn.fetchWithExponentialBackoff)(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $fmVjq.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $7eAIS.SLOIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await (0, $hT1xa.parseErrorMessage)(response);
                const httpError = new (0, $7eAIS.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId ?? undefined,
                    path: path
                });
                if (options.shouldLogError && options.shouldLogError(httpError)) this.logException(httpError, (0, $bZ6Gn.stripUUIDFromPath)(path), {
                    method: options.method || 'GET',
                    url: url,
                    status: responseStatusCode
                });
                throw httpError;
            }
        }
        return additionalFetchOptions.ignoreResponse ? null : (0, $fLJk5.parseResponse)(response);
    }
}

});
parcelRegister("cTA7L", function(module, exports) {

$parcel$export(module.exports, "REDIRECT_COUNT", () => $3804e15c953cc2d8$export$f6101897f0230549);
$parcel$export(module.exports, "setCookie", () => $3804e15c953cc2d8$export$110700823644f4a6);
$parcel$export(module.exports, "getCookieAsInteger", () => $3804e15c953cc2d8$export$6a289e5003f59269);
$parcel$export(module.exports, "clearCookie", () => $3804e15c953cc2d8$export$ad3506281d5a5e5d);
const $3804e15c953cc2d8$export$f6101897f0230549 = 'redirectCount';
const $3804e15c953cc2d8$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $3804e15c953cc2d8$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $3804e15c953cc2d8$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $3804e15c953cc2d8$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

});

parcelRegister("hT1xa", function(module, exports) {

$parcel$export(module.exports, "parseErrorMessage", () => $30e2b438421fffae$export$91c32f1b22d29b2d);
async function $30e2b438421fffae$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.error) return `${json.status || 'UNKNOWN_STATUS'} ${json.error || 'MISSING_ERROR_MESSAGE'}`;
    else if (json.status) return `${json.status} MISSING_ERROR_MESSAGE`;
    else if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || 'MISSING_ERROR_MESSAGE');
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}

});

parcelRegister("fLJk5", function(module, exports) {

$parcel$export(module.exports, "parseResponse", () => $95bfa249eb0301d7$export$ba14d9a5a581e827);
function $95bfa249eb0301d7$export$ba14d9a5a581e827(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}

});

parcelRegister("bZ6Gn", function(module, exports) {

$parcel$export(module.exports, "stripUUIDFromPath", () => $fb47b928702db867$export$6bd073e2c6dda996);
const $fb47b928702db867$var$UUID_REGEX = new RegExp(/((\w{4,12}-?)){5}/g);
const $fb47b928702db867$export$6bd073e2c6dda996 = (path)=>{
    return path.replace($fb47b928702db867$var$UUID_REGEX, '<UUID>');
};

});



parcelRegister("kl6VX", function(module, exports) {

$parcel$export(module.exports, "directoryClient", () => $4f169f0f24afad44$export$ead519165de472de);

var $hncrn = parcelRequire("hncrn");

var $le4QF = parcelRequire("le4QF");

var $kP1cg = parcelRequire("kP1cg");
const $4f169f0f24afad44$export$28456d095a642fd = 'internal.browse-users-allowed';
const $4f169f0f24afad44$var$buildTeamMembershipQuery = (teamId, membershipState)=>({
        query: `query TeamMembership($teamId: String!, $membershipState: [TeamMembershipStatus]) {
    TeamMembership: TeamMembership(teamId: $teamId, membershipStates: $membershipState) {
      user: profile {
        id,
        fullName,
        title,
        avatarUrl,
        timezone,
        status
      },
      state:membershipStatus,
      role,
      membershipId {
        teamId, memberId
      }
    }
  }`,
        variables: {
            teamId: teamId,
            membershipState: membershipState
        }
    });
const $4f169f0f24afad44$var$buildUserQuery = (userId, cloudId)=>({
        query: `query CloudUser($userId: String!, $cloudId: String!) {
    CloudUser(userId: $userId, cloudId: $cloudId) {
      avatarUrl
      id
      fullName
      title
    }
  }`,
        variables: {
            userId: userId,
            cloudId: cloudId
        }
    });
const $4f169f0f24afad44$var$delay = (millis)=>new Promise((resolve)=>{
        setTimeout(resolve, millis);
    });
class $4f169f0f24afad44$export$c8a50bf6c196fc10 extends (0, $le4QF.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/directory/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/directory/graphql`);
    }
    async queryFeatureFlags(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId, flags) {
        const queryFeatureFlags = {
            query: `query FeatureFlags($cloudId: String!, $flags: [String]!) {
        FeatureFlags(cloudId: $cloudId, flags: $flags) {
          flag
          enabled
        }
      }`,
            variables: {
                cloudId: this.getCloudId(cloudId),
                flags: flags
            }
        };
        const { FeatureFlags: FeatureFlags } = await this.makeGraphQLRequest(queryFeatureFlags, {
            operationName: 'FeatureFlags'
        });
        return FeatureFlags.map(({ flag: flag, enabled: enabled })=>[
                flag,
                enabled
            ]).reduce((acc, val)=>(acc[val[0]] = val[1], acc), {});
    }
    canRetryError(pendingRetries, error) {
        return pendingRetries > 0 && !!error && typeof error === 'object' && 'category' in error && error.category === 'NotFound';
    }
    /**
   * Get user information of all members of a team
   * @param {string} teamId
   * @returns {Promise}
   * @private
   * @deprecated use AGG instead
   */ queryTeamMemberships(teamId, membershipStatus = [
        'FULL_MEMBER'
    ]) {
        // eslint-disable-next-line no-console
        console.warn('Directory queryTeamMemberships is deprecated, use AGG instead');
        const teamMembershipsQuery = $4f169f0f24afad44$var$buildTeamMembershipQuery(teamId, membershipStatus);
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(teamMembershipsQuery, {
                    operationName: 'TeamMembership'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $4f169f0f24afad44$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest().then(({ TeamMembership: TeamMembership })=>TeamMembership);
    }
    /**
   * Get user information of all members of a team
   * @param {string} userId
   * @returns {Promise}
   */ queryUser(userId, /**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId) {
        const userQuery = $4f169f0f24afad44$var$buildUserQuery(userId, this.getCloudId(cloudId));
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(userQuery, {
                    operationName: 'CloudUser'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $4f169f0f24afad44$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest();
    }
}
const $4f169f0f24afad44$export$ead519165de472de = new $4f169f0f24afad44$export$c8a50bf6c196fc10((0, $hncrn.DEFAULT_CONFIG).stargateRoot, {
    logException: $kP1cg.logException
});

});

parcelRegister("bP17Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd66c970efc6b685$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");

var $a0w2l = parcelRequire("a0w2l");
const $bd66c970efc6b685$var$defaultConfig = {
    serviceUrl: `${(0, $hncrn.DEFAULT_CONFIG).stargateRoot}/users`
};
class $bd66c970efc6b685$export$f9c003efee04f318 extends (0, $f4dfy.RestClient) {
    constructor(config = {}){
        super({
            ...$bd66c970efc6b685$var$defaultConfig,
            ...config
        });
    }
    async getUserManageConfig(userId) {
        return this.getResourceCached(`/${userId}/manage`).then((resp)=>{
            return (0, $a0w2l.transformUserManageConfig)(resp);
        });
    }
    /**
	 * @deprecated
	 * User fetchUserAvatarInfo instead
	 */ async getMyAvatarUploadedStatus(userId) {
        return this.fetchUserAvatarInfo(userId);
    }
    async deleteAvatar(userId) {
        return this.deleteResource(`/${userId}/manage/avatar`);
    }
    async fetchUserAvatarInfo(userId) {
        return this.getResource(`/${userId}/manage/avatar`);
    }
    async updateUser({ id: id, ...user }) {
        return this.patchResource(`/${id}/manage/profile`, (0, $a0w2l.toManageAPIInput)(user));
    }
    async updateUserAvatar({ id: id, fileURI: fileURI }) {
        const fileObject = (0, $a0w2l.dataURItoFile)(fileURI);
        const formData = new FormData();
        formData.append('file', fileObject);
        const response = await this.makeRequest(`/${id}/manage/avatar`, {
            method: 'PUT',
            body: formData
        });
        return response.url;
    }
}
var $bd66c970efc6b685$export$2e2bcd8739ae039 = new $bd66c970efc6b685$export$f9c003efee04f318();

});
parcelRegister("a0w2l", function(module, exports) {

$parcel$export(module.exports, "transformUserManageConfig", () => $cbf9873764e358e5$export$d7725d3d27b80a68);
$parcel$export(module.exports, "toManageAPIInput", () => $cbf9873764e358e5$export$7b103107c889cb67);
$parcel$export(module.exports, "dataURItoFile", () => $cbf9873764e358e5$export$80d19edb7b1ae293);
parcelRequire("7VJg5");
var $7jfLy = parcelRequire("7jfLy");
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $cbf9873764e358e5$var$PROFILE_PROPS_MAP = new Map([
    [
        'id',
        'account_id'
    ],
    [
        'fullName',
        'name'
    ],
    [
        'nickname',
        'nickname'
    ],
    [
        'timezone',
        'zoneinfo'
    ],
    [
        'locale',
        'locale'
    ],
    [
        'avatarUrl',
        'picture'
    ],
    [
        'email',
        'email'
    ]
]);
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $cbf9873764e358e5$var$EXTENDED_PROFILE_PROPS_MAP = new Map([
    [
        'title',
        'job_title'
    ],
    [
        'department',
        'department'
    ],
    [
        'companyName',
        'organization'
    ],
    [
        'location',
        'location'
    ],
    [
        'phoneNumber',
        'phone_number'
    ]
]);
const $cbf9873764e358e5$export$5299664357e4f3dd = (res)=>{
    const data = res.account;
    const extendedData = data && data.extended_profile || {};
    if (!data) return null;
    const timeZone = data.zoneinfo;
    const localTime = ({ format: format })=>{
        if (!timeZone) return null;
        try {
            return (0, $7jfLy.default)(new Date(), timeZone, format);
        } catch (error) {
            // TODO: PTC-4908 send error to sentry for reporting
            return null;
        }
    };
    const profileProps = Array.from($cbf9873764e358e5$var$PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($cbf9873764e358e5$var$PROFILE_PROPS_MAP.has(key)) acc[key] = data[$cbf9873764e358e5$var$PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    const extendedProfileProps = Array.from($cbf9873764e358e5$var$EXTENDED_PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($cbf9873764e358e5$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) acc[key] = extendedData[$cbf9873764e358e5$var$EXTENDED_PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    return {
        ...profileProps,
        ...extendedProfileProps,
        localTime: localTime
    };
};
var $cbf9873764e358e5$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType["FullName"] = "fullName";
    FieldType["Nickname"] = "nickname";
    FieldType["Title"] = "title";
    FieldType["Department"] = "department";
    FieldType["CompanyName"] = "companyName";
    FieldType["Location"] = "location";
    FieldType["Timezone"] = "timezone";
    FieldType["Email"] = "email";
    FieldType["PhoneNumber"] = "phoneNumber";
    FieldType["Avatar"] = "picture";
    FieldType["Language"] = "language";
    FieldType["LocalTime"] = "localTime";
    FieldType["RemoteWeekdayIndex"] = "remoteWeekdayIndex";
    FieldType["RemoteWeekdayString"] = "remoteWeekdayString";
    FieldType["RemoteTimeString"] = "remoteTimeString";
    return FieldType;
}({});
const $cbf9873764e358e5$export$78158d2c2c6998d9 = {
    fullName: 'name',
    nickname: 'nickname',
    timezone: 'zoneinfo',
    locale: 'locale',
    email: 'email',
    // extended profile
    title: 'extended_profile.job_title',
    phoneNumber: 'extended_profile.phone_number',
    companyName: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $cbf9873764e358e5$export$2ff7b92b9e1bb4d2 = {
    email: 'email.initiateChange',
    picture: 'avatar'
};
const $cbf9873764e358e5$var$getFieldConfig = (data, field)=>{
    if ((field === 'email' || field === 'picture') && $cbf9873764e358e5$export$2ff7b92b9e1bb4d2[field]) return data[$cbf9873764e358e5$export$2ff7b92b9e1bb4d2[field]];
    const mappedFieldKey = field in $cbf9873764e358e5$export$78158d2c2c6998d9 ? $cbf9873764e358e5$export$78158d2c2c6998d9[field] : undefined;
    if (!mappedFieldKey) return undefined;
    const profileWrite = data['profile.write'];
    return profileWrite[mappedFieldKey];
};
const $cbf9873764e358e5$var$convertFieldKeyToFieldType = (key)=>{
    // Check if the key can be mapped to a FieldType value
    if (Object.values($cbf9873764e358e5$export$ed12481c953b8653).includes(key)) return key;
    return undefined;
};
const $cbf9873764e358e5$var$getMutabilityConstraintFor = (data, field)=>{
    const fieldConfig = $cbf9873764e358e5$var$getFieldConfig(data, field);
    if (!fieldConfig || fieldConfig.allowed) return undefined;
    const convertedField = $cbf9873764e358e5$var$convertFieldKeyToFieldType(field);
    if (!convertedField) return undefined;
    const reason = fieldConfig.reason;
    return {
        field: convertedField,
        reason: reason && reason.key || null
    };
};
const $cbf9873764e358e5$export$d7725d3d27b80a68 = (data)=>({
        mutabilityConstraints: Object.keys($cbf9873764e358e5$export$78158d2c2c6998d9).map((field)=>$cbf9873764e358e5$var$getMutabilityConstraintFor(data, field)).filter((constraint)=>constraint !== undefined)
    });
const $cbf9873764e358e5$export$7b103107c889cb67 = (input)=>{
    const output = {
        extended_profile: {}
    };
    Object.keys(input).forEach((key)=>{
        if ($cbf9873764e358e5$var$PROFILE_PROPS_MAP.has(key)) output[$cbf9873764e358e5$var$PROFILE_PROPS_MAP.get(key)] = input[key];
        if ($cbf9873764e358e5$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) output.extended_profile[$cbf9873764e358e5$var$EXTENDED_PROFILE_PROPS_MAP.get(key)] = input[key];
    });
    return output;
};
function $cbf9873764e358e5$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const byteString = dataURI.split(',')[0].includes('base64') ? atob(dataURI.split(',')[1]) : decodeURIComponent(dataURI.split(',')[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        mimeString = 'unknown';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 and Safari does not support the File constructor.
        return blob;
    }
}

});
parcelRegister("7VJg5", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("7jfLy")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $7jfLy = parcelRequire("7jfLy");





});
parcelRegister("7jfLy", function(module, exports) {

$parcel$export(module.exports, "default", () => $552689929d984fb3$export$2e2bcd8739ae039);

var $7noXc = parcelRequire("7noXc");

var $6wcTn = parcelRequire("6wcTn");

var $eGHhJ = parcelRequire("eGHhJ");
function $552689929d984fb3$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($7noXc)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $6wcTn.default)((0, $eGHhJ.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("6wcTn", function(module, exports) {

$parcel$export(module.exports, "default", () => $4befbb5afdcbfc65$export$2e2bcd8739ae039);

var $47etr = parcelRequire("47etr");

var $5I5AW = parcelRequire("5I5AW");

var $2uu2q = parcelRequire("2uu2q");
var $4befbb5afdcbfc65$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $4befbb5afdcbfc65$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($4befbb5afdcbfc65$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $2uu2q.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $5I5AW.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($47etr)))(dirtyDate, formatStr, options);
}

});
parcelRegister("5I5AW", function(module, exports) {

$parcel$export(module.exports, "default", () => $428566d76e0630b7$export$2e2bcd8739ae039);

var $a4aWD = parcelRequire("a4aWD");

var $a6f0S = parcelRequire("a6f0S");
var $428566d76e0630b7$var$MILLISECONDS_IN_MINUTE = 60000;
var $428566d76e0630b7$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $428566d76e0630b7$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $428566d76e0630b7$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $428566d76e0630b7$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $428566d76e0630b7$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $428566d76e0630b7$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $428566d76e0630b7$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $428566d76e0630b7$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $428566d76e0630b7$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $428566d76e0630b7$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $428566d76e0630b7$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $428566d76e0630b7$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $a4aWD.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $a4aWD.default)('long', date, options);
        }
    }
};
function $428566d76e0630b7$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $a6f0S.default)(timeZone, originalDate, true) / $428566d76e0630b7$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $428566d76e0630b7$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $428566d76e0630b7$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $428566d76e0630b7$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $428566d76e0630b7$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $428566d76e0630b7$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $428566d76e0630b7$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $428566d76e0630b7$var$formatTimezone(offset, dirtyDelimeter);
}
function $428566d76e0630b7$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $428566d76e0630b7$var$addLeadingZeros(minutes, 2);
}
var $428566d76e0630b7$export$2e2bcd8739ae039 = $428566d76e0630b7$var$formatters;

});
parcelRegister("a4aWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7542c480055dff24$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $7542c480055dff24$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $7542c480055dff24$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $7542c480055dff24$var$partsTimeZone(dtf, date) : $7542c480055dff24$var$hackyTimeZone(dtf, date);
}
function $7542c480055dff24$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $7542c480055dff24$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $7542c480055dff24$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("a6f0S", function(module, exports) {

$parcel$export(module.exports, "default", () => $75a61c39315b6d60$export$2e2bcd8739ae039);

var $4e7pW = parcelRequire("4e7pW");

var $cPmn1 = parcelRequire("cPmn1");
var $75a61c39315b6d60$var$MILLISECONDS_IN_HOUR = 3600000;
var $75a61c39315b6d60$var$MILLISECONDS_IN_MINUTE = 60000;
var $75a61c39315b6d60$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $75a61c39315b6d60$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $75a61c39315b6d60$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $75a61c39315b6d60$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$75a61c39315b6d60$var$validateTimezone(hours)) return NaN;
        return -(hours * $75a61c39315b6d60$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $75a61c39315b6d60$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$75a61c39315b6d60$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $75a61c39315b6d60$var$MILLISECONDS_IN_HOUR + minutes * $75a61c39315b6d60$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($75a61c39315b6d60$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $75a61c39315b6d60$var$toUtcDate(date);
        var offset = $75a61c39315b6d60$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $75a61c39315b6d60$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $75a61c39315b6d60$var$toUtcDate(date) {
    return (0, $cPmn1.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $75a61c39315b6d60$var$calcOffset(date, timezoneString) {
    var tokens = (0, $4e7pW.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $cPmn1.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $75a61c39315b6d60$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $75a61c39315b6d60$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $75a61c39315b6d60$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $75a61c39315b6d60$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $75a61c39315b6d60$var$validIANATimezoneCache = {};
function $75a61c39315b6d60$var$isValidTimezoneIANAString(timeZoneString) {
    if ($75a61c39315b6d60$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $75a61c39315b6d60$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("4e7pW", function(module, exports) {

$parcel$export(module.exports, "default", () => $313e39323cc367ca$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $313e39323cc367ca$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $313e39323cc367ca$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $313e39323cc367ca$var$partsOffset(dtf, date) : $313e39323cc367ca$var$hackyOffset(dtf, date);
}
var $313e39323cc367ca$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $313e39323cc367ca$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $313e39323cc367ca$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $313e39323cc367ca$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $313e39323cc367ca$var$dtfCache = {};
function $313e39323cc367ca$var$getDateTimeFormat(timeZone) {
    if (!$313e39323cc367ca$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $313e39323cc367ca$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $313e39323cc367ca$var$dtfCache[timeZone];
}

});

parcelRegister("cPmn1", function(module, exports) {

$parcel$export(module.exports, "default", () => $956b99c0c86aee93$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $956b99c0c86aee93$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("2uu2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d05af1238005827$export$2e2bcd8739ae039);

var $a04h3 = parcelRequire("a04h3");

var $ejJXr = parcelRequire("ejJXr");

var $a6f0S = parcelRequire("a6f0S");

var $6ireg = parcelRequire("6ireg");
var $1d05af1238005827$var$MILLISECONDS_IN_HOUR = 3600000;
var $1d05af1238005827$var$MILLISECONDS_IN_MINUTE = 60000;
var $1d05af1238005827$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $1d05af1238005827$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $6ireg.default)
};
function $1d05af1238005827$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $1d05af1238005827$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($a04h3)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $1d05af1238005827$var$splitDateString(argument);
    var parseYearResult = $1d05af1238005827$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $1d05af1238005827$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $1d05af1238005827$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $a6f0S.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $1d05af1238005827$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $1d05af1238005827$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $1d05af1238005827$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $1d05af1238005827$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $1d05af1238005827$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $1d05af1238005827$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $1d05af1238005827$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $1d05af1238005827$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $1d05af1238005827$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $1d05af1238005827$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $1d05af1238005827$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$1d05af1238005827$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $1d05af1238005827$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$1d05af1238005827$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $1d05af1238005827$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$1d05af1238005827$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $1d05af1238005827$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$1d05af1238005827$var$validateWeekDate(year, week)) return new Date(NaN);
        return $1d05af1238005827$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $1d05af1238005827$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$1d05af1238005827$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $1d05af1238005827$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $1d05af1238005827$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $1d05af1238005827$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$1d05af1238005827$var$validateTime(hours)) return NaN;
        return hours % 24 * $1d05af1238005827$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $1d05af1238005827$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$1d05af1238005827$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $1d05af1238005827$var$MILLISECONDS_IN_HOUR + minutes * $1d05af1238005827$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $1d05af1238005827$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$1d05af1238005827$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $1d05af1238005827$var$MILLISECONDS_IN_HOUR + minutes * $1d05af1238005827$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $1d05af1238005827$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $1d05af1238005827$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $1d05af1238005827$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $1d05af1238005827$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $1d05af1238005827$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $1d05af1238005827$var$isLeapYearIndex(year);
        if (isLeapYear && date > $1d05af1238005827$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $1d05af1238005827$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $1d05af1238005827$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $1d05af1238005827$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $1d05af1238005827$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $1d05af1238005827$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("6ireg", function(module, exports) {

$parcel$export(module.exports, "default", () => $49598b9ea35f9461$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $49598b9ea35f9461$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $49598b9ea35f9461$export$2e2bcd8739ae039 = $49598b9ea35f9461$var$tzPattern;

});



parcelRegister("eGHhJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab16907049be4ecb$export$2e2bcd8739ae039);

var $a6f0S = parcelRequire("a6f0S");

var $2uu2q = parcelRequire("2uu2q");
function $ab16907049be4ecb$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $2uu2q.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $a6f0S.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});





parcelRegister("1Ah8w", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b18fef77162262a$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");

var $kP1cg = parcelRequire("kP1cg");

var $1Ww4G = parcelRequire("1Ww4G");
const $1b18fef77162262a$var$PRODUCT_RECCOMENDATIONS = '/v1/product-recommendations';
const $1b18fef77162262a$var$PRODUCT_JOIN_OR_REQUEST_BULK = '/v1/access-requests/bulk/request';
const $1b18fef77162262a$var$ALL_SUPPORTED_PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-servicedesk',
    'jira-software',
    'jira-incident-manager',
    'jira-product-discovery',
    'opsgenie',
    'statuspage',
    'avocado',
    'townsquare',
    'compass',
    'avp',
    'beacon',
    'mercury'
];
class $1b18fef77162262a$export$3209eb31343f39d extends (0, $f4dfy.RestClient) {
    constructor(serviceUrl, config){
        super({
            serviceUrl: serviceUrl,
            config: config
        });
    }
    async getProductRecommendationsInner(supportedProducts = $1b18fef77162262a$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        try {
            const orgId = this.getOrgId();
            const queryProducts = supportedProducts && supportedProducts.length > 0 ? supportedProducts : $1b18fef77162262a$var$ALL_SUPPORTED_PRODUCTS;
            const productQueryParams = queryProducts.map((product)=>`product=${product}`).join('&');
            const capabilityQueryParams = capabilities && capabilities.length > 0 ? '&' + capabilities.map((capability)=>`capability=${capability}`).join('&') : '';
            const url = `${$1b18fef77162262a$var$PRODUCT_RECCOMENDATIONS}?orgId=${orgId}&${productQueryParams}${capabilityQueryParams}`;
            return await this.getResource(url);
        } catch (error) {
            this.logException(error, 'An error occurred while getting product recommendations.');
            throw error;
        }
    }
    async getProductRecommendations(supportedProducts = $1b18fef77162262a$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        // This endpoint may return duplicate resource ARIs with a different mode.
        const result = await this.getProductRecommendationsInner(supportedProducts, capabilities);
        try {
            const deduplicatedResult = (0, $1Ww4G.removeDuplicateRecommendations)(result);
            return deduplicatedResult;
        } catch (error) {
            this.logException(error, 'An error occurred while deduplicating product recommendations.');
            throw error;
        }
    }
    async joinOrRequestDefaultAccessToProductsBulk(simplifiedRequest) {
        if (simplifiedRequest.productAris.length === 0) return Promise.resolve([]);
        try {
            const resources = simplifiedRequest.productAris.map((ari)=>({
                    ari: ari,
                    role: 'product/member'
                }));
            const request = {
                resources: resources,
                note: simplifiedRequest.note,
                accessMode: simplifiedRequest.accessMode,
                source: simplifiedRequest.source
            };
            return await this.postResource($1b18fef77162262a$var$PRODUCT_JOIN_OR_REQUEST_BULK, request);
        } catch (error) {
            this.logException(error, 'An error occurred while joining or requesting access to products.');
            throw error;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$1b18fef77162262a$export$2e2bcd8739ae039 = new $1b18fef77162262a$export$3209eb31343f39d((0, $hncrn.DEFAULT_CONFIG).invitationsServiceUrl, {
    logException: $kP1cg.logException
});

});
parcelRegister("1Ww4G", function(module, exports) {

$parcel$export(module.exports, "removeDuplicateRecommendations", () => $76ec459f68198552$export$d9d1c981635dd213);
/**
 * Determines which capability is more desirable.
 * Users desire direct access over request access since it's instant.
 * @returns 0 if equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $76ec459f68198552$var$compareCapability = (a, b)=>{
    if (a === b) return 0;
    return a === 'DIRECT_ACCESS' ? -1 : 1;
};
/**
 * Determines which mode is more desirable.
 * Atlassian prefers to provide open access over domain restricted access.
 * Both of these modes have already been enabled by an admin.
 * If mode is undefined, it is deemed least desirable.
 * @returns 0 if equal, -1 if a is more open, 1 if b is more open.
 */ const $76ec459f68198552$var$compareMode = (a, b)=>{
    if (a === b) return 0;
    if (!a) return 1;
    if (!b) return -1;
    return a === 'OPEN' ? -1 : 1;
};
/**
 * Determine if a recommendation is more desirable than another.
 * Atlassian prefers a better capability over any mode setting.
 * The mode will only be compared if the capabilities are equal.
 * If both capability and mode are equal, the recommendations are considered the same.
 *
 * Assumes recommendations have the same resource ID.
 * Do not compare recommendations with different resource IDs, as it does not make sense.
 *
 * @returns 0 if capability and mode are equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $76ec459f68198552$var$compareRecommendations = (a, b)=>{
    if (a.resourceId !== b.resourceId) throw new Error('Recommendations must have the same resource ID');
    if ($76ec459f68198552$var$compareCapability(a.capability, b.capability) < 0) return -1;
    else if ($76ec459f68198552$var$compareCapability(a.capability, b.capability) > 0) return 1;
    else if ($76ec459f68198552$var$compareMode(a.mode, b.mode) < 0) return -1;
    else if ($76ec459f68198552$var$compareMode(a.mode, b.mode) > 0) return 1;
    return 0;
};
const $76ec459f68198552$var$toRecommendation = (recommendation)=>{
    const { capability: capability, ...rest } = recommendation;
    return {
        ...rest
    };
};
const $76ec459f68198552$export$d9d1c981635dd213 = (recommendations)=>{
    const { DIRECT_ACCESS: DIRECT_ACCESS, REQUEST_ACCESS: REQUEST_ACCESS } = recommendations.capability;
    const uniqueRecommendations = {};
    const allRecommendations = [
        ...DIRECT_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'DIRECT_ACCESS'
            })),
        ...REQUEST_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'REQUEST_ACCESS'
            }))
    ];
    allRecommendations.forEach((recommendation)=>{
        const existing = uniqueRecommendations[recommendation.resourceId];
        if (existing && $76ec459f68198552$var$compareRecommendations(existing, recommendation) <= 0) return;
        uniqueRecommendations[recommendation.resourceId] = recommendation;
    });
    const allUniqueRecommendations = Object.values(uniqueRecommendations);
    return {
        capability: {
            DIRECT_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'DIRECT_ACCESS').map($76ec459f68198552$var$toRecommendation),
            REQUEST_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'REQUEST_ACCESS').map($76ec459f68198552$var$toRecommendation)
        }
    };
};

});


parcelRegister("a6X0K", function(module, exports) {

$parcel$export(module.exports, "defaultLegionClient", () => $87dfec5f143ea955$export$95c697fe95d86a77);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");
const $87dfec5f143ea955$var$v3UrlPath = `/v3/teams`;
const $87dfec5f143ea955$var$v4UrlPath = `/v4/teams`;
class $87dfec5f143ea955$export$68a6a391e3cf23be extends (0, $f4dfy.RestClient) {
    constructor(serviceUrl){
        super({
            serviceUrl: serviceUrl
        });
        this.serviceUrlRoot = serviceUrl;
    }
    setRootUrl(url) {
        if (url === this.serviceUrlRoot) return;
        this.serviceUrlRoot = url;
        this.setServiceUrl(url);
    }
    async getTeamById(teamId) {
        const siteId = this.getCloudId();
        const teamResponse = await this.getResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}?siteId=${siteId}`);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    async getAllTeams(allTeamsQuery) {
        try {
            const orgId = this.getOrgId(allTeamsQuery.orgId);
            const siteId = this.getCloudId();
            const { entities: entities, cursor: cursor } = await this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/search`, {
                organizationId: orgId,
                siteId: siteId,
                limit: allTeamsQuery.limit,
                query: allTeamsQuery.searchQuery,
                cursor: allTeamsQuery.cursor || '',
                sortBy: allTeamsQuery.useDefaultSort ? null : allTeamsQuery.sortBy && allTeamsQuery.sortBy.length > 0 ? allTeamsQuery.sortBy : [
                    {
                        field: 'displayName',
                        order: 'asc'
                    }
                ],
                membership: {
                    memberAccountIds: allTeamsQuery.memberAccountIds
                },
                showEmptyTeams: allTeamsQuery.showEmptyTeams
            });
            const teams = entities.map((t)=>this.mapTeamSearchResponseV4ToTeamWithMembership(t));
            return {
                cursor: cursor,
                teams: teams
            };
        } catch (error) {
            this.logException(error, 'getAllTeams');
            return {
                cursor: '',
                teams: [],
                error: error instanceof Error ? error : undefined
            };
        }
    }
    async updateTeamById(teamId, data) {
        const teamResponse = await this.patchResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}`, data);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.addUsersToTeam instead
	 */ async inviteUsersToTeam(teamId, users, originQuery) {
        if (!users || users.length === 0) return Promise.resolve([]);
        const emails = [];
        const ids = [];
        users.forEach((user)=>{
            if (user.id) ids.push(user.id);
            else if (user.email) emails.push(user.email);
        });
        const url = `${$87dfec5f143ea955$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/invite?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url, {
            emailAddresses: emails,
            atlassianAccounts: ids
        });
    }
    async getMyTeamMembership(teamId) {
        return this.getResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/me?siteId=${this.getCloudId()}`, {
            shouldLogError: (e)=>e.status !== 400
        });
    }
    async getTeamLinksByTeamId(teamId) {
        let siteId = this.getCloudId();
        let response = await this.getResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links?siteId=${siteId}`);
        return this.mapLegionTeamLinksResponseV4ToTeamLinkResponse(response);
    }
    async createTeamLink(teamId, link) {
        const sanitisedTeamLink = {
            contentTitle: link.contentTitle.trim(),
            linkUri: link.linkUri.trim(),
            description: link.description.trim(),
            ...link.creationTime ? {
                creationTime: link.creationTime.trim()
            } : {},
            ...link.teamId ? {
                teamId: link.teamId.trim()
            } : {}
        };
        const response = await this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links`, sanitisedTeamLink);
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async updateTeamLink(teamId, linkId, { linkUri: linkUri, ...linkFields }) {
        const response = await this.putResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`, {
            linkUri: linkUri.trim(),
            ...linkFields
        });
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async deleteTeamLink(teamId, linkId) {
        return this.deleteResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`);
    }
    async reorderTeamLink(teamId, linkId, newPosition) {
        const queryArgs = `?linkId=${linkId}&newPosition=${newPosition}`;
        return this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/order${queryArgs}`);
    }
    async getOrgEligibilityForManagedTeams() {
        const orgId = this.getOrgId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgEligibilityForManagedTeams');
            throw err;
        }
        return this.getResourceCached(`${$87dfec5f143ea955$var$v4UrlPath}/org/${orgId}/premium/eligibility`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async acceptTeamInvitation(teamId) {
        return this.postResource(`${$87dfec5f143ea955$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/accept`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async declineTeamInvitation(teamId) {
        return this.postResource(`${$87dfec5f143ea955$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/decline`);
    }
    async selfJoinTeam(// TODO Test me
    teamId, originQuery) {
        const url = `${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/join?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url);
    }
    async addAgentsToTeam(teamId, agents) {
        if (!agents || agents.length === 0) {
            const missingAgentsError = new Error('Missing agents to add');
            this.logException(missingAgentsError, 'addAgentToTeam');
            throw missingAgentsError;
        }
        try {
            const url = `${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/agents`;
            return this.postResource(url, {
                agents: agents
            });
        } catch (e) {
            this.logException(e, 'addAgentToTeam');
            throw e;
        }
    }
    async removeAgentTeamAssociation(teamId, agentId) {
        try {
            const url = `${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/agents/${agentId}`;
            return this.deleteResource(url);
        } catch (e) {
            this.logException(e, 'removeAgentTeamAssociation');
            throw e;
        }
    }
    async cancelJoinRequest(teamId) {
        return this.deleteResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/request`);
    }
    async acceptJoinRequest(teamId, memberId) {
        return this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/accept`);
    }
    async declineJoinRequest(teamId, memberId) {
        return this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/decline`);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.removeTeamMemberships instead
	 */ async deleteTeamMembership(teamId, memberId) {
        return this.deleteResource(`${$87dfec5f143ea955$var$v3UrlPath}/${this.trimTeamARI(teamId)}/members/${memberId}`);
    }
    /**
	 * @private
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(teamId, memberId) {
        return this.deleteResource(`${$87dfec5f143ea955$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/${memberId}/revoke`);
    }
    async deleteTeam(teamId) {
        return this.deleteResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}`);
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        // This is still not working...
        const members = await this.getResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/members?size=2&membershipState=FULL_MEMBER&siteId=${this.getCloudId()}`);
        return members.entities.length === 1;
    }
    async createTeam(displayName, originQuery, members, membershipSettings = 'OPEN') {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$87dfec5f143ea955$var$v4UrlPath}?${this.constructProductOriginParams(originQuery)}`;
        const legionTeam = await this.postResource(url, {
            displayName: displayName,
            description: '',
            membershipSettings: membershipSettings,
            siteId: this.getCloudId(),
            organizationId: organizationId,
            members: [
                ...new Set(members)
            ]
        });
        return this.mapTeamCreateResponseV4ToTeam(legionTeam);
    }
    async createExternalTeam(description, externalReference, teamName, siteId) {
        const organizationId = this.getContext().orgId;
        const cloudId = this.getContext().cloudId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$87dfec5f143ea955$var$v4UrlPath}/external?origin.cloudId=${encodeURIComponent(this.getCloudId(siteId || cloudId))}`;
        const legionExternalTeam = await this.postResource(url, {
            description: description,
            externalReference: externalReference,
            organizationId: organizationId,
            siteId: siteId || cloudId,
            displayName: teamName
        });
        return this.mapTeamCreateResponseV4ToTeam(legionExternalTeam);
    }
    async getTeamAndGroupDiff(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/diff`, {
            siteId: siteId,
            externalReference: externalReference
        });
    }
    async linkExistingTeamToGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/link`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async getWriteMediaToken() {
        return this.getResource('/v4/teams/header-image/media-upload').then((response)=>({
                ...response,
                baseUrl: response.baseUrl?.endsWith('/') ? response.baseUrl.slice(0, -1) : response.baseUrl
            }));
    }
    async getSoftDeletedTeamById(teamId) {
        const orgId = this.getOrgId();
        const siteId = this.getCloudId();
        return this.getResource(`${$87dfec5f143ea955$var$v4UrlPath}/org/${orgId}/soft-deleted/${this.trimTeamARI(teamId)}?siteId=${siteId}`).then((response)=>({
                ...response.teamResponse,
                id: teamId
            }));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 */ async getUserInSiteUserBase(userId) {
        const siteId = this.getCloudId();
        return this.getResource(`/teams/site/${siteId}/users/${userId}/exists`, {
            headers: {
                Accept: 'application/json',
                'X-header-client-id': 'ptc-fe'
            }
        });
    }
    async retrieveBrowseUserPermission(product) {
        return this.getResourceCached(`/teams/site/${this.getCloudId()}/canSearchUsers?product=${product}`, undefined, // 2 minute expiration, resolves duplicate calls in initial load
        {
            expiration: 120000
        });
    }
    async getPermissions() {
        const orgId = this.getContext().orgId;
        const siteId = this.getCloudId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getPermissions');
            throw err;
        }
        return this.getResourceCached(`${$87dfec5f143ea955$var$v4UrlPath}/permission/self/organization/${orgId}?siteId=${siteId}`);
    }
    async getLinkedTeamsBulk(groupIds) {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getLinkedTeamsBulk');
            throw err;
        }
        const legionExternalTeam = await this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/external/bulk`, {
            organizationId: organizationId,
            source: 'ATLASSIAN_GROUP',
            externalIds: groupIds
        });
        return legionExternalTeam;
    }
    async getTeamProfileDetails(teamId) {
        const siteId = this.getCloudId();
        if (!siteId) {
            const err = new Error('Site ID is required');
            this.logException(err, 'getTeamProfileDetails');
            throw err;
        }
        const linkedTeamsProfileDetails = await this.getResource(`${$87dfec5f143ea955$var$v4UrlPath}/${teamId}/profile?siteId=${this.getCloudId()}`);
        return linkedTeamsProfileDetails;
    }
    async getOrgScope() {
        const orgId = this.getContext().orgId;
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgScope');
            throw err;
        }
        const orgScope = await this.getResourceCached(`${$87dfec5f143ea955$var$v4UrlPath}/org/${orgId}/scope`);
        return orgScope;
    }
    async restoreTeamToSyncedGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return await this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/${teamId}/external/restore`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async createTeamContainers(payload) {
        return this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/containers`, {
            ...payload
        });
    }
    async getTeamEnabledSites(teamId) {
        const teamEnabledSites = await this.getResourceCached(`${$87dfec5f143ea955$var$v4UrlPath}/migrations/scope/${teamId}`);
        return teamEnabledSites;
    }
    async assignTeamsToSites(migrations) {
        const assignTeamsToSitesResponse = await this.postResource(`${$87dfec5f143ea955$var$v4UrlPath}/migrations/scope`, {
            originOrgId: this.getContext().orgId,
            migrations: migrations
        });
        return assignTeamsToSitesResponse;
    }
    // some Legion APIs return team id with the team ARI
    trimTeamARI(teamId = '') {
        const OLD_TEAM_ARI_PREFIX = 'ari:cloud:teams::team/';
        const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
        return teamId.replace(TEAM_ARI_PREFIX, '').replace(OLD_TEAM_ARI_PREFIX, ''); // PTC-4213 will remove the references to the old team ARI
    }
    constructProductOriginParams(originQuery) {
        const product = (originQuery.product || '').toUpperCase();
        const queries = [
            `origin.cloudId=${encodeURIComponent(this.getCloudId(originQuery.cloudId))}`
        ];
        if (product) queries.push(`origin.product=${encodeURIComponent(product)}`);
        return queries.join('&');
    }
    mapTeamResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            scopeMode: teamResponse.scopeMode,
            isVerified: teamResponse.isVerified,
            ...teamResponse.externalReference && {
                externalReference: {
                    id: teamResponse.externalReference.id,
                    source: teamResponse.externalReference.source
                }
            }
        };
    }
    mapTeamCreateResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            memberIds: teamResponse.membership?.members?.map((m)=>m.membershipId.memberId) || [],
            membership: teamResponse.membership
        };
    }
    mapTeamSearchResponseV4ToTeamWithMembership(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            memberCount: teamResponse.memberCount,
            includesYou: teamResponse.includesYou,
            memberIds: [],
            members: [],
            membership: {
                members: [],
                errors: []
            },
            isVerified: teamResponse.isVerified
        };
    }
    mapLegionTeamLinksResponseV3ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV3ToTeamLink)
        };
    }
    mapLegionTeamLinksResponseV4ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV4ToTeamLink)
        };
    }
    mapLegionTeamLinkResponseV3ToTeamLink(legionLinkResponseV3) {
        return {
            contentTitle: legionLinkResponseV3.contentTitle,
            description: legionLinkResponseV3.description,
            creationTime: legionLinkResponseV3.creationTime,
            linkUri: legionLinkResponseV3.linkUri,
            linkId: legionLinkResponseV3.linkId,
            teamId: legionLinkResponseV3.teamId
        };
    }
    mapLegionTeamLinkResponseV4ToTeamLink(legionLinkResponseV4) {
        return {
            contentTitle: legionLinkResponseV4.contentTitle,
            description: legionLinkResponseV4.description,
            linkUri: legionLinkResponseV4.linkUri,
            linkId: legionLinkResponseV4.linkId,
            teamId: legionLinkResponseV4.teamId
        };
    }
}
const $87dfec5f143ea955$export$95c697fe95d86a77 = new $87dfec5f143ea955$export$68a6a391e3cf23be((0, $hncrn.DEFAULT_CONFIG).stargateRoot);

});

parcelRegister("lrqlI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eaef6ee7b9efae5$export$2e2bcd8739ae039);

var $7eAIS = parcelRequire("7eAIS");

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");
const $6eaef6ee7b9efae5$var$defaultConfig = {
    serviceUrl: `${(0, $hncrn.DEFAULT_CONFIG).stargateRoot}/users/manage`
};
const $6eaef6ee7b9efae5$var$NOT_EDITABLE = 'not_editable';
const $6eaef6ee7b9efae5$var$NOT_EDITABLE_FIELD = 'field';
const $6eaef6ee7b9efae5$var$NOT_EDITABLE_REASON = 'reason';
class $6eaef6ee7b9efae5$export$1f387592ab3ca6d0 extends (0, $f4dfy.RestClient) {
    constructor(config = {}){
        super({
            ...$6eaef6ee7b9efae5$var$defaultConfig,
            ...config
        });
    }
    async getProfileWithMutability(userId) {
        return this.getResource(`/${userId}/profile`).then((resp)=>{
            return $6eaef6ee7b9efae5$var$mapToMutabilityConstraints(resp);
        });
    }
}
function $6eaef6ee7b9efae5$var$mapToMutabilityConstraints(json) {
    let constraints = [];
    if (json[$6eaef6ee7b9efae5$var$NOT_EDITABLE] != null) for (const value of json[$6eaef6ee7b9efae5$var$NOT_EDITABLE])constraints = constraints.concat({
        field: value[$6eaef6ee7b9efae5$var$NOT_EDITABLE_FIELD],
        reason: $6eaef6ee7b9efae5$var$determineReason(value[$6eaef6ee7b9efae5$var$NOT_EDITABLE_REASON])
    });
    return constraints;
}
function $6eaef6ee7b9efae5$var$determineReason(value) {
    switch(value){
        case 'managed':
        case 'ext.dir.scim':
        case 'ext.dir.google':
            return value;
        default:
            throw new (0, $7eAIS.DefaultError)({
                message: `Unknown mutability constraint reason: ${value}`
            });
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$6eaef6ee7b9efae5$export$2e2bcd8739ae039 = new $6eaef6ee7b9efae5$export$1f387592ab3ca6d0();

});

parcelRegister("hmfTD", function(module, exports) {

$parcel$export(module.exports, "default", () => $205abd92f18b8d96$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");

var $HL98v = parcelRequire("HL98v");
const $205abd92f18b8d96$var$defaultConfig = {
    serviceUrl: `${(0, $hncrn.DEFAULT_CONFIG).stargateRoot}`
};
class $205abd92f18b8d96$export$a78b00aedb6cb3e9 extends (0, $f4dfy.RestClient) {
    constructor(config = {}){
        super({
            ...$205abd92f18b8d96$var$defaultConfig,
            ...config
        });
    }
    async getTeamLinkIcons(teamLinkUrls) {
        const requestBody = teamLinkUrls.map((url)=>({
                resourceUrl: url
            }));
        return this.postResourceRaw(`/object-resolver/resolve/batch`, JSON.stringify(requestBody)).then((0, $HL98v.transformIconData));
    }
    async getAriFromUrl(url) {
        return this.postResourceRaw(`/object-resolver/converter/toAri`, JSON.stringify({
            resourceUrl: url
        })).then((response)=>response?.data?.ari);
    }
    async getWebLinkTitle(webLinkUrl) {
        try {
            const response = await this.postResourceRaw('/object-resolver/resolve', JSON.stringify({
                resourceUrl: webLinkUrl
            }));
            if (response && 'data' in response) {
                if (response.data?.name) return response.data.name;
            }
            if (response && 'meta' in response && (response.meta?.visibility === 'restricted' || response.meta?.visibility === 'unauthorized')) {
                const auth = response.meta.auth?.[0];
                if (auth?.displayName) return auth.displayName;
            }
            return;
        } catch (error) {
            return;
        }
    }
}
var $205abd92f18b8d96$export$2e2bcd8739ae039 = new $205abd92f18b8d96$export$a78b00aedb6cb3e9();

});
parcelRegister("HL98v", function(module, exports) {

$parcel$export(module.exports, "transformIconData", () => $cd95287fec3ab6ab$export$39f4468adf4cb57c);

var $jzBG8 = parcelRequire("jzBG8");
const $cd95287fec3ab6ab$export$c64ca1c808335e8b = (jsonLd)=>{
    const { url: url, generator: { name: name, icon: icon } } = jsonLd;
    switch(name){
        case (0, $jzBG8.ProviderNames).CONFLUENCE:
            return {
                linkUrl: url,
                iconUrl: $cd95287fec3ab6ab$var$getConfluenceFavicon(url),
                productName: name
            };
        case (0, $jzBG8.ProviderNames).JIRA:
            return {
                linkUrl: url,
                iconUrl: $cd95287fec3ab6ab$var$getJiraFavicon(url),
                productName: name
            };
        default:
            return {
                linkUrl: url,
                iconUrl: typeof icon === 'object' ? icon['url'] : icon,
                productName: name
            };
    }
};
const $cd95287fec3ab6ab$var$isIconItemSuccess = (response)=>{
    return response.status === 200;
};
const $cd95287fec3ab6ab$export$39f4468adf4cb57c = (batchResp)=>batchResp.filter($cd95287fec3ab6ab$var$isIconItemSuccess).map((resp)=>resp.body.data).map($cd95287fec3ab6ab$export$c64ca1c808335e8b).filter((linkIconData)=>linkIconData.iconUrl !== undefined);
const $cd95287fec3ab6ab$var$getConfluenceFavicon = (url)=>`https://${new URL(url).hostname}/wiki/favicon.ico`;
const $cd95287fec3ab6ab$var$getJiraFavicon = (url)=>`https://${new URL(url).hostname}/favicon.ico`;

});
parcelRegister("jzBG8", function(module, exports) {

$parcel$export(module.exports, "ProviderNames", () => $714ee44137d16d13$export$132d457a8475f4c8);
/**
 * This type matches the props for the TeamLinkIcon component in embeddable-directory
 */ var $714ee44137d16d13$export$132d457a8475f4c8 = /*#__PURE__*/ function(ProviderNames) {
    ProviderNames["CONFLUENCE"] = "Confluence";
    ProviderNames["JIRA"] = "Jira";
    return ProviderNames;
}({});

});



parcelRegister("1qjKt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc76c53f54a183f0$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");
class $bc76c53f54a183f0$export$23820d8d740dd467 extends (0, $f4dfy.RestClient) {
    getIsSiteAdmin(/**
		 * @private
		 * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
		 */ cloudId) {
        return this.postResource('/permitted', {
            permissionId: 'manage',
            resourceId: `ari:cloud:platform::site/${this.getCloudId(cloudId)}`
        }).then((response)=>response.permitted);
    }
}
var /**
 * REST Client to make calls to resources on the activity service.
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
$bc76c53f54a183f0$export$2e2bcd8739ae039 = new $bc76c53f54a183f0$export$23820d8d740dd467({
    serviceUrl: (0, $hncrn.DEFAULT_CONFIG).permsServiceUrl
});

});

parcelRegister("3aHkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8e70f5078d5ceec$export$2e2bcd8739ae039);

var $7eAIS = parcelRequire("7eAIS");

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");
const $c8e70f5078d5ceec$var$V1_URL = '/teams/v1';
const $c8e70f5078d5ceec$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE = [
    'TEAM_NOT_FOUND'
];
class $c8e70f5078d5ceec$export$38575d07403d67c extends (0, $f4dfy.RestClient) {
    constructor(serviceUrlRoot){
        super({
            serviceUrl: serviceUrlRoot
        });
    }
    async addUsersToTeam(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to add');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$c8e70f5078d5ceec$var$V1_URL}/org/${orgId}/teams/${teamId}/members/add`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'addUsersToTeam');
            if (e instanceof (0, $7eAIS.HttpError) && $c8e70f5078d5ceec$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE.includes(e.message)) throw new (0, $7eAIS.SLOIgnoreHttpError)(e);
            throw e;
        }
    }
    async removeTeamMemberships(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to remove');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$c8e70f5078d5ceec$var$V1_URL}/org/${orgId}/teams/${teamId}/members/remove`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'removeTeamMemberships');
            throw e;
        }
    }
    async getTeamDetails(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$c8e70f5078d5ceec$var$V1_URL}/org/${orgId}/teams/${teamId}`;
            const response = await this.getResource(url);
            return response;
        } catch (e) {
            this.logException(e, 'getTeamDetails');
            throw e;
        }
    }
    async getTeamMembers(teamId, first = 50, after) {
        try {
            const orgId = this.getOrgId();
            const url = `${$c8e70f5078d5ceec$var$V1_URL}/org/${orgId}/teams/${teamId}/members`;
            const response = await this.postResource(url, {
                after: after,
                first: first
            });
            return response;
        } catch (e) {
            this.logException(e, 'getTeamMembers');
            throw e;
        }
    }
    async restoreTeam(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$c8e70f5078d5ceec$var$V1_URL}/org/${orgId}/teams/${teamId}/restore`;
            return this.postResource(url);
        } catch (e) {
            this.logException(e, 'restoreTeam');
            throw e;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$c8e70f5078d5ceec$export$2e2bcd8739ae039 = new $c8e70f5078d5ceec$export$38575d07403d67c((0, $hncrn.DEFAULT_CONFIG).publicApiRoot);

});

parcelRegister("4Xjsv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5645769de27b9599$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");
const $5645769de27b9599$var$defaultConfig = {
    serviceUrl: `${(0, $hncrn.DEFAULT_CONFIG).stargateRoot}/user-tenure/v1`
};
class $5645769de27b9599$export$e019a6241c871c27 extends (0, $f4dfy.RestClient) {
    constructor(config = {}){
        super({
            ...$5645769de27b9599$var$defaultConfig,
            ...config
        });
    }
    async getUserTenure(userId) {
        const orgId = this.getOrgId();
        return this.getResource(`/${orgId}/${userId}`).then((response)=>({
                ...response,
                userHireDate: new Date(response.userHireDate)
            })).catch((error)=>{
            throw new Error('Failed to fetch user tenure');
        });
    }
}
var $5645769de27b9599$export$2e2bcd8739ae039 = new $5645769de27b9599$export$e019a6241c871c27();

});

parcelRegister("3vA2C", function(module, exports) {

$parcel$export(module.exports, "default", () => $f308d6b289ddc64b$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $le4QF = parcelRequire("le4QF");

var $kP1cg = parcelRequire("kP1cg");

var $aJhpK = parcelRequire("aJhpK");

var $aQp5o = parcelRequire("aQp5o");

var $e5dnX = parcelRequire("e5dnX");

var $74sWx = parcelRequire("74sWx");

var $lh2BF = parcelRequire("lh2BF");

var $1I7W5 = parcelRequire("1I7W5");

var $1GAT2 = parcelRequire("1GAT2");

var $gQ7HG = parcelRequire("gQ7HG");

var $g7SFw = parcelRequire("g7SFw");
class $f308d6b289ddc64b$export$de0359e19b851166 extends (0, $le4QF.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super((0, $g7SFw.getUnshardedTeamCentralGraphqlUrl)(baseUrl), config);
    }
    // Team central url is a bit special, that it depends on cloudId.
    setBaseUrl(baseUrl) {
        const cloudId = this.getCloudId();
        this.setServiceUrl(cloudId && cloudId !== 'None' ? (0, $g7SFw.getTeamCentralGraphqlUrl)(baseUrl, cloudId) : (0, $g7SFw.getUnshardedTeamCentralGraphqlUrl)(baseUrl));
    }
    async addTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $aJhpK.AddTeamWatcherMutation),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'addTeamWatcher'
        });
        return response.addTeamWatcher;
    }
    async removeTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $1GAT2.RemoveTeamWatcherMutation),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'removeTeamWatcher'
        });
        return response.removeTeamWatcher;
    }
    async deleteKudos(id) {
        const response = await this.makeGraphQLRequest({
            query: (0, $1I7W5.KudosDeleteMutation),
            variables: {
                id: id
            }
        }, {
            operationName: 'DeleteKudos'
        });
        return response.deleteKudos;
    }
    async queryTagList(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $gQ7HG.TagListQuery),
            variables: variables
        }, {
            operationName: 'TagListByCloudId'
        });
        return response.tagSearchByCloudId;
    }
    async createTag(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $aQp5o.CreateTagMutation),
            variables: variables
        }, {
            operationName: 'createTagForCloudId'
        });
        return response.createTagForCloudId;
    }
    async createHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $e5dnX.HelpPointerCreateMutation),
            variables: variables
        }, {
            operationName: 'CreateHelpPointer'
        });
        return response.createHelpPointer;
    }
    async updateHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $lh2BF.HelpPointerUpdateMutation),
            variables: variables
        }, {
            operationName: 'UpdateHelpPointer'
        });
        return response.updateHelpPointer;
    }
    async deleteHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $74sWx.HelpPointerDeleteMutation),
            variables: variables
        }, {
            operationName: 'DeleteHelpPointer'
        });
        return response.deleteHelpPointer;
    }
}
var $f308d6b289ddc64b$export$2e2bcd8739ae039 = new $f308d6b289ddc64b$export$de0359e19b851166((0, $hncrn.DEFAULT_CONFIG).stargateRoot, {
    logException: $kP1cg.logException
});

});
parcelRegister("aJhpK", function(module, exports) {

$parcel$export(module.exports, "AddTeamWatcherMutation", () => $8b8e757f53dc0b98$export$2af9f827ad8bcf83);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $8b8e757f53dc0b98$export$2af9f827ad8bcf83 = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation addTeamWatcher($teamId: String!, $cloudId: String) {
		addTeamWatcher(input: { teamId: $teamId, cloudId: $cloudId }) {
			isWatching
			__typename
		}
	}
`);

});

parcelRegister("aQp5o", function(module, exports) {

$parcel$export(module.exports, "CreateTagMutation", () => $3dfd2b7e4e608497$export$5e59562b4f09e8ef);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $3dfd2b7e4e608497$export$5e59562b4f09e8ef = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation createTagForCloudId($name: String!, $cloudId: String!) {
		createTagForCloudId(input: { name: $name, cloudId: $cloudId }) {
			tag {
				id
				uuid
				name
			}
		}
	}
`);

});

parcelRegister("e5dnX", function(module, exports) {

$parcel$export(module.exports, "HelpPointerCreateMutation", () => $b204e0803c05b46e$export$a563da8c932d52b1);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $b204e0803c05b46e$export$a563da8c932d52b1 = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation CreateHelpPointer(
		$cloudId: String!
		$description: String
		$icon: IconInput
		$tagUuids: [UUID]
		$link: String!
		$name: String!
		$teamId: String!
		$type: HelpPointerType!
	) {
		createHelpPointer(
			input: {
				cloudId: $cloudId
				description: $description
				icon: $icon
				tagUuids: $tagUuids
				link: $link
				name: $name
				teamId: $teamId
				type: $type
			}
		) {
			helpPointer {
				id
			}
		}
	}
`);

});

parcelRegister("74sWx", function(module, exports) {

$parcel$export(module.exports, "HelpPointerDeleteMutation", () => $4ff6c1a1f6f975b9$export$558c9434019572a1);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $4ff6c1a1f6f975b9$export$558c9434019572a1 = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation DeleteHelpPointer($id: ID!) {
		deleteHelpPointer(input: { id: $id }) {
			success
		}
	}
`);

});

parcelRegister("lh2BF", function(module, exports) {

$parcel$export(module.exports, "HelpPointerUpdateMutation", () => $7790d0a6ce755ece$export$95b572ae48a37250);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $7790d0a6ce755ece$export$95b572ae48a37250 = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation UpdateHelpPointer(
		$id: ID!
		$description: String
		$teamId: String
		$newTeamName: String
		$icon: IconInput
		$tagUuids: [UUID]
		$link: String
		$name: String
		$type: HelpPointerType
	) {
		updateHelpPointer(
			input: {
				id: $id
				description: $description
				icon: $icon
				tagUuids: $tagUuids
				link: $link
				teamId: $teamId
				newTeamName: $newTeamName
				name: $name
				type: $type
			}
		) {
			helpPointer {
				id
			}
		}
	}
`);

});

parcelRegister("1I7W5", function(module, exports) {

$parcel$export(module.exports, "KudosDeleteMutation", () => $74ddfa197f970cd5$export$fc4c702e715ad2a4);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $74ddfa197f970cd5$export$fc4c702e715ad2a4 = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation DeleteKudos($id: ID!) {
		deleteKudos(input: { id: $id }) {
			success
			kudos {
				id
			}
		}
	}
`);

});

parcelRegister("1GAT2", function(module, exports) {

$parcel$export(module.exports, "RemoveTeamWatcherMutation", () => $f558522719fe1a0b$export$d1957676c49feb6a);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $f558522719fe1a0b$export$d1957676c49feb6a = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation removeTeamWatcher($teamId: String!, $cloudId: String) {
		removeTeamWatcher(input: { teamId: $teamId, cloudId: $cloudId }) {
			isWatching
			__typename
		}
	}
`);

});

parcelRegister("gQ7HG", function(module, exports) {

$parcel$export(module.exports, "TagListQuery", () => $8b0e4be529e1a6dc$export$2c592b5c06672873);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $8b0e4be529e1a6dc$export$2c592b5c06672873 = (0, $6NFTG.print)((0, $kuAvn.default)`
	query TagListByCloudId($q: String!, $cloudId: String!, $first: Int) {
		tagSearchByCloudId(q: $q, cloudId: $cloudId, first: $first) {
			edges {
				node {
					id
					uuid
					name
					projects {
						count
					}

					goals {
						count
					}

					helpLinks {
						count
					}
				}
			}
		}
	}
`);

});

parcelRegister("g7SFw", function(module, exports) {

$parcel$export(module.exports, "getTeamCentralGraphqlUrl", () => $fbde9dd5796ae376$export$ada1892306a6b676);
$parcel$export(module.exports, "getUnshardedTeamCentralGraphqlUrl", () => $fbde9dd5796ae376$export$71356c4826ea823a);
const $fbde9dd5796ae376$export$ada1892306a6b676 = (baseUrl, cloudId)=>`${baseUrl}/townsquare/s/${cloudId}/graphql`;
const $fbde9dd5796ae376$export$71356c4826ea823a = (baseUrl)=>`${baseUrl}/watermelon/graphql`;

});


parcelRegister("6s0GD", function(module, exports) {

$parcel$export(module.exports, "default", () => $43c2332765f70dfe$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");
const $43c2332765f70dfe$var$defaultConfig = {
    serviceUrl: `${(0, $hncrn.DEFAULT_CONFIG).stargateRoot}/teamsslack/api/team`
};
class $43c2332765f70dfe$export$9509cbc6b0605446 extends (0, $f4dfy.RestClient) {
    constructor(config = {}){
        super({
            ...$43c2332765f70dfe$var$defaultConfig,
            ...config
        });
    }
    async getTeamInSlack(teamId, teamName) {
        return this.getResource(`/${teamId}?teamName=${encodeURIComponent(teamName)}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async disconnectTeamInSlack(teamId) {
        return this.deleteResource(`/${teamId}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async updateTeamInSlack(teamId, channelId, usergroupHandle) {
        return this.postResource(`/${teamId}?channel=${channelId}&groupName=${usergroupHandle}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
}
var $43c2332765f70dfe$export$2e2bcd8739ae039 = new $43c2332765f70dfe$export$9509cbc6b0605446();

});

parcelRegister("fecpt", function(module, exports) {

$parcel$export(module.exports, "default", () => $495b63401d2fcee0$export$2e2bcd8739ae039);

var $hncrn = parcelRequire("hncrn");

var $f4dfy = parcelRequire("f4dfy");
const $495b63401d2fcee0$var$buildGetReadTokenURL = (accountId)=>`/api/user-image/${accountId}/header-image/read`;
class $495b63401d2fcee0$export$3c27e20d1b94924 extends (0, $f4dfy.RestClient) {
    async getReadMediaToken(accountId) {
        return this.getResource($495b63401d2fcee0$var$buildGetReadTokenURL(accountId)).then((response)=>response);
    }
    async getWriteMediaToken() {
        return this.getResource('/api/user-image/header-image/write').then((response)=>response);
    }
    async updateUserHeaderImage(headerImageId) {
        return await this.putResource('/api/user-image/self/header-image', {
            headerImageId: headerImageId
        });
    }
}
var $495b63401d2fcee0$export$2e2bcd8739ae039 = new $495b63401d2fcee0$export$3c27e20d1b94924({
    serviceUrl: (0, $hncrn.DEFAULT_CONFIG).stargateRoot
});

});


parcelRegister("5oAZz", function(module, exports) {

$parcel$export(module.exports, "ContainerType", () => $81e7c7ff801c5543$export$7d7a98f44861e6f7);
var $81e7c7ff801c5543$export$7d7a98f44861e6f7 = /*#__PURE__*/ function(ContainerType) {
    ContainerType["CONFLUENCE_SPACE"] = "CONFLUENCE_SPACE";
    ContainerType["JIRA_PROJECT"] = "JIRA_PROJECT";
    ContainerType["LOOM_SPACE"] = "LOOM_SPACE";
    return ContainerType;
}({});

});

parcelRegister("8HcYM", function(module, exports) {

$parcel$export(module.exports, "TeamContainersSkeleton", () => $10490122de930768$export$b4d5d8f3bbe29b5f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $hYvlq = parcelRequire("hYvlq");
var $78OnL = parcelRequire("78OnL");

var $7RSVt = parcelRequire("7RSVt");
const $10490122de930768$var$styles = {
    containers: "_yv0ewxkt",
    showMoreButtonSkeleton: "_2rko1q77 _1rjc1b66 _1bsbvbgk"
};
const $10490122de930768$export$b4d5d8f3bbe29b5f = ({ numberOfContainers: numberOfContainers })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
        space: "space.200",
        testId: "team-containers-skeleton",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hYvlq.default), {
                xcss: $10490122de930768$var$styles.containers,
                gap: "space.100",
                autoFlow: "row",
                children: [
                    ...Array(numberOfContainers)
                ].map((_, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7RSVt.LinkedContainerCardSkeleton), {}, index))
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                backgroundColor: "color.background.neutral",
                xcss: $10490122de930768$var$styles.showMoreButtonSkeleton
            })
        ]
    });
};

});
parcelRegister("hYvlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e062987a137d87a$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $3e062987a137d87a$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $3e062987a137d87a$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $3e062987a137d87a$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $3e062987a137d87a$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $3e062987a137d87a$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $3e062987a137d87a$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $3e062987a137d87a$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $3e062987a137d87a$var$Grid = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $hcewu.default)([
            $3e062987a137d87a$var$baseStyles.root,
            gap && $3e062987a137d87a$var$columnGapMap[gap],
            columnGap && $3e062987a137d87a$var$columnGapMap[columnGap],
            gap && $3e062987a137d87a$var$rowGapMap[gap],
            rowGap && $3e062987a137d87a$var$rowGapMap[rowGap],
            alignItems && $3e062987a137d87a$var$alignItemsMap[alignItems],
            alignContent && $3e062987a137d87a$var$alignContentMap[alignContent],
            justifyContent && $3e062987a137d87a$var$justifyContentMap[justifyContent],
            autoFlow && $3e062987a137d87a$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$3e062987a137d87a$var$Grid.displayName = 'Grid';
var $3e062987a137d87a$export$2e2bcd8739ae039 = $3e062987a137d87a$var$Grid;

});

parcelRegister("7RSVt", function(module, exports) {

$parcel$export(module.exports, "LinkedContainerCardSkeleton", () => $ff3d3cdee60df71b$export$b7a75d9378054329);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $c776o = parcelRequire("c776o");
const $ff3d3cdee60df71b$var$styles = {
    container: "_2rkoiti9 _1h6dz9xs _12y3e4h9 _12jimuej _1qu2nqa1 _syaz1fxt _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    avatarSkeleton: "_2rkoglpi _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    firstLineSkeleton: "_2rko1q77 _1rjc1b66",
    secondLineSkeleton: "_2rko1q77 _1rjc1b66 _1bsbqkoa"
};
const $ff3d3cdee60df71b$export$b7a75d9378054329 = ({ containerType: containerType })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $ff3d3cdee60df71b$var$styles.container,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.100",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    backgroundColor: "color.background.neutral",
                    xcss: $ff3d3cdee60df71b$var$styles.avatarSkeleton
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                    space: "space.100",
                    grow: "fill",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            backgroundColor: "color.background.neutral",
                            xcss: $ff3d3cdee60df71b$var$styles.firstLineSkeleton
                        }),
                        containerType ? /*#__PURE__*/ (0, $gt9Am.jsx)($ff3d3cdee60df71b$var$ContainerIcon, {
                            containerType: containerType
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            backgroundColor: "color.background.neutral",
                            xcss: $ff3d3cdee60df71b$var$styles.secondLineSkeleton
                        })
                    ]
                })
            ]
        })
    });
};
function $ff3d3cdee60df71b$var$ContainerIcon({ containerType: containerType }) {
    const { description: description, icon: icon, containerTypeText: containerTypeText } = (0, $c776o.getContainerProperties)({
        containerType: containerType,
        iconSize: 'medium'
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
        gap: "space.050",
        alignItems: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        size: "small",
                        color: "color.text.subtle",
                        children: description
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        size: "small",
                        color: "color.text.subtle",
                        children: containerTypeText
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("c776o", function(module, exports) {

$parcel$export(module.exports, "getContainerProperties", () => $34b9ccb2e6361c3a$export$4fa7913af1c65224);
/* get-container-properties.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");
var $kDaaB = parcelRequire("kDaaB");

var $iBgxn = parcelRequire("iBgxn");

var $9itkV = parcelRequire("9itkV");

var $8wyVH = parcelRequire("8wyVH");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $3cMgR = parcelRequire("3cMgR");

var $9gEy8 = parcelRequire("9gEy8");

var $W6AeD = parcelRequire("W6AeD");

var $8rtbR = parcelRequire("8rtbR");

var $bPPCv = parcelRequire("bPPCv");

var $fw1dd = parcelRequire("fw1dd");
const $34b9ccb2e6361c3a$var$styles = {
    iconWrapper: "_1bsb1crf _4t3i1crf",
    mediumIconWrapper: "_1bsb7vkz _4t3i7vkz",
    globeIconWrapper: "_2rko1sit _1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _12jimuej _1qu2nqa1"
};
const $34b9ccb2e6361c3a$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    addConfluenceContainerTitle: {
        id: 'ptc-directory.team-profile-page.team-containers.add-confluence-space-title',
        defaultMessage: 'Add space',
        description: 'Title of the card to add a Confluence space to a team'
    },
    confluenceContainerDescription: {
        id: 'ptc-directory.team-profile-page.team-containers.add-confluence-space-description',
        defaultMessage: 'Confluence',
        description: 'Description of the card to add a Confluence space to a team'
    },
    addLoomContainerTitle: {
        id: 'ptc-directory.team-profile-page.team-containers.add-loom-space-title',
        defaultMessage: 'Add space',
        description: 'Title of the card to add a Loom space to a team'
    },
    confluenceLoomDescription: {
        id: 'ptc-directory.team-profile-page.team-containers.add-loom-space-description',
        defaultMessage: 'Loom',
        description: 'Description of the card to add a Loom space to a team'
    },
    addJiraProjectTitle: {
        id: 'ptc-directory.team-profile-page.team-containers.add-jira-project-title',
        defaultMessage: 'Add project',
        description: 'Title of the card to add a Jira project to a team'
    },
    jiraProjectDescription: {
        id: 'ptc-directory.team-profile-page.team-containers.add-jira-project-description',
        defaultMessage: 'Jira',
        description: 'Description of the card to add a Jira project to a team'
    },
    addLoomSpaceTitle: {
        id: 'ptc-directory.team-profile-page.team-containers.add-loom-space-title',
        defaultMessage: 'Add space',
        description: 'Title of the card to add a Loom space to a team'
    },
    loomSpaceDescription: {
        id: 'ptc-directory.team-profile-page.team-containers.add-loom-space-description',
        defaultMessage: 'Loom',
        description: 'Description of the card to add a Loom space to a team'
    },
    projectContainerText: {
        id: 'ptc-directory.team-profile-page.team-containers.project-container-text',
        defaultMessage: 'project',
        description: 'Text for project type containers'
    },
    spaceContainerText: {
        id: 'ptc-directory.team-profile-page.team-containers.space-container-text',
        defaultMessage: 'space',
        description: 'Text for space type containers'
    },
    emptyWebLinkContainerDescription: {
        id: 'platform.teams.containers.empty-web-link-description',
        defaultMessage: 'Add any web link',
        description: 'Description displayed on the empty card for adding a web link to a team'
    },
    webLinkContainerDescription: {
        id: 'platform.teams.containers.web-link-title-description',
        defaultMessage: 'Web link',
        description: 'Description displayed for web link containers in team profile'
    }
});
const $34b9ccb2e6361c3a$var$getJiraIcon = (containerSubTypes)=>{
    switch(containerSubTypes){
        case 'PRODUCT_DISCOVERY':
            return 0, (/*@__PURE__*/$parcel$interopDefault($8rtbR));
        case 'SERVICE_DESK':
            return 0, (/*@__PURE__*/$parcel$interopDefault($bPPCv));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($W6AeD));
    }
};
const $34b9ccb2e6361c3a$var$getJiraContainerProperties = ({ containerTypeProperties: containerTypeProperties, iconSize: iconSize = 'small' })=>{
    const { subType: subType, name: name } = containerTypeProperties || {};
    const baseProperties = {
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...$34b9ccb2e6361c3a$export$defe85febe8b728c.jiraProjectDescription
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
            xcss: iconSize === 'medium' ? $34b9ccb2e6361c3a$var$styles.mediumIconWrapper : $34b9ccb2e6361c3a$var$styles.iconWrapper,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wyVH.default), {
                src: $34b9ccb2e6361c3a$var$getJiraIcon(subType),
                alt: "",
                testId: "jira-project-container-icon"
            })
        }),
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...$34b9ccb2e6361c3a$export$defe85febe8b728c.addJiraProjectTitle
        }),
        containerTypeText: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...$34b9ccb2e6361c3a$export$defe85febe8b728c.projectContainerText
        })
    };
    switch(subType){
        case 'PRODUCT_DISCOVERY':
        case 'SERVICE_DESK':
            return {
                ...baseProperties,
                containerTypeText: '',
                description: name || baseProperties.description
            };
        default:
            return baseProperties;
    }
};
const $34b9ccb2e6361c3a$var$getWebLinkContainerProperties = ({ isEmptyContainer: isEmptyContainer, isDisplayedOnProfileCard: isDisplayedOnProfileCard })=>{
    return {
        description: isEmptyContainer ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
            size: "medium",
            weight: "medium",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...$34b9ccb2e6361c3a$export$defe85febe8b728c.emptyWebLinkContainerDescription
            })
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...$34b9ccb2e6361c3a$export$defe85febe8b728c.webLinkContainerDescription
        }),
        icon: isEmptyContainer ? null : isDisplayedOnProfileCard ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
            label: "",
            size: "small",
            testId: "team-link-card-external-link-icon"
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $34b9ccb2e6361c3a$var$styles.globeIconWrapper,
            testId: "team-link-card-globe-icon",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iBgxn))), {
                label: "",
                size: "small"
            })
        }),
        title: null,
        containerTypeText: null
    };
};
const $34b9ccb2e6361c3a$export$4fa7913af1c65224 = ({ containerType: containerType, iconSize: iconSize = 'small', containerTypeProperties: containerTypeProperties, isEmptyContainer: isEmptyContainer, isDisplayedOnProfileCard: isDisplayedOnProfileCard })=>{
    switch(containerType){
        case 'ConfluenceSpace':
            return {
                description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...$34b9ccb2e6361c3a$export$defe85febe8b728c.confluenceContainerDescription
                }),
                icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                    xcss: iconSize === 'medium' ? $34b9ccb2e6361c3a$var$styles.mediumIconWrapper : $34b9ccb2e6361c3a$var$styles.iconWrapper,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wyVH.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9gEy8))),
                        alt: "",
                        testId: "confluence-space-container-icon"
                    })
                }),
                title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...$34b9ccb2e6361c3a$export$defe85febe8b728c.addConfluenceContainerTitle
                }),
                containerTypeText: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...$34b9ccb2e6361c3a$export$defe85febe8b728c.spaceContainerText
                })
            };
        case 'LoomSpace':
            return {
                description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...$34b9ccb2e6361c3a$export$defe85febe8b728c.loomSpaceDescription
                }),
                icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                    xcss: iconSize === 'medium' ? $34b9ccb2e6361c3a$var$styles.mediumIconWrapper : $34b9ccb2e6361c3a$var$styles.iconWrapper,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wyVH.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($fw1dd))),
                        alt: "",
                        testId: "loom-space-container-icon"
                    })
                }),
                title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...$34b9ccb2e6361c3a$export$defe85febe8b728c.addLoomContainerTitle
                }),
                containerTypeText: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...$34b9ccb2e6361c3a$export$defe85febe8b728c.spaceContainerText
                })
            };
        case 'JiraProject':
            return $34b9ccb2e6361c3a$var$getJiraContainerProperties({
                containerTypeProperties: containerTypeProperties,
                iconSize: iconSize
            });
        case 'WebLink':
            return $34b9ccb2e6361c3a$var$getWebLinkContainerProperties({
                isEmptyContainer: isEmptyContainer,
                isDisplayedOnProfileCard: isDisplayedOnProfileCard
            });
        default:
            return {
                description: null,
                icon: null,
                title: null,
                containerTypeText: null
            };
    }
};

});
parcelRegister("8wyVH", function(module, exports) {

$parcel$export(module.exports, "default", () => $43ef6b50fdd81ea8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDoP2 = parcelRequire("kDoP2");

var $58yRG = parcelRequire("58yRG");
const $43ef6b50fdd81ea8$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $43ef6b50fdd81ea8$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $eJOHy.useRef)(null);
    const providedColorMode = (0, $kDoP2.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $58yRG.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $eJOHy.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $hcewu.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("kDoP2", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $f201e3ae8b613c49$export$ce91654eb9fea460);
$parcel$export(module.exports, "default", () => $f201e3ae8b613c49$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $01wZP = parcelRequire("01wZP");
var $7y92E = parcelRequire("7y92E");
var $7I1UL = parcelRequire("7I1UL");
const $f201e3ae8b613c49$var$defaultThemeSettings = ()=>({
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: 'typography'
    });
const $f201e3ae8b613c49$var$ColorModeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $f201e3ae8b613c49$var$SetColorModeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $f201e3ae8b613c49$var$ThemeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $f201e3ae8b613c49$var$SetThemeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
function $f201e3ae8b613c49$export$ce91654eb9fea460() {
    const value = (0, $eJOHy.useContext)($f201e3ae8b613c49$var$ColorModeContext);
    return value;
}
function $f201e3ae8b613c49$export$20f3076712c8dfa() {
    const value = (0, $eJOHy.useContext)($f201e3ae8b613c49$var$ColorModeContext);
    const { colorMode: colorMode } = (0, $01wZP.default)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $eJOHy.useState)(colorMode || 'light');
    (0, $eJOHy.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $7I1UL.default)((theme)=>{
            setResolvedColorMode(theme.colorMode || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}
function $f201e3ae8b613c49$export$e2afe7397c3d11c7() {
    const value = (0, $eJOHy.useContext)($f201e3ae8b613c49$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
}
function $f201e3ae8b613c49$export$93d4e7f90805808f() {
    const theme = (0, $eJOHy.useContext)($f201e3ae8b613c49$var$ThemeContext);
    const [resolvedTheme, setResolvedTheme] = (0, $eJOHy.useState)(theme || (0, $01wZP.default)());
    (0, $eJOHy.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        const observer = new (0, $7I1UL.default)(setResolvedTheme);
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        theme
    ]);
    return theme ? theme : resolvedTheme;
}
function $f201e3ae8b613c49$export$501aa0dcd5527a48() {
    const value = (0, $eJOHy.useContext)($f201e3ae8b613c49$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $f201e3ae8b613c49$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $f201e3ae8b613c49$var$prefersDarkModeMql = $f201e3ae8b613c49$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $f201e3ae8b613c49$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $f201e3ae8b613c49$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 *
 * @internal
 */ function $f201e3ae8b613c49$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode, defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $eJOHy.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $eJOHy.useState)($f201e3ae8b613c49$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $eJOHy.useState)(()=>({
            ...$f201e3ae8b613c49$var$defaultThemeSettings(),
            ...defaultTheme
        }));
    const setColorMode = (0, $eJOHy.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($f201e3ae8b613c49$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $eJOHy.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        /**
     * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
     * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
     * `data-color-mode` attribute on the root element).
     *
     * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
     * applying the new theme.
     *
     * Without this, we can end up in the following scenario:
     * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
     * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
     * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
     * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
     */ const cleanupLastFnCall = async ()=>{
            if (lastSetGlobalThemePromiseRef.current) {
                const unbindFn = await lastSetGlobalThemePromiseRef.current;
                unbindFn();
                lastSetGlobalThemePromiseRef.current = null;
            }
        };
        const safelySetGlobalTheme = async ()=>{
            await cleanupLastFnCall();
            const promise = (0, $7y92E.default)({
                ...theme,
                colorMode: reconciledColorMode
            });
            lastSetGlobalThemePromiseRef.current = promise;
        };
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!$f201e3ae8b613c49$var$prefersDarkModeMql) return;
        const unbindListener = (0, $4eDgu.bind)($f201e3ae8b613c49$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($f201e3ae8b613c49$var$ColorModeContext.Provider, {
        value: reconciledColorMode,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($f201e3ae8b613c49$var$SetColorModeContext.Provider, {
            value: setColorMode,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($f201e3ae8b613c49$var$ThemeContext.Provider, {
                value: theme,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($f201e3ae8b613c49$var$SetThemeContext.Provider, {
                    value: setPartialTheme,
                    children: children
                })
            })
        })
    });
}
var $f201e3ae8b613c49$export$2e2bcd8739ae039 = $f201e3ae8b613c49$var$ThemeProvider;

});


parcelRegister("9gEy8", function(module, exports) {
module.exports = new URL("ConfluenceIcon.d49d30a0.svg", import.meta.url).toString();

});

parcelRegister("W6AeD", function(module, exports) {
module.exports = new URL("JiraIcon.61c2353c.svg", import.meta.url).toString();

});

parcelRegister("8rtbR", function(module, exports) {
module.exports = new URL("JiraProjectDiscovery.59099094.svg", import.meta.url).toString();

});

parcelRegister("bPPCv", function(module, exports) {
module.exports = new URL("JiraServiceManagement.e75af785.svg", import.meta.url).toString();

});

parcelRegister("fw1dd", function(module, exports) {
module.exports = new URL("LoomIcon.065e0b4f.svg", import.meta.url).toString();

});




parcelRegister("1jIHx", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamAnalytics", () => $dd0a96f3c12dd511$export$c673a0f984c6d01b);
$parcel$export(module.exports, "AnalyticsAction", () => $dd0a96f3c12dd511$export$30c16f5c43437fd7);

var $izv17 = parcelRequire("izv17");
const $dd0a96f3c12dd511$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $dd0a96f3c12dd511$var$runItLater = (cb)=>{
    if (window.requestIdleCallback === 'function') return window.requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $dd0a96f3c12dd511$export$c673a0f984c6d01b = ()=>{
    const [{ eventAttributes: injectedEventAttributes }] = (0, $izv17.usePeopleTeamsAnalyticsSubcontext)();
    const fireEvent = (kind)=>(createAnalyticsEvent, body)=>{
            if (!createAnalyticsEvent) return;
            $dd0a96f3c12dd511$var$runItLater(()=>{
                const eventWithSubcontextAttributes = {
                    ...body.attributes,
                    ...injectedEventAttributes
                };
                createAnalyticsEvent({
                    eventType: kind,
                    ...body,
                    attributes: eventWithSubcontextAttributes
                }).fire($dd0a96f3c12dd511$var$ANALYTICS_CHANNEL);
            });
        };
    return {
        fireOperationalEvent: fireEvent('operational'),
        fireScreenEvent: fireEvent('screen'),
        fireTrackEvent: fireEvent('track'),
        fireUIEvent: fireEvent('ui')
    };
};
var $dd0a96f3c12dd511$export$30c16f5c43437fd7 = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["RENDERED"] = "rendered";
    AnalyticsAction["CLICKED"] = "clicked";
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    AnalyticsAction["VIEWED"] = "viewed";
    AnalyticsAction["CLOSED"] = "closed";
    AnalyticsAction["ERROR"] = "error";
    AnalyticsAction["SUBMITED"] = "submitted";
    AnalyticsAction["FETCHED"] = "fetched";
    AnalyticsAction["SENT"] = "sent";
    AnalyticsAction["OPENED"] = "opened";
    return AnalyticsAction;
}({});

});
parcelRegister("izv17", function(module, exports) {

$parcel$export(module.exports, "usePeopleTeamsAnalyticsSubcontext", () => $15871a71fb0d22af$export$86448e866930ba8d);
$parcel$export(module.exports, "useInjectedEventAttribute", () => $15871a71fb0d22af$export$831917a198e22e70);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $15871a71fb0d22af$var$initialState = {
    eventAttributes: {}
};
const $15871a71fb0d22af$var$actions = {
    setEventAttributes: (eventAttributes)=>({ setState: setState, getState: getState })=>{
            const existingEventAttributes = getState().eventAttributes;
            const newEventAttributes = {
                ...existingEventAttributes,
                ...eventAttributes
            };
            Object.keys(newEventAttributes).forEach((keyString)=>{
                const key = keyString;
                if (newEventAttributes[key] === undefined) delete newEventAttributes[key];
            });
            setState({
                eventAttributes: newEventAttributes
            });
        }
};
const $15871a71fb0d22af$var$AnalyticsSubcontextStore = (0, $GtRbT.createStore)({
    initialState: $15871a71fb0d22af$var$initialState,
    actions: $15871a71fb0d22af$var$actions
});
const $15871a71fb0d22af$export$86448e866930ba8d = (0, $iJq0l.createHook)($15871a71fb0d22af$var$AnalyticsSubcontextStore);
const $15871a71fb0d22af$export$831917a198e22e70 = (key, value)=>{
    const { setEventAttributes: setEventAttributes } = $15871a71fb0d22af$export$86448e866930ba8d()[1];
    (0, $eJOHy.useEffect)(()=>{
        setEventAttributes({
            [key]: value
        });
        return ()=>setEventAttributes({
                [key]: undefined
            });
    }, [
        key,
        value,
        setEventAttributes
    ]);
};

});


parcelRegister("8Xvdz", function(module, exports) {

$parcel$export(module.exports, "transformPermissions", () => $4ab1a19594981060$export$7fe0bfa353103198);
$parcel$export(module.exports, "getProductPermissionRequestBody", () => $4ab1a19594981060$export$e16fe80afd1ad74c);
$parcel$export(module.exports, "hasProductPermission", () => $4ab1a19594981060$export$a2eea90ce05a9f1c);

var $jRFsK = parcelRequire("jRFsK");
const $4ab1a19594981060$var$PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-software',
    'jira-servicedesk',
    'jira-product-discovery',
    'loom'
];
const $4ab1a19594981060$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        (0, $jRFsK.SUPPORTED_PRODUCTS).forEach((supportedProduct)=>{
            if (permission.resourceId.includes(supportedProduct)) acc[supportedProduct] = {
                ...acc[supportedProduct],
                [permission.permissionId]: acc[supportedProduct]?.[permission.permissionId] || permission.permitted
            };
        });
        return acc;
    }, {});
};
const $4ab1a19594981060$export$e16fe80afd1ad74c = (cloudId, userId, permissionIds)=>{
    const body = permissionIds.reduce((acc, permissionId)=>{
        const permission = {
            permissionId: permissionId,
            resourceId: '',
            principalId: `ari:cloud:identity::user/${userId}`,
            dontRequirePrincipalInSite: true
        };
        $4ab1a19594981060$var$PRODUCTS.forEach((product)=>{
            acc.push({
                ...permission,
                resourceId: `ari:cloud:${product}::site/${cloudId}`
            });
        });
        return acc;
    }, []);
    return JSON.stringify(body);
};
const $4ab1a19594981060$export$a2eea90ce05a9f1c = (permissions, product, permissionIds)=>{
    if (!permissions[product]) return false;
    if ((!permissionIds || permissionIds.length === 0) && permissions[product]) return Object.values(permissions[product] || {}).some((value)=>value === true);
    return permissionIds?.some((permissionId)=>{
        const productPermissions = permissions[product];
        return productPermissions?.[permissionId];
    });
};

});
parcelRegister("jRFsK", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_PRODUCTS", () => $b8f35bcfaf3bff29$export$69caceff42c0da80);
const $b8f35bcfaf3bff29$export$69caceff42c0da80 = [
    'confluence',
    'jira',
    'loom'
];

});


parcelRegister("j29cm", function(module, exports) {

$parcel$export(module.exports, "useProductPermissions", () => $a3c9aef8b9e5dec6$export$5814f9544ee53f3b);

var $eJOHy = parcelRequire("eJOHy");

var $2lqCa = parcelRequire("2lqCa");
const $a3c9aef8b9e5dec6$export$5814f9544ee53f3b = ({ userId: userId, cloudId: cloudId, permissionIds: permissionIds }, { enabled: enabled } = {
    enabled: true
})=>{
    const [state, { getPermissions: getPermissions }] = (0, $2lqCa.useProductPermissionsStore)();
    const fetchData = (0, $eJOHy.useCallback)(async ()=>{
        getPermissions({
            cloudId: cloudId,
            userId: userId,
            enabled: enabled,
            permissionIds: permissionIds || [
                'manage',
                'write'
            ]
        });
    }, [
        cloudId,
        enabled,
        getPermissions,
        userId,
        permissionIds
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissions,
        error: state.error
    };
};

});
parcelRegister("2lqCa", function(module, exports) {

$parcel$export(module.exports, "useProductPermissionsStore", () => $7ac7035b06ce5315$export$933ed92af1ed5de9);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $8Xvdz = parcelRequire("8Xvdz");
const $7ac7035b06ce5315$var$actions = {
    getPermissions: ({ userId: userId, cloudId: cloudId, enabled: enabled, permissionIds: permissionIds = [
        'manage',
        'write'
    ] })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading, permissions: permissions } = getState();
            if (isLoading || !userId || !cloudId || !enabled) return;
            const shouldFetch = !hasLoaded || permissionIds.some((permissionId)=>permissions.confluence?.[permissionId] === undefined || permissions.jira?.[permissionId] === undefined || permissions.loom?.[permissionId] === undefined);
            if (!shouldFetch) return;
            try {
                setState({
                    isLoading: true
                });
                const response = await fetch('/gateway/api/permissions/bulk/permitted', {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    method: 'POST',
                    credentials: 'include',
                    body: (0, $8Xvdz.getProductPermissionRequestBody)(cloudId, userId, permissionIds)
                });
                if (!response.ok) throw new Error('Failed to fetch product permissions');
                const permissions = await response.json();
                dispatch($7ac7035b06ce5315$var$actions.setPermissions(permissions));
            } catch (error) {
                dispatch($7ac7035b06ce5315$var$actions.setError(new Error('Failed to fetch product permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: (0, $8Xvdz.transformPermissions)(permissions),
                permissionsResponse: permissions
            });
        }
};
const $7ac7035b06ce5315$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {}
    },
    actions: $7ac7035b06ce5315$var$actions,
    name: 'product-permissions-old'
});
const $7ac7035b06ce5315$export$933ed92af1ed5de9 = (0, $iJq0l.createHook)($7ac7035b06ce5315$var$Store);

});


parcelRegister("jEhCW", function(module, exports) {

$parcel$export(module.exports, "useRequestedContainers", () => $437d1625512390c9$export$e5b5663ca219614);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $9itkV = parcelRequire("9itkV");

var $2sLVw = parcelRequire("2sLVw");

var $7eAIS = parcelRequire("7eAIS");
var $301JM = parcelRequire("301JM");

var $6MZ4F = parcelRequire("6MZ4F");

var $kKHd9 = parcelRequire("kKHd9");
/**
 * Hook to track and poll for requested product containers (such as a Jira Project).
 * The initial list of requested containers is derived from the URL parameters, however it can be updated based on user interactions.
 *
 * Manages a list of requested containers, polls for updates, and removes found containers from the list.
 *
 * Supported container types: CONFLUENCE_SPACE, JIRA_PROJECT, LOOM_SPACE.
 *
 * @param teamId - The ID of the team whose containers are being tracked.
 * @param onRequestedContainerTimeout - Optional callback to handle timeout events for requested containers.
 * @returns The current list of requested containers and a function to add a container.
 */ function $437d1625512390c9$export$e5b5663ca219614({ teamId: teamId, cloudId: cloudId, onRequestedContainerTimeout: onRequestedContainerTimeout }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { refetchTeamContainers: refetchTeamContainers, teamContainers: teamContainers } = (0, $6MZ4F.useTeamContainers)(teamId);
    const [isTryingAgain, setIsTryingAgain] = (0, $eJOHy.useState)(false);
    const tryAgainCountRef = (0, $eJOHy.useRef)(0);
    const [refetchErrorCount, setRefetchErrorCount] = (0, $eJOHy.useState)(0);
    const [requestedContainers, setRequestedContainers] = (0, $eJOHy.useState)(()=>(0, $kKHd9.getRequestedContainersFromUrl)());
    const checkContainers = (0, $eJOHy.useCallback)(async ()=>{
        try {
            await refetchTeamContainers();
        } catch (error) {
            setRefetchErrorCount((prev)=>prev + 1);
        }
    }, [
        refetchTeamContainers
    ]);
    const onTimeout = (0, $eJOHy.useCallback)(({ startPolling: startPolling, reset: reset })=>{
        if (!onRequestedContainerTimeout) return;
        const flagId = `requested-container-timeout-${requestedContainers.join('-')}-${tryAgainCountRef.current}`;
        const createTryAgainFlag = ({ onAction: onAction })=>({
                id: flagId,
                title: requestedContainers.length === 1 ? formatMessage($437d1625512390c9$var$messages.timeoutTitle, {
                    container: (0, $kKHd9.containerDisplayName)(requestedContainers[0])
                }) : formatMessage($437d1625512390c9$var$messages.timeoutTitleMultiple),
                description: formatMessage($437d1625512390c9$var$messages.timeoutDescription),
                actions: [
                    {
                        content: formatMessage($437d1625512390c9$var$messages.timeoutAction),
                        onClick: ()=>{
                            onAction(flagId);
                            tryAgainAction();
                        }
                    }
                ]
            });
        const createContactSupportFlag = ({ onAction: onAction })=>({
                id: flagId,
                title: formatMessage($437d1625512390c9$var$messages.noConnectionTitle),
                description: formatMessage($437d1625512390c9$var$messages.noConnectionDescription),
                actions: [
                    {
                        content: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
                            alignItems: "center",
                            columnGap: "space.100",
                            children: [
                                formatMessage($437d1625512390c9$var$messages.noConnectionAction),
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
                                    label: ""
                                })
                            ]
                        }),
                        onClick: ()=>{
                            onAction(flagId);
                        },
                        href: 'https://support.atlassian.com/contact/#/&support_type=customer'
                    }
                ]
            });
        const tryAgainAction = async ()=>{
            setIsTryingAgain(true);
            tryAgainCountRef.current = tryAgainCountRef.current + 1;
            //todo: add analytics event here
            const containers = requestedContainers.map((container)=>{
                return {
                    type: (0, $kKHd9.convertContainerToType)(container),
                    containerSiteId: cloudId
                };
            }).filter(({ type: type })=>Boolean(type));
            try {
                const response = await (0, $301JM.teamsClient).createTeamContainers({
                    teamId: teamId,
                    containers: containers
                });
                const containersNotCreated = requestedContainers.filter((containerType)=>!response.containersCreated?.some((container)=>container.containerType === (0, $kKHd9.convertContainerToType)(containerType)));
                //containers are still being created
                if (containersNotCreated.length > 0) startPolling();
                else {
                    //all containers created so reset and update state
                    reset();
                    await refetchTeamContainers();
                }
            } catch (error) {
                if (error instanceof (0, $7eAIS.HttpError)) {
                    if (error.status === 500) {
                        //only allow for 2 retries
                        if (tryAgainCountRef.current < 2) return setTimeout(()=>{
                            //bug: this can cause two flags to be shown
                            tryAgainAction();
                        }, (0, $kKHd9.POLLING_INTERVAL));
                    }
                }
                onRequestedContainerTimeout(createContactSupportFlag);
            } finally{
                setIsTryingAgain(false);
            }
        };
        (0, $kKHd9.removeRequestedContainersFromUrl)();
        onRequestedContainerTimeout(tryAgainCountRef.current === 0 ? createTryAgainFlag : createContactSupportFlag);
    }, [
        cloudId,
        formatMessage,
        onRequestedContainerTimeout,
        refetchTeamContainers,
        requestedContainers,
        teamId
    ]);
    const { startPolling: startPolling, stopPolling: stopPolling, isPolling: isPolling, hasTimedOut: hasTimedOut } = (0, $kKHd9.useAsyncPolling)(checkContainers, {
        onTimeout: onTimeout
    });
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $kKHd9.userCanAccessFeature)()) return;
        //stop gap to prevent sending too many failed errors
        if (refetchErrorCount > 3) {
            stopPolling();
            //todo: add analytics event here
            return;
        }
        if (hasTimedOut || isTryingAgain) return;
        const containerCount = requestedContainers.length;
        if (isPolling && containerCount === 0) {
            (0, $kKHd9.removeRequestedContainersFromUrl)();
            stopPolling();
            return;
        }
        if (!isPolling && containerCount > 0) {
            setIsTryingAgain(false);
            startPolling();
        }
    }, [
        isPolling,
        refetchErrorCount,
        requestedContainers.length,
        hasTimedOut,
        startPolling,
        stopPolling,
        isTryingAgain
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const containersNotFound = requestedContainers.filter((containerType)=>!teamContainers.some((teamContainer)=>teamContainer.type === containerType));
        if (!(0, $kKHd9.containersEqual)(containersNotFound, requestedContainers)) setRequestedContainers(containersNotFound);
    }, [
        requestedContainers,
        checkContainers,
        teamContainers
    ]);
    const containersLoading = (0, $eJOHy.useMemo)(()=>hasTimedOut && !isTryingAgain || refetchErrorCount > 3 ? [] : requestedContainers, [
        hasTimedOut,
        requestedContainers,
        isTryingAgain,
        refetchErrorCount
    ]);
    return {
        requestedContainers: containersLoading
    };
}
const $437d1625512390c9$var$messages = (0, $7qGN1.defineMessages)({
    timeoutTitle: {
        id: 'teams-public.team-containers.timeout-title',
        defaultMessage: "We\u2019re couldn\u2019t connect your {container}",
        description: 'Title for the timeout flag'
    },
    timeoutTitleMultiple: {
        id: 'teams-public.team-containers.timeout-title',
        defaultMessage: "We\u2019re couldn\u2019t connect your spaces",
        description: 'Title for the timeout flag'
    },
    timeoutDescription: {
        id: 'teams-public.team-containers.timeout-description',
        defaultMessage: 'Something went wrong. Verify your connection and retry.',
        description: 'Description for the timeout flag'
    },
    timeoutAction: {
        id: 'teams-public.team-containers.timeout-action',
        defaultMessage: 'Try again',
        description: 'Action text for the timeout flag'
    },
    noConnectionTitle: {
        id: 'teams-public.team-containers.timeout-no-connection-title',
        defaultMessage: 'Connection failed',
        description: 'Title for the no connection flag'
    },
    noConnectionDescription: {
        id: 'teams-public.team-containers.timeout-no-connection-description',
        defaultMessage: 'Try manually creating the space yourself.',
        description: 'Description for the no connection flag'
    },
    noConnectionAction: {
        id: 'teams-public.team-containers.timeout-no-connection-action',
        defaultMessage: 'Contact support',
        description: 'Action text for the no connection flag'
    }
});

});
parcelRegister("6MZ4F", function(module, exports) {

$parcel$export(module.exports, "useTeamContainersHook", () => $71d232e5d68dd42c$export$cdd1842df65e002f);
$parcel$export(module.exports, "useTeamContainers", () => $71d232e5d68dd42c$export$63f31a5bbbef2f9a);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $ftN6c = parcelRequire("ftN6c");

var $1jIHx = parcelRequire("1jIHx");

var $9muWK = parcelRequire("9muWK");
const $71d232e5d68dd42c$var$initialConnectedTeamsState = {
    containerId: undefined,
    isLoading: false,
    hasLoaded: false,
    teams: undefined,
    error: null,
    numberOfTeams: undefined
};
const $71d232e5d68dd42c$var$initialState = {
    teamContainers: [],
    loading: true,
    hasLoaded: false,
    error: null,
    unlinkError: null,
    teamId: null,
    connectedTeams: $71d232e5d68dd42c$var$initialConnectedTeamsState
};
function $71d232e5d68dd42c$var$containersEqual(arr1, arr2) {
    const sortById = (a, b)=>a.id.localeCompare(b.id);
    return JSON.stringify([
        ...arr1
    ].sort(sortById)) === JSON.stringify([
        ...arr2
    ].sort(sortById));
}
const $71d232e5d68dd42c$var$actions = {
    fetchTeamContainers: (teamId, fireAnalytics)=>async ({ setState: setState, getState: getState })=>{
            const { teamId: currentTeamId } = getState();
            if (currentTeamId === teamId) return;
            setState({
                loading: true,
                error: null,
                teamContainers: [],
                teamId: teamId,
                hasLoaded: false
            });
            try {
                const containers = await (0, $9muWK.teamsClient).getTeamContainers(teamId);
                fireAnalytics((0, $1jIHx.AnalyticsAction).SUCCEEDED, 'fetchTeamContainers');
                setState({
                    teamContainers: containers,
                    loading: false,
                    error: null,
                    hasLoaded: true
                });
            } catch (err) {
                fireAnalytics((0, $1jIHx.AnalyticsAction).FAILED, 'fetchTeamContainers', err);
                setState({
                    teamContainers: [],
                    error: err,
                    loading: false,
                    hasLoaded: true
                });
            }
        },
    refetchTeamContainers: (fireAnalytics)=>async ({ setState: setState, getState: getState })=>{
            const { teamId: teamId } = getState();
            if (!teamId) return;
            try {
                const containers = await (0, $9muWK.teamsClient).getTeamContainers(teamId);
                fireAnalytics((0, $1jIHx.AnalyticsAction).SUCCEEDED, 'refetchTeamContainers');
                // optimisation to avoid unnecessary state updates
                if (!$71d232e5d68dd42c$var$containersEqual(containers, getState().teamContainers)) setState({
                    teamContainers: containers,
                    loading: false,
                    error: null,
                    hasLoaded: true
                });
            } catch (err) {
                fireAnalytics((0, $1jIHx.AnalyticsAction).FAILED, 'refetchTeamContainers', err);
                setState({
                    teamContainers: getState().teamContainers,
                    error: err,
                    loading: false,
                    hasLoaded: true
                });
            }
        },
    fetchNumberOfConnectedTeams: (containerId, fireAnalytics)=>async ({ setState: setState, getState: getState })=>{
            const { connectedTeams: { containerId: currentContainerId } } = getState();
            if (currentContainerId === containerId) return;
            setState({
                connectedTeams: {
                    ...$71d232e5d68dd42c$var$initialConnectedTeamsState,
                    containerId: containerId,
                    numberOfTeams: undefined
                }
            });
            try {
                const numberOfTeams = await (0, $9muWK.teamsClient).getNumberOfConnectedTeams(containerId);
                fireAnalytics({
                    action: (0, $1jIHx.AnalyticsAction).SUCCEEDED,
                    actionSubject: 'fetchNumberOfConnectedTeams',
                    containerId: containerId,
                    numberOfTeams: numberOfTeams
                });
                setState({
                    connectedTeams: {
                        ...$71d232e5d68dd42c$var$initialConnectedTeamsState,
                        containerId: containerId,
                        numberOfTeams: numberOfTeams
                    }
                });
            } catch (e) {
                fireAnalytics({
                    action: (0, $1jIHx.AnalyticsAction).FAILED,
                    actionSubject: 'fetchNumberOfConnectedTeams',
                    containerId: containerId,
                    numberOfTeams: $71d232e5d68dd42c$var$initialConnectedTeamsState.numberOfTeams,
                    error: e
                });
                setState({
                    connectedTeams: {
                        ...$71d232e5d68dd42c$var$initialConnectedTeamsState,
                        containerId: containerId,
                        error: e
                    }
                });
            }
        },
    fetchConnectedTeams: (containerId, fireAnalytics)=>async ({ setState: setState, getState: getState })=>{
            const { connectedTeams: { containerId: currentContainerId, numberOfTeams: numberOfTeams, hasLoaded: hasLoaded } } = getState();
            if (currentContainerId === containerId && hasLoaded) return;
            setState({
                connectedTeams: {
                    containerId: containerId,
                    isLoading: true,
                    hasLoaded: false,
                    teams: undefined,
                    error: null,
                    numberOfTeams: numberOfTeams
                }
            });
            try {
                const teams = await (0, $9muWK.teamsClient).getConnectedTeams(containerId);
                fireAnalytics({
                    action: (0, $1jIHx.AnalyticsAction).SUCCEEDED,
                    actionSubject: 'fetchConnectedTeams',
                    containerId: containerId,
                    numberOfTeams: numberOfTeams
                });
                setState({
                    connectedTeams: {
                        containerId: containerId,
                        isLoading: false,
                        hasLoaded: true,
                        teams: teams,
                        error: null,
                        numberOfTeams: numberOfTeams
                    }
                });
            } catch (e) {
                fireAnalytics({
                    action: (0, $1jIHx.AnalyticsAction).FAILED,
                    actionSubject: 'fetchConnectedTeams',
                    containerId: containerId,
                    numberOfTeams: numberOfTeams,
                    error: e
                });
                setState({
                    connectedTeams: {
                        containerId: containerId,
                        isLoading: false,
                        hasLoaded: false,
                        teams: [],
                        error: e,
                        numberOfTeams: numberOfTeams
                    }
                });
            }
        },
    unlinkTeamContainers: (teamId, containerId)=>async ({ setState: setState, getState: getState })=>{
            setState({
                unlinkError: null
            });
            try {
                const mutationResult = await (0, $9muWK.teamsClient).unlinkTeamContainer(teamId, containerId);
                if (mutationResult.deleteTeamConnectedToContainer.errors.length) // Just handle 1 error at a time should be suffcient as we disconenct only 1 container at a time
                setState({
                    unlinkError: mutationResult.deleteTeamConnectedToContainer.errors[0]
                });
                else {
                    const { teamContainers: teamContainers, connectedTeams: connectedTeams } = getState();
                    const newContainers = teamContainers.filter((container)=>container.id !== containerId);
                    if (connectedTeams.containerId === containerId) setState({
                        teamContainers: newContainers,
                        connectedTeams: $71d232e5d68dd42c$var$initialConnectedTeamsState
                    });
                    else setState({
                        teamContainers: newContainers
                    });
                }
            } catch (err) {
                setState({
                    unlinkError: err
                });
            }
        },
    addTeamContainer: (teamContainer)=>async ({ setState: setState, getState: getState })=>{
            const { teamContainers: teamContainers, connectedTeams: connectedTeams } = getState();
            const containerExists = teamContainers.some((container)=>container.id === teamContainer.id);
            if (containerExists) return;
            if (connectedTeams.containerId === teamContainer.id) setState({
                teamContainers: [
                    ...teamContainers,
                    teamContainer
                ],
                connectedTeams: $71d232e5d68dd42c$var$initialConnectedTeamsState
            });
            else setState({
                teamContainers: [
                    ...teamContainers,
                    teamContainer
                ]
            });
        }
};
const $71d232e5d68dd42c$var$Store = (0, $GtRbT.createStore)({
    initialState: $71d232e5d68dd42c$var$initialState,
    actions: $71d232e5d68dd42c$var$actions,
    name: 'teamContainersStore'
});
const $71d232e5d68dd42c$export$cdd1842df65e002f = (0, $iJq0l.createHook)($71d232e5d68dd42c$var$Store);
const $71d232e5d68dd42c$export$63f31a5bbbef2f9a = (teamId, enable = true)=>{
    const [state, actions] = $71d232e5d68dd42c$export$cdd1842df65e002f();
    const { fireOperationalEvent: fireOperationalEvent } = (0, $1jIHx.usePeopleAndTeamAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireOperationalAnalytics = (0, $eJOHy.useCallback)((action, actionSubject, error)=>{
        fireOperationalEvent(createAnalyticsEvent, {
            action: action,
            actionSubject: actionSubject,
            attributes: {
                teamId: teamId,
                ...error && {
                    error: {
                        message: error.message || JSON.stringify(error),
                        stack: error.stack
                    }
                }
            }
        });
    }, [
        fireOperationalEvent,
        createAnalyticsEvent,
        teamId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (enable) actions.fetchTeamContainers(teamId, fireOperationalAnalytics);
    }, [
        teamId,
        actions,
        enable,
        fireOperationalAnalytics
    ]);
    const refetchTeamContainers = (0, $eJOHy.useCallback)(async ()=>actions.refetchTeamContainers(fireOperationalAnalytics), [
        actions,
        fireOperationalAnalytics
    ]);
    return {
        ...state,
        addTeamContainer: actions.addTeamContainer,
        unlinkTeamContainers: (containerId)=>actions.unlinkTeamContainers(teamId, containerId),
        refetchTeamContainers: refetchTeamContainers
    };
};
const $71d232e5d68dd42c$export$aadc628af3b5ef88 = ()=>{
    const [state, actions] = $71d232e5d68dd42c$export$cdd1842df65e002f();
    const { fireOperationalEvent: fireOperationalEvent } = (0, $1jIHx.usePeopleAndTeamAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireOperationalAnalytics = (0, $eJOHy.useCallback)(({ action: action, actionSubject: actionSubject, containerId: containerId, numberOfTeams: numberOfTeams, error: error })=>{
        fireOperationalEvent(createAnalyticsEvent, {
            action: action,
            actionSubject: actionSubject,
            attributes: {
                containerId: containerId,
                numberOfTeams: numberOfTeams,
                ...error && {
                    error: {
                        message: error.message || JSON.stringify(error),
                        stack: error.stack
                    }
                }
            }
        });
    }, [
        fireOperationalEvent,
        createAnalyticsEvent
    ]);
    return {
        ...state.connectedTeams,
        fetchNumberOfConnectedTeams: (containerId)=>actions.fetchNumberOfConnectedTeams(containerId, fireOperationalAnalytics),
        fetchConnectedTeams: (containerId)=>actions.fetchConnectedTeams(containerId, fireOperationalAnalytics)
    };
};

});
parcelRegister("9muWK", function(module, exports) {

$parcel$export(module.exports, "teamsClient", () => $5c3baee58bb483b2$export$5ed932c3646b89c6);

var $iMBEh = parcelRequire("iMBEh");
class $5c3baee58bb483b2$export$db59823f35bf78ce {
    constructor(/**
		 * @param {ClientContextProps} context - Context including CloudId & OrgId to be used for all requests
		 */ context){
        this._aggClient = (0, $iMBEh.aggClient);
        if (context) this.setContext(context);
    }
    /**
	 * Sets the base URL to be used in the client requests
	 * @param {string} baseUrl - The new base URL
	 */ setBaseUrl(baseUrl) {
        this._aggClient.setBaseUrl(baseUrl);
    }
    /**
	 * Sets context including CloudId & OrgId to be used for all requests
	 */ setContext(context) {
        this._aggClient.setContext(context);
    }
    /**
	 * Get the containers for a given team
	 * @param {string} teamId
	 * @returns {Promise<TeamContainers>}
	 */ async getTeamContainers(teamId) {
        return this._aggClient.getTeamContainers(teamId);
    }
    /**
	 * Get the number of teams connected to a container (Confluence space or Jira project)
	 * @param {string} containerId
	 * @returns {Promise}
	 */ async getNumberOfConnectedTeams(containerId) {
        return this._aggClient.queryNumberOfTeamConnectedToContainer(containerId);
    }
    /**
	 * Get teams connected to a container (Confluence space or Jira project)
	 * @param {string} containerId
	 * @returns {Promise}
	 */ async getConnectedTeams(containerId) {
        return this._aggClient.queryTeamsConnectedToContainer(containerId);
    }
    /**
	 * Unlink a container from a team
	 * @param {string} teamId
	 * @param {string} containerId
	 * @returns {Promise<void>}
	 */ async unlinkTeamContainer(teamId, containerId) {
        return this._aggClient.unlinkTeamContainer(teamId, containerId);
    }
}
const $5c3baee58bb483b2$export$5ed932c3646b89c6 = new $5c3baee58bb483b2$export$db59823f35bf78ce();

});
parcelRegister("iMBEh", function(module, exports) {

$parcel$export(module.exports, "aggClient", () => $28167ea9a1d5ffbf$export$464c991dbf0b2393);

var $eGOwo = parcelRequire("eGOwo");

var $l4NH8 = parcelRequire("l4NH8");

var $9DO7B = parcelRequire("9DO7B");

var $cEtNJ = parcelRequire("cEtNJ");

var $5Zj3X = parcelRequire("5Zj3X");

var $cr8Js = parcelRequire("cr8Js");

var $3nttv = parcelRequire("3nttv");

var $bYWdG = parcelRequire("bYWdG");

var $5gRT3 = parcelRequire("5gRT3");
class $28167ea9a1d5ffbf$export$b44e5dafe13af7b3 extends (0, $5Zj3X.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/graphql`);
    }
    async getTeamContainers(teamId) {
        const teamAri = (0, $l4NH8.teamIdToAri)(teamId);
        const cypherQuery = `MATCH (team:IdentityTeam {ari: '${teamAri}'})-[:team_connected_to_container]->(container) RETURN container`;
        if ((0, $eGOwo.fg)('teams_containers_cypher_query_v2_migration')) {
            const response = await this.makeGraphQLRequest({
                query: (0, $5gRT3.TeamContainersQueryV2),
                variables: {
                    cypherQuery: cypherQuery,
                    params: {
                        id: teamAri
                    }
                }
            }, {
                operationName: 'TeamContainersQueryV2'
            });
            return this.processV2Response(response);
        } else {
            const response = await this.makeGraphQLRequest({
                query: (0, $5gRT3.TeamContainersQuery),
                variables: {
                    cypherQuery: cypherQuery
                }
            }, {
                operationName: 'TeamContainersQuery'
            });
            return this.processV1Response(response);
        }
    }
    processV2Response(response) {
        const containersResult = response.graphStore.cypherQueryV2.edges.reduce((containers, edge)=>{
            edge.node.columns.forEach((column)=>{
                const containerData = column.value?.data;
                if (!containerData && (0, $eGOwo.fg)('enable_team_containers_null_check')) return;
                if (containerData?.__typename === 'ConfluenceSpace') containers.push({
                    id: containerData.id,
                    type: containerData.__typename,
                    name: containerData.confluenceSpaceName || '',
                    icon: `${containerData.links.base}${containerData.icon.path}`,
                    createdDate: new Date(containerData.createdDate),
                    link: `${containerData.links.base}${containerData.links.webUi}`,
                    containerTypeProperties: {
                        subType: undefined,
                        name: undefined
                    }
                });
                else if (containerData?.__typename === 'JiraProject') containers.push({
                    id: containerData.id,
                    type: containerData.__typename,
                    name: containerData.jiraProjectName,
                    icon: containerData.avatar.medium,
                    createdDate: new Date(containerData.created),
                    link: containerData.webUrl,
                    containerTypeProperties: {
                        subType: containerData.projectType || '',
                        name: containerData.projectTypeName || ''
                    }
                });
                else if (containerData?.__typename === 'LoomSpace') containers.push({
                    id: containerData.id,
                    type: containerData.__typename,
                    name: containerData.loomSpaceName,
                    icon: '',
                    link: containerData.url
                });
            });
            return containers;
        }, []);
        return containersResult;
    }
    processV1Response(response) {
        const containersResult = response.graphStore.cypherQuery.edges.reduce((containers, edge)=>{
            if (!edge.node.to.data && (0, $eGOwo.fg)('enable_team_containers_null_check')) return containers;
            if (edge.node.to.data.__typename === 'ConfluenceSpace') containers.push({
                id: edge.node.to.id,
                type: edge.node.to.data.__typename,
                name: edge.node.to.data.confluenceSpaceName || '',
                icon: `${edge.node.to.data.links.base}${edge.node.to.data.icon.path}`,
                createdDate: new Date(edge.node.to.data.createdDate),
                link: `${edge.node.to.data.links.base}${edge.node.to.data.links.webUi}`,
                containerTypeProperties: {
                    subType: undefined,
                    name: undefined
                }
            });
            else if (edge.node.to.data.__typename === 'JiraProject') containers.push({
                id: edge.node.to.id,
                type: edge.node.to.data.__typename,
                name: edge.node.to.data.jiraProjectName,
                icon: edge.node.to.data.avatar.medium,
                createdDate: new Date(edge.node.to.data.created),
                link: edge.node.to.data.webUrl,
                containerTypeProperties: {
                    subType: edge.node.to.data.projectType || '',
                    name: edge.node.to.data.projectTypeName || ''
                }
            });
            else if (edge.node.to.data.__typename === 'LoomSpace') containers.push({
                id: edge.node.to.id,
                type: edge.node.to.data.__typename,
                name: edge.node.to.data.loomSpaceName,
                icon: '',
                link: edge.node.to.data.url
            });
            return containers;
        }, []);
        return containersResult;
    }
    async unlinkTeamContainer(teamId, containerId) {
        const teamAri = (0, $l4NH8.teamIdToAri)(teamId);
        const response = await this.makeGraphQLRequest({
            query: (0, $cr8Js.UnlinkContainerMutation),
            variables: {
                containerId: containerId,
                teamId: teamAri
            }
        }, {
            operationName: 'UnlinkContainerMutation'
        });
        return response.graphStore;
    }
    async queryNumberOfTeamConnectedToContainer(containerId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $3nttv.NumberOfTeamConnectedToContainerQuery),
            variables: {
                containerId: containerId
            }
        }, {
            operationName: 'NumberOfTeamConnectedToContainerQuery'
        });
        return response?.graphStore?.teamConnectedToContainerInverse?.edges?.length;
    }
    async queryTeamsConnectedToContainer(containerId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $bYWdG.TeamConnectedToContainerQuery),
            variables: {
                containerId: containerId
            }
        }, {
            operationName: 'TeamConnectedToContainerQuery'
        });
        return response?.graphStore?.teamConnectedToContainerInverse?.edges?.map(({ node: node })=>({
                id: node.id,
                displayName: node.displayName,
                description: node.description,
                state: node.state,
                membershipSettings: node.membershipSettings,
                organizationId: node.organizationId,
                creatorId: node.creator?.id,
                isVerified: node.isVerified,
                members: node.members?.nodes.map(({ member: member })=>({
                        id: member?.id ? (0, $9DO7B.toUserId)(member?.id) : '',
                        fullName: member?.name ?? '',
                        avatarUrl: member?.picture,
                        status: member?.accountStatus
                    })) ?? [],
                includesYou: false,
                // to-do - this needs to be computed - https://product-fabric.atlassian.net/browse/CCECO-4368
                memberCount: node.members?.nodes.length ?? 0,
                largeAvatarImageUrl: node.largeAvatarImageUrl,
                smallAvatarImageUrl: node.smallAvatarImageUrl,
                largeHeaderImageUrl: node.largeHeaderImageUrl,
                smallHeaderImageUrl: node.smallHeaderImageUrl,
                restriction: 'ORG_MEMBERS' // to-do - figure out if this should be optional (it's deprecated) - https://product-fabric.atlassian.net/browse/CCECO-4368
            }));
    }
}
const $28167ea9a1d5ffbf$export$464c991dbf0b2393 = new $28167ea9a1d5ffbf$export$b44e5dafe13af7b3((0, $cEtNJ.DEFAULT_CONFIG).stargateRoot, {
    logException: ()=>{}
});

});
parcelRegister("l4NH8", function(module, exports) {

$parcel$export(module.exports, "teamIdToAri", () => $2091441a5ccc7d07$export$dd2be0859897f01f);
const $2091441a5ccc7d07$export$e33271562ca4c847 = 'ari:cloud:identity::team/';
const $2091441a5ccc7d07$export$dd2be0859897f01f = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith($2091441a5ccc7d07$export$e33271562ca4c847) ? teamIdOrTeamAri : `${$2091441a5ccc7d07$export$e33271562ca4c847}${teamIdOrTeamAri}`;

});

parcelRegister("9DO7B", function(module, exports) {

$parcel$export(module.exports, "toUserId", () => $0b8e3c98b877be22$export$1d0eef1d33b05366);

var $8iAw6 = parcelRequire("8iAw6");
const $0b8e3c98b877be22$export$caac29844ad91f64 = (ari)=>ari.startsWith((0, $8iAw6.USER_ARI_PREFIX));
const $0b8e3c98b877be22$export$1d0eef1d33b05366 = (ari)=>{
    if ($0b8e3c98b877be22$export$caac29844ad91f64(ari)) return ari.replace((0, $8iAw6.USER_ARI_PREFIX), '');
    throw new Error('Invalid UserARI');
};

});
parcelRegister("8iAw6", function(module, exports) {

$parcel$export(module.exports, "USER_ARI_PREFIX", () => $91ee9bf8617b3f0e$export$470b0d72e4fdc43a);
var $91ee9bf8617b3f0e$export$be86baa40543cfe6 = /*#__PURE__*/ function(JiraProjectTypes) {
    JiraProjectTypes["PRODUCT_DISCOVERY"] = "Product Discovery";
    JiraProjectTypes["SOFTWARE"] = "Software";
    JiraProjectTypes["SERVICE_DESK"] = "Service Desk";
    JiraProjectTypes["BUSINESS"] = "Business";
    JiraProjectTypes["CUSTOMER_SERVICE"] = "Customer Service";
    return JiraProjectTypes;
}({});
const $91ee9bf8617b3f0e$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $91ee9bf8617b3f0e$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';

});


parcelRegister("cEtNJ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONFIG", () => $b2f0b836fdd5e4bd$export$c2f8e0cc249a8d8f);
const $b2f0b836fdd5e4bd$export$c2f8e0cc249a8d8f = {
    stargateRoot: '/gateway/api'
};

});

parcelRegister("5Zj3X", function(module, exports) {

$parcel$export(module.exports, "BaseGraphQlClient", () => $d56465e82fb30364$export$42f6d6baced34b2d);

var $5Bp6c = parcelRequire("5Bp6c");

var $9aIXu = parcelRequire("9aIXu");

var $k0sJC = parcelRequire("k0sJC");
class $d56465e82fb30364$export$42f6d6baced34b2d extends (0, $9aIXu.BaseClient) {
    constructor(serviceUrl, config){
        super(config);
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async makeGraphQLRequest(body, options = {}) {
        try {
            return (0, $k0sJC.handleGraphQLRequest)(this.serviceUrl, body, options);
        } catch (error) {
            if (error instanceof (0, $5Bp6c.GraphQLError)) throw error;
            this.logException(error, 'UnknownError in GraphQLClient.makeGraphQLRequestWithoutRetries');
            throw new (0, $5Bp6c.DefaultError)({});
        }
    }
}

});
parcelRegister("5Bp6c", function(module, exports) {

$parcel$export(module.exports, "DefaultError", () => $29f0e4c5bd8d411b$export$c73ca302efeda3b4);
$parcel$export(module.exports, "HttpError", () => $29f0e4c5bd8d411b$export$65bd6083489bd8bb);
$parcel$export(module.exports, "GraphQLError", () => $29f0e4c5bd8d411b$export$92d6ed0888e7cb7f);
var $29f0e4c5bd8d411b$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
class $29f0e4c5bd8d411b$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message || 'UnknownError';
        this.stack = new Error(message).stack || '';
    }
}
class $29f0e4c5bd8d411b$export$c73ca302efeda3b4 extends $29f0e4c5bd8d411b$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $29f0e4c5bd8d411b$export$c73ca302efeda3b4.prototype);
    }
}
class $29f0e4c5bd8d411b$export$d87f401f8106d7a2 extends $29f0e4c5bd8d411b$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $29f0e4c5bd8d411b$export$d87f401f8106d7a2.prototype);
    }
}
class $29f0e4c5bd8d411b$export$65bd6083489bd8bb extends $29f0e4c5bd8d411b$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId, path: path }){
        super(message);
        Object.setPrototypeOf(this, $29f0e4c5bd8d411b$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
        this.path = path;
    }
}
class $29f0e4c5bd8d411b$export$92d6ed0888e7cb7f extends $29f0e4c5bd8d411b$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $29f0e4c5bd8d411b$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $29f0e4c5bd8d411b$export$92d6ed0888e7cb7f(errorData);
        };
    }
}

});

parcelRegister("9aIXu", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $2b920daec16ad477$export$4f22f74eddb7716a);
class $2b920daec16ad477$export$4f22f74eddb7716a {
    constructor(config){
        this.cache = {};
        this.logException = (ex, name, context)=>{
            this.config.logException(ex, name, context);
        };
        this.config = config;
        this.context = {
            cloudId: null
        };
    }
    setContext(context) {
        this.context = {
            ...context,
            cloudId: context.cloudId || null
        };
    }
    getContext() {
        return this.context;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getOrgId(localValue) {
        const orgId = localValue || this.getContext().orgId;
        if (!orgId) {
            const err = new Error('No orgId set');
            this.logException(err, 'No orgId set');
            throw err;
        }
        return orgId;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getCloudId(localValue) {
        return localValue || this.getContext().cloudId;
    }
    keyWithContext(key) {
        return `${this.getContext().cloudId}-${this.getContext().orgId ?? 'no-org-id'}-${this.getContext().userId ?? 'no-user-id'}-${key}`;
    }
    // Default expiration is 5 minutes
    cacheValue(key, value, expiryMs = 300000) {
        this.cache[this.keyWithContext(key)] = {
            data: value,
            expiration: Date.now() + expiryMs
        };
    }
    getCachedValue(key) {
        const record = this.cache[this.keyWithContext(key)];
        if (record && record.expiration > Date.now()) return record.data;
        return undefined;
    }
}

});

parcelRegister("k0sJC", function(module, exports) {

$parcel$export(module.exports, "handleGraphQLRequest", () => $ddf76442a2a4d439$export$7feffc86760ee7ce);

var $5Bp6c = parcelRequire("5Bp6c");

var $4XF2N = parcelRequire("4XF2N");

var $aNr2y = parcelRequire("aNr2y");
async function $ddf76442a2a4d439$export$93d33e3b46bf00e7(serviceUrl, body, options = {}) {
    const operationNameQuery = options.operationName ? `?q=${options.operationName}` : '';
    const errorPolicy = options.errorPolicy || 'none';
    const url = serviceUrl + operationNameQuery;
    const request = fetch(url, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        credentials: 'include',
        body: JSON.stringify(body)
    }).then((res)=>{
        if (res.status < 300 || res.status === 400) return res.json();
        else throw res;
    });
    try {
        const response = await request;
        const errors = response.errors;
        if (errors) {
            if (errorPolicy === 'none') throw (0, $5Bp6c.GraphQLError).from(errors);
            else if (errorPolicy === 'all') // Set timeout will postpone error throwing and de-touch it to another event loop,
            // so we can return data along with throwing error
            return new Promise((resolve, reject)=>{
                setTimeout(()=>{
                    reject((0, $5Bp6c.GraphQLError).from(errors));
                }, 0);
            });
        }
        return response.data;
    } catch (error) {
        if (error instanceof Response) return {
            response: error
        };
        if (Object(error).hasOwnProperty('response')) throw error;
        return error;
    }
}
async function $ddf76442a2a4d439$export$7feffc86760ee7ce(serviceUrl, body, options = {}) {
    const makeGraphQLRequestWithRetries = (0, $4XF2N.withExponentialBackoff)($ddf76442a2a4d439$export$93d33e3b46bf00e7, {
        initial: (0, $4XF2N.EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
        jitter: (0, $4XF2N.EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
        max: (0, $4XF2N.EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
        retryIf: (data)=>{
            return (0, $4XF2N.isFetchResponse)(data) && (0, $4XF2N.is5xx)(data.response.status);
        }
    });
    const result = await makeGraphQLRequestWithRetries(serviceUrl, body, options);
    const response = result?.response;
    if (response) {
        const status = response.status;
        const statusText = response.statusText;
        const traceId = response.headers.get('atl-traceid');
        (0, $aNr2y.handleResponse)(response);
        if (status > 400 && status <= 599) throw new (0, $5Bp6c.HttpError)({
            message: statusText,
            status: status,
            traceId: traceId ?? undefined
        });
    }
    return result;
}

});
parcelRegister("4XF2N", function(module, exports) {

$parcel$export(module.exports, "EXPONENTIAL_BACKOFF_RETRY_POLICY", () => $d9b55a6ee96bca01$export$8f4286bf21155381);
$parcel$export(module.exports, "is5xx", () => $d9b55a6ee96bca01$export$55b2fbd5d4a32495);
$parcel$export(module.exports, "isFetchResponse", () => $d9b55a6ee96bca01$export$81f27058be86d7ea);
$parcel$export(module.exports, "withExponentialBackoff", () => $d9b55a6ee96bca01$export$20eaa22f2295996f);
const $d9b55a6ee96bca01$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $d9b55a6ee96bca01$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
function $d9b55a6ee96bca01$export$81f27058be86d7ea(data) {
    if (!data || !data.hasOwnProperty('response')) return false;
    return data.response instanceof Response;
}
// tslint:disable-next-line no-any
const $d9b55a6ee96bca01$var$defaultRetryIfCallback = (a)=>!a;
const $d9b55a6ee96bca01$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $d9b55a6ee96bca01$var$defaultRetryIfCallback
};
function $d9b55a6ee96bca01$export$20eaa22f2295996f(toTry, hofOptions = $d9b55a6ee96bca01$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
const $d9b55a6ee96bca01$export$b4c0bf5325504bf3 = $d9b55a6ee96bca01$export$20eaa22f2295996f((url, init)=>fetch(url, init), {
    initial: $d9b55a6ee96bca01$export$8f4286bf21155381.INITIAL_DELAY,
    jitter: $d9b55a6ee96bca01$export$8f4286bf21155381.JITTER,
    max: $d9b55a6ee96bca01$export$8f4286bf21155381.MAX_RETRIES,
    retryIf: (response)=>$d9b55a6ee96bca01$export$55b2fbd5d4a32495(response.status)
});

});

parcelRegister("aNr2y", function(module, exports) {

$parcel$export(module.exports, "handleResponse", () => $88e5dce47322afa5$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $88e5dce47322afa5$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $88e5dce47322afa5$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $88e5dce47322afa5$export$8c005e458e12d501.handlers = handlers;
    }
};
function $88e5dce47322afa5$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $88e5dce47322afa5$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});



parcelRegister("cr8Js", function(module, exports) {

$parcel$export(module.exports, "UnlinkContainerMutation", () => $506d53324a5d58ed$export$74f3ccf149f124b);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $506d53324a5d58ed$export$74f3ccf149f124b = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation unlinkTeamToContainerMutation($teamId: ID!, $containerId: ID!) {
		graphStore @optIn(to: ["GraphStoreMutation"]) {
			deleteTeamConnectedToContainer(
				input: { relationships: [{ from: $teamId, to: $containerId }] }
			) @optIn(to: ["GraphStoreTeamConnectedToContainer"]) {
				errors {
					message
					extensions {
						statusCode
						errorType
					}
				}
				success
			}
		}
	}
`);

});

parcelRegister("3nttv", function(module, exports) {

$parcel$export(module.exports, "NumberOfTeamConnectedToContainerQuery", () => $d41b42b33b3f1dfe$export$6c9c309d551311e);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $d41b42b33b3f1dfe$export$6c9c309d551311e = (0, $6NFTG.print)((0, $kuAvn.default)`
	query getNumberOfTeamsForContainer($containerId: ID!) {
		graphStore @optIn(to: "GraphStore") {
			teamConnectedToContainerInverse(id: $containerId, consistentRead: true)
				@optIn(to: "GraphStoreTeamConnectedToContainer") {
				edges {
					id
				}
			}
		}
	}
`);

});

parcelRegister("bYWdG", function(module, exports) {

$parcel$export(module.exports, "TeamConnectedToContainerQuery", () => $19f0f587da61df93$export$8e179b6008492526);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $19f0f587da61df93$export$8e179b6008492526 = (0, $6NFTG.print)((0, $kuAvn.default)`
	query getTeamsForContainer($containerId: ID!) {
		graphStore @optIn(to: "GraphStore") {
			teamConnectedToContainerInverse(id: $containerId, consistentRead: true)
				@optIn(to: "GraphStoreTeamConnectedToContainer") {
				edges {
					node {
						... on TeamV2 {
							id
							description
							displayName
							creator {
								id
							}
							smallAvatarImageUrl
							smallHeaderImageUrl
							largeAvatarImageUrl
							largeHeaderImageUrl
							members {
								nodes {
									member {
										id
										name
										picture
										accountStatus
										... on AtlassianAccountUser {
											extendedProfile {
												jobTitle
											}
										}
										... on AppUser {
											appType
										}
									}
									role
									state
								}
								pageInfo {
									endCursor
									hasNextPage
								}
							}
							organizationId
							membershipSettings
							isVerified
							state
						}
					}
				}
			}
		}
	}
`);

});

parcelRegister("5gRT3", function(module, exports) {

$parcel$export(module.exports, "TeamContainersQuery", () => $3d0c9b26e6ee1f23$export$f0275d326396e5f9);
$parcel$export(module.exports, "TeamContainersQueryV2", () => $3d0c9b26e6ee1f23$export$dc2f639827051505);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");

var $eGOwo = parcelRequire("eGOwo");
const $3d0c9b26e6ee1f23$export$f0275d326396e5f9 = (0, $6NFTG.print)((0, $kuAvn.default)`
	query TeamContainersQuery($cypherQuery: String!) {
		graphStore @optIn(to: ["GraphStore"]) {
			cypherQuery(query: $cypherQuery) @optIn(to: ["GraphStoreCypherQuery"]) {
				edges {
					__typename
					node {
						from {
							id
						}
						to {
							id
							data {
								__typename
								... on ConfluenceSpace {
									id
									confluenceSpaceName: name
									type
									createdDate
									links {
										base
										webUi
									}
									icon {
										path
									}
								}
								... on JiraProject {
									id
									jiraProjectName: name
									webUrl
									created
									avatar {
										medium
									}
									projectType
									projectTypeName
								}
								... on LoomSpace {
									id
									loomSpaceName: name
									url
								}
							}
						}
					}
				}
			}
		}
	}
`);
const $3d0c9b26e6ee1f23$export$dc2f639827051505 = (0, $6NFTG.print)((0, $kuAvn.default)`
	query TeamContainersQueryV2($cypherQuery: String!, $params: JSON!) {
		graphStore @optIn(to: ["GraphStore", "GraphStoreCypherQueryV2"]) {
			cypherQueryV2(query: $cypherQuery, params: $params) {
				edges {
					node {
						columns {
							key
							value {
								... on GraphStoreCypherQueryV2AriNode {
									data {
										__typename
										... on ConfluenceSpace {
											id
											confluenceSpaceName: name
											type
											createdDate
											links {
												base
												webUi
											}
											icon {
												path
											}
										}
										... on JiraProject {
											id
											jiraProjectName: name
											webUrl
											created
											avatar {
												medium
											}
											projectType
											projectTypeName
										}
										... on LoomSpace {
											id
											loomSpaceName: name
											url
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`);
const $3d0c9b26e6ee1f23$export$37a06e6db2d2421a = ()=>{
    return (0, $eGOwo.fg)('teams_containers_cypher_query_v2_migration') ? $3d0c9b26e6ee1f23$export$dc2f639827051505 : $3d0c9b26e6ee1f23$export$f0275d326396e5f9;
};

});




parcelRegister("kKHd9", function(module, exports) {

$parcel$export(module.exports, "containersEqual", () => $083c46b7ab289cb8$export$2a1a0b9521e054c6);
$parcel$export(module.exports, "getRequestedContainersFromUrl", () => $083c46b7ab289cb8$export$6135988482c416bf);
$parcel$export(module.exports, "userCanAccessFeature", () => $083c46b7ab289cb8$export$e449a6a201c8a49a);
$parcel$export(module.exports, "removeRequestedContainersFromUrl", () => $083c46b7ab289cb8$export$d3e8225e34bcdd7b);
$parcel$export(module.exports, "containerDisplayName", () => $083c46b7ab289cb8$export$8882c1eb80c03e81);
$parcel$export(module.exports, "convertContainerToType", () => $083c46b7ab289cb8$export$e4483a67fcde3e99);
$parcel$export(module.exports, "POLLING_INTERVAL", () => $083c46b7ab289cb8$export$3af5babb39324657);
$parcel$export(module.exports, "useAsyncPolling", () => $083c46b7ab289cb8$export$5fb81aa4b17dfe23);

var $eJOHy = parcelRequire("eJOHy");

var $59rsN = parcelRequire("59rsN");

var $639DS = parcelRequire("639DS");

var $5oAZz = parcelRequire("5oAZz");
const $083c46b7ab289cb8$export$5e146b243177da33 = {
    [(0, $5oAZz.ContainerType).CONFLUENCE_SPACE]: 'ConfluenceSpace',
    [(0, $5oAZz.ContainerType).JIRA_PROJECT]: 'JiraProject',
    [(0, $5oAZz.ContainerType).LOOM_SPACE]: 'LoomSpace'
};
const $083c46b7ab289cb8$var$CONTAINER_HUMAN_NAMES = {
    ConfluenceSpace: 'Confluence space',
    JiraProject: 'Jira project',
    LoomSpace: 'Loom space'
};
const $083c46b7ab289cb8$var$SEARCH_PARAM_NAME = 'requestedContainers';
function $083c46b7ab289cb8$export$2a1a0b9521e054c6(arr1, arr2) {
    return JSON.stringify([
        ...arr1
    ].sort()) === JSON.stringify([
        ...arr2
    ].sort());
}
function $083c46b7ab289cb8$export$6135988482c416bf() {
    const searchParams = new URLSearchParams(window.location.search);
    const values = searchParams.get($083c46b7ab289cb8$var$SEARCH_PARAM_NAME)?.split(',').filter(Boolean) || [];
    const containers = values.filter((value)=>Object.values((0, $5oAZz.ContainerType)).includes(value)).map((value)=>$083c46b7ab289cb8$export$5e146b243177da33[value]);
    if (containers.length === 0) return [];
    return $083c46b7ab289cb8$export$e449a6a201c8a49a() ? containers : [];
}
function $083c46b7ab289cb8$export$d3e8225e34bcdd7b() {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete($083c46b7ab289cb8$var$SEARCH_PARAM_NAME);
    window.history.replaceState({}, '', `${window.location.pathname}?${searchParams.toString()}`);
}
function $083c46b7ab289cb8$export$8882c1eb80c03e81(container) {
    return $083c46b7ab289cb8$var$CONTAINER_HUMAN_NAMES[container];
}
function $083c46b7ab289cb8$export$e4483a67fcde3e99(container) {
    switch(container){
        case 'ConfluenceSpace':
            return (0, $5oAZz.ContainerType).CONFLUENCE_SPACE;
        case 'JiraProject':
            return (0, $5oAZz.ContainerType).JIRA_PROJECT;
        case 'LoomSpace':
            return (0, $5oAZz.ContainerType).LOOM_SPACE;
        default:
            return null;
    }
}
function $083c46b7ab289cb8$export$e449a6a201c8a49a() {
    if ((0, $59rsN.default).initializeCalled()) {
        const value = (0, $59rsN.default).getExperimentValue('teams_app_auto_container_creation', 'cohort', 'control');
        return value === 'universal_create' || value === 'profile_page';
    }
    return false;
}
let $083c46b7ab289cb8$export$3af5babb39324657 = 1000;
let $083c46b7ab289cb8$export$a882ecf05d191257 = 15000;
/**
 * Hook for polling an async callback at a fixed interval, with timeout and pending state management.
 *
 * Starts polling the provided callback and stops after a set duration or when stopped manually.
 * Ensures only one callback is pending at a time.
 *
 * @param callback - The async function to poll.
 * @param onTimeout - Optional callback to execute when polling times out.
 * @returns An object with polling controls and state: startPolling, stopPolling, isPolling, hasTimedOut.
 */ function $083c46b7ab289cb8$export$5fb81aa4b17dfe23(callback, { onTimeout: onTimeout } = {}) {
    const [hasTimedOut, setHasTimedOut] = (0, $eJOHy.useState)(false);
    const timeoutRef = (0, $eJOHy.useRef)(null);
    const [isPolling, setIsPolling] = (0, $eJOHy.useState)(false);
    const [isPending, setIsPending] = (0, $eJOHy.useState)(false);
    const stopPolling = (0, $eJOHy.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setIsPolling(false);
        setHasTimedOut(false);
        setIsPending(false);
    }, []);
    const reset = (0, $eJOHy.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setHasTimedOut(false);
        setIsPolling(false);
        setIsPending(false);
    }, []);
    const startPolling = (0, $eJOHy.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setHasTimedOut(false);
        setIsPolling(true);
        setIsPending(false);
        timeoutRef.current = setTimeout(()=>{
            stopPolling();
            setHasTimedOut(true);
            if (onTimeout) onTimeout({
                startPolling: startPolling,
                stopPolling: stopPolling,
                reset: reset
            });
        }, $083c46b7ab289cb8$export$a882ecf05d191257);
    }, [
        stopPolling,
        onTimeout,
        reset
    ]);
    const wrappedCallback = (0, $eJOHy.useCallback)(async ()=>{
        if (isPending) return;
        setIsPending(true);
        try {
            await callback();
        } finally{
            setIsPending(false);
        }
    }, [
        callback,
        isPending
    ]);
    (0, $639DS.default)(isPolling ? wrappedCallback : ()=>{}, isPolling ? $083c46b7ab289cb8$export$3af5babb39324657 : null);
    return {
        reset: reset,
        startPolling: startPolling,
        stopPolling: stopPolling,
        isPolling: isPolling,
        hasTimedOut: hasTimedOut
    };
}

});
parcelRegister("639DS", function(module, exports) {

$parcel$export(module.exports, "default", () => $87e5fde5788b34cf$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $87e5fde5788b34cf$var$useInterval(callback, delay) {
    const savedCallback = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $eJOHy.useEffect)(()=>{
        function tick() {
            if (savedCallback.current) savedCallback.current();
        }
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
    }, [
        delay
    ]);
}
var $87e5fde5788b34cf$export$2e2bcd8739ae039 = $87e5fde5788b34cf$var$useInterval;

});



parcelRegister("127OW", function(module, exports) {

$parcel$export(module.exports, "useTeamLinksAndContainers", () => $8f786a312805325d$export$5200d5ff4aebd4a7);

var $eJOHy = parcelRequire("eJOHy");

var $jTh0R = parcelRequire("jTh0R");

var $6MZ4F = parcelRequire("6MZ4F");

var $leRWe = parcelRequire("leRWe");
const $8f786a312805325d$var$MAX_LINKS_LIMIT = 10;
const $8f786a312805325d$export$5200d5ff4aebd4a7 = (teamId, enableContainers = true)=>{
    const { teamContainers: teamContainers, loading: containersLoading, hasLoaded: containersHasLoaded, error: containersError, addTeamContainer: addTeamContainer, unlinkTeamContainers: unlinkTeamContainers } = (0, $6MZ4F.useTeamContainers)(teamId, enableContainers);
    const [{ links: links, linkIcons: linkIcons, isLoading: webLinksLoading, hasError: webLinksError, hasLoaded: webLinksHasLoaded, iconsLoading: iconsLoading, iconHasLoaded: iconHasLoaded }, { getTeamWebLinks: getTeamWebLinks, createTeamWebLink: createTeamWebLink, updateTeamWebLink: updateTeamWebLink, removeWebLink: removeWebLink }] = (0, $leRWe.useTeamWebLinks)();
    (0, $eJOHy.useEffect)(()=>{
        getTeamWebLinks(teamId);
    }, [
        getTeamWebLinks,
        teamId
    ]);
    const webLinkContainers = (0, $eJOHy.useMemo)(()=>(0, $jTh0R.webLinksToContainers)(links, linkIcons), [
        links,
        linkIcons
    ]);
    const allContainers = (0, $eJOHy.useMemo)(()=>[
            ...teamContainers,
            ...webLinkContainers
        ], [
        teamContainers,
        webLinkContainers
    ]);
    const canAddMoreLink = (0, $eJOHy.useMemo)(()=>allContainers.length < $8f786a312805325d$var$MAX_LINKS_LIMIT, [
        allContainers.length
    ]);
    const addTeamLink = (0, $eJOHy.useCallback)(async (containerOrWebLink)=>{
        if ((0, $jTh0R.isNewTeamWebLink)(containerOrWebLink)) return await createTeamWebLink(teamId, containerOrWebLink);
        else if (containerOrWebLink.type === 'WebLink') {
            const webLink = (0, $jTh0R.containerToNewWebLink)(containerOrWebLink);
            return await createTeamWebLink(teamId, webLink);
        } else {
            addTeamContainer(containerOrWebLink);
            return Promise.resolve(containerOrWebLink);
        }
    }, [
        teamId,
        createTeamWebLink,
        addTeamContainer
    ]);
    const updateTeamLinkById = (0, $eJOHy.useCallback)(async (linkId, updatedFields)=>{
        const container = allContainers.find((link)=>link.id === linkId);
        if (!container) return;
        if (container.type === 'WebLink') {
            const currentWebLink = (0, $jTh0R.containerToNewWebLink)(container);
            const updatedWebLink = {
                ...currentWebLink,
                ...updatedFields
            };
            return await updateTeamWebLink(teamId, linkId, updatedWebLink);
        }
    }, [
        teamId,
        allContainers,
        updateTeamWebLink
    ]);
    const removeTeamLink = (0, $eJOHy.useCallback)(async (container)=>{
        if (container.type === 'WebLink') await removeWebLink(teamId, container.id);
        else await unlinkTeamContainers(container.id);
    }, [
        teamId,
        removeWebLink,
        unlinkTeamContainers
    ]);
    return {
        isLoading: containersLoading || webLinksLoading,
        hasError: !!containersError || webLinksError,
        containersError: !!containersError,
        webLinksError: webLinksError,
        containersHasLoaded: containersHasLoaded,
        webLinksHasLoaded: webLinksHasLoaded,
        hasLoaded: containersHasLoaded && webLinksHasLoaded,
        teamLinks: allContainers,
        canAddMoreLink: canAddMoreLink,
        iconsLoading: iconsLoading,
        iconHasLoaded: iconHasLoaded,
        addTeamLink: addTeamLink,
        updateTeamLinkById: updateTeamLinkById,
        removeTeamLink: removeTeamLink
    };
};

});
parcelRegister("jTh0R", function(module, exports) {

$parcel$export(module.exports, "containerToNewWebLink", () => $54a5e8f5ce1833e3$export$7cd9d491ff28b738);
$parcel$export(module.exports, "webLinksToContainers", () => $54a5e8f5ce1833e3$export$6a7bb6c7b84e9956);
$parcel$export(module.exports, "isNewTeamWebLink", () => $54a5e8f5ce1833e3$export$26e8ccc2e609ae74);
const $54a5e8f5ce1833e3$export$7cd9d491ff28b738 = (container)=>{
    return {
        contentTitle: container.name,
        description: '',
        linkUri: container.link || ''
    };
};
const $54a5e8f5ce1833e3$export$34d06abc801403e2 = (link, iconData)=>{
    return {
        id: link.linkId,
        type: 'WebLink',
        name: link.contentTitle,
        icon: iconData?.iconUrl || null,
        link: link.linkUri
    };
};
const $54a5e8f5ce1833e3$export$6a7bb6c7b84e9956 = (links, linkIcons = [])=>{
    return links.map((link)=>{
        const iconData = linkIcons.find((icon)=>icon.linkUrl === link.linkUri);
        return $54a5e8f5ce1833e3$export$34d06abc801403e2(link, iconData);
    });
};
const $54a5e8f5ce1833e3$export$26e8ccc2e609ae74 = (input)=>{
    return 'contentTitle' in input && 'linkUri' in input && !('type' in input) && !('id' in input);
};

});

parcelRegister("leRWe", function(module, exports) {

$parcel$export(module.exports, "useTeamWebLinks", () => $6a70128eca79fa03$export$72df01179a70062e);
$parcel$export(module.exports, "useTeamWebLinksActions", () => $6a70128eca79fa03$export$e1403f4f298df7e3);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $301JM = parcelRequire("301JM");
const $6a70128eca79fa03$var$initialState = {
    teamId: '',
    isLoading: false,
    hasLoaded: false,
    hasError: false,
    shouldReload: false,
    errorType: null,
    links: [],
    linkIcons: [],
    iconsLoading: false,
    iconsError: false,
    iconHasLoaded: false
};
const $6a70128eca79fa03$export$e324594224ef24da = {
    getTeamWebLinks: (teamId)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { links: links, teamId: currentTeamId } = getState();
            const initialLinks = teamId === currentTeamId ? links : [];
            setState({
                teamId: teamId,
                isLoading: true,
                hasLoaded: false,
                hasError: false,
                shouldReload: false,
                links: initialLinks
            });
            try {
                const { entities: entities } = await (0, $301JM.teamsClient).getTeamLinksByTeamId(teamId);
                if (getState().teamId !== teamId) return;
                setState({
                    isLoading: false,
                    hasLoaded: true,
                    hasError: false,
                    shouldReload: false,
                    links: entities
                });
                if (entities.length > 0) dispatch($6a70128eca79fa03$export$e324594224ef24da.getTeamWebLinkIcons(teamId));
            } catch (e) {
                if (getState().teamId !== teamId) return;
                setState({
                    isLoading: false,
                    hasLoaded: true,
                    hasError: true,
                    errorType: e instanceof Error ? e : undefined,
                    shouldReload: false,
                    links: []
                });
            }
        },
    getTeamWebLinkIcons: (teamId)=>async ({ getState: getState, setState: setState })=>{
            const { links: links, linkIcons: currentIcons } = getState();
            if (links.length === 0) return;
            const linkUrls = links.map((link)=>link.linkUri);
            const uncachedUrls = linkUrls.filter((url)=>!currentIcons.some((icon)=>icon.linkUrl === url));
            if (uncachedUrls.length > 0) try {
                setState({
                    iconsLoading: true,
                    iconsError: false
                });
                const newIconData = await (0, $301JM.teamsClient).getTeamLinkIcons(uncachedUrls);
                if (getState().teamId === teamId) setState({
                    linkIcons: [
                        ...currentIcons,
                        ...newIconData || []
                    ],
                    iconsLoading: false,
                    iconsError: false,
                    iconHasLoaded: true
                });
            } catch (iconError) {
                if (getState().teamId === teamId) setState({
                    iconsLoading: false,
                    iconsError: true,
                    iconHasLoaded: true
                });
            }
            else setState({
                iconsLoading: false,
                iconsError: false,
                iconHasLoaded: true
            });
        },
    createTeamWebLink: (teamId, newLink)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const result = await (0, $301JM.teamsClient).createTeamLink(teamId, newLink);
            const currentState = getState();
            if (currentState.teamId !== teamId) return result;
            setState({
                links: [
                    ...currentState.links,
                    result
                ]
            });
            dispatch($6a70128eca79fa03$export$e324594224ef24da.getTeamWebLinkIcons(teamId));
            return result;
        },
    updateTeamWebLink: (teamId, linkId, newLink)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const result = await (0, $301JM.teamsClient).updateTeamLink(teamId, linkId, newLink);
            const currentState = getState();
            if (currentState.teamId !== teamId) return result;
            const oldLink = currentState.links.find((link)=>link.linkId === linkId);
            const urlChanged = oldLink && oldLink.linkUri !== result.linkUri;
            setState({
                links: currentState.links.map((link)=>link.linkId === linkId ? result : link)
            });
            if (urlChanged) {
                const updatedIcons = currentState.linkIcons.filter((icon)=>icon.linkUrl !== oldLink.linkUri);
                setState({
                    linkIcons: updatedIcons
                });
                dispatch($6a70128eca79fa03$export$e324594224ef24da.getTeamWebLinkIcons(teamId));
            }
            return result;
        },
    removeWebLink: (teamId, linkId)=>async ({ getState: getState, setState: setState })=>{
            const currentState = getState();
            if (currentState.teamId !== teamId) return;
            await (0, $301JM.teamsClient).deleteTeamLink(teamId, linkId);
            setState({
                links: currentState.links.filter((link)=>link.linkId !== linkId)
            });
        },
    fetchWebLinkTitle: (url)=>async ({ setState: setState })=>{
            if (!url) return undefined;
            try {
                const title = await (0, $301JM.teamsClient).getWebLinkTitle(url);
                return title;
            } catch (error) {
                return undefined;
            }
        },
    initialState: (state)=>({ setState: setState })=>{
            setState({
                ...$6a70128eca79fa03$var$initialState,
                ...state
            });
        }
};
const $6a70128eca79fa03$var$TeamWebLinksStore = (0, $GtRbT.createStore)({
    initialState: $6a70128eca79fa03$var$initialState,
    actions: $6a70128eca79fa03$export$e324594224ef24da
});
const $6a70128eca79fa03$export$72df01179a70062e = (0, $iJq0l.createHook)($6a70128eca79fa03$var$TeamWebLinksStore);
const $6a70128eca79fa03$export$e1403f4f298df7e3 = (0, $iJq0l.createHook)($6a70128eca79fa03$var$TeamWebLinksStore, {
    selector: null
});

});


parcelRegister("bXnEP", function(module, exports) {

$parcel$export(module.exports, "getAddContainerCards", () => $967da3b5b4561b37$export$a1480278fb6646ef);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $dcLzM = parcelRequire("dcLzM");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $c776o = parcelRequire("c776o");
const $967da3b5b4561b37$var$styles = {
    card: "_4cvr1h6o _1bsb1osq",
    container: "_2rkoop52 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _d0altlke",
    iconWrapper: "_2rkoiti9 _12y3e4h9 _12jimuej _1qu2gq9o _syaz131l _4cvxmuej _ksodnqa1"
};
const $967da3b5b4561b37$var$AddContainerCardWrapper = ({ children: children, onClick: onClick })=>{
    const [hovered, setHovered] = (0, $eJOHy.useState)(false);
    const handleMouseEnter = ()=>setHovered(true);
    const handleMouseLeave = ()=>setHovered(false);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        backgroundColor: hovered ? 'elevation.surface.hovered' : 'elevation.surface.sunken',
        xcss: $967da3b5b4561b37$var$styles.container,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: onClick,
        children: children
    });
};
const $967da3b5b4561b37$export$7f436a9048e9eef4 = ({ containerType: containerType, onAddAContainerClick: onAddAContainerClick })=>{
    const { description: description, icon: icon, title: title } = (0, $c776o.getContainerProperties)({
        containerType: containerType,
        iconSize: (0, $eGOwo.fg)('enable_medium_size_icons_for_team_link_cards') ? 'medium' : undefined,
        isEmptyContainer: true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($967da3b5b4561b37$var$AddContainerCardWrapper, {
        onClick: onAddAContainerClick,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.100",
            xcss: $967da3b5b4561b37$var$styles.card,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: $967da3b5b4561b37$var$styles.iconWrapper,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                        label: "Add a container",
                        appearance: "subtle",
                        icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                                ...iconProps,
                                size: "small"
                            }),
                        testId: "add-icon",
                        onClick: (e)=>{
                            onAddAContainerClick(e);
                            e.stopPropagation();
                        }
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                    ...(0, $eGOwo.fg)('enable_medium_size_icons_for_team_link_cards') ? {
                        space: 'space.025'
                    } : {},
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                            maxLines: 1,
                            weight: "medium",
                            color: "color.text",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
                            gap: "space.050",
                            alignItems: "center",
                            children: [
                                icon,
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                    size: "small",
                                    color: "color.text.subtle",
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $967da3b5b4561b37$export$a1480278fb6646ef = ({ showAddContainer: showAddContainer, onAddAContainerClick: onAddAContainerClick })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            showAddContainer.Jira && /*#__PURE__*/ (0, $gt9Am.jsx)($967da3b5b4561b37$export$7f436a9048e9eef4, {
                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Jira'),
                containerType: "JiraProject"
            }),
            showAddContainer.Confluence && /*#__PURE__*/ (0, $gt9Am.jsx)($967da3b5b4561b37$export$7f436a9048e9eef4, {
                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Confluence'),
                containerType: "ConfluenceSpace"
            }),
            showAddContainer.Loom && (0, $eGOwo.fg)('loom_tab_in_container_linker_team_profile_page') && /*#__PURE__*/ (0, $gt9Am.jsx)($967da3b5b4561b37$export$7f436a9048e9eef4, {
                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Loom'),
                containerType: "LoomSpace"
            }),
            showAddContainer.WebLink && /*#__PURE__*/ (0, $gt9Am.jsx)($967da3b5b4561b37$export$7f436a9048e9eef4, {
                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'WebLink'),
                containerType: "WebLink"
            })
        ]
    });
};

});

parcelRegister("i9St2", function(module, exports) {

$parcel$export(module.exports, "getAddContainerCardsWithCreate", () => $b2f8d8c567bbe343$export$eeba043952cfe076);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");

var $Ay1uj = parcelRequire("Ay1uj");

var $dcLzM = parcelRequire("dcLzM");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $7RSVt = parcelRequire("7RSVt");

var $91pAT = parcelRequire("91pAT");
const $b2f8d8c567bbe343$var$styles = {
    card: "_4cvr1h6o _1bsb1osq",
    container: "_2rkoop52 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _d0altlke",
    iconWrapper: "_2rkopd34 _1bsb1u1b _4t3i1u1b _1e0c1txw _4cvr1h6o _1bah1h6o _12jimuej _1qu2gq9o"
};
const $b2f8d8c567bbe343$var$AddContainerCardWrapper = ({ children: children, onClick: onClick })=>{
    const [hovered, setHovered] = (0, $eJOHy.useState)(false);
    const handleMouseEnter = ()=>setHovered(true);
    const handleMouseLeave = ()=>setHovered(false);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        backgroundColor: hovered ? 'elevation.surface.hovered' : 'elevation.surface.sunken',
        xcss: $b2f8d8c567bbe343$var$styles.container,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: onClick,
        children: children
    });
};
const $b2f8d8c567bbe343$export$6d22b38090af8710 = ({ containerType: containerType, onAddAContainerClick: onAddAContainerClick, isLoading: isLoading })=>{
    const { description: description, title: title } = (0, $91pAT.getContainerProperties)({
        containerType: containerType
    });
    if (isLoading) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7RSVt.LinkedContainerCardSkeleton), {});
    return /*#__PURE__*/ (0, $gt9Am.jsx)($b2f8d8c567bbe343$var$AddContainerCardWrapper, {
        onClick: onAddAContainerClick,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.100",
            xcss: $b2f8d8c567bbe343$var$styles.card,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: $b2f8d8c567bbe343$var$styles.iconWrapper,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                        label: "Add a container",
                        appearance: "subtle",
                        icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                                ...iconProps,
                                size: "small"
                            }),
                        testId: "add-icon",
                        onClick: (e)=>{
                            onAddAContainerClick(e);
                            e.stopPropagation();
                        }
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                    ...(0, $eGOwo.fg)('enable_medium_size_icons_for_team_link_cards') ? {
                        space: 'space.025'
                    } : {},
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                            maxLines: 1,
                            weight: "medium",
                            color: "color.text",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                            gap: "space.050",
                            alignItems: "center",
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                size: "small",
                                color: "color.text.subtle",
                                children: description
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $b2f8d8c567bbe343$export$eeba043952cfe076 = ({ showAddContainer: showAddContainer, onAddAContainerClick: onAddAContainerClick, containersLoading: containersLoading })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            showAddContainer.Jira && /*#__PURE__*/ (0, $gt9Am.jsx)($b2f8d8c567bbe343$export$6d22b38090af8710, {
                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Jira'),
                containerType: "JiraProject",
                isLoading: containersLoading.jira
            }),
            showAddContainer.Confluence && /*#__PURE__*/ (0, $gt9Am.jsx)($b2f8d8c567bbe343$export$6d22b38090af8710, {
                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Confluence'),
                containerType: "ConfluenceSpace",
                isLoading: containersLoading.confluence
            }),
            showAddContainer.Loom && /*#__PURE__*/ (0, $gt9Am.jsx)($b2f8d8c567bbe343$export$6d22b38090af8710, {
                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Loom'),
                containerType: "LoomSpace",
                isLoading: containersLoading.loom
            }),
            showAddContainer.WebLink && /*#__PURE__*/ (0, $gt9Am.jsx)($b2f8d8c567bbe343$export$6d22b38090af8710, {
                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'WebLink'),
                containerType: "WebLink"
            })
        ]
    });
};
const $b2f8d8c567bbe343$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    addExistingLinkTitle: {
        id: 'ptc-directory.team-profile-page.team-containers.add-confluence-space-title',
        defaultMessage: 'Add an existing space',
        description: 'Title of the card to add a Confluence space to a team'
    }
});

});
parcelRegister("91pAT", function(module, exports) {

$parcel$export(module.exports, "getContainerProperties", () => $b0eed392216be329$export$4fa7913af1c65224);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");
var $kDaaB = parcelRequire("kDaaB");

var $3pQT5 = parcelRequire("3pQT5");

var $lmJ87 = parcelRequire("lmJ87");
const $b0eed392216be329$export$4fa7913af1c65224 = ({ containerType: containerType })=>{
    switch(containerType){
        case 'ConfluenceSpace':
            return {
                description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...$b0eed392216be329$export$defe85febe8b728c.confluenceContainerDescription
                }),
                icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3pQT5))), {
                    label: 'confluence space',
                    spacing: 'spacious'
                }),
                title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...$b0eed392216be329$export$defe85febe8b728c.addConfluenceContainerTitle
                })
            };
        case 'LoomSpace':
            return {
                description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...$b0eed392216be329$export$defe85febe8b728c.loomSpaceDescription
                }),
                icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3pQT5))), {
                    label: 'loom space',
                    spacing: 'spacious'
                }),
                title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...$b0eed392216be329$export$defe85febe8b728c.addLoomContainerTitle
                })
            };
        case 'JiraProject':
            return {
                description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...$b0eed392216be329$export$defe85febe8b728c.jiraProjectDescription
                }),
                icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lmJ87))), {
                    label: 'jira project',
                    spacing: 'spacious'
                }),
                title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...$b0eed392216be329$export$defe85febe8b728c.addJiraProjectTitle
                })
            };
        case 'WebLink':
            return {
                description: null,
                icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lmJ87))), {
                    label: 'web link',
                    spacing: 'spacious'
                }),
                title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...$b0eed392216be329$export$defe85febe8b728c.addWebLinkTitle
                })
            };
        default:
            return {
                description: null,
                icon: null,
                title: null
            };
    }
};
const $b0eed392216be329$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    addConfluenceContainerTitle: {
        id: 'ptc-directory.team-profile-page.team-containers.auto-create.add-confluence-space-title',
        defaultMessage: 'Confluence space',
        description: 'Title of the card to add a Confluence space to a team'
    },
    confluenceContainerDescription: {
        id: 'ptc-directory.team-profile-page.team-containers.auto-create.add-confluence-space-description',
        defaultMessage: 'Create a knowledge bank',
        description: 'Description of the card to add a Confluence space to a team'
    },
    addLoomContainerTitle: {
        id: 'ptc-directory.team-profile-page.team-containers.auto-create.add-loom-space-title',
        defaultMessage: 'Loom space',
        description: 'Title of the card to add a Loom space to a team'
    },
    loomSpaceDescription: {
        id: 'ptc-directory.team-profile-page.team-containers.auto-create.add-loom-space-description',
        defaultMessage: 'Share async updates',
        description: 'Description of the card to add a Loom space to a team'
    },
    addJiraProjectTitle: {
        id: 'ptc-directory.team-profile-page.team-containers.auto-create.add-jira-project-title',
        defaultMessage: 'Jira project',
        description: 'Title of the card to add a Jira project to a team'
    },
    jiraProjectDescription: {
        id: 'ptc-directory.team-profile-page.team-containers.auto-create.add-jira-project-description',
        defaultMessage: 'Plan out project tasks',
        description: 'Description of the card to add a Jira project to a team'
    },
    addWebLinkTitle: {
        id: 'ptc-directory.team-profile-page.team-containers.auto-create.add-web-link-title',
        defaultMessage: 'Add any web link',
        description: 'Title of the card to add a any web link to a team'
    }
});

});


parcelRegister("8HUCq", function(module, exports) {

$parcel$export(module.exports, "DisconnectDialogLazy", () => $ee1acf4444cfe915$export$3f4d3ee9eb71a228);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
parcelRequire("bn7wb");
var $aAuez = parcelRequire("aAuez");
var $7qz8r = parcelRequire("7qz8r");

const $ee1acf4444cfe915$var$DisconnectDialogLazyInner = (0, $aAuez.lazyForPaint)(()=>(parcelRequire("jZXbl")).then(({ DisconnectDialog: DisconnectDialog })=>DisconnectDialog));
const $ee1acf4444cfe915$export$3f4d3ee9eb71a228 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7qz8r.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($ee1acf4444cfe915$var$DisconnectDialogLazyInner, {
            ...props
        })
    });

});
parcelRegister("bn7wb", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("aAuez")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("aAuez")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("aAuez")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("7qz8r")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("l7ep7")).useLazyPhase);
parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $MkKnc = parcelRequire("MkKnc");

var $aAuez = parcelRequire("aAuez");
parcelRequire("4XKbm");
var $7eb8v = parcelRequire("7eb8v");
var $esFTx = parcelRequire("esFTx");
parcelRequire("jv91R");
var $7qz8r = parcelRequire("7qz8r");
parcelRequire("1llka");
var $l7ep7 = parcelRequire("l7ep7");

var $hrq5I = parcelRequire("hrq5I");

});
parcelRegister("7veda", function(module, exports) {

$parcel$export(module.exports, "getConfig", () => $576673b9f1b70022$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $576673b9f1b70022$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("8V4xR")).MODE);

var $8V4xR = parcelRequire("8V4xR");
const $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN = undefined;
const $576673b9f1b70022$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $576673b9f1b70022$var$DEFAULT_MODE = (0, $8V4xR.MODE).HYDRATE;
const $576673b9f1b70022$var$DEFAULT_RETRY = 2;
const $576673b9f1b70022$var$config = {
    crossOrigin: $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN,
    manifest: $576673b9f1b70022$var$DEFAULT_MANIFEST,
    mode: $576673b9f1b70022$var$DEFAULT_MODE,
    retry: $576673b9f1b70022$var$DEFAULT_RETRY
};
const $576673b9f1b70022$export$44487a86467333c3 = ()=>$576673b9f1b70022$var$config;
const $576673b9f1b70022$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $576673b9f1b70022$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN;
    $576673b9f1b70022$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $576673b9f1b70022$var$DEFAULT_MANIFEST;
    $576673b9f1b70022$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $576673b9f1b70022$var$DEFAULT_MODE;
    $576673b9f1b70022$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $576673b9f1b70022$var$DEFAULT_RETRY;
};

});
parcelRegister("8V4xR", function(module, exports) {

$parcel$export(module.exports, "MODE", () => $67e72c25add85f29$export$e48589d9e4824227);
const $67e72c25add85f29$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("MkKnc", function(module, exports) {

var $8h7zW = parcelRequire("8h7zW");

var $7veda = parcelRequire("7veda");
parcelRequire("1llka");
var $eGDOl = parcelRequire("eGDOl");
var $l7ep7 = parcelRequire("l7ep7");

var $a1Dox = parcelRequire("a1Dox");
const $091493b8f27d5831$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $7veda.setConfig)(config);
        (0, $eGDOl.LISTENERS).length = 0;
        (0, $l7ep7.setCurrent)(0);
        if (!(0, $a1Dox.isNodeEnvironment)()) (0, $8h7zW.collect)();
    }
};

});
parcelRegister("8h7zW", function(module, exports) {

$parcel$export(module.exports, "collect", () => $6065ca3c1e226813$export$bb44f104e3c54dae);

var $7veda = parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $bzDJE = parcelRequire("bzDJE");

var $9WyUY = parcelRequire("9WyUY");

var $1NKbK = parcelRequire("1NKbK");
const $6065ca3c1e226813$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $7veda.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $8V4xR.MODE).RENDER ? (0, $9WyUY.cloneElements)(markers[i], lazyBegin) : (0, $1NKbK.refElements)(markers[i], lazyBegin);
        if ((0, $bzDJE.COLLECTED).has(lazyBegin)) (0, $bzDJE.COLLECTED).get(lazyBegin).push(value);
        else (0, $bzDJE.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("bzDJE", function(module, exports) {

$parcel$export(module.exports, "PHASE", () => $86d1c92cf7d83ac0$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $86d1c92cf7d83ac0$export$4831ef3968ea94ef);
const $86d1c92cf7d83ac0$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $86d1c92cf7d83ac0$export$4831ef3968ea94ef = new Map();

});

parcelRegister("9WyUY", function(module, exports) {

$parcel$export(module.exports, "cloneElements", () => $73d49dd0c38c2a1c$export$c42217d53a7ebafb);
const $73d49dd0c38c2a1c$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break; // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("1NKbK", function(module, exports) {

$parcel$export(module.exports, "refElements", () => $14fe3218cc4e45c4$export$c69443129766a7fc);
const $14fe3218cc4e45c4$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});


parcelRegister("1llka", function(module, exports) {

$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("l7ep7")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("l7ep7")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("l7ep7")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("eGDOl")).LISTENERS);

var $l7ep7 = parcelRequire("l7ep7");

var $eGDOl = parcelRequire("eGDOl");

var $7Peej = parcelRequire("7Peej");

});
parcelRegister("l7ep7", function(module, exports) {

$parcel$export(module.exports, "setCurrent", () => $f5f56cc3db1024b3$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $f5f56cc3db1024b3$export$5a25eca35e5debcb);
$parcel$export(module.exports, "useLazyPhase", () => $f5f56cc3db1024b3$export$1dc361b277327f88);

var $eJOHy = parcelRequire("eJOHy");

var $bzDJE = parcelRequire("bzDJE");

var $eGDOl = parcelRequire("eGDOl");

var $7Peej = parcelRequire("7Peej");
let $f5f56cc3db1024b3$var$CURRENT_PHASE = (0, $bzDJE.PHASE).PAINT;
const $f5f56cc3db1024b3$export$5f80f094fd31fffd = (phase)=>{
    $f5f56cc3db1024b3$var$CURRENT_PHASE = phase;
    (0, $eGDOl.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $f5f56cc3db1024b3$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $eJOHy.createContext)({
    subscribe: (0, $7Peej.createSubscribe)((0, $eGDOl.LISTENERS)),
    currentValue: ()=>$f5f56cc3db1024b3$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $f5f56cc3db1024b3$export$5f80f094fd31fffd((0, $bzDJE.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$f5f56cc3db1024b3$export$5f80f094fd31fffd((0, $bzDJE.PHASE).PAINT)
    }
});
const $f5f56cc3db1024b3$export$1dc361b277327f88 = ()=>{
    const v = (0, $eJOHy.useContext)($f5f56cc3db1024b3$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("eGDOl", function(module, exports) {

$parcel$export(module.exports, "LISTENERS", () => $ab13de8c68717d57$export$81b9c458a026d68f);
const $ab13de8c68717d57$export$81b9c458a026d68f = [];

});

parcelRegister("7Peej", function(module, exports) {

$parcel$export(module.exports, "createSubscribe", () => $5b2855963721e7ea$export$364097d812234b3f);
const $5b2855963721e7ea$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});



parcelRegister("a1Dox", function(module, exports) {

$parcel$export(module.exports, "getExport", () => $74c88e574846d6bd$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $74c88e574846d6bd$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $74c88e574846d6bd$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $74c88e574846d6bd$export$62bf630d0de3d781);
$parcel$export(module.exports, "hash", () => (parcelRequire("ed3y6")).default);

var $ed3y6 = parcelRequire("ed3y6");
const $74c88e574846d6bd$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $74c88e574846d6bd$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $74c88e574846d6bd$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $74c88e574846d6bd$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("ed3y6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5850857827bd3c9$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $a5850857827bd3c9$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});



parcelRegister("aAuez", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", () => $7b54b80385d7fc57$export$c952e5f94576010e);
$parcel$export(module.exports, "lazyAfterPaint", () => $7b54b80385d7fc57$export$291dd592399bdafa);
$parcel$export(module.exports, "lazy", () => $7b54b80385d7fc57$export$488013bae63b21da);

var $j5vcn = parcelRequire("j5vcn");

var $7veda = parcelRequire("7veda");

var $bzDJE = parcelRequire("bzDJE");

var $a1Dox = parcelRequire("a1Dox");
var $ed3y6 = parcelRequire("ed3y6");

var $b8XF0 = parcelRequire("b8XF0");

var $jA7rF = parcelRequire("jA7rF");

var $c7s3I = parcelRequire("c7s3I");

var $iFrYh = parcelRequire("iFrYh");

var $dcrQD = parcelRequire("dcrQD");

var $dcUz2 = parcelRequire("dcUz2");

var $2f83m = parcelRequire("2f83m");
function $7b54b80385d7fc57$var$_extends() {
    $7b54b80385d7fc57$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7b54b80385d7fc57$var$_extends.apply(this, arguments);
}
function $7b54b80385d7fc57$var$lazyProxy(_loader, { defer: defer = (0, $bzDJE.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $a1Dox.isNodeEnvironment)();
    const dataLazyId = (0, $ed3y6.default)(moduleId);
    const LazyInternal = isServer ? (0, $c7s3I.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $jA7rF.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $iFrYh.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $7veda.getConfig)();
                return (0, $dcUz2.retry)(_loader, {
                    delay: (0, $b8XF0.RETRY_DELAY),
                    factor: (0, $b8XF0.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $a1Dox.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $7veda.getConfig)();
        return (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $bzDJE.PHASE).PAINT ? (0, $b8XF0.PRIORITY).HIGH : (0, $b8XF0.PRIORITY).LOW;
        return (0, $dcrQD.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $7b54b80385d7fc57$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $bzDJE.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $bzDJE.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $bzDJE.PHASE).LAZY
    }
};
function $7b54b80385d7fc57$export$c952e5f94576010e(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $7b54b80385d7fc57$export$291dd592399bdafa(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $7b54b80385d7fc57$export$488013bae63b21da(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazy, opts || {}));
}

});
parcelRegister("j5vcn", function(module, exports) {

$parcel$export(module.exports, "getAssetUrlsFromId", () => $de56af5358c8f987$export$303f43e55cf1ef2f);
const $de56af5358c8f987$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("b8XF0", function(module, exports) {

$parcel$export(module.exports, "PRIORITY", () => $81ceb864b052c80d$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $81ceb864b052c80d$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $81ceb864b052c80d$export$ba64c908e55507fe);
const $81ceb864b052c80d$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $81ceb864b052c80d$export$a339266ad71b2447 = 300;
const $81ceb864b052c80d$export$ba64c908e55507fe = 1;

});

parcelRegister("jA7rF", function(module, exports) {

$parcel$export(module.exports, "createComponentClient", () => $e417279bde8da3e7$export$6898b5504b58699a);

var $eJOHy = parcelRequire("eJOHy");

var $7veda = parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $bzDJE = parcelRequire("bzDJE");
parcelRequire("4XKbm");
var $esFTx = parcelRequire("esFTx");
parcelRequire("1llka");
var $l7ep7 = parcelRequire("l7ep7");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");

var $2f83m = parcelRequire("2f83m");

var $bVeRl = parcelRequire("bVeRl");

var $7fZLe = parcelRequire("7fZLe");

var $hrq5I = parcelRequire("hrq5I");

var $9qVNk = parcelRequire("9qVNk");
function $e417279bde8da3e7$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $eJOHy.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $bzDJE.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $bzDJE.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $eJOHy.useContext)((0, $hrq5I.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $2f83m.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        }; // Subscribe to LazyWait context, triggering load when until is true
        (0, $9qVNk.useSubscription)({
            context: (0, $esFTx.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $bzDJE.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
        (0, $9qVNk.useSubscription)({
            context: (0, $l7ep7.LazyPhaseContext),
            load: load,
            onValue: (v)=>status.phase = v >= defer
        });
        const { setFallback: setFallback } = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
        (0, $eJOHy.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $bzDJE.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return; // override Suspense fallback with magic input wrappers
            const component = (0, $7veda.getConfig)().mode === (0, $8V4xR.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bVeRl.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fZLe.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("4XKbm", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => (parcelRequire("esFTx")).WaitContext);

var $esFTx = parcelRequire("esFTx");

var $7eb8v = parcelRequire("7eb8v");

});
parcelRegister("esFTx", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => $a8742da03f685732$export$9ba3fe09d15de47b);

var $eJOHy = parcelRequire("eJOHy");

var $ddxDA = parcelRequire("ddxDA");
const $a8742da03f685732$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $eJOHy.createContext)({
    subscribe: ()=>(0, $ddxDA.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("ddxDA", function(module, exports) {

$parcel$export(module.exports, "noopCleanup", () => $99f694f5596397af$export$276c7dbda7675aec);
const $99f694f5596397af$export$276c7dbda7675aec = ()=>{};

});


parcelRegister("7eb8v", function(module, exports) {

var $eJOHy = parcelRequire("eJOHy");

var $esFTx = parcelRequire("esFTx");
const $54327a9f9e29fe04$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $eJOHy.useContext)((0, $esFTx.WaitContext));
    const value = (0, $eJOHy.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $eJOHy.useRef)(new Set());
    const api = (0, $eJOHy.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $eJOHy.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $esFTx.WaitContext).Provider, {
        value: api.current
    }, children);
};

});


parcelRegister("jv91R", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("7qz8r")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("4XL9N")).LazySuspenseContext);

var $7qz8r = parcelRequire("7qz8r");

var $4XL9N = parcelRequire("4XL9N");

});
parcelRegister("7qz8r", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => $56863736a86894e9$export$256c542058532d6f);

var $eJOHy = parcelRequire("eJOHy");

var $a1Dox = parcelRequire("a1Dox");

var $4XL9N = parcelRequire("4XL9N");
class $56863736a86894e9$export$256c542058532d6f extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback; // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            },
            name: this.props.name
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $eJOHy.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this; // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4XL9N.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4XL9N.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $a1Dox.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("4XL9N", function(module, exports) {

$parcel$export(module.exports, "LazySuspenseContext", () => $39d1408803878497$export$c33990e84065970c);

var $eJOHy = parcelRequire("eJOHy");
const $39d1408803878497$export$c33990e84065970c = /*#__PURE__*/ (0, $eJOHy.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});



parcelRegister("2f83m", function(module, exports) {

$parcel$export(module.exports, "createLoaderError", () => $1a233ab151dd1ee2$export$c73a6a6f0bf7d425);
const $1a233ab151dd1ee2$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $1a233ab151dd1ee2$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') return Object.assign(error, {
        [$1a233ab151dd1ee2$export$6aa69c1258005366]: true
    });
    return error;
};
const $1a233ab151dd1ee2$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($1a233ab151dd1ee2$export$6aa69c1258005366);

});

parcelRegister("bVeRl", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackRender", () => $8ae08b5f412b712d$export$d55db778a3e1446b);

var $eJOHy = parcelRequire("eJOHy");

var $hrq5I = parcelRequire("hrq5I");
parcelRequire("4XKbm");
var $esFTx = parcelRequire("esFTx");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");
function $8ae08b5f412b712d$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $8ae08b5f412b712d$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $eJOHy.useRef)(null);
    const { current: ssrDomNodes } = (0, $eJOHy.useRef)(content || []);
    const profilerContext = (0, $eJOHy.useContext)((0, $hrq5I.ProfilerContext)).current;
    const waitContext = (0, $eJOHy.useContext)((0, $esFTx.WaitContext));
    const suspenseContext = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
    (0, $eJOHy.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext === null || profilerContext.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($8ae08b5f412b712d$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext === null || profilerContext.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        }; // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $8ae08b5f412b712d$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $8ae08b5f412b712d$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});
parcelRegister("hrq5I", function(module, exports) {

$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $cb29326da0127013$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $cb29326da0127013$export$8146ab57a3f7a7cb);

var $eJOHy = parcelRequire("eJOHy");
const $cb29326da0127013$export$e2d53c0cbedd2710 = {
    current: null
};
const $cb29326da0127013$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $eJOHy.createContext)($cb29326da0127013$export$e2d53c0cbedd2710);

});


parcelRegister("7fZLe", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $5489d785fce022f5$export$ca5b8fbc835d95e4);

var $eJOHy = parcelRequire("eJOHy");

var $a1Dox = parcelRequire("a1Dox");
function $5489d785fce022f5$var$_extends() {
    $5489d785fce022f5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5489d785fce022f5$var$_extends.apply(this, arguments);
}
const $5489d785fce022f5$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $a1Dox.attrToProp), {
            key: String(i)
        }); // text node
        if (!tagName) return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $eJOHy.Fragment), props, el.textContent); // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $eJOHy.createElement)(tagName.toLowerCase(), props); // tag with content
        return /*#__PURE__*/ (0, $eJOHy.createElement)(tagName.toLowerCase(), $5489d785fce022f5$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("9qVNk", function(module, exports) {

$parcel$export(module.exports, "useSubscription", () => $6de35f980c3d94e0$export$368b4214baeb914c);

var $eJOHy = parcelRequire("eJOHy");
function $6de35f980c3d94e0$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $eJOHy.useContext)(context);
    (0, $eJOHy.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("c7s3I", function(module, exports) {

$parcel$export(module.exports, "createComponentServer", () => $8d2be766ecc6ab62$export$eb2e4b04351cdd9e);

var $j5vcn = parcelRequire("j5vcn");

var $eJOHy = parcelRequire("eJOHy");

var $7veda = parcelRequire("7veda");

var $bzDJE = parcelRequire("bzDJE");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");

var $a1Dox = parcelRequire("a1Dox");

var $2f83m = parcelRequire("2f83m");
function $8d2be766ecc6ab62$var$load(moduleId, loader) {
    try {
        return (0, $a1Dox.getExport)(loader());
    } catch (err) {
        throw (0, $2f83m.createLoaderError)(err);
    }
}
function $8d2be766ecc6ab62$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $8d2be766ecc6ab62$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $7veda.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $bzDJE.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("link", {
                key: url,
                rel: defer === (0, $bzDJE.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("iFrYh", function(module, exports) {

$parcel$export(module.exports, "createDeferred", () => $0381d5b0cf615548$export$e673efccd97e4223);
const $0381d5b0cf615548$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{});
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            } // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("dcrQD", function(module, exports) {

$parcel$export(module.exports, "preloadAsset", () => $99c1ff5e48fc9639$export$25bad4aa00c45355);

var $j5vcn = parcelRequire("j5vcn");

var $ddxDA = parcelRequire("ddxDA");

var $7veda = parcelRequire("7veda");

var $a1Dox = parcelRequire("a1Dox");

var $b8XF0 = parcelRequire("b8XF0");

var $dfXT0 = parcelRequire("dfXT0");

var $hrq5I = parcelRequire("hrq5I");
function $99c1ff5e48fc9639$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $7veda.getConfig)();
    const assets = (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $dfXT0.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $99c1ff5e48fc9639$var$fakePromise = {
    then: ()=>$99c1ff5e48fc9639$var$fakePromise,
    catch: ()=>$99c1ff5e48fc9639$var$fakePromise,
    finally: ()=>$99c1ff5e48fc9639$var$fakePromise
};
function $99c1ff5e48fc9639$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy'); // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $dfXT0.insertLinkTag)(href, rel));
        return $99c1ff5e48fc9639$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {} // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $99c1ff5e48fc9639$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $ddxDA.noopCleanup;
}
function $99c1ff5e48fc9639$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $a1Dox.isNodeEnvironment)()) return 0, $ddxDA.noopCleanup;
    (_GlobalReactLooselyLa = (0, $hrq5I.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $b8XF0.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $99c1ff5e48fc9639$export$3af04dbcb01bad4d,
        $99c1ff5e48fc9639$export$1046fd6a49d5e7a,
        $99c1ff5e48fc9639$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {}
    return 0, $ddxDA.noopCleanup;
}

});
parcelRegister("dfXT0", function(module, exports) {

$parcel$export(module.exports, "insertLinkTag", () => $9a6b213a2be2821b$export$6610512821c8a4ce);

var $hrq5I = parcelRequire("hrq5I");

var $ddxDA = parcelRequire("ddxDA");

var $7veda = parcelRequire("7veda");
function $9a6b213a2be2821b$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $ddxDA.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $7veda.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $hrq5I.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});


parcelRegister("dcUz2", function(module, exports) {

$parcel$export(module.exports, "retry", () => $99d845ced60c5b28$export$9369b12211e1fce4);
const $99d845ced60c5b28$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1; // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
     // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $99d845ced60c5b28$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $99d845ced60c5b28$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $99d845ced60c5b28$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $99d845ced60c5b28$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $99d845ced60c5b28$var$calculateDelay(context, policy);
        if (delay) await $99d845ced60c5b28$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});



parcelRegister("jZXbl", function(module, exports) {

let $e8f19f200b008fe0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e8f19f200b008fe0$var$load("kPASh").then(()=>parcelRequire('e9FZe'));

});


parcelRegister("3Koe6", function(module, exports) {

$parcel$export(module.exports, "NoProductAccessState", () => $bf98518c03fbefd8$export$ecd1a08b364becd6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");
var $kDaaB = parcelRequire("kDaaB");

var $806LH = parcelRequire("806LH");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $aLDyW = parcelRequire("aLDyW");
const $bf98518c03fbefd8$var$styles = {
    emptyStateContainer: "_2rkoiti9 _189ee4h9 _1h6dmuej _18zrxy5q _12y3e4h9 _12jimuej _1qu2nqa1",
    emptyStateContainerNext: "_2rkoiti9 _189ee4h9 _1h6dmuej _18zrpxbi _1rjcpxbi _12y3e4h9 _12jimuej _1qu2nqa1",
    contentWrapper: "_bozgxy5q"
};
const $bf98518c03fbefd8$export$ecd1a08b364becd6 = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $78OnL.default), {
        space: "space.100",
        xcss: (0, $eGOwo.fg)('enable-team-profile-refactor') ? $bf98518c03fbefd8$var$styles.emptyStateContainerNext : $bf98518c03fbefd8$var$styles.emptyStateContainer,
        testId: "team-containers-no-product-access-state",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            alignBlock: "center",
            space: (0, $eGOwo.fg)('enable-team-profile-refactor') ? 'space.200' : undefined,
            children: [
                (0, $eGOwo.fg)('enable-team-profile-refactor') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLDyW.NoProductAccessIconNext), {}) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLDyW.NoProductAccessIcon), {}),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: (0, $eGOwo.fg)('enable-team-profile-refactor') ? undefined : $bf98518c03fbefd8$var$styles.contentWrapper,
                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                        space: (0, $eGOwo.fg)('enable-team-profile-refactor') ? 'space.200' : 'space.100',
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                                size: "small",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                    ...$bf98518c03fbefd8$var$messages.teamContainerEmptyStateTitle
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...$bf98518c03fbefd8$var$messages.teamContainerEmptyStateDescription
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $bf98518c03fbefd8$var$messages = (0, $7qGN1.defineMessages)({
    teamContainerEmptyStateTitle: {
        id: 'ptc.team-profile-page.team-containers.empty-state.title',
        defaultMessage: 'Add the places your team works',
        description: 'Empty state title when user has no product access'
    },
    teamContainerEmptyStateDescription: {
        id: 'ptc.team-profile-page.team-containers.empty-state.description',
        defaultMessage: 'Your team can link their Jira projects, Confluence spaces here to show where they work',
        description: 'Empty state description when user has no product access'
    }
});

});
parcelRegister("aLDyW", function(module, exports) {

$parcel$export(module.exports, "NoProductAccessIcon", () => $e9c61e60f79aa9ec$export$bf513868cd2f920f);
$parcel$export(module.exports, "NoProductAccessIconNext", () => $e9c61e60f79aa9ec$export$77007a5b054e46f7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8wyVH = parcelRequire("8wyVH");

var $8IeH1 = parcelRequire("8IeH1");

var $4J5kk = parcelRequire("4J5kk");
function $e9c61e60f79aa9ec$var$TeamContainersNoProductAccess() {
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "180",
        height: "170",
        viewBox: "0 0 180 170",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M65.004 40.9222L33.3022 45.8529L38.2329 77.5546L118.928 65.004L115.791 44.8301L78.3249 50.6572L65.004 40.9222Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M120.273 73.6499L39.5776 86.2006L45.8529 126.548L126.548 113.998L120.273 73.6499Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#clip0_5508_39188)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M129.406 142.298C120.375 151.329 105.733 151.329 96.7018 142.298C87.671 133.267 87.671 118.626 96.7018 109.595L104.878 101.419L111.419 107.959L103.243 116.135C97.8241 121.554 97.8241 130.339 103.243 135.757C108.661 141.176 117.446 141.176 122.865 135.757L131.041 127.582L137.581 134.122L129.406 142.298Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M152.298 119.406C161.329 110.375 161.329 95.7328 152.298 86.7019C143.267 77.6711 128.625 77.6711 119.594 86.7019L111.418 94.8779L117.959 101.419L126.135 93.2427C131.553 87.8242 140.339 87.8242 145.757 93.2427C151.176 98.6612 151.176 107.446 145.757 112.865L137.581 121.041L144.122 127.582L152.298 119.406Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M139.449 106.092L116.324 129.217L109.783 122.676L132.908 99.5512L139.449 106.092Z",
                        fill: "#FCA700"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M101.784 117.729L90.8252 119.434C91.8704 115.787 93.8291 112.347 96.7015 109.475L104.877 101.299L111.418 107.84L103.242 116.016C102.702 116.556 102.216 117.129 101.784 117.729ZM125.459 106.88L126.548 113.878L116.972 115.367L125.459 106.88ZM121.979 84.5L123.699 95.5589L117.959 101.299L111.418 94.7581L119.594 86.5822C120.352 85.8246 121.149 85.1305 121.979 84.5Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M147.591 62.1215C147.471 62.5353 147.38 62.9491 147.239 63.3629C146.689 65.0183 145.949 66.7017 144.779 68.2518C143.63 69.8019 141.847 71.1485 139.838 71.6886C137.837 72.2498 135.835 72.1025 134.073 71.6886C130.528 70.8329 127.687 69.1005 125.178 67.375H125.249V67.3329C125.798 67.5293 127.25 68.2798 128.639 68.855C130.013 69.4582 131.324 69.872 131.324 69.872C129.675 68.5323 127.871 67.5363 125.968 66.4982C124.079 65.4672 122.133 64.401 120.512 63.0613L120.329 63.3419C121.753 64.4922 122.986 65.5654 123.444 66.0704C120.59 64.3449 116.678 61.2517 113.154 57.871C112.266 57.0293 111.406 56.1735 110.575 55.3248C110.391 55.1355 110.081 54.8198 110.138 54.8759C110.138 54.8759 110.123 54.8619 110.088 54.8479L109.961 54.7707L109.616 54.5673C109.158 54.2938 108.707 54.0202 108.27 53.7607C107.819 53.5362 107.382 53.3188 106.952 53.1084C106.74 53.0032 106.529 52.8839 106.325 52.7997C106.113 52.7156 105.909 52.6385 105.704 52.5613C105.303 52.414 104.915 52.2246 104.541 52.1054C104.168 51.9931 103.815 51.8949 103.484 51.7967C103.576 51.6845 104.02 51.8599 104.513 51.9581C104.999 52.0703 105.535 52.2246 105.888 51.895L104.837 51.5162C104.478 51.425 104.125 51.3409 103.773 51.2497L103.244 51.1164C103.068 51.0743 102.892 51.0743 102.716 51.0533C102.363 51.0252 102.018 50.9901 101.673 50.9621C101.673 51.5022 102.434 51.3759 102.582 51.4811C102.434 51.5092 102.117 51.5232 101.659 51.5162C101.433 51.5372 101.179 51.5863 100.89 51.6214C100.601 51.6635 100.277 51.6705 99.953 51.7897C98.6068 52.0843 96.9787 52.926 95.703 54.5743C94.4555 56.2437 93.645 58.6986 93.6309 61.3289C93.6309 62.6335 93.7507 63.9872 94.1172 65.2708L94.237 65.7548L94.4062 66.2247C94.5189 66.5333 94.6176 66.856 94.7445 67.1646C95.0334 67.7538 95.2731 68.378 95.6325 68.9111C96.2598 70.0474 97.1056 71.0013 97.9725 71.843C98.4518 72.2147 98.8535 72.6566 99.361 72.9442C99.6006 73.1055 99.8402 73.2668 100.073 73.4211C100.305 73.5824 100.573 73.6806 100.813 73.8139C101.06 73.9402 101.299 74.0664 101.532 74.1856C101.778 74.2908 102.032 74.368 102.272 74.4662C102.751 74.6486 103.216 74.845 103.681 74.9361C104.147 75.0484 104.577 75.1887 104.992 75.2728C105.415 75.343 105.817 75.4061 106.177 75.4622C106.902 75.6235 107.53 75.6165 107.988 75.7077C108.453 75.7779 108.756 75.862 108.883 75.9602C109.123 76.1566 108.629 76.4021 107.072 76.7177L107.389 76.9913C104.147 77.0684 101.412 76.6476 98.1346 75.2167C97.7329 74.9081 97.6554 74.9221 97.8175 74.6977C97.7329 74.5925 97.599 74.4101 97.7117 74.347C98.1417 73.835 97.1902 73.3931 96.8448 73.0845C96.725 73.3159 96.4994 73.4071 96.2105 73.337C95.9285 73.2598 95.5762 73.0353 95.1744 72.7057C94.7515 72.3971 94.3991 71.878 93.9833 71.3449C93.7648 71.0784 93.6097 70.7628 93.4335 70.4472C93.2644 70.1245 93.0741 69.8089 92.9261 69.4582C92.6582 68.7568 92.3552 68.0554 92.2142 67.3329C92.1296 66.9752 92.0309 66.6315 91.9746 66.2948C91.9252 65.9511 91.8829 65.6215 91.8406 65.3129C91.7067 64.0644 91.7067 63.0894 91.6856 62.7247C91.1922 62.6195 91.0795 61.8619 91.2134 61.0483C91.2768 60.2277 91.5658 59.3719 91.4178 58.888C91.3755 58.9441 91.0865 59.3159 91.0512 59.365C90.9878 59.2527 90.9808 58.9371 91.0442 58.4882C91.1429 58.0463 91.2698 57.4641 91.5023 56.8188C91.9605 55.5353 92.8485 54.0483 93.8987 52.919C94.1736 52.6525 94.4414 52.386 94.6952 52.1334C94.9841 51.916 95.2519 51.7126 95.5057 51.5232C95.6325 51.425 95.7524 51.3409 95.8651 51.2497C95.992 51.1795 96.1118 51.1094 96.2246 51.0462C96.4501 50.92 96.6475 50.8007 96.8025 50.7026C97.1127 50.4851 97.31 50.3939 97.2818 50.3238C97.2536 50.2607 96.9999 50.2256 96.4924 50.3659C98.2051 49.0613 100.714 48.3809 103.244 48.5843C105.789 48.7596 108.312 49.6645 110.687 50.899C110.983 51.0603 111.272 51.2216 111.575 51.3829L112.019 51.6284C112.217 51.7406 112.485 51.8599 112.675 52.0913C113.154 52.5613 113.633 53.0382 114.12 53.5152C115.05 54.42 115.987 55.3318 116.953 56.2367C118.877 58.0533 120.886 59.8489 122.972 61.5463C125.065 63.2297 127.243 64.8149 129.506 66.0984C130.64 66.7297 131.796 67.2838 132.952 67.7257C134.115 68.1395 135.278 68.4271 136.392 68.5253C138.626 68.6586 140.508 67.873 141.629 66.2597C142.235 65.5163 142.636 64.5694 142.975 63.6576C143.144 63.1946 143.243 62.6966 143.369 62.2337C143.44 62.0092 143.475 61.7567 143.51 61.5182L143.567 61.1605L143.595 60.9852L143.609 60.894C143.609 60.894 143.609 60.894 143.602 60.887C143.637 60.908 143.687 60.887 143.708 60.9501C143.687 60.887 143.75 60.887 143.602 60.88C143.658 60.88 143.708 60.8659 143.743 60.8379C143.743 60.8239 143.771 60.8379 143.764 60.7958C143.75 60.7327 143.736 60.6625 143.722 60.5994C143.687 60.4661 143.658 60.3259 143.616 60.1856C143.433 59.6315 143.243 59.0142 142.989 58.4671C142.524 57.3589 141.995 56.4751 141.995 56.4751C141.311 55.1845 140.501 53.922 139.641 52.6735C139.641 52.6735 139.303 52.3158 138.76 51.7406C138.217 51.1585 137.47 50.3659 136.681 49.419C135.898 48.4791 135.074 47.3919 134.489 46.2206C133.904 45.0632 133.594 43.8147 133.699 42.9099C133.516 41.8157 133.615 40.6795 133.925 39.6274C134.101 39.1153 134.277 38.5893 134.538 38.1193C134.757 37.6213 135.053 37.1865 135.335 36.7376C136.497 34.97 137.949 33.4901 139.444 32.0943C139.444 32.0943 139.493 32.0592 139.556 32.0031C139.859 32.0031 140.177 32.0311 140.395 32.1153C140.36 31.975 140.48 31.989 140.494 31.9399L140.508 32.0592C140.874 31.6804 141.304 31.3437 141.769 31.0491C141.72 30.9159 141.699 30.8317 141.713 30.8247C140.007 30.3688 135.37 31.8347 134.066 30.7335L131.606 31.3157C130.612 30.8738 129.4 30.7125 129.802 30.1022C130.204 29.492 141.565 27.2265 144.709 28.2716L144.673 28.2926C144.673 28.2926 145.667 28.5171 145.639 28.3908C146.118 30.5582 146.915 33.5882 145.801 35.6363C146.069 36.3728 144.342 46.6695 142.51 43.934C142.721 42.2647 142.601 40.1815 142.721 38.5261C142.763 36.8498 142.721 34.7806 142.672 33.2305C142.672 33.2305 142.665 33.2095 142.651 33.1814C142.629 33.2235 142.615 33.2586 142.622 33.2796C140.578 34.6333 138.823 36.3728 137.675 38.2456C137.09 39.1784 136.73 40.1394 136.596 40.9951C136.469 41.8578 136.568 42.6153 136.871 43.5131C136.66 43.5412 136.554 43.7166 136.709 43.7937L136.927 43.6604C137.209 44.9721 138.076 46.0101 138.908 46.9781C139.754 47.9601 140.628 48.9561 141.333 50.4641C141.333 50.4571 141.347 49.9731 141.347 49.9591C143.109 52.0493 145.089 54.5042 146.626 57.4641C146.809 57.8359 146.992 58.2146 147.182 58.5934C147.394 59.0984 147.605 59.6104 147.817 60.1224C147.873 60.2908 147.979 60.4591 148 60.6345L147.859 61.1675L147.605 62.1074L147.591 62.1215Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("defs", {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                    id: "clip0_5508_39188",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        width: "111",
                        height: "111",
                        fill: "white",
                        transform: "translate(69 59)"
                    })
                })
            })
        ]
    });
}
const $e9c61e60f79aa9ec$var$styles = {
    icon: "_1ul9ys9h _p12fys9h"
};
function $e9c61e60f79aa9ec$export$bf513868cd2f920f() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($e9c61e60f79aa9ec$var$TeamContainersNoProductAccess, {})
    });
}
function $e9c61e60f79aa9ec$export$77007a5b054e46f7() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $e9c61e60f79aa9ec$var$styles.icon,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wyVH.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($4J5kk))),
            alt: ""
        })
    });
}

});
parcelRegister("4J5kk", function(module, exports) {
module.exports = new URL("NoProductAccess.a1396ea1.svg", import.meta.url).toString();

});



parcelRegister("cW3YY", function(module, exports) {

$parcel$export(module.exports, "TeamLinkCard", () => $0d8c6d3660820d3c$export$281f9ee6597a4098);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $6zhpo = parcelRequire("6zhpo");

var $NByNW = parcelRequire("NByNW");

var $eJ9f5 = parcelRequire("eJ9f5");

var $eGOwo = parcelRequire("eGOwo");

var $lc0OY = parcelRequire("lc0OY");
var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $k71qx = parcelRequire("k71qx");

var $2Mwhw = parcelRequire("2Mwhw");

var $cu2KJ = parcelRequire("cu2KJ");

var $1jIHx = parcelRequire("1jIHx");

var $c776o = parcelRequire("c776o");

var $4uA8Z = parcelRequire("4uA8Z");
const $0d8c6d3660820d3c$var$styles = {
    container: "_2rkoop52 _1h6dz9xs _12y3e4h9 _12jimuej _1qu2nqa1 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _syaz1fxt",
    card: "_4cvr1h6o _1bsb1osq",
    anchor: "_4bfu18uv _1hmsglyw _ajmmnqa1 _2rkoop52 _1bsb1osq _syaz1fxt _10531fxt _1hvw1bk5 _nt751p6i _49pcnqa1 _1bg4v77o _30l31fxt",
    iconWrapper: "_1bsbzwfg _4t3izwfg _1ul9zwfg _1tkezwfg",
    crossIconWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _18u01wug",
    showMoreIconWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _18u01wug",
    linkableContent: "_16jlkb7n _1o9zkb7n _i0dlf1ug"
};
const $0d8c6d3660820d3c$export$281f9ee6597a4098 = ({ containerType: containerType, title: title, containerIcon: containerIcon, link: link, containerId: containerId, containerTypeProperties: containerTypeProperties, onDisconnectButtonClick: onDisconnectButtonClick, onEditLinkClick: onEditLinkClick, iconsLoading: iconsLoading, iconHasLoaded: iconHasLoaded, openInNewTab: openInNewTab })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { description: description, icon: icon, containerTypeText: containerTypeText } = (0, $c776o.getContainerProperties)({
        containerType: containerType,
        iconSize: 'medium',
        containerTypeProperties: containerTypeProperties
    });
    const [hovered, setHovered] = (0, $eJOHy.useState)(false);
    const [focused, setFocused] = (0, $eJOHy.useState)(false);
    const [showCloseIcon, setShowCloseIcon] = (0, $eJOHy.useState)(false);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(false);
    const [showKeyboardFocus, setShowKeyboardFocus] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fireUIEvent: fireUIEvent } = (0, $1jIHx.usePeopleAndTeamAnalytics)();
    const handleMouseEnter = ()=>{
        setHovered(true);
        if (containerType !== 'WebLink') setShowCloseIcon(true);
    };
    const handleFocus = ()=>{
        setFocused(true);
        if (containerType !== 'WebLink') setShowCloseIcon(true);
    };
    const handleBlur = ()=>{
        setFocused(false);
        if (containerType !== 'WebLink' && !hovered) setShowCloseIcon(false);
    };
    const handleMouseLeave = ()=>{
        setHovered(false);
        if (containerType !== 'WebLink' && !focused) setShowCloseIcon(false);
    };
    const handleIconClick = ()=>{
        if ((0, $eGOwo.fg)('fix_team_link_card_a11y')) setShowKeyboardFocus(false);
    };
    const handleKeyDown = (e)=>{
        if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Tab' || e.key === 'Escape') && (0, $eGOwo.fg)('fix_team_link_card_a11y')) setShowKeyboardFocus(true);
    };
    const handleLinkClick = (e)=>{
        const baseAttributes = {
            container: containerType,
            containerId: containerId
        };
        const attributes = containerType === 'WebLink' && link ? {
            containerSelected: {
                ...baseAttributes,
                linkDomain: (0, $4uA8Z.getDomainFromLinkUri)(link)
            }
        } : {
            containerSelected: baseAttributes
        };
        fireUIEvent(createAnalyticsEvent, {
            action: (0, $1jIHx.AnalyticsAction).CLICKED,
            actionSubject: 'container',
            actionSubjectId: 'teamContainer',
            attributes: attributes
        });
        if (openInNewTab) {
            e.preventDefault();
            window.open(link || '#', '_blank', 'noopener, noreferrer');
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        backgroundColor: hovered ? 'color.background.input.hovered' : 'color.background.input',
        xcss: $0d8c6d3660820d3c$var$styles.container,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onKeyDown: handleKeyDown,
        testId: "team-link-card-inner",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.100",
            xcss: $0d8c6d3660820d3c$var$styles.card,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Mwhw.ContainerIcon), {
                    containerType: containerType,
                    title: title,
                    containerIcon: containerIcon,
                    size: "medium",
                    iconsLoading: iconsLoading,
                    iconHasLoaded: iconHasLoaded
                }),
                (0, $eGOwo.fg)('fix_team_link_card_a11y') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
                            xcss: $0d8c6d3660820d3c$var$styles.anchor,
                            href: link || '#',
                            onClick: handleLinkClick,
                            testId: "team-link-card-linkable-content",
                            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                                space: "space.025",
                                children: [
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                        maxLines: 1,
                                        weight: "medium",
                                        color: "color.text",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
                                        gap: "space.050",
                                        alignItems: "center",
                                        children: [
                                            icon,
                                            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                                                space: "space.050",
                                                children: [
                                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                                        size: "small",
                                                        color: "color.text.subtle",
                                                        children: description
                                                    }),
                                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                                        size: "small",
                                                        color: "color.text.subtle",
                                                        children: containerTypeText
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cu2KJ.TeamLinkCardActions), {
                            containerType: containerType,
                            title: title,
                            containerId: containerId,
                            hovered: hovered,
                            focused: focused,
                            isDropdownOpen: isDropdownOpen,
                            showKeyboardFocus: showKeyboardFocus,
                            onDisconnectButtonClick: ()=>{
                                handleIconClick();
                                onDisconnectButtonClick();
                            },
                            onEditLinkClick: ()=>{
                                handleIconClick();
                                onEditLinkClick?.();
                            },
                            onDropdownOpenChange: setIsDropdownOpen
                        })
                    ]
                }) : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: $0d8c6d3660820d3c$var$styles.linkableContent,
                            testId: "team-link-card-linkable-content",
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                                href: link || '#',
                                appearance: "subtle",
                                onClick: handleLinkClick,
                                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                                    space: "space.025",
                                    children: [
                                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                            maxLines: 1,
                                            weight: "medium",
                                            color: "color.text",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
                                            gap: "space.050",
                                            alignItems: "center",
                                            children: [
                                                icon,
                                                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                                                    space: "space.050",
                                                    children: [
                                                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                                            size: "small",
                                                            color: "color.text.subtle",
                                                            children: description
                                                        }),
                                                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                                            size: "small",
                                                            color: "color.text.subtle",
                                                            children: containerTypeText
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        showCloseIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: $0d8c6d3660820d3c$var$styles.crossIconWrapper,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                                content: formatMessage($0d8c6d3660820d3c$var$messages.disconnectTooltip),
                                position: "top",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                                    label: `disconnect the container ${title}`,
                                    appearance: "subtle",
                                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
                                            ...iconProps,
                                            size: "small"
                                        }),
                                    spacing: "compact",
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        e.stopPropagation();
                                        onDisconnectButtonClick();
                                        fireUIEvent(createAnalyticsEvent, {
                                            action: (0, $1jIHx.AnalyticsAction).CLICKED,
                                            actionSubject: 'button',
                                            actionSubjectId: 'containerUnlinkButton',
                                            attributes: {
                                                containerSelected: {
                                                    container: containerType,
                                                    containerId: containerId
                                                }
                                            }
                                        });
                                    }
                                })
                            })
                        }),
                        containerType === 'WebLink' && (hovered || isDropdownOpen) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: $0d8c6d3660820d3c$var$styles.showMoreIconWrapper,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
                                trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                                        ref: triggerRef,
                                        ...triggerProps,
                                        label: `more options for ${title}`,
                                        appearance: "subtle",
                                        icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                                                ...iconProps,
                                                size: "small"
                                            }),
                                        spacing: "compact"
                                    }),
                                placement: "bottom-end",
                                shouldRenderToParent: true,
                                onOpenChange: (attrs)=>{
                                    setIsDropdownOpen(attrs.isOpen);
                                },
                                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $aLJ1L.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                e.stopPropagation();
                                                onEditLinkClick?.();
                                                fireUIEvent(createAnalyticsEvent, {
                                                    action: (0, $1jIHx.AnalyticsAction).CLICKED,
                                                    actionSubject: 'button',
                                                    actionSubjectId: 'containerEditLinkButton',
                                                    attributes: {
                                                        containerSelected: {
                                                            container: containerType,
                                                            containerId: containerId
                                                        }
                                                    }
                                                });
                                            },
                                            children: formatMessage($0d8c6d3660820d3c$var$messages.editLink)
                                        }),
                                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                e.stopPropagation();
                                                onDisconnectButtonClick();
                                                fireUIEvent(createAnalyticsEvent, {
                                                    action: (0, $1jIHx.AnalyticsAction).CLICKED,
                                                    actionSubject: 'button',
                                                    actionSubjectId: 'containerUnlinkButton',
                                                    attributes: {
                                                        containerSelected: {
                                                            container: containerType,
                                                            containerId: containerId
                                                        }
                                                    }
                                                });
                                            },
                                            children: formatMessage($0d8c6d3660820d3c$var$messages.removeLink)
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $0d8c6d3660820d3c$var$messages = (0, $7qGN1.defineMessages)({
    disconnectTooltip: {
        id: 'ptc-directory.team-containers.disconnect-button.tooltip',
        defaultMessage: 'Disconnect',
        description: 'Tooltip for the disconnect button'
    },
    editLink: {
        id: 'ptc-directory.team-containers.edit-link',
        defaultMessage: 'Edit link',
        description: 'Edit link option in dropdown'
    },
    removeLink: {
        id: 'ptc-directory.team-containers.remove-link',
        defaultMessage: 'Remove',
        description: 'Remove link option in dropdown'
    }
});

});
parcelRegister("2Mwhw", function(module, exports) {

$parcel$export(module.exports, "ContainerIcon", () => $c1d5e95343988623$export$6d6da6edaddd5876);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");

var $cV8sz = parcelRequire("cV8sz");

var $8IeH1 = parcelRequire("8IeH1");

var $gjh28 = parcelRequire("gjh28");
const $c1d5e95343988623$var$styles = {
    linkIconWrapperMedium: "_2rkopd34 _1bsb1u1b _4t3i1u1b _1e0c1txw _4cvr1h6o _1bah1h6o _12jimuej _1qu2nqa1 _bfhkqbzx",
    linkIconWrapperSmall: "_2rkogqwt _1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _12jimuej _1qu2nqa1 _bfhkqbzx",
    skeletonMedium: "_2rkopd34 _bfhkn82g _1bsb1u1b _4t3i1u1b",
    skeletonSmall: "_2rkogqwt _bfhkn82g _1bsb1tcg _4t3i1tcg"
};
const $c1d5e95343988623$var$IconSkeleton = ({ size: size, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: size === 'medium' ? $c1d5e95343988623$var$styles.skeletonMedium : $c1d5e95343988623$var$styles.skeletonSmall,
        testId: "container-icon-skeleton"
    });
};
const $c1d5e95343988623$export$6d6da6edaddd5876 = ({ containerType: containerType, title: title, containerIcon: containerIcon, size: size = 'medium', iconsLoading: iconsLoading = false, iconHasLoaded: iconHasLoaded = true })=>{
    const isMedium = size === 'medium';
    if (containerType === 'LoomSpace') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gjh28.LoomSpaceAvatar), {
        spaceName: title,
        size: isMedium ? 'large' : size
    });
    if (containerType === 'WebLink') {
        if (iconsLoading || !iconHasLoaded) return /*#__PURE__*/ (0, $gt9Am.jsx)($c1d5e95343988623$var$IconSkeleton, {
            size: size
        });
        if (!containerIcon) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: isMedium ? $c1d5e95343988623$var$styles.linkIconWrapperMedium : $c1d5e95343988623$var$styles.linkIconWrapperSmall,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cV8sz))), {
                label: "",
                testId: "linked-container-WebLink-icon"
            })
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
        appearance: "square",
        size: size,
        src: containerIcon,
        testId: `linked-container-${containerType}-icon`
    });
};

});
parcelRegister("cV8sz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $96815ed7645c21ae$var$_react = $96815ed7645c21ae$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $96815ed7645c21ae$var$_baseNew = $96815ed7645c21ae$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $96815ed7645c21ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $96815ed7645c21ae$var$LinkIcon = (props)=>/*#__PURE__*/ $96815ed7645c21ae$var$_react.default.createElement($96815ed7645c21ae$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$96815ed7645c21ae$var$LinkIcon.displayName = 'LinkIcon';
var $96815ed7645c21ae$var$_default = module.exports.default = $96815ed7645c21ae$var$LinkIcon;

});

parcelRegister("gjh28", function(module, exports) {

$parcel$export(module.exports, "LoomSpaceAvatar", () => $30915f17cad8af7e$export$6055fe3c3d07f8d9);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $DmpGx = parcelRequire("DmpGx");
const $30915f17cad8af7e$var$boxStyle = null;
const $30915f17cad8af7e$var$smallBoxStyle = null;
const $30915f17cad8af7e$var$largeBoxStyle = null;
function $30915f17cad8af7e$export$6055fe3c3d07f8d9({ spaceName: spaceName = '', size: size = 'small' }) {
    const avatarText = (0, $DmpGx.getAvatarText)(spaceName);
    const containerColor = (0, $DmpGx.pickContainerColor)(spaceName);
    const textColor = (0, $DmpGx.pickTextColor)(spaceName);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            backgroundColor: containerColor,
            color: textColor
        },
        className: (0, $hcewu.default)([
            "_2rkoiti9 _189ee4h9 _1dqonqa1 _1h6dmuej _1e0c1txw _4cvr1h6o _1bah1h6o",
            size === 'small' ? "_11c8140y _4t3i1tcg _1bsb1tcg" : "_11c8lodh _4t3izwfg _1bsbzwfg"
        ]),
        children: avatarText
    });
}

});
parcelRegister("DmpGx", function(module, exports) {

$parcel$export(module.exports, "getAvatarText", () => $b3654f8d2efbab60$export$a3b2d23d4cacf752);
$parcel$export(module.exports, "pickContainerColor", () => $b3654f8d2efbab60$export$55185ae96e679e0a);
$parcel$export(module.exports, "pickTextColor", () => $b3654f8d2efbab60$export$7063fff24f5d2ae7);

var $a1YST = parcelRequire("a1YST");
var $b3654f8d2efbab60$var$SpaceColors = /*#__PURE__*/ function(SpaceColors) {
    SpaceColors["ORANGE_LIGHT"] = "#FFD5D2";
    SpaceColors["BLUE_LIGHT"] = "#CFE1FD";
    SpaceColors["YELLOW_LIGHT"] = "#FCE4A6";
    SpaceColors["TEAL"] = "#BAF3DB";
    return SpaceColors;
}($b3654f8d2efbab60$var$SpaceColors || {});
var $b3654f8d2efbab60$var$AvatarTextColors = /*#__PURE__*/ function(AvatarTextColors) {
    AvatarTextColors["ORANGE_DARK"] = "#AE2E24";
    AvatarTextColors["BLUE_DARK"] = "#123263";
    AvatarTextColors["YELLOW_DARK"] = "#9E4C00";
    AvatarTextColors["TEAL_DARK"] = "#164B35";
    return AvatarTextColors;
}($b3654f8d2efbab60$var$AvatarTextColors || {});
const $b3654f8d2efbab60$var$AVATAR_CONTAINER_COLORS = [
    "#FFD5D2",
    "#CFE1FD",
    "#FCE4A6",
    "#BAF3DB"
];
const $b3654f8d2efbab60$var$AVATAR_TEXT_COLORS = [
    "#AE2E24",
    "#123263",
    "#9E4C00",
    "#164B35"
];
const $b3654f8d2efbab60$var$hash = (str)=>{
    let hash = $a1YST(str);
    hash = ~hash;
    return Math.abs(Number(hash));
};
const $b3654f8d2efbab60$export$a3b2d23d4cacf752 = (spaceName)=>{
    return spaceName?.trim().length ? spaceName.trim()[0].toUpperCase() : '';
};
const $b3654f8d2efbab60$export$55185ae96e679e0a = (spaceName)=>{
    const avatarHash = $b3654f8d2efbab60$var$hash(spaceName);
    return $b3654f8d2efbab60$var$AVATAR_CONTAINER_COLORS[avatarHash % $b3654f8d2efbab60$var$AVATAR_CONTAINER_COLORS.length];
};
const $b3654f8d2efbab60$export$7063fff24f5d2ae7 = (spaceName)=>{
    const avatarHash = $b3654f8d2efbab60$var$hash(spaceName);
    return $b3654f8d2efbab60$var$AVATAR_TEXT_COLORS[avatarHash % $b3654f8d2efbab60$var$AVATAR_TEXT_COLORS.length];
};

});
parcelRegister("a1YST", function(module, exports) {
"use strict";
function $74d939bae6db6f1a$var$hash(str) {
    var hash = 5381, i = str.length;
    while(i)hash = hash * 33 ^ str.charCodeAt(--i);
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return hash >>> 0;
}
module.exports = $74d939bae6db6f1a$var$hash;

});




parcelRegister("cu2KJ", function(module, exports) {

$parcel$export(module.exports, "TeamLinkCardActions", () => $a8dd00f7986546ec$export$7f8ec3a4a0c86d35);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $Ay1uj = parcelRequire("Ay1uj");

var $6qaBj = parcelRequire("6qaBj");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $6zhpo = parcelRequire("6zhpo");

var $NByNW = parcelRequire("NByNW");

var $8IeH1 = parcelRequire("8IeH1");

var $k71qx = parcelRequire("k71qx");

var $1jIHx = parcelRequire("1jIHx");
const $a8dd00f7986546ec$var$styles = {
    crossIconWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _18u01wug",
    showMoreIconWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _18u01wug",
    iconHidden: "_tzy4idpf",
    iconVisible: "_tzy4kb7n"
};
const $a8dd00f7986546ec$var$messages = (0, $7qGN1.defineMessages)({
    disconnectTooltip: {
        id: 'ptc-directory.team-containers.disconnect-button.tooltip',
        defaultMessage: 'Disconnect',
        description: 'Tooltip for the disconnect button'
    },
    editLink: {
        id: 'ptc-directory.team-containers.edit-link',
        defaultMessage: 'Edit link',
        description: 'Edit link option in dropdown'
    },
    removeLink: {
        id: 'ptc-directory.team-containers.remove-link',
        defaultMessage: 'Remove',
        description: 'Remove link option in dropdown'
    }
});
const $a8dd00f7986546ec$export$7f8ec3a4a0c86d35 = ({ containerType: containerType, title: title, containerId: containerId, hovered: hovered, focused: focused, isDropdownOpen: isDropdownOpen, showKeyboardFocus: showKeyboardFocus, onDisconnectButtonClick: onDisconnectButtonClick, onEditLinkClick: onEditLinkClick, onDropdownOpenChange: onDropdownOpenChange })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fireUIEvent: fireUIEvent } = (0, $1jIHx.usePeopleAndTeamAnalytics)();
    // Show icons when:
    // 1. Hovering over the card
    // 2. Dropdown is open
    // 3. Focused via keyboard navigation (when showKeyboardFocus is true)
    const shouldShowIcon = hovered || isDropdownOpen || focused && showKeyboardFocus;
    const handleDisconnectClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        onDisconnectButtonClick();
        fireUIEvent(createAnalyticsEvent, {
            action: (0, $1jIHx.AnalyticsAction).CLICKED,
            actionSubject: 'button',
            actionSubjectId: 'containerUnlinkButton',
            attributes: {
                containerSelected: {
                    container: containerType,
                    containerId: containerId
                }
            }
        });
    };
    const handleEditLinkClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        onEditLinkClick?.();
        fireUIEvent(createAnalyticsEvent, {
            action: (0, $1jIHx.AnalyticsAction).CLICKED,
            actionSubject: 'button',
            actionSubjectId: 'containerEditLinkButton',
            attributes: {
                containerSelected: {
                    container: containerType,
                    containerId: containerId
                }
            }
        });
    };
    if (containerType === 'WebLink') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a8dd00f7986546ec$var$styles.showMoreIconWrapper, shouldShowIcon ? $a8dd00f7986546ec$var$styles.iconVisible : $a8dd00f7986546ec$var$styles.iconHidden),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    ref: triggerRef,
                    ...triggerProps,
                    label: `more options for ${title}`,
                    appearance: "subtle",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                            ...iconProps,
                            size: "small"
                        }),
                    spacing: "compact"
                }),
            placement: "bottom-end",
            shouldRenderToParent: true,
            onOpenChange: (attrs)=>{
                onDropdownOpenChange(attrs.isOpen);
            },
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $aLJ1L.default), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                        onClick: handleEditLinkClick,
                        children: formatMessage($a8dd00f7986546ec$var$messages.editLink)
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                        onClick: handleDisconnectClick,
                        children: formatMessage($a8dd00f7986546ec$var$messages.removeLink)
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a8dd00f7986546ec$var$styles.crossIconWrapper, shouldShowIcon ? $a8dd00f7986546ec$var$styles.iconVisible : $a8dd00f7986546ec$var$styles.iconHidden),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: formatMessage($a8dd00f7986546ec$var$messages.disconnectTooltip),
            position: "top",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                label: `disconnect the container ${title}`,
                appearance: "subtle",
                icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
                        ...iconProps,
                        size: "small"
                    }),
                spacing: "compact",
                onClick: handleDisconnectClick
            })
        })
    });
};

});

parcelRegister("4uA8Z", function(module, exports) {

$parcel$export(module.exports, "getDomainFromLinkUri", () => $a3bc224bdf9daccc$export$cda14c9dfe45538);
/**
 * Extract the domain from the URL. Strips "www" subdomains
 * e.g. http://dogs.animals.com/yellow/golden-retriever becomes "dogs.animals.com"
 * e.g. http://www.blake.com/memes becomes "blake.com"
 *
 * Return an empty string if a totally invalid url is somehow passed in.
 * @param url
 */ const $a3bc224bdf9daccc$export$cda14c9dfe45538 = (url)=>{
    let hostname;
    try {
        try {
            hostname = $a3bc224bdf9daccc$export$eb5a321f13bbb969(url);
        } catch (noProtocolError) {
            /**
			 * Backend (Legion) validates whether the string is URI compliant. But URL expects
			 * the string to have a protocol. This is not validated by URI compliancy. So
			 * following is just a quick fix just for display purposes.
			 */ hostname = $a3bc224bdf9daccc$export$eb5a321f13bbb969('http://' + url);
        }
    } catch (error) {
        return '';
    }
    return hostname.replace(/^www\./, '');
};
const $a3bc224bdf9daccc$export$eb5a321f13bbb969 = (url)=>{
    const urlObj = new URL(url);
    return urlObj.hostname;
};

});


parcelRegister("89pUB", function(module, exports) {

$parcel$export(module.exports, "getCreateContainerContactSupportFlag", () => $a376446b4dad6207$export$75f1977f5167ef50);
$parcel$export(module.exports, "getCreateContainerTryAgainFlag", () => $a376446b4dad6207$export$59d3f9f96568637f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7qGN1 = parcelRequire("7qGN1");
var $kDaaB = parcelRequire("kDaaB");

var $9itkV = parcelRequire("9itkV");

var $2sLVw = parcelRequire("2sLVw");
const $a376446b4dad6207$export$75f1977f5167ef50 = ()=>({
        id: 'teams-public.team-container.create-container.error.contact-support',
        type: 'error',
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...$a376446b4dad6207$var$messages.noConnectionTitle
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...$a376446b4dad6207$var$messages.noConnectionDescription
        }),
        actions: [
            {
                content: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
                    alignItems: "center",
                    columnGap: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...$a376446b4dad6207$var$messages.noConnectionAction
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
                            label: ""
                        })
                    ]
                }),
                href: 'https://support.atlassian.com/contact/#/&support_type=customer'
            }
        ]
    });
const $a376446b4dad6207$export$59d3f9f96568637f = ({ tryAgainAction: tryAgainAction, containerType: containerType })=>({
        id: 'teams-public.team-container.create-container.error.try-again',
        type: 'error',
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...$a376446b4dad6207$var$messages.timeoutTitle,
            values: {
                containerType: containerType
            }
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...$a376446b4dad6207$var$messages.timeoutDescription
        }),
        actions: [
            {
                content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...$a376446b4dad6207$var$messages.timeoutAction
                }),
                onClick: ()=>{
                    tryAgainAction?.();
                }
            }
        ]
    });
const $a376446b4dad6207$var$messages = (0, $7qGN1.defineMessages)({
    timeoutTitle: {
        id: 'teams-public.team-containers.timeout-title',
        defaultMessage: "We\u2019re couldn\u2019t connect your {containerType}",
        description: 'Title for the timeout flag'
    },
    timeoutDescription: {
        id: 'teams-public.team-containers.timeout-description',
        defaultMessage: 'Something went wrong. Verify your connection and retry.',
        description: 'Description for the timeout flag'
    },
    timeoutAction: {
        id: 'teams-public.team-containers.timeout-action',
        defaultMessage: 'Try again',
        description: 'Action text for the timeout flag'
    },
    noConnectionTitle: {
        id: 'teams-public.team-containers.timeout-no-connection-title',
        defaultMessage: 'Connection failed',
        description: 'Title for the no connection flag'
    },
    noConnectionDescription: {
        id: 'teams-public.team-containers.timeout-no-connection-description',
        defaultMessage: 'Try manually creating the space yourself.',
        description: 'Description for the no connection flag'
    },
    noConnectionAction: {
        id: 'teams-public.team-containers.timeout-no-connection-action',
        defaultMessage: 'Contact support',
        description: 'Action text for the no connection flag'
    }
});

});


parcelRegister("kVKdq", function(module, exports) {
module.exports = new URL("TeamAppTile.eb507a2b.svg", import.meta.url).toString();

});

parcelRegister("j1svA", function(module, exports) {

$parcel$export(module.exports, "TeamActions", () => $f353c60eedfc0a58$export$4af45cafad4b35a7);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $7m76n = parcelRequire("7m76n");
var $XUWry = parcelRequire("XUWry");

var $7saMl = parcelRequire("7saMl");

var $7jwft = parcelRequire("7jwft");

var $dlNJO = parcelRequire("dlNJO");

var $fg93x = parcelRequire("fg93x");
const $f353c60eedfc0a58$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
const $f353c60eedfc0a58$export$4af45cafad4b35a7 = ({ isKudosEnabled: isKudosEnabled, otherActions: otherActions, loading: loading, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isKudosOpen, setIsKudosOpen] = (0, $eJOHy.useState)(false);
    const onKudosClick = (0, $eJOHy.useCallback)(()=>{
        setIsKudosOpen(true);
    }, []);
    const actions = [];
    let kudosProps = null;
    if (isKudosEnabled) {
        actions.push({
            id: $f353c60eedfc0a58$var$GIVE_KUDOS_ACTION_ID,
            item: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7saMl.default), {
                onClick: onKudosClick,
                children: formatMessage((0, $dlNJO.messages).giveKudos)
            })
        });
        kudosProps = props;
    }
    if (otherActions) actions.push(...otherActions);
    if (actions.length === 0) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fg93x.MoreActions), {
                actions: actions,
                loading: loading
            }),
            isKudosEnabled && kudosProps && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7m76n.GiveKudosLauncherLazy), {
                    isOpen: isKudosOpen,
                    onClose: ()=>setIsKudosOpen(false),
                    recipient: {
                        type: (0, $XUWry.KudosType).TEAM,
                        recipientId: (0, $7jwft.extractIdFromAri)(kudosProps.teamId)
                    },
                    analyticsSource: kudosProps.analyticsSource,
                    teamCentralBaseUrl: kudosProps.teamCentralBaseUrl,
                    cloudId: kudosProps.cloudId,
                    addFlag: kudosProps.showKudosFlag
                })
            })
        ]
    });
};

});
parcelRegister("7m76n", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $ec00209f14041f24$export$93fe397a02fe8b76);

var $eJOHy = parcelRequire("eJOHy");

const $ec00209f14041f24$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lWqKn")));

});
parcelRegister("lWqKn", function(module, exports) {

let $ff93c327b9f5ea83$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $ff93c327b9f5ea83$var$load("76n7a"),
    $ff93c327b9f5ea83$var$load("l253H"),
    $ff93c327b9f5ea83$var$load("ffQaD"),
    $ff93c327b9f5ea83$var$load("kvRbA"),
    $ff93c327b9f5ea83$var$load("2tv8I")
]).then(()=>parcelRequire('3dj1A'));

});


parcelRegister("XUWry", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $2c3b135763fda18f$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $2c3b135763fda18f$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $2c3b135763fda18f$export$7a1fc1a1b0477464);
var $2c3b135763fda18f$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    KudosType["MIXED"] = "mixed";
    return KudosType;
}({});
var $2c3b135763fda18f$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $2c3b135763fda18f$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($2c3b135763fda18f$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("dlNJO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fa4c18cc28a52248$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $fa4c18cc28a52248$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    giveKudos: {
        id: 'team-profile-card.team-actions.give-kudos',
        defaultMessage: 'Give kudos',
        description: 'Give kudos button text'
    }
});

});

parcelRegister("fg93x", function(module, exports) {

$parcel$export(module.exports, "MoreActions", () => $9ad4be22816b3ba0$export$f2f44eb5b71ba65f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $Ay1uj = parcelRequire("Ay1uj");

var $aMdh8 = parcelRequire("aMdh8");

var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");

var $kJsb4 = parcelRequire("kJsb4");

var $8nu6j = parcelRequire("8nu6j");

var $5FbiI = parcelRequire("5FbiI");
const $9ad4be22816b3ba0$export$f2f44eb5b71ba65f = ({ actions: actions, loading: loading })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setOpen] = (0, $eJOHy.useState)(false);
    const onMoreClick = (0, $eJOHy.useCallback)((shouldBeOpen)=>{
        setOpen(shouldBeOpen);
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
        isOpen: isOpen,
        onClose: ()=>setOpen(false),
        content: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jUgeq.default), {
                spacing: "cozy",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6YEko.default), {
                    children: actions.map((action)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                            children: action.item
                        }, action.id))
                })
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))),
                label: formatMessage((0, $5FbiI.messages).showMoreIconLabel),
                onClick: ()=>onMoreClick(!isOpen),
                isSelected: isOpen,
                isLoading: loading
            }),
        placement: "right-start",
        shouldRenderToParent: false
    });
};

});
parcelRegister("5FbiI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3236bf24e223d273$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3236bf24e223d273$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    showMoreIconLabel: {
        id: 'team-profile-card.team-actions.more-actions.show-more-icon-label',
        defaultMessage: 'Show more',
        description: 'Show more icon label'
    }
});

});



parcelRegister("cn8gg", function(module, exports) {

$parcel$export(module.exports, "TeamConnections", () => $2f2a7af2be9c6b72$export$e9e0251ab710cd0d);
$parcel$export(module.exports, "NewTeamConnections", () => $2f2a7af2be9c6b72$export$2b2d577aaefbdd98);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $5DgXR = parcelRequire("5DgXR");

var $f58rc = parcelRequire("f58rc");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $2Mwhw = parcelRequire("2Mwhw");
var $c776o = parcelRequire("c776o");

var $2EPX4 = parcelRequire("2EPX4");
const $2f2a7af2be9c6b72$var$styles = {
    containerWrapperStyles: "_1e0c1txw _4cvr1h6o",
    containerIconStyles: "_2rkoiti9 _4t3i1tcg _1bsb1tcg",
    containerTypeIconButtonStyles: "_18u01wug _4t3i7vkz _1bsb7vkz"
};
const $2f2a7af2be9c6b72$export$e9e0251ab710cd0d = ({ containerType: containerType, title: title, containerIcon: containerIcon, link: link })=>{
    const isContainerIconEnabled = (0, $eGOwo.fg)('loom_tab_in_container_linker_team_profile_page');
    const { description: description, icon: icon, containerTypeText: containerTypeText } = (0, $c776o.getContainerProperties)({
        containerType: containerType,
        iconSize: 'medium',
        isDisplayedOnProfileCard: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        (0, $2EPX4.fireEvent)(createAnalyticsEvent, {
            action: 'clicked',
            actionSubject: 'teamConnectionItem',
            actionSubjectId: 'teamProfileCard',
            attributes: {
                container: containerType
            }
        });
    }, [
        containerType,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f58rc.default), {
        href: link,
        onClick: onClick,
        ...(0, $eGOwo.fg)('enable_new_tab_for_team_container') ? {
            target: '_blank'
        } : {},
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.100",
            xcss: $2f2a7af2be9c6b72$var$styles.containerWrapperStyles,
            children: [
                isContainerIconEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Mwhw.ContainerIcon), {
                    containerType: containerType,
                    title: title,
                    containerIcon: containerIcon,
                    size: "small"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "img",
                    src: containerIcon,
                    alt: "",
                    testId: "linked-container-icon",
                    xcss: $2f2a7af2be9c6b72$var$styles.containerIconStyles
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                            maxLines: 1,
                            color: "color.text",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                            space: "space.050",
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                    size: "small",
                                    color: "color.text.subtlest",
                                    children: description
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                    size: "small",
                                    color: "color.text.subtlest",
                                    children: containerTypeText
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    backgroundColor: 'color.background.neutral.subtle',
                    xcss: $2f2a7af2be9c6b72$var$styles.containerTypeIconButtonStyles,
                    testId: "container-type-icon",
                    children: icon
                })
            ]
        })
    });
};
const $2f2a7af2be9c6b72$export$2b2d577aaefbdd98 = ({ containerType: containerType, title: title, containerIcon: containerIcon, link: link })=>{
    const isContainerIconEnabled = (0, $eGOwo.fg)('loom_tab_in_container_linker_team_profile_page');
    const { description: description, icon: icon, containerTypeText: containerTypeText } = (0, $c776o.getContainerProperties)({
        containerType: containerType,
        iconSize: 'medium',
        isDisplayedOnProfileCard: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        (0, $2EPX4.fireEvent)(createAnalyticsEvent, {
            action: 'clicked',
            actionSubject: 'teamConnectionItem',
            actionSubjectId: 'teamProfileCard',
            attributes: {
                container: containerType
            }
        });
    }, [
        containerType,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f58rc.default), {
        href: link,
        onClick: onClick,
        ...(0, $eGOwo.fg)('enable_new_tab_for_team_container') ? {
            target: '_blank'
        } : {},
        description: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    size: "small",
                    color: "color.text.subtlest",
                    children: description
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    size: "small",
                    color: "color.text.subtlest",
                    children: containerTypeText
                })
            ]
        }),
        iconBefore: isContainerIconEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Mwhw.ContainerIcon), {
            containerType: containerType,
            title: title,
            containerIcon: containerIcon,
            size: "small"
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
            size: "small",
            appearance: "square",
            src: containerIcon,
            testId: "linked-container-icon"
        }),
        iconAfter: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            backgroundColor: 'color.background.neutral.subtle',
            xcss: $2f2a7af2be9c6b72$var$styles.containerTypeIconButtonStyles,
            testId: "container-type-icon",
            children: icon
        }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
            maxLines: 1,
            color: "color.text",
            children: title
        })
    });
};

});

parcelRegister("24Kc0", function(module, exports) {

$parcel$export(module.exports, "TeamContainersSkeleton", () => $604663a248f09a86$export$b4d5d8f3bbe29b5f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $hkxJ5 = parcelRequire("hkxJ5");
const $604663a248f09a86$var$styles = {
    showMoreButtonSkeleton: "_2rko1q77 _1rjc1b66 _1bsbvbgk",
    containerSkeletonWrapper: "_bozgpxbi _y4tipxbi"
};
const $604663a248f09a86$export$b4d5d8f3bbe29b5f = ({ numberOfContainers: numberOfContainers })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $604663a248f09a86$var$styles.containerSkeletonWrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
            space: "space.200",
            testId: "profile-card-team-containers-skeleton",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $78OnL.default), {
                    space: "space.100",
                    children: [
                        ...Array(numberOfContainers)
                    ].map((_, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hkxJ5.LinkedContainerCardSkeleton), {}, index))
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    backgroundColor: "color.background.neutral",
                    xcss: $604663a248f09a86$var$styles.showMoreButtonSkeleton
                })
            ]
        })
    });
};

});
parcelRegister("hkxJ5", function(module, exports) {

$parcel$export(module.exports, "LinkedContainerCardSkeleton", () => $1d20eae726fa7cdd$export$b7a75d9378054329);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
const $1d20eae726fa7cdd$var$styles = {
    containerWrapperSkeleton: "_2rkoiti9 _1h6dz9xs _12y3e4h9 _12jimuej _1qu2nqa1 _syaz1fxt _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    containerIconSkeleton: "_2rkoiti9 _4t3i1tcg _1bsb1tcg _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    firstLineSkeleton: "_2rko1q77 _1rjc1b66",
    secondLineSkeleton: "_2rko1q77 _1rjc1b66 _1bsbqkoa",
    containerTypeIconSkeleton: "_2rkoiti9 _4t3i7vkz _1bsb7vkz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc"
};
const $1d20eae726fa7cdd$export$b7a75d9378054329 = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
        space: "space.100",
        xcss: $1d20eae726fa7cdd$var$styles.containerWrapperSkeleton,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $1d20eae726fa7cdd$var$styles.containerIconSkeleton,
                backgroundColor: "color.background.neutral"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                grow: "fill",
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        xcss: $1d20eae726fa7cdd$var$styles.firstLineSkeleton,
                        backgroundColor: "color.background.neutral"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        xcss: $1d20eae726fa7cdd$var$styles.secondLineSkeleton,
                        backgroundColor: "color.background.neutral"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $1d20eae726fa7cdd$var$styles.containerTypeIconSkeleton,
                backgroundColor: "color.background.neutral"
            })
        ]
    });
};

});



parcelRegister("c8mEv", function(module, exports) {

$parcel$export(module.exports, "default", () => $381a86e9af2003aa$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4J0ad = parcelRequire("4J0ad");

var $7m76n = parcelRequire("7m76n");
var $XUWry = parcelRequire("XUWry");

var $gh6xW = parcelRequire("gh6xW");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");

var $dWlMJ = parcelRequire("dWlMJ");

var $k60Oj = parcelRequire("k60Oj");

var $5H2ec = parcelRequire("5H2ec");
class $381a86e9af2003aa$var$ProfileCardResourced extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static{
        this.defaultProps = {
            actions: []
        };
    }
    componentDidMount() {
        this._isMounted = true;
        this.clientFetchProfile();
    }
    componentDidUpdate(prevProps) {
        const { userId: userId, cloudId: cloudId, resourceClient: resourceClient } = this.props;
        if (userId !== prevProps.userId || cloudId !== prevProps.cloudId || resourceClient !== prevProps.resourceClient) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    handleClientSuccess(profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: profileData,
            reportingLinesData: reportingLinesData,
            isKudosEnabled: shouldShowGiveKudos,
            teamCentralBaseUrl: teamCentralBaseUrl
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    render() {
        const { isLoading: isLoading, hasError: hasError, error: error, data: data, reportingLinesData: reportingLinesData, isKudosEnabled: isKudosEnabled, teamCentralBaseUrl: teamCentralBaseUrl } = this.state;
        const { onReportingLinesClick: onReportingLinesClick, cloudId: cloudId, userId: userId, addFlag: addFlag } = this.props;
        const isFetchingOrNotStartToFetchYet = isLoading === true || isLoading === undefined;
        if (isFetchingOrNotStartToFetchYet) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.CardWrapper), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5H2ec.default), {
                fireAnalytics: this.fireAnalytics
            })
        });
        else if (hasError) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.CardWrapper), {
            testId: "profile-card-resourced-error-state",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dWlMJ.default), {
                errorType: error,
                reload: this.clientFetchProfile,
                fireAnalytics: this.fireAnalytics
            })
        });
        const newProps = {
            hasError: hasError,
            errorType: error,
            clientFetchProfile: this.clientFetchProfile,
            reportingLines: reportingLinesData,
            onReportingLinesClick: onReportingLinesClick,
            cloudId: cloudId,
            userId: userId,
            addFlag: addFlag,
            ...data,
            isKudosEnabled: isKudosEnabled,
            teamCentralBaseUrl: teamCentralBaseUrl,
            openKudosDrawer: this.openKudosDrawer
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.CardWrapper), {
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    isKudosEnabled && newProps.teamCentralBaseUrl && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                        fallback: null,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7m76n.GiveKudosLauncherLazy), {
                            isOpen: this.state.kudosDrawerOpen,
                            recipient: {
                                type: (0, $XUWry.KudosType).INDIVIDUAL,
                                recipientId: this.props.userId
                            },
                            analyticsSource: "profile-card",
                            teamCentralBaseUrl: newProps.teamCentralBaseUrl,
                            cloudId: this.props.cloudId,
                            addFlag: this.props.addFlag,
                            onClose: this.closeKudosDrawer
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k60Oj.default), {
                        ...newProps,
                        actions: this.filterActions()
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this._isMounted = false, this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            reportingLinesData: undefined,
            isKudosEnabled: false,
            kudosDrawerOpen: false,
            teamCentralBaseUrl: undefined
        }, this.fireAnalytics = (payload)=>{
            // Don't fire analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.createAnalyticsEvent) (0, $2EPX4.fireEvent)(this.props.createAnalyticsEvent, payload);
        }, this.clientFetchProfile = ()=>{
            const { cloudId: cloudId, userId: userId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                hasError: false,
                data: null
            }, ()=>{
                const requests = Promise.all([
                    this.props.resourceClient.getProfile(cloudId, userId, this.fireAnalytics),
                    this.props.resourceClient.getReportingLines(userId),
                    this.props.resourceClient.shouldShowGiveKudos(),
                    this.props.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        }, this.filterActions = ()=>(0, $gh6xW.default)(this.props.actions, this.state.data), this.openKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: true
            });
        }, this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        };
    }
}
const $381a86e9af2003aa$export$a6d9ff68ecba3be5 = $381a86e9af2003aa$var$ProfileCardResourced;
var $381a86e9af2003aa$export$2e2bcd8739ae039 = (0, $4J0ad.default)()($381a86e9af2003aa$var$ProfileCardResourced);

});
parcelRegister("gh6xW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4adbe5caf86a5ece$export$2e2bcd8739ae039);
const $4adbe5caf86a5ece$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $4adbe5caf86a5ece$export$2e2bcd8739ae039 = $4adbe5caf86a5ece$var$filterActions;

});

parcelRegister("b4A0H", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $d37aab7a36a1d923$export$6aa22a823032b784);
$parcel$export(module.exports, "SpinnerContainer", () => $d37aab7a36a1d923$export$a5e06607a5ac6158);
/* UserTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ // PLEASE NOTE: This file is sync-loaded with the trigger components. Only add components here that
// are necessary for the main render of the trigger component to help maintain bundle size.
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $d37aab7a36a1d923$var$styles = {
    cardWrapper: "_2rkoglpi _1bsb1gwv",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm"
};
const $d37aab7a36a1d923$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($d37aab7a36a1d923$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        children: children
    });
const $d37aab7a36a1d923$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        xcss: (0, $6qaBj.cx)($d37aab7a36a1d923$var$styles.spinnerContainer),
        children: children
    });

});

parcelRegister("dWlMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4c4e00d9fd0e109$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $a03qM = parcelRequire("a03qM");

var $jZF1f = parcelRequire("jZF1f");

var $5qJVF = parcelRequire("5qJVF");

var $3CCXY = parcelRequire("3CCXY");

var $2EPX4 = parcelRequire("2EPX4");
const $d4c4e00d9fd0e109$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $eJOHy.useEffect)(()=>{
        fireAnalytics((0, $2EPX4.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3CCXY.ErrorTitle), {
            children: "The user is no longer available for the site"
        });
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CCXY.ErrorTitle), {
            children: [
                "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $gt9Am.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    color: "color.text.subtlest",
                    children: "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CCXY.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
                label: "icon error",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jZF1f))),
                LEGACY_size: "xlarge"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                onClick: reload,
                children: "Try again"
            })
        ]
    });
};
var $d4c4e00d9fd0e109$export$2e2bcd8739ae039 = $d4c4e00d9fd0e109$var$ErrorMessage;

});
parcelRegister("3CCXY", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $f4fe046f369d0d86$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $f4fe046f369d0d86$export$b065fd053267ec81);
$parcel$export(module.exports, "TeamErrorText", () => $f4fe046f369d0d86$export$90d92ccfb27352c6);
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $f4fe046f369d0d86$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_11c82smr _syaz1fxt _19pku2gc",
    teamErrorText: "_syaz1wmz _19pku2gc"
};
const $f4fe046f369d0d86$export$bb27b7e39840238f = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.errorWrapper),
        ...props
    });
const $f4fe046f369d0d86$export$b065fd053267ec81 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.errorTitle),
        children: props.children
    });
const $f4fe046f369d0d86$export$90d92ccfb27352c6 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.teamErrorText),
        children: props.children
    });

});


parcelRegister("k60Oj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ProfilecardInternal", () => $5a897b393a8f8510$export$64e0275ede8ab792);
$parcel$export(module.exports, "default", () => $5a897b393a8f8510$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $4J0ad = parcelRequire("4J0ad");

var $5DgXR = parcelRequire("5DgXR");

var $5bY40 = parcelRequire("5bY40");

var $eGOwo = parcelRequire("eGOwo");

var $7ep4S = parcelRequire("7ep4S");


var $2L2e5 = parcelRequire("2L2e5");

var $hSR6z = parcelRequire("hSR6z");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");

var $g5TmB = parcelRequire("g5TmB");

var $kNQN4 = parcelRequire("kNQN4");

var $dWlMJ = parcelRequire("dWlMJ");

var $4HKGS = parcelRequire("4HKGS");

var $2eJsG = parcelRequire("2eJsG");
const $5a897b393a8f8510$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
const $5a897b393a8f8510$var$useKudos = (cloudId, userId, teamCentralBaseUrl, openKudosDrawer)=>{
    const kudosUrl = (0, $eJOHy.useMemo)(()=>{
        const recipientId = userId ? `&recipientId=${userId}` : '';
        const cloudIdParam = cloudId ? `&cloudId=${cloudId}` : '';
        return `${teamCentralBaseUrl || ''}/kudos/give?type=individual${recipientId}${cloudIdParam}`;
    }, [
        cloudId,
        teamCentralBaseUrl,
        userId
    ]);
    const kudosButtonCallback = (0, $eJOHy.useCallback)(()=>{
        if (openKudosDrawer) openKudosDrawer();
        else window.open(kudosUrl);
    }, [
        kudosUrl,
        openKudosDrawer
    ]);
    const kudosAction = (0, $eJOHy.useMemo)(()=>{
        return {
            label: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $2L2e5.default).giveKudosButton
            }),
            id: $5a897b393a8f8510$var$GIVE_KUDOS_ACTION_ID,
            callback: kudosButtonCallback,
            link: kudosUrl
        };
    }, [
        kudosButtonCallback,
        kudosUrl
    ]);
    return {
        kudosAction: kudosAction,
        kudosButtonCallback: kudosButtonCallback,
        kudosUrl: kudosUrl
    };
};
const $5a897b393a8f8510$var$Wrapper = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.CardWrapper), {
        testId: "profilecard",
        role: "dialog",
        labelledBy: "profilecard-name-label",
        children: props.children
    });
const $5a897b393a8f8510$export$64e0275ede8ab792 = (props)=>{
    const [openTime] = (0, $eJOHy.useState)((0, $kNQN4.getPageTime)());
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const fireAnalytics = (0, $eJOHy.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $2EPX4.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsWithDuration = (0, $eJOHy.useCallback)((generator)=>{
        const elapsed = (0, $kNQN4.getPageTime)() - openTime;
        const event = generator(elapsed);
        fireAnalytics(event);
    }, [
        fireAnalytics,
        openTime
    ]);
    const { kudosAction: kudosAction } = $5a897b393a8f8510$var$useKudos(props.cloudId, props.userId, props.teamCentralBaseUrl, props.openKudosDrawer);
    const { actions: actions = [], isCurrentUser: isCurrentUser, isKudosEnabled: isKudosEnabled, status: status = 'active' } = props;
    const realActions = (0, $eJOHy.useMemo)(()=>{
        if (isCurrentUser || !isKudosEnabled || status !== 'active') return actions;
        return actions.concat([
            kudosAction
        ]);
    }, [
        actions,
        isCurrentUser,
        isKudosEnabled,
        kudosAction,
        status
    ]);
    const { isLoading: isLoading, fullName: fullName, hasError: hasError } = props;
    const canRender = !hasError && !isLoading && !!(fullName || status === 'closed');
    (0, $eJOHy.useEffect)(()=>{
        if (canRender) fireAnalyticsWithDuration((duration)=>(0, $2EPX4.profileCardRendered)('user', 'content', {
                duration: duration,
                numActions: realActions.length
            }));
    }, [
        canRender,
        fireAnalyticsWithDuration,
        realActions
    ]);
    if (hasError) return /*#__PURE__*/ (0, $gt9Am.jsx)($5a897b393a8f8510$var$Wrapper, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dWlMJ.default), {
            reload: props.clientFetchProfile,
            errorType: props.errorType || null,
            fireAnalytics: fireAnalytics
        })
    });
    if (isLoading) return /*#__PURE__*/ (0, $gt9Am.jsx)($5a897b393a8f8510$var$Wrapper, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($5a897b393a8f8510$var$LoadingView, {
            fireAnalyticsWithDuration: fireAnalyticsWithDuration
        })
    });
    if (!canRender) return null;
    const isDisabledUser = status === 'inactive' || status === 'closed';
    return /*#__PURE__*/ (0, $gt9Am.jsx)($5a897b393a8f8510$var$Wrapper, {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hSR6z.CardContainer), {
            isDisabledUser: isDisabledUser,
            withoutElevation: props.withoutElevation,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.ProfileImage), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
                        size: "xlarge",
                        src: status !== 'closed' ? props.avatarUrl : undefined,
                        borderColor: `var(--ds-shadow-overlay, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hSR6z.CardContent), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2eJsG.ProfileCardDetails), {
                            ...props,
                            status: status,
                            fireAnalyticsWithDuration: fireAnalyticsWithDuration
                        }),
                        realActions && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.ActionsFlexSpacer), {}),
                                /*#__PURE__*/ (0, $gt9Am.jsx)($5a897b393a8f8510$var$Actions, {
                                    actions: realActions,
                                    fireAnalyticsWithDuration: fireAnalyticsWithDuration,
                                    isTriggeredUsingKeyboard: props.isTriggeredUsingKeyboard
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $5a897b393a8f8510$var$Actions = ({ actions: actions, fireAnalyticsWithDuration: fireAnalyticsWithDuration, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard })=>{
    const onActionClick = (0, $eJOHy.useCallback)((action, args, event, index)=>{
        fireAnalyticsWithDuration((duration)=>(0, $2EPX4.actionClicked)('user', {
                duration: duration,
                hasHref: !!action.link,
                hasOnClick: !!action.callback,
                index: index,
                actionId: action.id || 'no-id-specified'
            }));
        if (action.callback && (0, $g5TmB.isBasicClick)(event)) {
            event.preventDefault();
            action.callback(event, ...args);
        }
    }, [
        fireAnalyticsWithDuration
    ]);
    if (!actions || actions.length === 0) return null;
    const regularActions = actions.slice(0, (0, $4HKGS.ACTION_OVERFLOW_THRESHOLD));
    const overflowActions = actions.length > (0, $4HKGS.ACTION_OVERFLOW_THRESHOLD) ? actions.slice((0, $4HKGS.ACTION_OVERFLOW_THRESHOLD)) : undefined;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hSR6z.ActionButtonGroup), {
        testId: "profilecard-actions",
        children: [
            regularActions.map((action, index)=>{
                const isKudos = action.id === $5a897b393a8f8510$var$GIVE_KUDOS_ACTION_ID;
                const button = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $5bY40.default), {
                    appearance: "default",
                    onClick: (event, ...args)=>onActionClick(action, args, event, index),
                    href: action.link || '',
                    autoFocus: index === 0 && isTriggeredUsingKeyboard,
                    id: `action-button-${action.id}`,
                    "aria-labelledby": (0, $eGOwo.fg)('enable_userprofilecard_arialabelfix') ? `action-button-${action.id} profilecard-name-label` : '',
                    children: [
                        action.label,
                        isKudos && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.AnimationWrapper), {
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.KudosBlobAnimation), {})
                        })
                    ]
                }, action.id || index);
                if (isKudos) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.AnimatedKudosButton), {
                    children: button
                }, `profile-card-action-kudos_${action.id || index}`);
                return button;
            }),
            overflowActions && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4HKGS.OverflowProfileCardButtons), {
                actions: overflowActions,
                fireAnalyticsWithDuration: fireAnalyticsWithDuration,
                onItemClick: (action, args, event, index)=>onActionClick(action, args, event, index + (0, $4HKGS.ACTION_OVERFLOW_THRESHOLD))
            })
        ]
    });
};
const $5a897b393a8f8510$var$LoadingView = ({ fireAnalyticsWithDuration: fireAnalyticsWithDuration })=>{
    (0, $eJOHy.useEffect)(()=>{
        fireAnalyticsWithDuration((duration)=>(0, $2EPX4.profileCardRendered)('user', 'spinner', {
                duration: duration
            }));
    }, [
        fireAnalyticsWithDuration
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.SpinnerContainer), {
        testId: "profilecard-spinner-container",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
    });
};
var $5a897b393a8f8510$export$2e2bcd8739ae039 = (0, $4J0ad.default)()($5a897b393a8f8510$export$64e0275ede8ab792);

});
parcelRegister("2L2e5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0136d5b4c5e5df89$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0136d5b4c5e5df89$var$messages = (0, $7qGN1.defineMessages)({
    inactiveAccountMsg: {
        id: 'pt.profile-card.inactive.account',
        defaultMessage: 'Account deactivated',
        description: 'A text in a grey lozenge shows that this user is inactive'
    },
    generalDescMsgForDisabledUser: {
        id: 'pt.profile-card.general.msg.disabled.user',
        defaultMessage: 'You can no longer collaborate with this person.',
        description: 'A first sentence of a long text explains this user is inactive/closed'
    },
    inactiveAccountDescMsgNoDate: {
        id: 'pt.profile-card.inactive.account.no.date',
        defaultMessage: 'Their account has been deactivated.',
        description: 'A long text explains this user is inactive when we do not know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.inactive.account.has.date.this.week',
        defaultMessage: 'Their account was deactivated this week.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.inactive.account.has.date.this.month',
        defaultMessage: 'Their account was deactivated this month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.inactive.account.has.date.last.month',
        defaultMessage: 'Their account was deactivated last month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.inactive.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deactivated for a few months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.inactive.account.has.date.several.months',
        defaultMessage: 'Their account has been deactivated for several months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.inactive.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deactivated for more than a year.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    closedAccountMsg: {
        id: 'pt.profile-card.closed.account',
        defaultMessage: 'Account deleted',
        description: 'A text in a grey lozenge shows that this user is closed/deleted'
    },
    closedAccountDescMsgNoDate: {
        id: 'pt.profile-card.closed.account.no.date',
        defaultMessage: 'Their account has been deleted.',
        description: 'A long text explains this user is closed when we do not know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.closed.account.has.date.this.week',
        defaultMessage: 'Their account was deleted this week.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.closed.account.has.date.this.month',
        defaultMessage: 'Their account was deleted this month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.closed.account.has.date.last.month',
        defaultMessage: 'Their account was deleted last month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.closed.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deleted for a few months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.closed.account.has.date.several.months',
        defaultMessage: 'Their account has been deleted for several months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.closed.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deleted for more than a year.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    disabledAccountDefaultName: {
        id: 'pt.profile-card.disabled.account.default.name',
        defaultMessage: 'Former user',
        description: 'A default name when we cannot get name of an inactive or closed user'
    },
    teamViewProfile: {
        id: 'pt.team-profile-card.team.action.view-profile',
        defaultMessage: 'View profile',
        description: "Button that takes you to view this team\u2019s profile"
    },
    memberCount: {
        id: 'pt.team-profile-card.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team'
    },
    memberCountIncludingYou: {
        id: 'pt.team-profile-card.team.member.count-including-you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team and highlight that the user is a member'
    },
    membersMoreThan50: {
        id: 'pt.team-profile-card.team.member.many',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the team has more than 50 members'
    },
    membersMoreThan50IncludingYou: {
        id: 'pt.team-profile-card.team.member.many-including-you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the team has more than 50 members and highlight that the user is a member'
    },
    teamErrorTitle: {
        id: 'pt.team-profile-card.error.title',
        defaultMessage: "We\u2019re having trouble retrieving this teams information",
        description: 'Title for an error view explaining that data for this team cannot be accessed'
    },
    teamErrorText: {
        id: 'pt.team-profile-card.error.suggestion',
        defaultMessage: 'Wait a few moments, then try again.',
        description: 'Second line suggesting how to fix the issue'
    },
    teamErrorButton: {
        id: 'pt.team-profile-card.error.refresh-button',
        defaultMessage: 'Try again',
        description: 'Text on a button that will try to get the data again when clicked'
    },
    teamForbiddenErrorStateTitle: {
        id: 'pt.team-profile-card.forbidden-error-state.title',
        defaultMessage: "We can\u2019t show you this team",
        description: 'Title for the error state that is displayed when a user lacks access to the team'
    },
    teamForbiddenErrorStateDescription: {
        id: 'pt.team-profile-card.forbidden-error-state.description',
        defaultMessage: "You don\u2019t have access to view this team.",
        description: 'Description for the error state that is displayed when a user lacks access to the team'
    },
    managerSectionHeading: {
        id: 'pt.team-profile-card.manager.heading',
        defaultMessage: 'Manager',
        description: "Title for a section on the profile card that show the user's direct manager"
    },
    directReportsSectionHeading: {
        id: 'pt.team-profile-card.directReports.heading',
        defaultMessage: 'Direct reports',
        description: "Title for a section on the profile card that show the user's direct reports"
    },
    teamProfileCardAriaLabel: {
        id: 'pt.team-profile-card.aria-label',
        defaultMessage: 'More information about this team',
        description: 'Aria label for the team profile card'
    },
    giveKudosButton: {
        id: 'pt.profile-card.give-kudos',
        defaultMessage: 'Give kudos',
        description: 'Title for the button on the profile card for a user to give a kudos'
    },
    profileCardMoreIconLabel: {
        id: 'pt.profile-card.more-icon-label',
        defaultMessage: 'More',
        description: 'Label for the meatballs icon on the profile card, which when clicked will provide more options'
    },
    profileCardMoreReportingLinesLabel: {
        id: 'pt.user-profile-card.reporting-lines.more-icon-label',
        defaultMessage: '+{count} more {count, plural, one {profile} other {profiles}}',
        description: 'Label for the "more profiles" indicator in the reporting lines section of the user profile card'
    },
    profileCardMoreMembersLabel: {
        id: 'pt.team.profile-card.members.more-icon-label',
        defaultMessage: '+{count} more {count, plural, one {members} other {members}}',
        description: 'Label for the "more members" indicator in the members section of the team profile card'
    }
});
var $0136d5b4c5e5df89$export$2e2bcd8739ae039 = $0136d5b4c5e5df89$var$messages;

});

parcelRegister("hSR6z", function(module, exports) {

$parcel$export(module.exports, "ProfileImage", () => $923382155ddc76ef$export$a7a74ab5cffd1455);
$parcel$export(module.exports, "ActionsFlexSpacer", () => $923382155ddc76ef$export$d395c8d16f1e359d);
$parcel$export(module.exports, "KudosBlobAnimation", () => $923382155ddc76ef$export$4a8a956251d4bf6f);
$parcel$export(module.exports, "AnimationWrapper", () => $923382155ddc76ef$export$58517bb1b373a54c);
$parcel$export(module.exports, "AnimatedKudosButton", () => $923382155ddc76ef$export$6196a3f52a6944fe);
$parcel$export(module.exports, "ActionButtonGroup", () => $923382155ddc76ef$export$73d695ae27330056);
$parcel$export(module.exports, "OverflowActionButtonsWrapper", () => $923382155ddc76ef$export$ff778e5b796745a6);
$parcel$export(module.exports, "CardContent", () => $923382155ddc76ef$export$64ef9b8c11710c47);
$parcel$export(module.exports, "DetailsGroup", () => $923382155ddc76ef$export$35cf684daac137ac);
$parcel$export(module.exports, "DisabledInfo", () => $923382155ddc76ef$export$2062e7265a95a823);
$parcel$export(module.exports, "LozengeWrapper", () => $923382155ddc76ef$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "CustomLozengeContainer", () => $923382155ddc76ef$export$6ebf103500ba5a45);
$parcel$export(module.exports, "JobTitleLabel", () => $923382155ddc76ef$export$d6c0e5f211c8d617);
$parcel$export(module.exports, "AppTitleLabel", () => $923382155ddc76ef$export$4865ffa72a4d5f9);
$parcel$export(module.exports, "CardContainer", () => $923382155ddc76ef$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "DetailsLabel", () => $923382155ddc76ef$export$138a08882ebf7289);
$parcel$export(module.exports, "DetailsLabelIcon", () => $923382155ddc76ef$export$79d7d9b2f6a70c70);
$parcel$export(module.exports, "DetailsLabelText", () => $923382155ddc76ef$export$b0ec2c767a0e0eab);
/* Card.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");
const $923382155ddc76ef$var$kudosButtonAnimationTransformationCompiled = null;
const $923382155ddc76ef$var$styles = {
    profileImage: "_kqswstnw _154i1ejb _1ltv1ejb",
    actionsFlexSpacer: "_16jlkb7n _1o9zidpf _i0dl1wug",
    kudosBlobAnimationStyle: "_1e0cglyw _4t3i1w81 _1bsb1w81 _1pby1mrw _kqswstnw _154ixy5q",
    animationWrapper: "_mkrz1rip _kqswstnw _154ize3t _1ltvze3t _94n5ze3t _1xi2ze3t",
    animatedKudosButton: "_18u0u2gc",
    actionButtonGroup: "_zulp12x7 _uiztglyw _19pkpxbi _2hwxze3t _18u0ze3t _otyrze3t _y3gnusic _1bahesu3 _1e0c1txw",
    overflowActionButtonsWrapper: "_1e0c1o8l _1bsbzwfg _4t3izwfg",
    cardContent: "_1e0c1txw _2lx21bp4 _1tkebv7e",
    detailsGroup: "_1e0c1txw _2lx21bp4 _18u01epz _19bvxy5q _1bsb18pt",
    disabledInfo: "_11c81o8v _syaz1fxt _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t",
    lozengeWrapper: "_19pkpxbi _1e0c1ule",
    customLozengeContainer: "_1e0c1txw _2lx2vrvc _1n261g80 _1bah1y6m _19pkutpp",
    cardContainer: "_1reo15vq _18m915vq _kqswh2mm _12vemgnk _1lrw14bs _ca0q1ejb _19bv1ejb _u5f31ejb _n3td1ejb",
    cardContainerActiveUser: "_1itk1419",
    cardContainerDisabledUser: "_1itkkf3t",
    cardContainerWithElevation: "_2rkoglpi _16qs1cd0",
    detailsLabel: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1y6m _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t _o5721q9c",
    detailsLabelNext: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1y6m _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t _19bvze3t _o5721q9c",
    detailsLabelExtraTopSpace: "_19pkxy5q",
    detailsLabelIcon: "_1e0c1txw _1o9zidpf _syaz131l _1bsb7vkz _4t3i7vkz _s7n4jp4b _19pkze3t",
    detailsLabelText: "_1reo15vq _18m915vq _11c8dcr7 _1bto1l2s _syaz1fxt _19pkze3t _18u0ze3t",
    kudosBlobAnimation: "_1e0cglyw _4t3i1w81 _1bsb1w81 _1pby1mrw _kqswstnw _j7hq1q51 _tip8kb7n _5sagi11n _1itkiwwe",
    jobTitleLabel: "_19pkze3t _otyrze3t _18u0utpp _2hwxze3t",
    appTitleLabel: "_2rkoglpi _syaz1fxt _u5f312x7 _19bv12x7 _1bsb1ns9 _19pk1b66 _otyrze3t _18u0utpp _2hwxze3t"
};
const $923382155ddc76ef$export$a7a74ab5cffd1455 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.profileImage),
        children: children
    });
const $923382155ddc76ef$export$d395c8d16f1e359d = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.actionsFlexSpacer)
    });
const $923382155ddc76ef$export$b08abf2f97b92ea5 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.kudosBlobAnimationStyle)
    });
const $923382155ddc76ef$export$4a8a956251d4bf6f = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.kudosBlobAnimationStyle)
    });
const $923382155ddc76ef$export$58517bb1b373a54c = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.animationWrapper),
        children: children
    });
const $923382155ddc76ef$export$6196a3f52a6944fe = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.animatedKudosButton),
        children: children
    });
const $923382155ddc76ef$export$73d695ae27330056 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.actionButtonGroup),
        children: children
    });
const $923382155ddc76ef$export$ff778e5b796745a6 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.overflowActionButtonsWrapper),
        children: children
    });
const $923382155ddc76ef$export$64ef9b8c11710c47 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.cardContent),
        children: children
    });
const $923382155ddc76ef$export$35cf684daac137ac = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.detailsGroup),
        children: children
    });
const $923382155ddc76ef$export$2062e7265a95a823 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.disabledInfo),
        children: children
    });
const $923382155ddc76ef$export$75180efdd3f4d9c2 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.lozengeWrapper),
        children: children
    });
const $923382155ddc76ef$export$6ebf103500ba5a45 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.customLozengeContainer),
        children: children
    });
const $923382155ddc76ef$export$d6c0e5f211c8d617 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.jobTitleLabel),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
            maxLines: 1,
            color: "color.text.inverse",
            children: children
        })
    });
const $923382155ddc76ef$export$4865ffa72a4d5f9 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.appTitleLabel),
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
            color: "color.text",
            size: "UNSAFE_small",
            weight: "bold",
            children: children
        })
    });
const $923382155ddc76ef$export$8a23e74e5cf3ca41 = ({ children: children, isDisabledUser: isDisabledUser, withoutElevation: withoutElevation })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.cardContainer, isDisabledUser ? $923382155ddc76ef$var$styles.cardContainerDisabledUser : $923382155ddc76ef$var$styles.cardContainerActiveUser, !withoutElevation && $923382155ddc76ef$var$styles.cardContainerWithElevation),
        children: children
    });
const $923382155ddc76ef$export$138a08882ebf7289 = ({ children: children, extraTopSpace: extraTopSpace = false })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "dl",
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.detailsLabelNext, extraTopSpace && $923382155ddc76ef$var$styles.detailsLabelExtraTopSpace),
        children: children
    });
const $923382155ddc76ef$export$79d7d9b2f6a70c70 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "dt",
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.detailsLabelIcon),
        children: children
    });
const $923382155ddc76ef$export$b0ec2c767a0e0eab = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "dd",
        xcss: (0, $6qaBj.cx)($923382155ddc76ef$var$styles.detailsLabelText),
        children: children
    });

});

parcelRegister("g5TmB", function(module, exports) {

$parcel$export(module.exports, "isBasicClick", () => $d966bd6e0cdd5a4c$export$eddcd8a5b7e09991);
const $d966bd6e0cdd5a4c$export$eddcd8a5b7e09991 = (event)=>{
    return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

});

parcelRegister("4HKGS", function(module, exports) {

$parcel$export(module.exports, "ACTION_OVERFLOW_THRESHOLD", () => $5caf5a903f1ee918$export$3e2419a7546ad45e);
$parcel$export(module.exports, "OverflowProfileCardButtons", () => $5caf5a903f1ee918$export$9d9b53d23c0df7a1);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $aMdh8 = parcelRequire("aMdh8");

var $2L2e5 = parcelRequire("2L2e5");

var $hSR6z = parcelRequire("hSR6z");

var $2EPX4 = parcelRequire("2EPX4");
const $5caf5a903f1ee918$export$3e2419a7546ad45e = 2;
const $5caf5a903f1ee918$export$9d9b53d23c0df7a1 = (props)=>{
    const intl = (0, $lRq8t.default)();
    const [, setOpen] = (0, $eJOHy.useState)(false);
    const { actions: actions, onItemClick: onItemClick, fireAnalyticsWithDuration: fireAnalyticsWithDuration } = props;
    const numActions = actions.length + $5caf5a903f1ee918$export$3e2419a7546ad45e;
    const onOpenChange = (0, $eJOHy.useCallback)(({ isOpen: nextOpen })=>{
        setOpen((prevOpen)=>{
            if (nextOpen && !prevOpen) fireAnalyticsWithDuration((duration)=>(0, $2EPX4.moreActionsClicked)('user', {
                    duration: duration,
                    numActions: numActions
                }));
            return nextOpen;
        });
    }, [
        numActions,
        fireAnalyticsWithDuration
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.OverflowActionButtonsWrapper), {
        testId: "profilecard-actions-overflow",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
            onOpenChange: onOpenChange,
            placement: 'bottom-end',
            trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: testId, ...providedProps })=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    type: "button",
                    ...providedProps,
                    ref: triggerRef,
                    label: intl.formatMessage((0, $2L2e5.default).profileCardMoreIconLabel),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($aMdh8)))
                });
            },
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
                children: actions.map((action, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                        onClick: (event, ...args)=>{
                            onItemClick(action, args, event, index);
                        },
                        href: action.link,
                        children: action.label
                    }, action.id))
            })
        })
    });
};

});

parcelRegister("2eJsG", function(module, exports) {

$parcel$export(module.exports, "ProfileCardDetails", () => $6b40f946ab5fe434$export$c0e6870b898eb99d);
/* ProfileCardDetails.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $kDaaB = parcelRequire("kDaaB");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $5qJVF = parcelRequire("5qJVF");

var $8IeH1 = parcelRequire("8IeH1");

var $kMx18 = parcelRequire("kMx18");

var $2L2e5 = parcelRequire("2L2e5");

var $hSR6z = parcelRequire("hSR6z");

var $59oGz = parcelRequire("59oGz");

var $3oOiz = parcelRequire("3oOiz");
const $6b40f946ab5fe434$var$styles = {
    detailedListWrapper: "_19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
    detailedListWrapperNext: "_19pkxy5q _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
    fullNameLabel: "_1reo15vq _18m915vq _11c81ixg _1bto1l2s _o5721q9c",
    noMetaLabel: "_2hwxidpf _18u0idpf _rcujxy5q _1l6uutpp",
    noMetaLabelWithHighSpecificity: "_1hpmxy5q _1bguutpp",
    metaLabel: "_2hwxidpf _otyridpf _18u0idpf _rcujutpp",
    metaLabelWithHighSpecificity: "_2hwxidpf _otyridpf _18u0idpf _1hpmutpp",
    disabledAccount: "_syaz1fxt",
    activeAccount: "_syaz15cr"
};
const $6b40f946ab5fe434$var$renderName = (nickname, fullName, meta)=>{
    if (!fullName && !nickname) return null;
    const isNicknameRedundant = !nickname || nickname === fullName;
    const shownNickname = ` (${nickname}) `;
    const displayName = isNicknameRedundant ? fullName : `${fullName}${shownNickname}`;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "h2",
        xcss: (0, $k0ahr.cx)($6b40f946ab5fe434$var$styles.fullNameLabel, $6b40f946ab5fe434$var$styles.activeAccount, meta ? (0, $eGOwo.fg)('platform_editor_profilecard_style_fix') ? $6b40f946ab5fe434$var$styles.metaLabelWithHighSpecificity : $6b40f946ab5fe434$var$styles.metaLabel : (0, $eGOwo.fg)('platform_editor_profilecard_style_fix') ? $6b40f946ab5fe434$var$styles.noMetaLabelWithHighSpecificity : $6b40f946ab5fe434$var$styles.noMetaLabel),
        testId: "profilecard-name",
        id: "profilecard-name-label",
        children: displayName
    });
};
const $6b40f946ab5fe434$var$disabledAccountDesc = (statusModifiedDate, disabledAccountMessage, status = 'closed')=>{
    // consumer does not want to use built-in message
    if (disabledAccountMessage) return disabledAccountMessage;
    const date = statusModifiedDate ? new Date(statusModifiedDate * 1000) : null;
    const relativeDateKey = (0, $kMx18.default)(date);
    const msgKey = relativeDateKey ? `${status}AccountDescMsgHasDate${relativeDateKey}` : `${status}AccountDescMsgNoDate`;
    const secondSentence = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...(0, $2L2e5.default)[msgKey]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $5qJVF.default), {
        as: "p",
        testId: "profilecard-disabled-account",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $2L2e5.default).generalDescMsgForDisabledUser
            }),
            " ",
            secondSentence
        ]
    });
};
const $6b40f946ab5fe434$var$CustomLozenges = ({ lozenges: lozenges = [] })=>{
    if (lozenges.length === 0) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.CustomLozengeContainer), {
        children: lozenges.map(({ text: text, ...otherProps }, index)=>/*#__PURE__*/ (0, $eJOHy.createElement)((0, $jdqdp.default), {
                ...otherProps,
                key: index
            }, text))
    });
};
const $6b40f946ab5fe434$var$ServiceAccountProfileCardDetails = (props)=>{
    const { fullName: fullName, nickname: nickname } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hSR6z.DetailsGroup), {
        children: [
            $6b40f946ab5fe434$var$renderName(nickname, fullName),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.AppTitleLabel), {
                children: "SERVICE ACCOUNT"
            })
        ]
    });
};
const $6b40f946ab5fe434$var$BotProfileCardDetails = (props)=>{
    const { fullName: fullName, nickname: nickname } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hSR6z.DetailsGroup), {
        children: [
            $6b40f946ab5fe434$var$renderName(nickname, fullName),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.AppTitleLabel), {
                children: "APP"
            })
        ]
    });
};
const $6b40f946ab5fe434$var$DisabledProfileCardDetails = (props)=>{
    const { companyName: companyName, disabledAccountMessage: disabledAccountMessage, fullName: fullName, hasDisabledAccountLozenge: hasDisabledAccountLozenge = true, nickname: nickname, status: status, statusModifiedDate: statusModifiedDate } = props;
    const name = status === 'inactive' ? fullName || nickname : nickname || /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...(0, $2L2e5.default).disabledAccountDefaultName
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hSR6z.DetailsGroup), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "h2",
                xcss: (0, $k0ahr.cx)($6b40f946ab5fe434$var$styles.fullNameLabel, $6b40f946ab5fe434$var$styles.noMetaLabel, $6b40f946ab5fe434$var$styles.disabledAccount),
                testId: "profilecard-name",
                id: "profilecard-name-label",
                children: name
            }),
            hasDisabledAccountLozenge && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.LozengeWrapper), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                    appearance: "default",
                    isBold: true,
                    children: status === 'inactive' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $2L2e5.default).inactiveAccountMsg
                    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $2L2e5.default).closedAccountMsg
                    })
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.DisabledInfo), {
                children: $6b40f946ab5fe434$var$disabledAccountDesc(statusModifiedDate, disabledAccountMessage, status)
            }),
            status === 'inactive' && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59oGz.default), {
                icon: "companyName",
                children: companyName
            })
        ]
    });
};
const $6b40f946ab5fe434$export$c0e6870b898eb99d = (props)=>{
    const { meta: meta, status: status } = props;
    if (props.isServiceAccount) return /*#__PURE__*/ (0, $gt9Am.jsx)($6b40f946ab5fe434$var$ServiceAccountProfileCardDetails, {
        ...props
    });
    if (props.isBot) return /*#__PURE__*/ (0, $gt9Am.jsx)($6b40f946ab5fe434$var$BotProfileCardDetails, {
        ...props
    });
    if (status === 'inactive' || status === 'closed') return /*#__PURE__*/ (0, $gt9Am.jsx)($6b40f946ab5fe434$var$DisabledProfileCardDetails, {
        ...props,
        status: status
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hSR6z.DetailsGroup), {
        children: [
            $6b40f946ab5fe434$var$renderName(props.nickname, props.fullName, meta),
            meta && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.JobTitleLabel), {
                children: meta
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)($6b40f946ab5fe434$var$CustomLozenges, {
                lozenges: props.customLozenges
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                xcss: $6b40f946ab5fe434$var$styles.detailedListWrapperNext,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59oGz.default), {
                        icon: "email",
                        extraTopSpace: true,
                        children: props.email
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59oGz.default), {
                        icon: "time",
                        children: props.timestring
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59oGz.default), {
                        icon: "companyName",
                        children: props.companyName
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59oGz.default), {
                        icon: "location",
                        children: props.location
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3oOiz.default), {
                reportingLines: props.reportingLines,
                reportingLinesProfileUrl: props.reportingLinesProfileUrl,
                onReportingLinesClick: props.onReportingLinesClick,
                fireAnalyticsWithDuration: props.fireAnalyticsWithDuration
            })
        ]
    });
};

});
parcelRegister("kMx18", function(module, exports) {

$parcel$export(module.exports, "default", () => $098edd1c518e81d8$export$2e2bcd8739ae039);

var $1dCza = parcelRequire("1dCza");

var $aKeeT = parcelRequire("aKeeT");

var $37UhW = parcelRequire("37UhW");

var $dBLX0 = parcelRequire("dBLX0");
function $098edd1c518e81d8$export$c03bb0116ee09d4b(date, today = new Date()) {
    return !!date.getTime && (0, $dBLX0.default)(date) && date.getTime() <= today.getTime();
}
function $098edd1c518e81d8$export$2e2bcd8739ae039(date, today = new Date()) {
    if (!date || !$098edd1c518e81d8$export$c03bb0116ee09d4b(date, today)) return null;
    if ((0, $37UhW.default)(date)) return 'ThisWeek';
    if ((0, $aKeeT.default)(date)) return 'ThisMonth';
    if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() - 1) return 'LastMonth';
    const diffInMonths = (0, $1dCza.default)(today, date);
    if (diffInMonths < 6) return 'AFewMonths';
    if (diffInMonths <= 12) return 'SeveralMonths';
    return 'MoreThanAYear';
}

});

parcelRegister("59oGz", function(module, exports) {

$parcel$export(module.exports, "default", () => $07129a6752975c71$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $defwj = parcelRequire("defwj");

var $dNLHm = parcelRequire("dNLHm");

var $63OXZ = parcelRequire("63OXZ");

var $rZPcB = parcelRequire("rZPcB");

var $hSR6z = parcelRequire("hSR6z");
const $07129a6752975c71$var$icons = {
    location: (0, (/*@__PURE__*/$parcel$interopDefault($63OXZ))),
    time: (0, (/*@__PURE__*/$parcel$interopDefault($defwj))),
    email: (0, (/*@__PURE__*/$parcel$interopDefault($dNLHm))),
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($rZPcB)))
};
class $07129a6752975c71$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static{
        this.defaultProps = {
            icon: ''
        };
    }
    render() {
        if (!this.props.children) return null;
        // @ts-ignore
        const IconElement = this.props.icon && $07129a6752975c71$var$icons[this.props.icon];
        const displayIcon = IconElement ? /*#__PURE__*/ (0, $gt9Am.jsx)(IconElement, {
            label: `${this.props.icon}`,
            LEGACY_size: "small",
            color: "var(--ds-text-subtlest, #626F86)"
        }) : null;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hSR6z.DetailsLabel), {
            extraTopSpace: this.props.extraTopSpace,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.DetailsLabelIcon), {
                    children: displayIcon
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.DetailsLabelText), {
                    children: this.props.children
                })
            ]
        });
    }
}

});
parcelRegister("defwj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61cc856ba673fb016dcc97fed2247ace>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a189f26dbb75729$var$_react = $9a189f26dbb75729$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9a189f26dbb75729$var$_clock = $9a189f26dbb75729$var$_interopRequireDefault((parcelRequire("i5stJ")));

var $9a189f26dbb75729$var$_recent = $9a189f26dbb75729$var$_interopRequireDefault((parcelRequire("3YzE3")));
function $9a189f26dbb75729$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ClockIcon.
 * This component is ClockIcon, with `UNSAFE_fallbackIcon` set to "RecentIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a189f26dbb75729$var$ClockIcon = (props)=>/*#__PURE__*/ $9a189f26dbb75729$var$_react.default.createElement($9a189f26dbb75729$var$_clock.default, Object.assign({
        LEGACY_fallbackIcon: $9a189f26dbb75729$var$_recent.default
    }, props));
$9a189f26dbb75729$var$ClockIcon.Name = 'ClockIconMigration';
var $9a189f26dbb75729$var$_default = module.exports.default = $9a189f26dbb75729$var$ClockIcon;

});
parcelRegister("3YzE3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e52a008305be905$var$_react = $2e52a008305be905$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $2e52a008305be905$var$_clock = $2e52a008305be905$var$_interopRequireDefault((parcelRequire("i5stJ")));
function $2e52a008305be905$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2e52a008305be905$var$RecentIcon = (props)=>/*#__PURE__*/ $2e52a008305be905$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 8.002v4.002c0 .28.116.53.301.712l2.47 2.47a1.003 1.003 0 0 0 1.414 0 1.003 1.003 0 0 0 0-1.415L13 11.586V6a1 1 0 0 0-2 0zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></svg>`
    }, props, {
        newIcon: $2e52a008305be905$var$_clock.default
    }));
$2e52a008305be905$var$RecentIcon.displayName = 'RecentIcon';
var $2e52a008305be905$var$_default = module.exports.default = $2e52a008305be905$var$RecentIcon;

});


parcelRegister("dNLHm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2014ecb862bd114df9c4eca3bb7d0c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0c4d9df726ba45c$var$_react = $a0c4d9df726ba45c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a0c4d9df726ba45c$var$_email = $a0c4d9df726ba45c$var$_interopRequireDefault((parcelRequire("hluWa")));

var $a0c4d9df726ba45c$var$_email2 = $a0c4d9df726ba45c$var$_interopRequireDefault((parcelRequire("4ZN93")));
function $a0c4d9df726ba45c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0c4d9df726ba45c$var$EmailIcon = (props)=>/*#__PURE__*/ $a0c4d9df726ba45c$var$_react.default.createElement($a0c4d9df726ba45c$var$_email.default, Object.assign({
        LEGACY_fallbackIcon: $a0c4d9df726ba45c$var$_email2.default
    }, props));
$a0c4d9df726ba45c$var$EmailIcon.Name = 'EmailIconMigration';
var $a0c4d9df726ba45c$var$_default = module.exports.default = $a0c4d9df726ba45c$var$EmailIcon;

});
parcelRegister("hluWa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19440c8dd0e3db5766add744ad314d45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca0c654a3a0a1b61$var$_react = $ca0c654a3a0a1b61$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ca0c654a3a0a1b61$var$_baseNew = $ca0c654a3a0a1b61$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ca0c654a3a0a1b61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca0c654a3a0a1b61$var$EmailIcon = (props)=>/*#__PURE__*/ $ca0c654a3a0a1b61$var$_react.default.createElement($ca0c654a3a0a1b61$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$ca0c654a3a0a1b61$var$EmailIcon.displayName = 'EmailIcon';
var $ca0c654a3a0a1b61$var$_default = module.exports.default = $ca0c654a3a0a1b61$var$EmailIcon;

});

parcelRegister("4ZN93", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a32fb20eb7dd93a$var$_react = $3a32fb20eb7dd93a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $3a32fb20eb7dd93a$var$_email = $3a32fb20eb7dd93a$var$_interopRequireDefault((parcelRequire("hluWa")));
function $3a32fb20eb7dd93a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3a32fb20eb7dd93a$var$EmailIcon = (props)=>/*#__PURE__*/ $3a32fb20eb7dd93a$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $3a32fb20eb7dd93a$var$_email.default
    }));
$3a32fb20eb7dd93a$var$EmailIcon.displayName = 'EmailIcon';
var $3a32fb20eb7dd93a$var$_default = module.exports.default = $3a32fb20eb7dd93a$var$EmailIcon;

});


parcelRegister("63OXZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::15069c31a0410504ca6fc11c34278f93>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $469a8ec5d735aa86$var$_react = $469a8ec5d735aa86$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $469a8ec5d735aa86$var$_location = $469a8ec5d735aa86$var$_interopRequireDefault((parcelRequire("2TuHL")));

var $469a8ec5d735aa86$var$_location2 = $469a8ec5d735aa86$var$_interopRequireDefault((parcelRequire("7wMyK")));
function $469a8ec5d735aa86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LocationIcon.
 * This component is LocationIcon, with `UNSAFE_fallbackIcon` set to "LocationIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $469a8ec5d735aa86$var$LocationIcon = (props)=>/*#__PURE__*/ $469a8ec5d735aa86$var$_react.default.createElement($469a8ec5d735aa86$var$_location.default, Object.assign({
        LEGACY_fallbackIcon: $469a8ec5d735aa86$var$_location2.default
    }, props));
$469a8ec5d735aa86$var$LocationIcon.Name = 'LocationIconMigration';
var $469a8ec5d735aa86$var$_default = module.exports.default = $469a8ec5d735aa86$var$LocationIcon;

});
parcelRegister("2TuHL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a077d34b75af68b5a629fa3ed5b43193>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21b8892eb2d01846$var$_react = $21b8892eb2d01846$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $21b8892eb2d01846$var$_baseNew = $21b8892eb2d01846$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $21b8892eb2d01846$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21b8892eb2d01846$var$LocationIcon = (props)=>/*#__PURE__*/ $21b8892eb2d01846$var$_react.default.createElement($21b8892eb2d01846$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5c-3.627 0-5.764 4.07-3.705 7.056L8 13.93l3.705-5.373C13.765 5.57 11.627 1.5 8 1.5M3.06 9.408C.314 5.427 3.164 0 8 0s7.686 5.427 4.94 9.408l-4.323 6.268a.75.75 0 0 1-1.234 0zM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.5 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0" clip-rule="evenodd"/>`
    }, props));
$21b8892eb2d01846$var$LocationIcon.displayName = 'LocationIcon';
var $21b8892eb2d01846$var$_default = module.exports.default = $21b8892eb2d01846$var$LocationIcon;

});

parcelRegister("7wMyK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57b1307724c0968d$var$_react = $57b1307724c0968d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $57b1307724c0968d$var$_location = $57b1307724c0968d$var$_interopRequireDefault((parcelRequire("2TuHL")));
function $57b1307724c0968d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $57b1307724c0968d$var$LocationIcon = (props)=>/*#__PURE__*/ $57b1307724c0968d$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21c-2.28 0-6-8.686-6-12a6 6 0 1 1 12 0c0 3.314-3.72 12-6 12m0-9a2.912 2.912 0 1 0 0-5.824A2.912 2.912 0 0 0 12 12"/></svg>`
    }, props, {
        newIcon: $57b1307724c0968d$var$_location.default
    }));
$57b1307724c0968d$var$LocationIcon.displayName = 'LocationIcon';
var $57b1307724c0968d$var$_default = module.exports.default = $57b1307724c0968d$var$LocationIcon;

});


parcelRegister("rZPcB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f7f55381552b3bb050a399d88ef8b3fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05427adb8338e2ba$var$_react = $05427adb8338e2ba$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $05427adb8338e2ba$var$_officeBuilding = $05427adb8338e2ba$var$_interopRequireDefault((parcelRequire("jPgjO")));

var $05427adb8338e2ba$var$_officeBuilding2 = $05427adb8338e2ba$var$_interopRequireDefault((parcelRequire("if7fN")));
function $05427adb8338e2ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for OfficeBuildingIcon.
 * This component is OfficeBuildingIcon, with `UNSAFE_fallbackIcon` set to "OfficeBuildingIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05427adb8338e2ba$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $05427adb8338e2ba$var$_react.default.createElement($05427adb8338e2ba$var$_officeBuilding.default, Object.assign({
        LEGACY_fallbackIcon: $05427adb8338e2ba$var$_officeBuilding2.default
    }, props));
$05427adb8338e2ba$var$OfficeBuildingIcon.Name = 'OfficeBuildingIconMigration';
var $05427adb8338e2ba$var$_default = module.exports.default = $05427adb8338e2ba$var$OfficeBuildingIcon;

});
parcelRegister("jPgjO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfe75e26330f86b48e811f0d520fc5e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6ef7042ada3add3$var$_react = $e6ef7042ada3add3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e6ef7042ada3add3$var$_baseNew = $e6ef7042ada3add3$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e6ef7042ada3add3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6ef7042ada3add3$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $e6ef7042ada3add3$var$_react.default.createElement($e6ef7042ada3add3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$e6ef7042ada3add3$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $e6ef7042ada3add3$var$_default = module.exports.default = $e6ef7042ada3add3$var$OfficeBuildingIcon;

});

parcelRegister("if7fN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d47f41275bf2da31$var$_react = $d47f41275bf2da31$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $d47f41275bf2da31$var$_officeBuilding = $d47f41275bf2da31$var$_interopRequireDefault((parcelRequire("jPgjO")));
function $d47f41275bf2da31$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d47f41275bf2da31$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $d47f41275bf2da31$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8v-2.145c-1.616-.001-3-.003-3-.004 0 0 .005-10.708.009-10.708L8 8.144z"/><path d="M12 7h2v2h-2zm-6 3h2v2H6zm0 3h2v2H6zm6-3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/><path fill-rule="nonzero" d="M18.991 19C18.998 19 19 4.995 19 4.995c0 .006-7.991.005-7.991.005C11.002 5 11 19 11 19zM9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/></g></svg>`
    }, props, {
        newIcon: $d47f41275bf2da31$var$_officeBuilding.default
    }));
$d47f41275bf2da31$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $d47f41275bf2da31$var$_default = module.exports.default = $d47f41275bf2da31$var$OfficeBuildingIcon;

});



parcelRegister("3oOiz", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ab7f990b9f1d2bd$export$2e2bcd8739ae039);
/* ReportingLinesDetails.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $5DgXR = parcelRequire("5DgXR");

var $gqBnP = parcelRequire("gqBnP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $46R8N = parcelRequire("46R8N");

var $2L2e5 = parcelRequire("2L2e5");

var $3JKJg = parcelRequire("3JKJg");

var $2EPX4 = parcelRequire("2EPX4");
function $7ab7f990b9f1d2bd$var$getProfileHref(userId, profileUrl) {
    return profileUrl ? profileUrl + userId : undefined;
}
const $7ab7f990b9f1d2bd$var$reportingLinesHeadingDefaultStyles = (0, $1DXK0.xcss)({
    color: 'color.text',
    font: 'font.heading.xxsmall',
    fontWeight: 'font.weight.semibold',
    marginBottom: 'space.100'
});
const $7ab7f990b9f1d2bd$var$reportingLinesHeadingStyles = (0, $1DXK0.xcss)({
    marginBottom: '0'
});
const $7ab7f990b9f1d2bd$var$styles = {
    reportingLinesButton: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _bfhk1w7a _irr3166n"
};
const $7ab7f990b9f1d2bd$var$avatarGroupMaxCount = 5;
const $7ab7f990b9f1d2bd$var$ReportingLinesDetails = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fireAnalyticsWithDuration: fireAnalyticsWithDuration, reportingLines: reportingLines = {}, reportingLinesProfileUrl: reportingLinesProfileUrl, onReportingLinesClick: onReportingLinesClick } = props;
    const { managers: managers = [], reports: reports = [] } = reportingLines;
    const manager = managers.length >= 1 ? managers[0] : undefined;
    const hasReports = reports.length > 0;
    const getReportingLinesOnClick = (user, userType)=>onReportingLinesClick ? ()=>{
            fireAnalyticsWithDuration((duration)=>(0, $2EPX4.reportingLinesClicked)({
                    duration: duration,
                    userType: userType
                }));
            onReportingLinesClick(user);
        } : undefined;
    const onReportingLinksClick = (user, userType, href)=>{
        let shouldPreventDefault = false;
        if (onReportingLinesClick) shouldPreventDefault = onReportingLinesClick(user) === false;
        fireAnalyticsWithDuration((duration)=>(0, $2EPX4.reportingLinesClicked)({
                duration: duration,
                userType: userType
            }));
        if (shouldPreventDefault) return;
        if (href) window.location.href = href;
    };
    const showMoreButtonProps = {
        'aria-label': formatMessage((0, $2L2e5.default).profileCardMoreReportingLinesLabel, {
            count: reports.length - $7ab7f990b9f1d2bd$var$avatarGroupMaxCount + 1
        })
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            manager && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3JKJg.ReportingLinesSection), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                        xcss: [
                            $7ab7f990b9f1d2bd$var$reportingLinesHeadingDefaultStyles,
                            $7ab7f990b9f1d2bd$var$reportingLinesHeadingStyles
                        ],
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $2L2e5.default).managerSectionHeading
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3JKJg.OffsetWrapper), {
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                            onClick: ()=>onReportingLinksClick(manager, 'manager', $7ab7f990b9f1d2bd$var$getProfileHref(manager.accountIdentifier, reportingLinesProfileUrl)),
                            isDisabled: !onReportingLinesClick,
                            xcss: $7ab7f990b9f1d2bd$var$styles.reportingLinesButton,
                            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3JKJg.ManagerSection), {
                                children: [
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
                                        size: "xsmall",
                                        src: manager.pii?.picture
                                    }),
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3JKJg.ManagerName), {
                                        children: manager.pii?.name
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            hasReports && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3JKJg.ReportingLinesSection), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                        xcss: $7ab7f990b9f1d2bd$var$reportingLinesHeadingDefaultStyles,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $2L2e5.default).directReportsSectionHeading
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gqBnP.default), {
                        appearance: "stack",
                        size: "small",
                        data: reports.map((member)=>{
                            return {
                                key: member.accountIdentifier,
                                name: member.pii?.name || '',
                                src: member.pii?.picture,
                                href: $7ab7f990b9f1d2bd$var$getProfileHref(member.accountIdentifier, reportingLinesProfileUrl),
                                onClick: getReportingLinesOnClick(member, 'direct-report')
                            };
                        }),
                        maxCount: $7ab7f990b9f1d2bd$var$avatarGroupMaxCount,
                        testId: "profilecard-reports-avatar-group",
                        showMoreButtonProps: showMoreButtonProps
                    })
                ]
            })
        ]
    });
};
var $7ab7f990b9f1d2bd$export$2e2bcd8739ae039 = $7ab7f990b9f1d2bd$var$ReportingLinesDetails;

});
parcelRegister("3JKJg", function(module, exports) {

$parcel$export(module.exports, "ReportingLinesSection", () => $0c9cf2d6f4667094$export$ae48ddd79a45b949);
$parcel$export(module.exports, "ManagerSection", () => $0c9cf2d6f4667094$export$2992b481dad9fb03);
$parcel$export(module.exports, "ManagerName", () => $0c9cf2d6f4667094$export$98f8ec89e658b052);
$parcel$export(module.exports, "OffsetWrapper", () => $0c9cf2d6f4667094$export$56eae56612ce5f3);
/* ReportingLines.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $0c9cf2d6f4667094$var$styles = {
    reportingLinesSection: "_18u01b66 _19pku2gc",
    managerSection: "_1e0c1txw _4cvr1h6o _18u01b66 _19pk1b66 _otyr1b66 _2hwx1b66",
    managerName: "_11c81o8v _18u0u2gc",
    offsetWrapper: "_19pk1b66 _18u0r5cr"
};
const $0c9cf2d6f4667094$export$ae48ddd79a45b949 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($0c9cf2d6f4667094$var$styles.reportingLinesSection),
        children: children
    });
const $0c9cf2d6f4667094$export$2992b481dad9fb03 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($0c9cf2d6f4667094$var$styles.managerSection),
        children: children
    });
const $0c9cf2d6f4667094$export$98f8ec89e658b052 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($0c9cf2d6f4667094$var$styles.managerName),
        children: children
    });
const $0c9cf2d6f4667094$export$56eae56612ce5f3 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($0c9cf2d6f4667094$var$styles.offsetWrapper),
        children: children
    });

});




parcelRegister("5H2ec", function(module, exports) {

$parcel$export(module.exports, "default", () => $75ec444a04f48b56$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");
const $75ec444a04f48b56$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $eJOHy.useEffect)(()=>{
        fireAnalytics((0, $2EPX4.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
    });
};
var $75ec444a04f48b56$export$2e2bcd8739ae039 = $75ec444a04f48b56$var$UserLoadingState;

});


parcelRegister("39Fdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a556daa2b306b37$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $7m76n = parcelRequire("7m76n");
var $XUWry = parcelRequire("XUWry");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $IW7jS = parcelRequire("IW7jS");

var $gh6xW = parcelRequire("gh6xW");

var $8WJ7D = parcelRequire("8WJ7D");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");


var $bQmsU = parcelRequire("bQmsU");

var $1GAK3 = parcelRequire("1GAK3");

var $5H2ec = parcelRequire("5H2ec");
function $9a556daa2b306b37$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, trigger: trigger, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQmsU.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        trigger: trigger,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1GAK3.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $9a556daa2b306b37$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible, ssrPlaceholderId: ssrPlaceholderId }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isMounted = (0, $eJOHy.useRef)(false);
    const showDelay = trigger === 'click' || propsIsVisible && (0, $eGOwo.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $776ef75d5b01ad48$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' || propsIsVisible && (0, $eGOwo.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $776ef75d5b01ad48$export$89a9f35a94d7f196);
    const showTimer = (0, $eJOHy.useRef)(0);
    const hideTimer = (0, $eJOHy.useRef)(0);
    const [visible, setVisible] = (0, $eJOHy.useState)(false);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(undefined);
    const [hasError, setHasError] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [data, setData] = (0, $eJOHy.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $eJOHy.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $eJOHy.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $eJOHy.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $eJOHy.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eJOHy.useState)(false);
    const triggerRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $eJOHy.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $2EPX4.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $eJOHy.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $eJOHy.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $eJOHy.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $eJOHy.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $eGOwo.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $eJOHy.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $eJOHy.useCallback)(()=>{
        return (0, $gh6xW.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $eJOHy.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    const ssrPlaceholderProp = (0, $eGOwo.fg)('cc_mention_ssr_placeholder') ? {
        'data-ssr-placeholder-replace': ssrPlaceholderId
    } : {};
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $8WJ7D.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        ...ssrPlaceholderProp,
                        children: children
                    });
                },
                zIndex: (0, $IW7jS.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card'),
                shouldDisableFocusLock: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7m76n.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $XUWry.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $9a556daa2b306b37$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5H2ec.default), {
            fireAnalytics: fireAnalytics
        })
    });

});
parcelRegister("8WJ7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a2772a88ae71e4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $95a2772a88ae71e4$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($95a2772a88ae71e4$var$messages.label, {
        fullName: fullName
    }) : formatMessage($95a2772a88ae71e4$var$messages.fallbackLabel);
};
const $95a2772a88ae71e4$var$messages = (0, $7qGN1.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $95a2772a88ae71e4$export$2e2bcd8739ae039 = $95a2772a88ae71e4$var$getLabelMessage;

});

parcelRegister("bQmsU", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $2dca9d01bdb4de20$export$4b013ffffcb40af8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $j19W0 = parcelRequire("j19W0");

var $2EPX4 = parcelRequire("2EPX4");

var $46Rs7 = parcelRequire("46Rs7");

var $dWlMJ = parcelRequire("dWlMJ");

var $kKboJ = parcelRequire("kKboJ");

var $5TZsz = parcelRequire("5TZsz");
const $2dca9d01bdb4de20$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $eJOHy.useState)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireAnalytics = (0, $eJOHy.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $2EPX4.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $eJOHy.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $46Rs7.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const { href: profileHref } = (0, $j19W0.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    const getCreator = (0, $eJOHy.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: (0, $eGOwo.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $eJOHy.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileData = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireAnalytics,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKboJ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dWlMJ.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5TZsz.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        })
    });
};

});
parcelRegister("46Rs7", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $5342ced741c59880$export$3761e66a04602cbd);
const $5342ced741c59880$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $5342ced741c59880$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($5342ced741c59880$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("kKboJ", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $d15bd5f3ea87f8ed$export$2c6604b50c274e6f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $d15bd5f3ea87f8ed$var$styles = (0, $1DXK0.xcss)({
    width: '360px'
});
const $d15bd5f3ea87f8ed$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: $d15bd5f3ea87f8ed$var$styles,
        children: children
    });
};

});

parcelRegister("5TZsz", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $aff86c6979038d17$export$ed0ca9c1d49ea0bf);

var $eJOHy = parcelRequire("eJOHy");

const $aff86c6979038d17$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2XXEr")));

});
parcelRegister("2XXEr", function(module, exports) {

let $228f5cf7f6ecd638$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $228f5cf7f6ecd638$var$load("76n7a"),
    $228f5cf7f6ecd638$var$load("l253H"),
    $228f5cf7f6ecd638$var$load("ffQaD"),
    $228f5cf7f6ecd638$var$load("kvRbA"),
    $228f5cf7f6ecd638$var$load("gsod0")
]).then(()=>parcelRequire('e1nCN'));

});



parcelRegister("1GAK3", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $500dc3728366069c$export$403d297463f226af);

var $eJOHy = parcelRequire("eJOHy");

const $500dc3728366069c$export$403d297463f226af = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>Promise.resolve((parcelRequire("k60Oj"))));

});


parcelRegister("gVW5o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3ae7ede256e7473e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $5DgXR = parcelRequire("5DgXR");

var $gqBnP = parcelRequire("gqBnP");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");
var $5bY40 = parcelRequire("5bY40");

var $aMdh8 = parcelRequire("aMdh8");

var $f58rc = parcelRequire("f58rc");
var $jUgeq = parcelRequire("jUgeq");

var $lXcOw = parcelRequire("lXcOw");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $6djmC = parcelRequire("6djmC");
var $3cMgR = parcelRequire("3cMgR");

var $IW7jS = parcelRequire("IW7jS");

var $k71qx = parcelRequire("k71qx");

var $2L2e5 = parcelRequire("2L2e5");

var $hSR6z = parcelRequire("hSR6z");

var $3CCXY = parcelRequire("3CCXY");

var $6tEph = parcelRequire("6tEph");

var $84DsM = parcelRequire("84DsM");

var $2EPX4 = parcelRequire("2EPX4");

var $g5TmB = parcelRequire("g5TmB");

var $8djnC = parcelRequire("8djnC");

var $2uYZ4 = parcelRequire("2uYZ4");

var $8ZI1l = parcelRequire("8ZI1l");
const $3ae7ede256e7473e$var$LARGE_MEMBER_COUNT = 50;
const $3ae7ede256e7473e$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
const $3ae7ede256e7473e$var$avatarGroupMaxCount = 9;
function $3ae7ede256e7473e$var$onMemberClick(callback, userId, analytics, index, hasHref) {
    return (event)=>{
        analytics((duration)=>(0, $2EPX4.teamAvatarClicked)({
                duration: duration,
                hasHref: hasHref,
                hasOnClick: !!callback,
                index: index
            }));
        if (callback) callback(userId, event);
    };
}
const $3ae7ede256e7473e$var$TeamMembers = ({ analytics: analytics, generateUserLink: generateUserLink, members: members, onUserClick: onUserClick, includingYou: includingYou, isTriggeredByKeyboard: isTriggeredByKeyboard })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const count = members ? members.length : 0;
    const message = includingYou ? count >= $3ae7ede256e7473e$var$LARGE_MEMBER_COUNT ? (0, $2L2e5.default).membersMoreThan50IncludingYou : (0, $2L2e5.default).memberCountIncludingYou : count >= $3ae7ede256e7473e$var$LARGE_MEMBER_COUNT ? (0, $2L2e5.default).membersMoreThan50 : (0, $2L2e5.default).memberCount;
    // Use a ref to track whether this is currently open, so we can fire events
    // iff the more section is being opened (not closed).
    const isMoreMembersOpen = (0, $eJOHy.useRef)(false);
    const avatarRef = (0, $eJOHy.useRef)(null);
    const ref = (element)=>{
        if (isTriggeredByKeyboard) {
            avatarRef.current = element;
            avatarRef.current?.focus();
        }
    };
    const onMoreClick = (0, $eJOHy.useCallback)(()=>{
        const { current: isOpen } = isMoreMembersOpen;
        if (!isOpen) analytics((duration)=>(0, $2EPX4.moreMembersClicked)({
                duration: duration,
                memberCount: count
            }));
        isMoreMembersOpen.current = !isOpen;
    }, [
        analytics,
        count
    ]);
    const showMoreButtonProps = {
        onClick: onMoreClick,
        'aria-label': formatMessage((0, $2L2e5.default).profileCardMoreMembersLabel, {
            count: count - $3ae7ede256e7473e$var$avatarGroupMaxCount + 1
        })
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6tEph.MemberCount), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...message,
                    values: {
                        count: count
                    }
                })
            }),
            members && members.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6tEph.AvatarSection), {
                children: (0, $eGOwo.fg)('enable_team_profilecard_toggletip_a11y_fix') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gqBnP.default), {
                    appearance: "stack",
                    data: members.map((member, index)=>{
                        const href = generateUserLink?.(member.id);
                        const onClick = $3ae7ede256e7473e$var$onMemberClick(onUserClick, member.id, analytics, index, !!generateUserLink);
                        return {
                            key: member.id,
                            name: member.fullName,
                            src: member.avatarUrl,
                            href: href,
                            onClick: onClick
                        };
                    }),
                    maxCount: $3ae7ede256e7473e$var$avatarGroupMaxCount,
                    showMoreButtonProps: showMoreButtonProps,
                    testId: "profilecard-avatar-group",
                    overrides: {
                        Avatar: {
                            render: (Component, props, index)=>index === 0 ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
                                    ref: ref,
                                    ...props,
                                    testId: "first-member"
                                }) : /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                                    ...props
                                })
                        }
                    }
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gqBnP.default), {
                    appearance: "stack",
                    data: members.map((member, index)=>{
                        const href = generateUserLink?.(member.id);
                        const onClick = $3ae7ede256e7473e$var$onMemberClick(onUserClick, member.id, analytics, index, !!generateUserLink);
                        return {
                            key: member.id,
                            name: member.fullName,
                            src: member.avatarUrl,
                            href: href,
                            onClick: onClick
                        };
                    }),
                    maxCount: $3ae7ede256e7473e$var$avatarGroupMaxCount,
                    showMoreButtonProps: showMoreButtonProps,
                    testId: "profilecard-avatar-group"
                })
            })
        ]
    });
};
function $3ae7ede256e7473e$var$onActionClick(action, analytics, index) {
    return (event, ...args)=>{
        analytics((duration)=>(0, $2EPX4.actionClicked)('team', {
                duration: duration,
                hasHref: !!action.link,
                hasOnClick: !!action.callback,
                index: index,
                actionId: action.id || ''
            }));
        if (action.callback && (0, $g5TmB.isBasicClick)(event)) {
            event.preventDefault();
            action.callback(event, ...args);
        }
    };
}
const $3ae7ede256e7473e$var$ActionButton = ({ action: action, analytics: analytics, index: index })=>{
    const isGiveKudosActionButton = action.id === $3ae7ede256e7473e$var$GIVE_KUDOS_ACTION_ID;
    const actionButton = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $5bY40.default), {
        onClick: $3ae7ede256e7473e$var$onActionClick(action, analytics, index),
        href: action.link || '',
        shouldFitContainer: true,
        children: [
            action.label,
            isGiveKudosActionButton && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.AnimationWrapper), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.KudosBlobAnimation), {})
            })
        ]
    }, action.id || index);
    if (isGiveKudosActionButton) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSR6z.AnimatedKudosButton), {
        children: actionButton
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6tEph.WrappedButton), {
        children: actionButton
    });
};
const $3ae7ede256e7473e$var$ExtraActions = ({ actions: actions, analytics: analytics })=>{
    const [isOpen, setOpen] = (0, $eJOHy.useState)(false);
    const count = actions.length;
    const onMoreClick = (0, $eJOHy.useCallback)((shouldBeOpen)=>{
        if (shouldBeOpen) // Only fire this event when OPENING the dropdown
        analytics((duration)=>(0, $2EPX4.moreActionsClicked)('team', {
                duration: duration,
                numActions: count + 2
            }));
        setOpen(shouldBeOpen);
    }, [
        analytics,
        count
    ]);
    if (!count) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6tEph.MoreButton), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
            isOpen: isOpen,
            onClose: ()=>setOpen(false),
            placement: "bottom-start",
            content: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jUgeq.default), {
                    children: actions.map((action, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $f58rc.default), {
                            onClick: $3ae7ede256e7473e$var$onActionClick(action, analytics, index + 2),
                            href: action.link,
                            children: action.label
                        }, action.id || index))
                }),
            trigger: (triggerProps)=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    testId: "more-actions-button",
                    ...triggerProps,
                    isSelected: isOpen,
                    onClick: ()=>onMoreClick(!isOpen),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))),
                    label: "actions"
                });
            },
            zIndex: (0, $IW7jS.layers).modal(),
            shouldRenderToParent: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card')
        })
    });
};
const $3ae7ede256e7473e$var$ButtonSection = ({ actions: actions, analytics: analytics })=>{
    if (!actions) return null;
    const extraActions = actions.slice(2);
    const initialActions = actions.slice(0, 2);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6tEph.ActionButtons), {
        children: [
            initialActions.map((action, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)($3ae7ede256e7473e$var$ActionButton, {
                    action: action,
                    analytics: analytics,
                    index: index
                }, index)),
            extraActions && /*#__PURE__*/ (0, $gt9Am.jsx)($3ae7ede256e7473e$var$ExtraActions, {
                actions: extraActions,
                analytics: analytics
            })
        ]
    });
};
const $3ae7ede256e7473e$var$TeamProfilecardContent = ({ actions: actions, analytics: analytics, team: team, viewingUserId: viewingUserId, generateUserLink: generateUserLink, onUserClick: onUserClick, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick, isTriggeredByKeyboard: isTriggeredByKeyboard })=>{
    const allActions = [
        {
            label: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $2L2e5.default).teamViewProfile
            }),
            link: viewProfileLink,
            callback: viewProfileOnClick,
            id: 'view-profile'
        },
        ...actions || []
    ];
    const includingYou = team.members && team.members.some((member)=>member.id === viewingUserId);
    (0, $eJOHy.useEffect)(()=>{
        analytics((duration)=>(0, $2EPX4.profileCardRendered)('team', 'content', {
                duration: duration,
                numActions: allActions.length,
                memberCount: team.members?.length,
                includingYou: includingYou,
                descriptionLength: team.description.length,
                titleLength: team.displayName.length
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $84DsM.CardWrapper), {
        testId: "team-profilecard",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84DsM.CardHeader), {
                image: team.largeHeaderImageUrl || team.smallHeaderImageUrl,
                label: team.displayName
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $84DsM.CardContent), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                        content: team.displayName,
                        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6tEph.TeamName), {
                                    children: team.displayName
                                }),
                                team.isVerified && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lXcOw.VerifiedTeamIcon), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)($3ae7ede256e7473e$var$TeamMembers, {
                        analytics: analytics,
                        members: team.members,
                        generateUserLink: generateUserLink,
                        includingYou: includingYou,
                        onUserClick: onUserClick,
                        isTriggeredByKeyboard: isTriggeredByKeyboard
                    }),
                    team.description.trim() && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6tEph.DescriptionWrapper), {
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6tEph.Description), {
                            children: team.description
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)($3ae7ede256e7473e$var$ButtonSection, {
                        actions: allActions,
                        analytics: analytics
                    })
                ]
            })
        ]
    });
};
const $3ae7ede256e7473e$var$ErrorMessage = ({ analytics: analytics, clientFetchProfile: clientFetchProfile, isLoading: isLoading })=>{
    const hasRetry = !!clientFetchProfile;
    (0, $eJOHy.useEffect)(()=>{
        analytics((duration)=>(0, $2EPX4.profileCardRendered)('team', 'error', {
                duration: duration,
                hasRetry: hasRetry
            }));
    }, [
        analytics,
        hasRetry
    ]);
    const retry = (0, $eJOHy.useCallback)(()=>{
        analytics((duration)=>(0, $2EPX4.errorRetryClicked)({
                duration: duration
            }));
        if (clientFetchProfile) clientFetchProfile();
    }, [
        analytics,
        clientFetchProfile
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CCXY.ErrorWrapper), {
        testId: "team-profilecard-error",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8djnC.ErrorIllustration), {}),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                as: "p",
                weight: "semibold",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $2L2e5.default).teamErrorTitle
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3CCXY.TeamErrorText), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $2L2e5.default).teamErrorText
                })
            }),
            clientFetchProfile && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6tEph.ActionButtons), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6tEph.WrappedButton), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                        testId: "client-fetch-profile-button",
                        shouldFitContainer: true,
                        onClick: retry,
                        isLoading: isLoading,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $2L2e5.default).teamErrorButton
                        })
                    })
                })
            })
        ]
    });
};
const $3ae7ede256e7473e$var$TeamProfileCard = (props)=>{
    const { analytics: analytics, clientFetchProfile: clientFetchProfile, hasError: hasError, isLoading: isLoading, team: team, errorType: errorType } = props;
    if (hasError) {
        if (errorType?.reason === 'TEAMS_FORBIDDEN') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2uYZ4.default), {
            analytics: analytics
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84DsM.CardWrapper), {
            testId: "team-profilecard",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($3ae7ede256e7473e$var$ErrorMessage, {
                analytics: analytics,
                clientFetchProfile: clientFetchProfile,
                isLoading: isLoading
            })
        });
    }
    if (isLoading) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ZI1l.default), {
        analytics: analytics
    });
    if (team) return /*#__PURE__*/ (0, $gt9Am.jsx)($3ae7ede256e7473e$var$TeamProfilecardContent, {
        ...props,
        team: team
    });
    return null;
};
var $3ae7ede256e7473e$export$2e2bcd8739ae039 = $3ae7ede256e7473e$var$TeamProfileCard;

});
parcelRegister("6tEph", function(module, exports) {

$parcel$export(module.exports, "TeamForbiddenErrorStateWrapper", () => $152d685fc9163978$export$66ecf3d3b7b1c016);
$parcel$export(module.exports, "TeamName", () => $152d685fc9163978$export$8fe6f0aed18a58c7);
$parcel$export(module.exports, "MemberCount", () => $152d685fc9163978$export$1cbd03a20253b620);
$parcel$export(module.exports, "AvatarSection", () => $152d685fc9163978$export$82a6f3ee677bdbfe);
$parcel$export(module.exports, "DescriptionWrapper", () => $152d685fc9163978$export$2bf1f2b0d31b60fc);
$parcel$export(module.exports, "Description", () => $152d685fc9163978$export$393edc798c47379d);
$parcel$export(module.exports, "ActionButtons", () => $152d685fc9163978$export$88c65d2d98aab183);
$parcel$export(module.exports, "WrappedButton", () => $152d685fc9163978$export$44e087c32db6077d);
$parcel$export(module.exports, "MoreButton", () => $152d685fc9163978$export$7f94856880993f27);
$parcel$export(module.exports, "AccessLockSVGWrapper", () => $152d685fc9163978$export$71bcd744fda975e5);
/* TeamCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $806LH = parcelRequire("806LH");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");
const $152d685fc9163978$var$styles = {
    teamforbiddenerrorstatewrapper: "_1bsbnklw _kqswh2mm",
    teamname: "_11c8lodh _1reo15vq _18m915vq _1p1dglyw _c71lckbl _1e0ccj1k",
    membercount: "_syaz1wmz _19pk1b66",
    avatarsection: "_19pkpxbi _18u01i6y",
    descriptionwrapper: "_19pkpxbi _4cvr1h6o _1e0c1txw",
    description: "_1reo15vq _18m915vq _c71l1wqb _1e0ccj1k",
    actionbuttons: "_1bsb1osq _1e0c1txw _1bah1yb4 _19pk1ejb _2hwx10v4 _otyridpf _18u0x0bf",
    wrappedbutton: "_i0dlidpf _16jlkb7n _18u0u2gc",
    morebutton: "_18u0u2gc",
    accesslocksvgwrapper: "_otyr1ejb"
};
const $152d685fc9163978$export$66ecf3d3b7b1c016 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($152d685fc9163978$var$styles.teamforbiddenerrorstatewrapper),
        ...props
    });
const $152d685fc9163978$export$8fe6f0aed18a58c7 = (props)=>(0, $eGOwo.fg)('enable_profilecard_h2tag_a11y_fix') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($152d685fc9163978$var$styles.teamname),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
            size: "medium",
            as: "h2",
            children: props.children
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($152d685fc9163978$var$styles.teamname),
        ...props
    });
const $152d685fc9163978$export$1cbd03a20253b620 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($152d685fc9163978$var$styles.membercount),
        ...props
    });
const $152d685fc9163978$export$82a6f3ee677bdbfe = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($152d685fc9163978$var$styles.avatarsection),
        ...props
    });
const $152d685fc9163978$export$2bf1f2b0d31b60fc = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($152d685fc9163978$var$styles.descriptionwrapper),
        ...props
    });
const $152d685fc9163978$export$393edc798c47379d = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($152d685fc9163978$var$styles.description),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
            maxLines: 3,
            ...props
        })
    });
const $152d685fc9163978$export$88c65d2d98aab183 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($152d685fc9163978$var$styles.actionbuttons),
        backgroundColor: "elevation.surface.overlay",
        ...props
    });
const $152d685fc9163978$export$44e087c32db6077d = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($152d685fc9163978$var$styles.wrappedbutton),
        ...props
    });
const $152d685fc9163978$export$7f94856880993f27 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($152d685fc9163978$var$styles.morebutton),
        ...props
    });
const $152d685fc9163978$export$71bcd744fda975e5 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($152d685fc9163978$var$styles.accesslocksvgwrapper),
        ...props
    });

});

parcelRegister("84DsM", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $a368743025da7b9f$export$6aa22a823032b784);
$parcel$export(module.exports, "CardHeader", () => $a368743025da7b9f$export$5665775b26e26c5d);
$parcel$export(module.exports, "CardContent", () => $a368743025da7b9f$export$64ef9b8c11710c47);
$parcel$export(module.exports, "LoadingWrapper", () => $a368743025da7b9f$export$43a792a870d28db2);
/* TeamTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");

var $gVqtd = parcelRequire("gVqtd");
const $a368743025da7b9f$var$styles = {
    cardtriggerwrapper: "_1e0c1kw7",
    cardwrapper: "_2rkoglpi _1bsbnklw _kqswh2mm",
    cardheader: "_4t3i1qr7 _1bsb1osq",
    cardcontent: "_1e0c1txw _2lx21bp4 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1tke1l8a",
    loadingwrapper: "_y3gn1h6o _19pk1jfw _otyr1jfw"
};
const $a368743025da7b9f$export$a443be8291b92497 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.cardtriggerwrapper)
    });
const $a368743025da7b9f$export$6aa22a823032b784 = ({ testId: testId, children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.cardwrapper),
        backgroundColor: "elevation.surface.overlay",
        testId: testId,
        children: children
    });
const $a368743025da7b9f$export$5665775b26e26c5d = ({ image: image, isLoading: isLoading, label: label })=>isLoading || !image ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.cardheader),
        backgroundColor: "color.background.neutral"
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gVqtd.CoverImage), {
        alt: label || '',
        src: image
    });
const $a368743025da7b9f$export$64ef9b8c11710c47 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.cardcontent),
        ...props
    });
const $a368743025da7b9f$export$43a792a870d28db2 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.loadingwrapper),
        ...props
    });

});
parcelRegister("gVqtd", function(module, exports) {

$parcel$export(module.exports, "CoverImage", () => $2e76209cd6ae11d8$export$a65e282337ff0f53);
/* CoverImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $2e76209cd6ae11d8$var$styles = {
    container: "_1reo15vq _18m915vq _1bsb1osq _4t3i1qr7 _kqswh2mm _13liglpi _qrwqglpi _1e0c1txw _1bah1h6o _4cvr1h6o",
    image: "_1bsbnklw _4t3i1wug"
};
const $2e76209cd6ae11d8$export$a65e282337ff0f53 = ({ src: src, alt: alt = '' })=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const imgRef = (0, $eJOHy.useRef)(null);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        ref: containerRef,
        xcss: $2e76209cd6ae11d8$var$styles.container,
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            as: "img",
            ref: imgRef,
            src: src,
            alt: alt,
            xcss: $2e76209cd6ae11d8$var$styles.image
        })
    });
};

});


parcelRegister("8djnC", function(module, exports) {

$parcel$export(module.exports, "ErrorIllustration", () => $77bea060b54b8733$export$e0319f52fc2380b1);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $77bea060b54b8733$export$e0319f52fc2380b1 = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "42",
        height: "53",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M0.649902 0H163.93V212H0.649902V0Z",
                        fill: "var(--ds-surface-overlay, white)",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
                        fill: "url(#paint0_linear)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                        opacity: "0.6",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                opacity: "0.6",
                                d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
                                fill: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                opacity: "0.6",
                                d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
                                fill: "#C1C7D0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                            opacity: "0.6",
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                opacity: "0.6",
                                d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
                                fill: "#B3BAC5"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
                            fill: "#B3BAC5"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
                            fill: "#B3BAC5"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint0_linear",
                        x1: "26.1692",
                        y1: "228.621",
                        x2: "138.408",
                        y2: "116.382",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.297",
                                stopColor: "#C6CBD4",
                                stopOpacity: "0.8812"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6301",
                                stopColor: "#D3D7DE",
                                stopOpacity: "0.748"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9795",
                                stopColor: "#E9EBEF",
                                stopOpacity: "0.6082"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#EBECF0",
                                stopOpacity: "0.6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            d: "M0.649902 0H163.93V212H0.649902V0Z",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("2uYZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1a04f00525dfc56$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6MnLl = parcelRequire("6MnLl");

var $2L2e5 = parcelRequire("2L2e5");

var $6tEph = parcelRequire("6tEph");

var $2EPX4 = parcelRequire("2EPX4");

var $8emkh = parcelRequire("8emkh");
var $d1a04f00525dfc56$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics } = props;
    const intl = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        analytics((duration)=>(0, $2EPX4.profileCardRendered)('team', 'error', {
                duration: duration
            }));
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6tEph.TeamForbiddenErrorStateWrapper), {
        testId: "team-profilecard-forbidden-error-state",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6MnLl.default), {
            header: intl.formatMessage((0, $2L2e5.default).teamForbiddenErrorStateTitle),
            description: intl.formatMessage((0, $2L2e5.default).teamForbiddenErrorStateDescription),
            renderImage: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6tEph.AccessLockSVGWrapper), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8emkh.default), {})
                })
        })
    });
};

});
parcelRegister("8emkh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e8c84b91b091fb7$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $4e8c84b91b091fb7$var$AccessLockSVG = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "191",
        height: "222",
        viewBox: "0 0 191 222",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M0 0.400391H190.2V221.9H0V0.400391Z",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M122.7 119.9H49.4V36.9998C49.8906 27.6107 53.9659 18.7679 60.7854 12.2956C67.6048 5.82318 76.6481 2.21484 86.05 2.21484C95.4519 2.21484 104.495 5.82318 111.315 12.2956C118.134 18.7679 122.209 27.6107 122.7 36.9998V119.9ZM61.4 107.9H110.7V36.9998C110.301 30.7336 107.53 24.8546 102.951 20.5583C98.3722 16.2619 92.3289 13.8706 86.05 13.8706C79.7711 13.8706 73.7279 16.2619 69.149 20.5583C64.5701 24.8546 61.7993 30.7336 61.4 36.9998V107.9Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H19.1C18.348 59.2976 17.605 59.4639 16.9262 59.7874C16.2474 60.111 15.6503 60.5834 15.1794 61.1697C14.7085 61.7559 14.3758 62.4408 14.2063 63.1734C14.0367 63.906 14.0346 64.6675 14.2 65.401C17.9782 81.0252 15.9154 97.4916 8.4 111.701C2.5112 123.071 -0.389112 135.752 -0.0282299 148.551C0.332652 161.351 3.94288 173.848 10.463 184.868C16.9831 195.888 26.1988 205.069 37.2436 211.548C48.2884 218.026 60.7993 221.589 73.6 221.901H91.5C101.565 222.141 111.577 220.365 120.946 216.679C130.315 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601Z",
                        fill: "#FF991F"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H36.9C36.154 59.3157 35.4203 59.494 34.7507 59.8232C34.0812 60.1523 33.492 60.6244 33.0247 61.2061C32.5574 61.7878 32.2235 62.4649 32.0464 63.1897C31.8694 63.9146 31.8535 64.6694 32 65.401C35.8087 81.0131 33.7816 97.4789 26.3 111.701C20.3828 123.006 17.4891 135.648 17.9 148.401C18.9 188.401 51.5 220.901 91.5 221.901C101.565 222.141 111.577 220.365 120.946 216.679C130.314 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501Z",
                        fill: "#FFAB00"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.4001 214H91.7001C80.2465 213.718 69.0525 210.53 59.1692 204.735C49.2859 198.939 41.0377 190.727 35.1991 180.87C29.3605 171.012 26.1231 159.832 25.7909 148.38C25.4587 136.928 28.0426 125.579 33.3001 115.4C41.036 100.558 43.5711 83.5517 40.5001 67.0996H146.2C143.017 83.4736 145.522 100.444 153.3 115.2C158.352 124.82 160.962 135.534 160.9 146.4C160.926 155.276 159.199 164.07 155.818 172.277C152.436 180.484 147.467 187.942 141.195 194.223C134.923 200.505 127.472 205.485 119.27 208.879C111.068 212.273 102.276 214.013 93.4001 214Z",
                        fill: "#FFC400"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        style: {
                            mixBlendMode: 'multiply'
                        },
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            d: "M152.8 178.6L84.5 119.6L80.8 123.9L149.9 183.5L152.8 178.6Z",
                            fill: "#FFE380"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M90.4 170.601C88.3452 170.598 86.3155 170.15 84.4509 169.287C82.5862 168.424 80.9312 167.166 79.5999 165.601C78.2601 164.053 77.2786 162.229 76.7254 160.259C76.1722 158.288 76.0611 156.219 76.4 154.201L78.3 141.601C75.4643 138.69 73.5294 135.023 72.7277 131.039C71.926 127.055 72.2917 122.925 73.7808 119.144C75.2699 115.363 77.8191 112.093 81.122 109.726C84.4249 107.359 88.3411 105.996 92.4 105.801H93.4C98.996 105.801 104.363 108.024 108.32 111.981C112.277 115.938 114.5 121.305 114.5 126.901C114.496 132.416 112.302 137.703 108.4 141.601L110.4 154.201C110.692 156.226 110.548 158.291 109.979 160.257C109.41 162.222 108.428 164.044 107.1 165.601C105.769 167.166 104.114 168.424 102.249 169.287C100.384 170.15 98.3547 170.598 96.3 170.601H90.4Z",
                        fill: "#FFAB00"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M106.6 126.9C106.586 128.711 106.196 130.499 105.456 132.151C104.716 133.803 103.641 135.284 102.3 136.5C101.574 137.222 101.032 138.107 100.719 139.081C100.405 140.056 100.33 141.091 100.5 142.1L102.6 155.4C102.728 156.305 102.662 157.226 102.405 158.103C102.147 158.979 101.706 159.79 101.109 160.482C100.512 161.173 99.7741 161.729 98.9446 162.112C98.1152 162.494 97.2134 162.695 96.3 162.7H90.4C89.4866 162.695 88.5848 162.494 87.7554 162.112C86.926 161.729 86.188 161.173 85.5912 160.482C84.9944 159.79 84.5526 158.979 84.2954 158.103C84.0382 157.226 83.9715 156.305 84.1 155.4L86.2 142C86.3747 140.983 86.2925 139.937 85.9607 138.959C85.6289 137.981 85.058 137.102 84.3 136.4C82.8962 135.116 81.7988 133.532 81.0892 131.767C80.3795 130.001 80.0756 128.099 80.2 126.2C80.2928 122.699 81.7726 119.379 84.3137 116.969C86.8548 114.559 90.2492 113.258 93.75 113.35C97.2509 113.443 100.571 114.923 102.981 117.464C105.391 120.005 106.693 123.399 106.6 126.9Z",
                        fill: "#253858"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M149.2 130.901H93.4C92.8286 130.992 92.2443 130.959 91.6872 130.802C91.1302 130.645 90.6138 130.37 90.1736 129.994C89.7334 129.619 89.3799 129.152 89.1375 128.627C88.8951 128.102 88.7695 127.53 88.7695 126.951C88.7695 126.373 88.8951 125.801 89.1375 125.275C89.3799 124.75 89.7334 124.284 90.1736 123.908C90.6138 123.532 91.1302 123.257 91.6872 123.1C92.2443 122.944 92.8286 122.91 93.4 123.001H149.2C150.14 123.151 150.995 123.631 151.613 124.355C152.23 125.079 152.57 126 152.57 126.951C152.57 127.903 152.23 128.823 151.613 129.547C150.995 130.271 150.14 130.751 149.2 130.901Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M153.1 126.901C153.075 125.875 152.656 124.897 151.93 124.172C151.204 123.446 150.226 123.027 149.2 123.001H112.4C111.829 122.91 111.244 122.944 110.687 123.1C110.13 123.257 109.614 123.532 109.174 123.908C108.733 124.284 108.38 124.75 108.137 125.275C107.895 125.801 107.77 126.373 107.77 126.951C107.77 127.53 107.895 128.102 108.137 128.627C108.38 129.152 108.733 129.619 109.174 129.994C109.614 130.37 110.13 130.645 110.687 130.802C111.244 130.959 111.829 130.992 112.4 130.901H149.2C150.243 130.875 151.235 130.442 151.964 129.695C152.693 128.947 153.1 127.945 153.1 126.901Z",
                        fill: "#2684FF"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M167.7 149.4C163.25 149.4 158.9 148.081 155.2 145.608C151.5 143.136 148.616 139.622 146.913 135.511C145.21 131.399 144.764 126.875 145.632 122.511C146.5 118.146 148.643 114.137 151.79 110.99C154.937 107.844 158.946 105.701 163.31 104.833C167.675 103.965 172.199 104.41 176.31 106.113C180.422 107.816 183.936 110.7 186.408 114.4C188.88 118.1 190.2 122.45 190.2 126.9C190.2 132.868 187.829 138.591 183.61 142.81C179.39 147.03 173.667 149.4 167.7 149.4ZM167.7 112.3C164.812 112.3 161.99 113.157 159.589 114.761C157.188 116.365 155.316 118.645 154.211 121.313C153.106 123.981 152.817 126.917 153.381 129.749C153.944 132.581 155.334 135.182 157.376 137.224C159.418 139.266 162.02 140.657 164.852 141.22C167.684 141.783 170.619 141.494 173.287 140.389C175.955 139.284 178.235 137.413 179.839 135.012C181.444 132.611 182.3 129.788 182.3 126.9C182.274 123.036 180.727 119.338 177.995 116.606C175.262 113.873 171.564 112.327 167.7 112.3Z",
                        fill: "#2684FF"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M67.8 165.301H55.6C55.3423 165.278 55.1009 165.166 54.918 164.983C54.7351 164.8 54.6225 164.558 54.6 164.301C54.6 164.036 54.7053 163.781 54.8929 163.594C55.0804 163.406 55.3348 163.301 55.6 163.301H67.8C68.0652 163.301 68.3196 163.406 68.5071 163.594C68.6946 163.781 68.8 164.036 68.8 164.301C68.7775 164.558 68.6649 164.8 68.482 164.983C68.2991 165.166 68.0576 165.278 67.8 165.301Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M62.7999 182.5C62.6675 182.512 62.5342 182.491 62.412 182.438C62.2897 182.386 62.1825 182.304 62.0999 182.2C61.9167 182.013 61.8141 181.761 61.8141 181.5C61.8141 181.238 61.9167 180.987 62.0999 180.8L70.4999 172.3C70.6925 172.155 70.9307 172.085 71.1708 172.102C71.4109 172.119 71.6368 172.222 71.807 172.393C71.9773 172.563 72.0804 172.789 72.0974 173.029C72.1145 173.269 72.0444 173.507 71.8999 173.7L63.4999 182.2C63.3098 182.38 63.0616 182.486 62.7999 182.5Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M79.9 189.6C79.6424 189.577 79.4009 189.464 79.218 189.282C79.0351 189.099 78.9226 188.857 78.9 188.6V175.6C78.9226 175.342 79.0351 175.1 79.218 174.918C79.4009 174.735 79.6424 174.622 79.9 174.6C80.1652 174.6 80.4196 174.705 80.6071 174.893C80.7947 175.08 80.9 175.334 80.9 175.6V188.6C80.9 188.865 80.7947 189.119 80.6071 189.307C80.4196 189.494 80.1652 189.6 79.9 189.6Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M128.8 111.301H116.7C116.565 111.317 116.428 111.302 116.299 111.257C116.17 111.213 116.054 111.14 115.957 111.043C115.861 110.947 115.788 110.83 115.743 110.702C115.699 110.573 115.684 110.436 115.7 110.301C115.7 110.036 115.805 109.781 115.993 109.594C116.18 109.406 116.435 109.301 116.7 109.301H128.8C129.065 109.301 129.32 109.406 129.507 109.594C129.695 109.781 129.8 110.036 129.8 110.301C129.816 110.436 129.801 110.573 129.757 110.702C129.712 110.83 129.639 110.947 129.543 111.043C129.446 111.14 129.33 111.213 129.201 111.257C129.072 111.302 128.935 111.317 128.8 111.301Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M113.2 102.601C112.938 102.587 112.69 102.481 112.5 102.301C112.317 102.114 112.214 101.863 112.214 101.601C112.214 101.339 112.317 101.088 112.5 100.901L121 92.5008C121.193 92.3563 121.431 92.2862 121.671 92.3033C121.911 92.3204 122.137 92.4235 122.307 92.5937C122.477 92.7639 122.58 92.9898 122.597 93.2299C122.615 93.47 122.544 93.7082 122.4 93.9008L113.9 102.301C113.812 102.399 113.704 102.477 113.583 102.528C113.462 102.58 113.331 102.605 113.2 102.601Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M104.5 100C104.235 100 103.98 99.8947 103.793 99.7072C103.605 99.5196 103.5 99.2653 103.5 99.0001V86.1C103.5 85.8348 103.605 85.5805 103.793 85.3929C103.98 85.2054 104.235 85.1 104.5 85.1C104.635 85.084 104.772 85.0988 104.901 85.1433C105.03 85.1879 105.146 85.2611 105.243 85.3574C105.339 85.4536 105.412 85.5705 105.457 85.6991C105.501 85.8278 105.516 85.9649 105.5 86.1V99.0001C105.516 99.1352 105.501 99.2723 105.457 99.401C105.412 99.5296 105.339 99.6465 105.243 99.7428C105.146 99.839 105.03 99.9122 104.901 99.9568C104.772 100.001 104.635 100.016 104.5 100Z",
                        fill: "#FFFAE5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("defs", {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M0 0.400391H190.2V221.9H0V0.400391Z",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var $4e8c84b91b091fb7$export$2e2bcd8739ae039 = $4e8c84b91b091fb7$var$AccessLockSVG;

});


parcelRegister("8ZI1l", function(module, exports) {

$parcel$export(module.exports, "default", () => $46bb11efbe40b76f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");

var $84DsM = parcelRequire("84DsM");

var $2EPX4 = parcelRequire("2EPX4");
var $46bb11efbe40b76f$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics } = props;
    (0, $eJOHy.useEffect)(()=>{
        analytics((duration)=>(0, $2EPX4.profileCardRendered)('team', 'spinner', {
                duration: duration
            }));
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $84DsM.CardWrapper), {
        testId: "team-profilecard",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84DsM.CardHeader), {
                isLoading: true
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84DsM.CardContent), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84DsM.LoadingWrapper), {
                    testId: "team-profilecard-spinner",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
                })
            })
        ]
    });
};

});


parcelRegister("gt9J0", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardTrigger", () => $758186bad753e133$export$64983741fea6a45d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $j19W0 = parcelRequire("j19W0");

var $2EPX4 = parcelRequire("2EPX4");

var $46Rs7 = parcelRequire("46Rs7");

var $i1LXi = parcelRequire("i1LXi");

var $5TZsz = parcelRequire("5TZsz");
const $758186bad753e133$export$64983741fea6a45d = ({ trigger: trigger = 'hover', viewingUserId: viewingUserId, product: product, ...props })=>{
    const { resourceClient: resourceClient, agentId: userId, cloudId: cloudId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireAnalytics = (0, $eJOHy.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $2EPX4.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const getCreator = async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'FORGE':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                const userId = (0, $46Rs7.getAAIDFromARI)(creator) || '';
                try {
                    if (!userId || !cloudId) return undefined;
                    const { href: profileHref } = (0, $j19W0.navigateToTeamsApp)({
                        type: 'USER',
                        payload: {
                            userId: userId
                        },
                        cloudId: cloudId
                    });
                    const creatorInfo = await props.resourceClient.getProfile(cloudId, userId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: (0, $eGOwo.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${userId}`,
                        id: userId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    };
    const fetchAgentProfile = async ()=>{
        const agentInfo = await resourceClient.getRovoAgentProfile({
            type: 'agent',
            value: userId
        }, fireAnalytics);
        const agentCreatorInfo = await getCreator(agentInfo.creator_type, agentInfo.creator || undefined);
        return {
            ...agentInfo,
            creatorInfo: agentCreatorInfo
        };
    };
    const renderProfileCard = ({ profileData: profileData, error: error })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5TZsz.AgentProfileCardLazy), {
                agent: profileData,
                hasError: !!error,
                cloudId: props.cloudId,
                errorType: error,
                onChatClick: props.onChatClick,
                onConversationStartersClick: props.onConversationStartersClick,
                resourceClient: props.resourceClient,
                addFlag: props.addFlag
            })
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i1LXi.default), {
        ...props,
        trigger: "hover",
        renderProfileCard: renderProfileCard,
        fetchProfile: fetchAgentProfile,
        fireAnalytics: fireAnalytics,
        profileCardType: "agent"
    });
};

});
parcelRegister("i1LXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c39059745cd896c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kJsb4 = parcelRequire("kJsb4");

var $IW7jS = parcelRequire("IW7jS");

var $2EPX4 = parcelRequire("2EPX4");

var $lTC8G = parcelRequire("lTC8G");

var $ipkSN = parcelRequire("ipkSN");

var $dbca5 = parcelRequire("dbca5");

var $cDswp = parcelRequire("cDswp");
const $0c39059745cd896c$var$DELAY_MS_SHOW = 800;
const $0c39059745cd896c$var$DELAY_MS_HIDE = 200;
function $0c39059745cd896c$var$ProfileCardTrigger({ trigger: trigger, ariaLabelledBy: ariaLabelledBy, children: children, renderProfileCard: renderProfileCard, fetchProfile: fetchProfile, disabledAriaAttributes: disabledAriaAttributes, profileCardType: profileCardType, fireAnalytics: fireAnalytics, ...popupProps }) {
    const showDelay = trigger === 'click' ? 0 : $0c39059745cd896c$var$DELAY_MS_SHOW;
    const hideDelay = trigger === 'click' ? 0 : $0c39059745cd896c$var$DELAY_MS_HIDE;
    const showTimer = (0, $eJOHy.useRef)(0);
    const hideTimer = (0, $eJOHy.useRef)(0);
    const [visible, setVisible] = (0, $eJOHy.useState)(false);
    const { profileData: profileData, isLoading: isLoading, error: error, getProfileData: getProfileData } = (0, $lTC8G.useProfileInfo)({
        fetchUserProfile: fetchProfile
    });
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    const hideProfilecard = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
        }, hideDelay);
    }, [
        hideDelay
    ]);
    const showProfilecard = (0, $eJOHy.useCallback)(async ()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                getProfileData?.();
                setVisible(true);
                if (fireAnalytics) fireAnalytics((0, $2EPX4.cardTriggered)(profileCardType, trigger));
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        getProfileData,
        fireAnalytics,
        profileCardType,
        trigger
    ]);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
        ...popupProps,
        isOpen: !!visible,
        onClose: hideProfilecard,
        shouldUseCaptureOnOutsideClick: true,
        autoFocus: popupProps.autoFocus ?? trigger === 'click',
        zIndex: (0, $IW7jS.layers).modal(),
        shouldFitContainer: false,
        trigger: (triggerProps)=>{
            const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = triggerProps;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dbca5.PopupTrigger), {
                ...disabledAriaAttributes ? restInnerProps : triggerProps,
                ref: triggerProps.ref,
                hideProfilecard: hideProfilecard,
                showProfilecard: showProfilecard,
                children: children,
                ariaLabelledBy: ariaLabelledBy,
                trigger: trigger
            });
        },
        content: ()=>// eslint-disable-next-line jsx-a11y/no-static-element-interactions
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onFocus: showProfilecard,
                children: isLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cDswp.ProfileCardWrapper), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ipkSN.LoadingState), {
                        fireAnalytics: fireAnalytics,
                        profileType: profileCardType
                    })
                }) : renderProfileCard({
                    profileData: profileData,
                    error: error
                })
            })
    });
}
var $0c39059745cd896c$export$2e2bcd8739ae039 = $0c39059745cd896c$var$ProfileCardTrigger;

});
parcelRegister("lTC8G", function(module, exports) {

$parcel$export(module.exports, "useProfileInfo", () => $9dfb19bc72613412$export$6cace87f7d7a9738);

var $eJOHy = parcelRequire("eJOHy");
const $9dfb19bc72613412$export$6cace87f7d7a9738 = ({ fetchUserProfile: fetchUserProfile })=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [profileData, setProfileData] = (0, $eJOHy.useState)();
    const getProfileData = async ()=>{
        setIsLoading(true);
        try {
            const profileData = await fetchUserProfile?.();
            setProfileData(profileData);
            setIsLoading(false);
        } catch (error) {
            setError(error);
            setIsLoading(false);
        }
    };
    return {
        profileData: profileData,
        isLoading: isLoading,
        error: error,
        getProfileData: getProfileData
    };
};

});

parcelRegister("ipkSN", function(module, exports) {

$parcel$export(module.exports, "LoadingState", () => $d786fc7d1a693149$export$62aa48085237e36f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");
const $d786fc7d1a693149$export$62aa48085237e36f = ({ fireAnalytics: fireAnalytics, profileType: profileType })=>{
    (0, $eJOHy.useEffect)(()=>{
        if (fireAnalytics) fireAnalytics((0, $2EPX4.profileCardRendered)(profileType, 'spinner'));
    }, [
        fireAnalytics,
        profileType
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
    });
};

});

parcelRegister("dbca5", function(module, exports) {

$parcel$export(module.exports, "PopupTrigger", () => $0e39a5545a71219d$export$95d4acdbab2fc6ef);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $0e39a5545a71219d$var$PopupTriggerInner = ({ children: children, trigger: trigger, showProfilecard: showProfilecard, hideProfilecard: hideProfilecard, ariaLabelledBy: ariaLabelledBy, ...props }, ref)=>{
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const onKeyPress = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            showProfilecard();
        }
    }, [
        showProfilecard
    ]);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        // Prevent the click event from propagating to parent containers.
        event.stopPropagation();
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const containerListeners = (0, $eJOHy.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        ...containerListeners,
        ref: ref,
        "aria-labelledby": ariaLabelledBy,
        children: children
    });
};
const $0e39a5545a71219d$export$95d4acdbab2fc6ef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef($0e39a5545a71219d$var$PopupTriggerInner);

});

parcelRegister("cDswp", function(module, exports) {

$parcel$export(module.exports, "ProfileCardWrapper", () => $c7759d4452f622cb$export$59abd6feb7dc8540);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $c7759d4452f622cb$var$styles = (0, $1DXK0.xcss)({
    width: '360px'
});
const $c7759d4452f622cb$export$59abd6feb7dc8540 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: $c7759d4452f622cb$var$styles,
        children: children
    });
};

});




parcelRegister("22c3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd84232d8ddd3e42$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $xvuCV = parcelRequire("xvuCV");

var $a9cht = parcelRequire("a9cht");
const $fd84232d8ddd3e42$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $fd84232d8ddd3e42$export$2e2bcd8739ae039 = $fd84232d8ddd3e42$var$AkFlag;

});
parcelRegister("a9cht", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $3b59aa1149416ec4$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $3b59aa1149416ec4$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $3b59aa1149416ec4$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $3b59aa1149416ec4$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $3b59aa1149416ec4$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $3b59aa1149416ec4$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $3b59aa1149416ec4$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $3b59aa1149416ec4$export$a2c3479950310d7d);

var $eJOHy = parcelRequire("eJOHy");

var $xvuCV = parcelRequire("xvuCV");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3b59aa1149416ec4$var$ForPaintJiraCommonFlag = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("2H90P")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3b59aa1149416ec4$var$AfterPaintJiraCommonFlag = (0, $bQWwW.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("2H90P")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $3b59aa1149416ec4$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3b59aa1149416ec4$var$ForPaintFlagGroup = (0, $bQWwW.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("anv8L")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3b59aa1149416ec4$var$AfterPaintFlagGroup = (0, $bQWwW.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("anv8L")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $3b59aa1149416ec4$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$ForPaintFlagGroup, props);
const $3b59aa1149416ec4$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, props));
const $3b59aa1149416ec4$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $3b59aa1149416ec4$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $3b59aa1149416ec4$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $3b59aa1149416ec4$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $3b59aa1149416ec4$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $3b59aa1149416ec4$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $3b59aa1149416ec4$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$FlagGroupImpl, props));

});
parcelRegister("2H90P", function(module, exports) {

let $1f66969b09514848$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1f66969b09514848$var$load("ffQaD"),
    $1f66969b09514848$var$load("kvRbA"),
    $1f66969b09514848$var$load("76n7a"),
    $1f66969b09514848$var$load("l253H"),
    $1f66969b09514848$var$load("b8ahE")
]).then(()=>parcelRequire('jbDfJ'));

});

parcelRegister("anv8L", function(module, exports) {

let $78e4352d1cfc41ca$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $78e4352d1cfc41ca$var$load("5vCaf").then(()=>parcelRequire('1ZKRU'));

});








//# sourceMappingURL=async-profilecard.f076cc44.js.map
